import * as z from "react";
import St, { useRef as ct, useEffect as Me, useState as ke, useCallback as Mr, useMemo as Uu, forwardRef as Mp, useContext as Ip, isValidElement as Ir, cloneElement as Nr, Children as Np, useLayoutEffect as il } from "react";
import "react-dom/client";
import { Dialog as Lp, Container as sl, Typography as gt, InputBase as No, Button as Oa, Menu as Hu, MenuItem as Li, Box as uv, Chip as Vu, Snackbar as cv, Card as fv, CardHeader as dv, CardContent as pv, Accordion as hv, AccordionSummary as mv, Tooltip as wr, AccordionDetails as vv, IconButton as un, List as gv, ListItemText as yv, Tabs as bv, Tab as Wu, AppBar as wv, Toolbar as Sv } from "@mui/material";
import { createTheme as qp, styled as Fp, useTheme as zp } from "@mui/material/styles";
import * as Lr from "monaco-editor";
import Pv from "react-dom";
function xv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ev(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function a() {
      return this instanceof a ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(a) {
    var r = Object.getOwnPropertyDescriptor(e, a);
    Object.defineProperty(n, a, r.get ? r : {
      enumerable: !0,
      get: function() {
        return e[a];
      }
    });
  }), n;
}
var qi = { exports: {} }, na = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gu;
function _v() {
  if (Gu) return na;
  Gu = 1;
  var e = St, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(i, u, f) {
    var p, c = {}, l = null, v = null;
    f !== void 0 && (l = "" + f), u.key !== void 0 && (l = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (p in u) a.call(u, p) && !o.hasOwnProperty(p) && (c[p] = u[p]);
    if (i && i.defaultProps) for (p in u = i.defaultProps, u) c[p] === void 0 && (c[p] = u[p]);
    return { $$typeof: t, type: i, key: l, ref: v, props: c, _owner: r.current };
  }
  return na.Fragment = n, na.jsx = s, na.jsxs = s, na;
}
var Ku;
function Cv() {
  return Ku || (Ku = 1, qi.exports = _v()), qi.exports;
}
var V = Cv();
const _o = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
qp({
  components: {
    MuiAppBar: {
      defaultProps: {
        position: "sticky"
      },
      styleOverrides: {
        root: {
          background: "#fff !important"
        }
      }
    },
    MuiCard: {
      defaultProps: {
        elevation: 0
      }
    }
  },
  palette: {
    mode: "light",
    background: {
      default: "#fff"
    }
  }
});
qp({
  components: {
    MuiAppBar: {
      defaultProps: {
        position: "sticky"
      },
      styleOverrides: {
        root: {
          background: "transparent !important"
        }
      }
    },
    MuiCard: {
      defaultProps: {
        elevation: 0
      }
    },
    MuiTable: {
      styleOverrides: {
        root: {
          background: "transparent !important"
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: _o[400]
        }
      }
    }
  },
  palette: {
    mode: "dark",
    background: {
      default: _o[900],
      paper: _o[800]
    }
  }
});
function Bp(e, t, n, a) {
  n === void 0 && (n = globalThis), a === void 0 && (a = {});
  var r = ct(), o = a.capture, s = a.passive, i = a.once;
  Me(function() {
    r.current = t;
  }, [t]), Me(function() {
    if (n && n.addEventListener) {
      var u = function(p) {
        return r.current(p);
      }, f = { capture: o, passive: s, once: i };
      return n.addEventListener(e, u, f), function() {
        n.removeEventListener(e, u, f);
      };
    }
  }, [e, n, o, s, i]);
}
var Hr = {}, Rv = function(e, t, n) {
  return Hr[e] || (Hr[e] = { callbacks: [], value: n }), Hr[e].callbacks.push(t), { deregister: function() {
    var a = Hr[e].callbacks, r = a.indexOf(t);
    r > -1 && a.splice(r, 1);
  }, emit: function(a) {
    Hr[e].value !== a && (Hr[e].value = a, Hr[e].callbacks.forEach(function(r) {
      t !== r && r(a);
    }));
  } };
};
function Up(e, t) {
  if (t === void 0 && (t = typeof globalThis < "u" && globalThis.localStorage || typeof globalThis < "u" && globalThis.localStorage ? globalThis.localStorage : typeof window < "u" && window.localStorage ? window.localStorage : typeof localStorage < "u" ? localStorage : null), t) {
    var n = /* @__PURE__ */ function(a) {
      return { get: function(r, o) {
        var s = a.getItem(r);
        return s == null ? typeof o == "function" ? o() : o : JSON.parse(s);
      }, set: function(r, o) {
        a.setItem(r, JSON.stringify(o));
      } };
    }(t);
    return function(a) {
      return function(r, o, s) {
        var i = s.get, u = s.set, f = ct(null), p = ke(function() {
          return i(o, r);
        }), c = p[0], l = p[1];
        Bp("storage", function(d) {
          if (d.key === o) {
            var h = JSON.parse(d.newValue);
            c !== h && l(h);
          }
        }), Me(function() {
          return f.current = Rv(o, l, r), function() {
            f.current.deregister();
          };
        }, [r, o]);
        var v = Mr(function(d) {
          var h = typeof d == "function" ? d(c) : d;
          u(o, h), l(h), f.current.emit(d);
        }, [c, u, o]);
        return [c, v];
      }(a, e, n);
    };
  }
  return ke;
}
var Ju = function() {
}, Ov = { classList: { add: Ju, remove: Ju } }, $v = function(e, t, n) {
  n === void 0 && (n = globalThis);
  var a = e ? Up(e, t) : ke, r = n.matchMedia ? n.matchMedia("(prefers-color-scheme: dark)") : {}, o = { addEventListener: function(u, f) {
    return r.addListener && r.addListener(f);
  }, removeEventListener: function(u, f) {
    return r.removeListener && r.removeListener(f);
  } }, s = r.media === "(prefers-color-scheme: dark)", i = n.document && n.document.body || Ov;
  return { usePersistedDarkModeState: a, getDefaultOnChange: function(u, f, p) {
    return u === void 0 && (u = i), f === void 0 && (f = "dark-mode"), p === void 0 && (p = "light-mode"), function(c) {
      u.classList.add(c ? f : p), u.classList.remove(c ? p : f);
    };
  }, mediaQueryEventTarget: o, getInitialValue: function(u) {
    return s ? r.matches : u;
  } };
};
function Ml(e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = {});
  var n = t.element, a = t.classNameDark, r = t.classNameLight, o = t.onChange, s = t.storageKey;
  s === void 0 && (s = "darkMode");
  var i = t.storageProvider, u = t.global, f = Uu(function() {
    return $v(s, i, u);
  }, [s, i, u]), p = f.getDefaultOnChange, c = f.mediaQueryEventTarget, l = (0, f.usePersistedDarkModeState)((0, f.getInitialValue)(e)), v = l[0], d = l[1], h = Uu(function() {
    return o || p(n, a, r);
  }, [o, n, a, r, p]);
  return Me(function() {
    h(v);
  }, [h, v]), Bp("change", function(g) {
    return d(g.matches);
  }, c), { value: v, enable: Mr(function() {
    return d(!0);
  }, [d]), disable: Mr(function() {
    return d(!1);
  }, [d]), toggle: Mr(function() {
    return d(function(g) {
      return !g;
    });
  }, [d]) };
}
const {
  createElement: Nn,
  createContext: Tv,
  forwardRef: Hp,
  useCallback: vt,
  useContext: Vp,
  useEffect: Zr,
  useImperativeHandle: Wp,
  useLayoutEffect: jv,
  useMemo: Dv,
  useRef: bt,
  useState: Tn
} = z, Qu = z[`useId${Math.random()}`.slice(0, 5)], kv = jv, ti = Tv(null);
ti.displayName = "PanelGroupContext";
const en = kv, Av = typeof Qu == "function" ? Qu : () => null;
let Mv = 0;
function Il(e = null) {
  const t = Av(), n = bt(e || t || null);
  return n.current === null && (n.current = "" + Mv++), e ?? n.current;
}
function Gp({
  children: e,
  className: t = "",
  collapsedSize: n,
  collapsible: a,
  defaultSize: r,
  forwardedRef: o,
  id: s,
  maxSize: i,
  minSize: u,
  onCollapse: f,
  onExpand: p,
  onResize: c,
  order: l,
  style: v,
  tagName: d = "div",
  ...h
}) {
  const g = Vp(ti);
  if (g === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const {
    collapsePanel: b,
    expandPanel: E,
    getPanelSize: S,
    getPanelStyle: w,
    groupId: y,
    isPanelCollapsed: x,
    reevaluatePanelConstraints: P,
    registerPanel: C,
    resizePanel: R,
    unregisterPanel: m
  } = g, _ = Il(s), O = bt({
    callbacks: {
      onCollapse: f,
      onExpand: p,
      onResize: c
    },
    constraints: {
      collapsedSize: n,
      collapsible: a,
      defaultSize: r,
      maxSize: i,
      minSize: u
    },
    id: _,
    idIsFromProps: s !== void 0,
    order: l
  });
  bt({
    didLogMissingDefaultSizeWarning: !1
  }), en(() => {
    const {
      callbacks: A,
      constraints: M
    } = O.current, B = {
      ...M
    };
    O.current.id = _, O.current.idIsFromProps = s !== void 0, O.current.order = l, A.onCollapse = f, A.onExpand = p, A.onResize = c, M.collapsedSize = n, M.collapsible = a, M.defaultSize = r, M.maxSize = i, M.minSize = u, (B.collapsedSize !== M.collapsedSize || B.collapsible !== M.collapsible || B.maxSize !== M.maxSize || B.minSize !== M.minSize) && P(O.current, B);
  }), en(() => {
    const A = O.current;
    return C(A), () => {
      m(A);
    };
  }, [l, _, C, m]), Wp(o, () => ({
    collapse: () => {
      b(O.current);
    },
    expand: (A) => {
      E(O.current, A);
    },
    getId() {
      return _;
    },
    getSize() {
      return S(O.current);
    },
    isCollapsed() {
      return x(O.current);
    },
    isExpanded() {
      return !x(O.current);
    },
    resize: (A) => {
      R(O.current, A);
    }
  }), [b, E, S, x, _, R]);
  const T = w(O.current, r);
  return Nn(d, {
    ...h,
    children: e,
    className: t,
    id: s,
    style: {
      ...T,
      ...v
    },
    // CSS selectors
    "data-panel": "",
    "data-panel-collapsible": a || void 0,
    "data-panel-group-id": y,
    "data-panel-id": _,
    "data-panel-size": parseFloat("" + T.flexGrow).toFixed(1)
  });
}
const ba = Hp((e, t) => Nn(Gp, {
  ...e,
  forwardedRef: t
}));
Gp.displayName = "Panel";
ba.displayName = "forwardRef(Panel)";
let ll = null, Qr = null;
function Iv(e, t) {
  if (t) {
    const n = (t & Xp) !== 0, a = (t & Zp) !== 0, r = (t & eh) !== 0, o = (t & th) !== 0;
    if (n)
      return r ? "se-resize" : o ? "ne-resize" : "e-resize";
    if (a)
      return r ? "sw-resize" : o ? "nw-resize" : "w-resize";
    if (r)
      return "s-resize";
    if (o)
      return "n-resize";
  }
  switch (e) {
    case "horizontal":
      return "ew-resize";
    case "intersection":
      return "move";
    case "vertical":
      return "ns-resize";
  }
}
function Nv() {
  Qr !== null && (document.head.removeChild(Qr), ll = null, Qr = null);
}
function Fi(e, t) {
  const n = Iv(e, t);
  ll !== n && (ll = n, Qr === null && (Qr = document.createElement("style"), document.head.appendChild(Qr)), Qr.innerHTML = `*{cursor: ${n}!important;}`);
}
function Kp(e) {
  return e.type === "keydown";
}
function Jp(e) {
  return e.type.startsWith("pointer");
}
function Qp(e) {
  return e.type.startsWith("mouse");
}
function ri(e) {
  if (Jp(e)) {
    if (e.isPrimary)
      return {
        x: e.clientX,
        y: e.clientY
      };
  } else if (Qp(e))
    return {
      x: e.clientX,
      y: e.clientY
    };
  return {
    x: 1 / 0,
    y: 1 / 0
  };
}
function Lv() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
function qv(e, t, n) {
  return e.x < t.x + t.width && e.x + e.width > t.x && e.y < t.y + t.height && e.y + e.height > t.y;
}
function Fv(e, t) {
  if (e === t) throw new Error("Cannot compare node with itself");
  const n = {
    a: Zu(e),
    b: Zu(t)
  };
  let a;
  for (; n.a.at(-1) === n.b.at(-1); )
    e = n.a.pop(), t = n.b.pop(), a = e;
  ve(a, "Stacking order can only be calculated for elements with a common ancestor");
  const r = {
    a: Xu(Yu(n.a)),
    b: Xu(Yu(n.b))
  };
  if (r.a === r.b) {
    const o = a.childNodes, s = {
      a: n.a.at(-1),
      b: n.b.at(-1)
    };
    let i = o.length;
    for (; i--; ) {
      const u = o[i];
      if (u === s.a) return 1;
      if (u === s.b) return -1;
    }
  }
  return Math.sign(r.a - r.b);
}
const zv = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function Bv(e) {
  var t;
  const n = getComputedStyle((t = Yp(e)) !== null && t !== void 0 ? t : e).display;
  return n === "flex" || n === "inline-flex";
}
function Uv(e) {
  const t = getComputedStyle(e);
  return !!(t.position === "fixed" || t.zIndex !== "auto" && (t.position !== "static" || Bv(e)) || +t.opacity < 1 || "transform" in t && t.transform !== "none" || "webkitTransform" in t && t.webkitTransform !== "none" || "mixBlendMode" in t && t.mixBlendMode !== "normal" || "filter" in t && t.filter !== "none" || "webkitFilter" in t && t.webkitFilter !== "none" || "isolation" in t && t.isolation === "isolate" || zv.test(t.willChange) || t.webkitOverflowScrolling === "touch");
}
function Yu(e) {
  let t = e.length;
  for (; t--; ) {
    const n = e[t];
    if (ve(n, "Missing node"), Uv(n)) return n;
  }
  return null;
}
function Xu(e) {
  return e && Number(getComputedStyle(e).zIndex) || 0;
}
function Zu(e) {
  const t = [];
  for (; e; )
    t.push(e), e = Yp(e);
  return t;
}
function Yp(e) {
  const {
    parentNode: t
  } = e;
  return t && t instanceof ShadowRoot ? t.host : t;
}
const Xp = 1, Zp = 2, eh = 4, th = 8, Hv = Lv() === "coarse";
let Ht = [], jn = !1, kr = /* @__PURE__ */ new Map(), ni = /* @__PURE__ */ new Map();
const Da = /* @__PURE__ */ new Set();
function Vv(e, t, n, a, r) {
  var o;
  const {
    ownerDocument: s
  } = t, i = {
    direction: n,
    element: t,
    hitAreaMargins: a,
    setResizeHandlerState: r
  }, u = (o = kr.get(s)) !== null && o !== void 0 ? o : 0;
  return kr.set(s, u + 1), Da.add(i), Lo(), function() {
    var p;
    ni.delete(e), Da.delete(i);
    const c = (p = kr.get(s)) !== null && p !== void 0 ? p : 1;
    if (kr.set(s, c - 1), Lo(), c === 1 && kr.delete(s), Ht.includes(i)) {
      const l = Ht.indexOf(i);
      l >= 0 && Ht.splice(l, 1), Ll(), r("up", !0, null);
    }
  };
}
function ec(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: a
  } = ri(e);
  jn = !0, Nl({
    target: t,
    x: n,
    y: a
  }), Lo(), Ht.length > 0 && (qo("down", e), e.preventDefault(), e.stopPropagation());
}
function aa(e) {
  const {
    x: t,
    y: n
  } = ri(e);
  if (jn && e.buttons === 0 && (jn = !1, qo("up", e)), !jn) {
    const {
      target: a
    } = e;
    Nl({
      target: a,
      x: t,
      y: n
    });
  }
  qo("move", e), Ll(), Ht.length > 0 && e.preventDefault();
}
function cn(e) {
  const {
    target: t
  } = e, {
    x: n,
    y: a
  } = ri(e);
  ni.clear(), jn = !1, Ht.length > 0 && e.preventDefault(), qo("up", e), Nl({
    target: t,
    x: n,
    y: a
  }), Ll(), Lo();
}
function Nl({
  target: e,
  x: t,
  y: n
}) {
  Ht.splice(0);
  let a = null;
  (e instanceof HTMLElement || e instanceof SVGElement) && (a = e), Da.forEach((r) => {
    const {
      element: o,
      hitAreaMargins: s
    } = r, i = o.getBoundingClientRect(), {
      bottom: u,
      left: f,
      right: p,
      top: c
    } = i, l = Hv ? s.coarse : s.fine;
    if (t >= f - l && t <= p + l && n >= c - l && n <= u + l) {
      if (a !== null && document.contains(a) && o !== a && !o.contains(a) && !a.contains(o) && // Calculating stacking order has a cost, so we should avoid it if possible
      // That is why we only check potentially intersecting handles,
      // and why we skip if the event target is within the handle's DOM
      Fv(a, o) > 0) {
        let d = a, h = !1;
        for (; d && !d.contains(o); ) {
          if (qv(d.getBoundingClientRect(), i)) {
            h = !0;
            break;
          }
          d = d.parentElement;
        }
        if (h)
          return;
      }
      Ht.push(r);
    }
  });
}
function zi(e, t) {
  ni.set(e, t);
}
function Ll() {
  let e = !1, t = !1;
  Ht.forEach((a) => {
    const {
      direction: r
    } = a;
    r === "horizontal" ? e = !0 : t = !0;
  });
  let n = 0;
  ni.forEach((a) => {
    n |= a;
  }), e && t ? Fi("intersection", n) : e ? Fi("horizontal", n) : t ? Fi("vertical", n) : Nv();
}
function Lo() {
  kr.forEach((e, t) => {
    const {
      body: n
    } = t;
    n.removeEventListener("contextmenu", cn), n.removeEventListener("pointerdown", ec), n.removeEventListener("pointerleave", aa), n.removeEventListener("pointermove", aa);
  }), window.removeEventListener("pointerup", cn), window.removeEventListener("pointercancel", cn), Da.size > 0 && (jn ? (Ht.length > 0 && kr.forEach((e, t) => {
    const {
      body: n
    } = t;
    e > 0 && (n.addEventListener("contextmenu", cn), n.addEventListener("pointerleave", aa), n.addEventListener("pointermove", aa));
  }), window.addEventListener("pointerup", cn), window.addEventListener("pointercancel", cn)) : kr.forEach((e, t) => {
    const {
      body: n
    } = t;
    e > 0 && (n.addEventListener("pointerdown", ec, {
      capture: !0
    }), n.addEventListener("pointermove", aa));
  }));
}
function qo(e, t) {
  Da.forEach((n) => {
    const {
      setResizeHandlerState: a
    } = n, r = Ht.includes(n);
    a(e, r, t);
  });
}
function Wv() {
  const [e, t] = Tn(0);
  return vt(() => t((n) => n + 1), []);
}
function ve(e, t) {
  if (!e)
    throw console.error(t), Error(t);
}
const ql = 10;
function tn(e, t, n = ql) {
  return e.toFixed(n) === t.toFixed(n) ? 0 : e > t ? 1 : -1;
}
function Sr(e, t, n = ql) {
  return tn(e, t, n) === 0;
}
function Et(e, t, n) {
  return tn(e, t, n) === 0;
}
function Gv(e, t, n) {
  if (e.length !== t.length)
    return !1;
  for (let a = 0; a < e.length; a++) {
    const r = e[a], o = t[a];
    if (!Et(r, o, n))
      return !1;
  }
  return !0;
}
function $n({
  panelConstraints: e,
  panelIndex: t,
  size: n
}) {
  const a = e[t];
  ve(a != null, `Panel constraints not found for index ${t}`);
  let {
    collapsedSize: r = 0,
    collapsible: o,
    maxSize: s = 100,
    minSize: i = 0
  } = a;
  if (tn(n, i) < 0)
    if (o) {
      const u = (r + i) / 2;
      tn(n, u) < 0 ? n = r : n = i;
    } else
      n = i;
  return n = Math.min(s, n), n = parseFloat(n.toFixed(ql)), n;
}
function wa({
  delta: e,
  initialLayout: t,
  panelConstraints: n,
  pivotIndices: a,
  prevLayout: r,
  trigger: o
}) {
  if (Et(e, 0))
    return t;
  const s = [...t], [i, u] = a;
  ve(i != null, "Invalid first pivot index"), ve(u != null, "Invalid second pivot index");
  let f = 0;
  if (o === "keyboard") {
    {
      const c = e < 0 ? u : i, l = n[c];
      ve(l, `Panel constraints not found for index ${c}`);
      const {
        collapsedSize: v = 0,
        collapsible: d,
        minSize: h = 0
      } = l;
      if (d) {
        const g = t[c];
        if (ve(g != null, `Previous layout not found for panel index ${c}`), Et(g, v)) {
          const b = h - g;
          tn(b, Math.abs(e)) > 0 && (e = e < 0 ? 0 - b : b);
        }
      }
    }
    {
      const c = e < 0 ? i : u, l = n[c];
      ve(l, `No panel constraints found for index ${c}`);
      const {
        collapsedSize: v = 0,
        collapsible: d,
        minSize: h = 0
      } = l;
      if (d) {
        const g = t[c];
        if (ve(g != null, `Previous layout not found for panel index ${c}`), Et(g, h)) {
          const b = g - v;
          tn(b, Math.abs(e)) > 0 && (e = e < 0 ? 0 - b : b);
        }
      }
    }
  }
  {
    const c = e < 0 ? 1 : -1;
    let l = e < 0 ? u : i, v = 0;
    for (; ; ) {
      const h = t[l];
      ve(h != null, `Previous layout not found for panel index ${l}`);
      const b = $n({
        panelConstraints: n,
        panelIndex: l,
        size: 100
      }) - h;
      if (v += b, l += c, l < 0 || l >= n.length)
        break;
    }
    const d = Math.min(Math.abs(e), Math.abs(v));
    e = e < 0 ? 0 - d : d;
  }
  {
    let l = e < 0 ? i : u;
    for (; l >= 0 && l < n.length; ) {
      const v = Math.abs(e) - Math.abs(f), d = t[l];
      ve(d != null, `Previous layout not found for panel index ${l}`);
      const h = d - v, g = $n({
        panelConstraints: n,
        panelIndex: l,
        size: h
      });
      if (!Et(d, g) && (f += d - g, s[l] = g, f.toPrecision(3).localeCompare(Math.abs(e).toPrecision(3), void 0, {
        numeric: !0
      }) >= 0))
        break;
      e < 0 ? l-- : l++;
    }
  }
  if (Gv(r, s))
    return r;
  {
    const c = e < 0 ? u : i, l = t[c];
    ve(l != null, `Previous layout not found for panel index ${c}`);
    const v = l + f, d = $n({
      panelConstraints: n,
      panelIndex: c,
      size: v
    });
    if (s[c] = d, !Et(d, v)) {
      let h = v - d, b = e < 0 ? u : i;
      for (; b >= 0 && b < n.length; ) {
        const E = s[b];
        ve(E != null, `Previous layout not found for panel index ${b}`);
        const S = E + h, w = $n({
          panelConstraints: n,
          panelIndex: b,
          size: S
        });
        if (Et(E, w) || (h -= w - E, s[b] = w), Et(h, 0))
          break;
        e > 0 ? b-- : b++;
      }
    }
  }
  const p = s.reduce((c, l) => l + c, 0);
  return Et(p, 100) ? s : r;
}
function Kv({
  layout: e,
  panelsArray: t,
  pivotIndices: n
}) {
  let a = 0, r = 100, o = 0, s = 0;
  const i = n[0];
  ve(i != null, "No pivot index found"), t.forEach((c, l) => {
    const {
      constraints: v
    } = c, {
      maxSize: d = 100,
      minSize: h = 0
    } = v;
    l === i ? (a = h, r = d) : (o += h, s += d);
  });
  const u = Math.min(r, 100 - o), f = Math.max(a, 100 - s), p = e[i];
  return {
    valueMax: u,
    valueMin: f,
    valueNow: p
  };
}
function ka(e, t = document) {
  return Array.from(t.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${e}"]`));
}
function rh(e, t, n = document) {
  const r = ka(e, n).findIndex((o) => o.getAttribute("data-panel-resize-handle-id") === t);
  return r ?? null;
}
function nh(e, t, n) {
  const a = rh(e, t, n);
  return a != null ? [a, a + 1] : [-1, -1];
}
function ah(e, t = document) {
  var n;
  if (t instanceof HTMLElement && (t == null || (n = t.dataset) === null || n === void 0 ? void 0 : n.panelGroupId) == e)
    return t;
  const a = t.querySelector(`[data-panel-group][data-panel-group-id="${e}"]`);
  return a || null;
}
function ai(e, t = document) {
  const n = t.querySelector(`[data-panel-resize-handle-id="${e}"]`);
  return n || null;
}
function Jv(e, t, n, a = document) {
  var r, o, s, i;
  const u = ai(t, a), f = ka(e, a), p = u ? f.indexOf(u) : -1, c = (r = (o = n[p]) === null || o === void 0 ? void 0 : o.id) !== null && r !== void 0 ? r : null, l = (s = (i = n[p + 1]) === null || i === void 0 ? void 0 : i.id) !== null && s !== void 0 ? s : null;
  return [c, l];
}
function Qv({
  committedValuesRef: e,
  eagerValuesRef: t,
  groupId: n,
  layout: a,
  panelDataArray: r,
  panelGroupElement: o,
  setLayout: s
}) {
  bt({
    didWarnAboutMissingResizeHandle: !1
  }), en(() => {
    if (!o)
      return;
    const i = ka(n, o);
    for (let u = 0; u < r.length - 1; u++) {
      const {
        valueMax: f,
        valueMin: p,
        valueNow: c
      } = Kv({
        layout: a,
        panelsArray: r,
        pivotIndices: [u, u + 1]
      }), l = i[u];
      if (l != null) {
        const v = r[u];
        ve(v, `No panel data found for index "${u}"`), l.setAttribute("aria-controls", v.id), l.setAttribute("aria-valuemax", "" + Math.round(f)), l.setAttribute("aria-valuemin", "" + Math.round(p)), l.setAttribute("aria-valuenow", c != null ? "" + Math.round(c) : "");
      }
    }
    return () => {
      i.forEach((u, f) => {
        u.removeAttribute("aria-controls"), u.removeAttribute("aria-valuemax"), u.removeAttribute("aria-valuemin"), u.removeAttribute("aria-valuenow");
      });
    };
  }, [n, a, r, o]), Zr(() => {
    if (!o)
      return;
    const i = t.current;
    ve(i, "Eager values not found");
    const {
      panelDataArray: u
    } = i, f = ah(n, o);
    ve(f != null, `No group found for id "${n}"`);
    const p = ka(n, o);
    ve(p, `No resize handles found for group id "${n}"`);
    const c = p.map((l) => {
      const v = l.getAttribute("data-panel-resize-handle-id");
      ve(v, "Resize handle element has no handle id attribute");
      const [d, h] = Jv(n, v, u, o);
      if (d == null || h == null)
        return () => {
        };
      const g = (b) => {
        if (!b.defaultPrevented)
          switch (b.key) {
            case "Enter": {
              b.preventDefault();
              const E = u.findIndex((S) => S.id === d);
              if (E >= 0) {
                const S = u[E];
                ve(S, `No panel data found for index ${E}`);
                const w = a[E], {
                  collapsedSize: y = 0,
                  collapsible: x,
                  minSize: P = 0
                } = S.constraints;
                if (w != null && x) {
                  const C = wa({
                    delta: Et(w, y) ? P - y : y - w,
                    initialLayout: a,
                    panelConstraints: u.map((R) => R.constraints),
                    pivotIndices: nh(n, v, o),
                    prevLayout: a,
                    trigger: "keyboard"
                  });
                  a !== C && s(C);
                }
              }
              break;
            }
          }
      };
      return l.addEventListener("keydown", g), () => {
        l.removeEventListener("keydown", g);
      };
    });
    return () => {
      c.forEach((l) => l());
    };
  }, [o, e, t, n, a, r, s]);
}
function tc(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function oh(e, t) {
  const n = e === "horizontal", {
    x: a,
    y: r
  } = ri(t);
  return n ? a : r;
}
function Yv(e, t, n, a, r) {
  const o = n === "horizontal", s = ai(t, r);
  ve(s, `No resize handle element found for id "${t}"`);
  const i = s.getAttribute("data-panel-group-id");
  ve(i, "Resize handle element has no group id attribute");
  let {
    initialCursorPosition: u
  } = a;
  const f = oh(n, e), p = ah(i, r);
  ve(p, `No group element found for id "${i}"`);
  const c = p.getBoundingClientRect(), l = o ? c.width : c.height;
  return (f - u) / l * 100;
}
function Xv(e, t, n, a, r, o) {
  if (Kp(e)) {
    const s = n === "horizontal";
    let i = 0;
    e.shiftKey ? i = 100 : r != null ? i = r : i = 10;
    let u = 0;
    switch (e.key) {
      case "ArrowDown":
        u = s ? 0 : i;
        break;
      case "ArrowLeft":
        u = s ? -i : 0;
        break;
      case "ArrowRight":
        u = s ? i : 0;
        break;
      case "ArrowUp":
        u = s ? 0 : -i;
        break;
      case "End":
        u = 100;
        break;
      case "Home":
        u = -100;
        break;
    }
    return u;
  } else
    return a == null ? 0 : Yv(e, t, n, a, o);
}
function Zv({
  panelDataArray: e
}) {
  const t = Array(e.length), n = e.map((o) => o.constraints);
  let a = 0, r = 100;
  for (let o = 0; o < e.length; o++) {
    const s = n[o];
    ve(s, `Panel constraints not found for index ${o}`);
    const {
      defaultSize: i
    } = s;
    i != null && (a++, t[o] = i, r -= i);
  }
  for (let o = 0; o < e.length; o++) {
    const s = n[o];
    ve(s, `Panel constraints not found for index ${o}`);
    const {
      defaultSize: i
    } = s;
    if (i != null)
      continue;
    const u = e.length - a, f = r / u;
    a++, t[o] = f, r -= f;
  }
  return t;
}
function fn(e, t, n) {
  t.forEach((a, r) => {
    const o = e[r];
    ve(o, `Panel data not found for index ${r}`);
    const {
      callbacks: s,
      constraints: i,
      id: u
    } = o, {
      collapsedSize: f = 0,
      collapsible: p
    } = i, c = n[u];
    if (c == null || a !== c) {
      n[u] = a;
      const {
        onCollapse: l,
        onExpand: v,
        onResize: d
      } = s;
      d && d(a, c), p && (l || v) && (v && (c == null || Sr(c, f)) && !Sr(a, f) && v(), l && (c == null || !Sr(c, f)) && Sr(a, f) && l());
    }
  });
}
function co(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] != t[n])
      return !1;
  return !0;
}
function eg({
  defaultSize: e,
  dragState: t,
  layout: n,
  panelData: a,
  panelIndex: r,
  precision: o = 3
}) {
  const s = n[r];
  let i;
  return s == null ? i = e != null ? e.toPrecision(o) : "1" : a.length === 1 ? i = "1" : i = s.toPrecision(o), {
    flexBasis: 0,
    flexGrow: i,
    flexShrink: 1,
    // Without this, Panel sizes may be unintentionally overridden by their content
    overflow: "hidden",
    // Disable pointer events inside of a panel during resize
    // This avoid edge cases like nested iframes
    pointerEvents: t !== null ? "none" : void 0
  };
}
function tg(e, t = 10) {
  let n = null;
  return (...r) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...r);
    }, t);
  };
}
function rc(e) {
  try {
    if (typeof localStorage < "u")
      e.getItem = (t) => localStorage.getItem(t), e.setItem = (t, n) => {
        localStorage.setItem(t, n);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (t) {
    console.error(t), e.getItem = () => null, e.setItem = () => {
    };
  }
}
function ih(e) {
  return `react-resizable-panels:${e}`;
}
function sh(e) {
  return e.map((t) => {
    const {
      constraints: n,
      id: a,
      idIsFromProps: r,
      order: o
    } = t;
    return r ? a : o ? `${o}:${JSON.stringify(n)}` : JSON.stringify(n);
  }).sort((t, n) => t.localeCompare(n)).join(",");
}
function lh(e, t) {
  try {
    const n = ih(e), a = t.getItem(n);
    if (a) {
      const r = JSON.parse(a);
      if (typeof r == "object" && r != null)
        return r;
    }
  } catch {
  }
  return null;
}
function rg(e, t, n) {
  var a, r;
  const o = (a = lh(e, n)) !== null && a !== void 0 ? a : {}, s = sh(t);
  return (r = o[s]) !== null && r !== void 0 ? r : null;
}
function ng(e, t, n, a, r) {
  var o;
  const s = ih(e), i = sh(t), u = (o = lh(e, r)) !== null && o !== void 0 ? o : {};
  u[i] = {
    expandToSizes: Object.fromEntries(n.entries()),
    layout: a
  };
  try {
    r.setItem(s, JSON.stringify(u));
  } catch (f) {
    console.error(f);
  }
}
function nc({
  layout: e,
  panelConstraints: t
}) {
  const n = [...e], a = n.reduce((o, s) => o + s, 0);
  if (n.length !== t.length)
    throw Error(`Invalid ${t.length} panel layout: ${n.map((o) => `${o}%`).join(", ")}`);
  if (!Et(a, 100) && n.length > 0)
    for (let o = 0; o < t.length; o++) {
      const s = n[o];
      ve(s != null, `No layout data found for index ${o}`);
      const i = 100 / a * s;
      n[o] = i;
    }
  let r = 0;
  for (let o = 0; o < t.length; o++) {
    const s = n[o];
    ve(s != null, `No layout data found for index ${o}`);
    const i = $n({
      panelConstraints: t,
      panelIndex: o,
      size: s
    });
    s != i && (r += s - i, n[o] = i);
  }
  if (!Et(r, 0))
    for (let o = 0; o < t.length; o++) {
      const s = n[o];
      ve(s != null, `No layout data found for index ${o}`);
      const i = s + r, u = $n({
        panelConstraints: t,
        panelIndex: o,
        size: i
      });
      if (s !== u && (r -= u - s, n[o] = u, Et(r, 0)))
        break;
    }
  return n;
}
const ag = 100, Sa = {
  getItem: (e) => (rc(Sa), Sa.getItem(e)),
  setItem: (e, t) => {
    rc(Sa), Sa.setItem(e, t);
  }
}, ac = {};
function uh({
  autoSaveId: e = null,
  children: t,
  className: n = "",
  direction: a,
  forwardedRef: r,
  id: o = null,
  onLayout: s = null,
  keyboardResizeBy: i = null,
  storage: u = Sa,
  style: f,
  tagName: p = "div",
  ...c
}) {
  const l = Il(o), v = bt(null), [d, h] = Tn(null), [g, b] = Tn([]), E = Wv(), S = bt({}), w = bt(/* @__PURE__ */ new Map()), y = bt(0), x = bt({
    autoSaveId: e,
    direction: a,
    dragState: d,
    id: l,
    keyboardResizeBy: i,
    onLayout: s,
    storage: u
  }), P = bt({
    layout: g,
    panelDataArray: [],
    panelDataArrayChanged: !1
  });
  bt({
    didLogIdAndOrderWarning: !1,
    didLogPanelConstraintsWarning: !1,
    prevPanelIds: []
  }), Wp(r, () => ({
    getId: () => x.current.id,
    getLayout: () => {
      const {
        layout: G
      } = P.current;
      return G;
    },
    setLayout: (G) => {
      const {
        onLayout: ee
      } = x.current, {
        layout: ae,
        panelDataArray: j
      } = P.current, N = nc({
        layout: G,
        panelConstraints: j.map((W) => W.constraints)
      });
      tc(ae, N) || (b(N), P.current.layout = N, ee && ee(N), fn(j, N, S.current));
    }
  }), []), en(() => {
    x.current.autoSaveId = e, x.current.direction = a, x.current.dragState = d, x.current.id = l, x.current.onLayout = s, x.current.storage = u;
  }), Qv({
    committedValuesRef: x,
    eagerValuesRef: P,
    groupId: l,
    layout: g,
    panelDataArray: P.current.panelDataArray,
    setLayout: b,
    panelGroupElement: v.current
  }), Zr(() => {
    const {
      panelDataArray: G
    } = P.current;
    if (e) {
      if (g.length === 0 || g.length !== G.length)
        return;
      let ee = ac[e];
      ee == null && (ee = tg(ng, ag), ac[e] = ee);
      const ae = [...G], j = new Map(w.current);
      ee(e, ae, j, g, u);
    }
  }, [e, g, u]), Zr(() => {
  });
  const C = vt((G) => {
    const {
      onLayout: ee
    } = x.current, {
      layout: ae,
      panelDataArray: j
    } = P.current;
    if (G.constraints.collapsible) {
      const N = j.map((L) => L.constraints), {
        collapsedSize: W = 0,
        panelSize: K,
        pivotIndices: I
      } = Vr(j, G, ae);
      if (ve(K != null, `Panel size not found for panel "${G.id}"`), !Sr(K, W)) {
        w.current.set(G.id, K);
        const X = Rn(j, G) === j.length - 1 ? K - W : W - K, Y = wa({
          delta: X,
          initialLayout: ae,
          panelConstraints: N,
          pivotIndices: I,
          prevLayout: ae,
          trigger: "imperative-api"
        });
        co(ae, Y) || (b(Y), P.current.layout = Y, ee && ee(Y), fn(j, Y, S.current));
      }
    }
  }, []), R = vt((G, ee) => {
    const {
      onLayout: ae
    } = x.current, {
      layout: j,
      panelDataArray: N
    } = P.current;
    if (G.constraints.collapsible) {
      const W = N.map((re) => re.constraints), {
        collapsedSize: K = 0,
        panelSize: I = 0,
        minSize: L = 0,
        pivotIndices: X
      } = Vr(N, G, j), Y = ee ?? L;
      if (Sr(I, K)) {
        const re = w.current.get(G.id), pe = re != null && re >= Y ? re : Y, ce = Rn(N, G) === N.length - 1 ? I - pe : pe - I, de = wa({
          delta: ce,
          initialLayout: j,
          panelConstraints: W,
          pivotIndices: X,
          prevLayout: j,
          trigger: "imperative-api"
        });
        co(j, de) || (b(de), P.current.layout = de, ae && ae(de), fn(N, de, S.current));
      }
    }
  }, []), m = vt((G) => {
    const {
      layout: ee,
      panelDataArray: ae
    } = P.current, {
      panelSize: j
    } = Vr(ae, G, ee);
    return ve(j != null, `Panel size not found for panel "${G.id}"`), j;
  }, []), _ = vt((G, ee) => {
    const {
      panelDataArray: ae
    } = P.current, j = Rn(ae, G);
    return eg({
      defaultSize: ee,
      dragState: d,
      layout: g,
      panelData: ae,
      panelIndex: j
    });
  }, [d, g]), O = vt((G) => {
    const {
      layout: ee,
      panelDataArray: ae
    } = P.current, {
      collapsedSize: j = 0,
      collapsible: N,
      panelSize: W
    } = Vr(ae, G, ee);
    return ve(W != null, `Panel size not found for panel "${G.id}"`), N === !0 && Sr(W, j);
  }, []), T = vt((G) => {
    const {
      layout: ee,
      panelDataArray: ae
    } = P.current, {
      collapsedSize: j = 0,
      collapsible: N,
      panelSize: W
    } = Vr(ae, G, ee);
    return ve(W != null, `Panel size not found for panel "${G.id}"`), !N || tn(W, j) > 0;
  }, []), A = vt((G) => {
    const {
      panelDataArray: ee
    } = P.current;
    ee.push(G), ee.sort((ae, j) => {
      const N = ae.order, W = j.order;
      return N == null && W == null ? 0 : N == null ? -1 : W == null ? 1 : N - W;
    }), P.current.panelDataArrayChanged = !0, E();
  }, [E]);
  en(() => {
    if (P.current.panelDataArrayChanged) {
      P.current.panelDataArrayChanged = !1;
      const {
        autoSaveId: G,
        onLayout: ee,
        storage: ae
      } = x.current, {
        layout: j,
        panelDataArray: N
      } = P.current;
      let W = null;
      if (G) {
        const I = rg(G, N, ae);
        I && (w.current = new Map(Object.entries(I.expandToSizes)), W = I.layout);
      }
      W == null && (W = Zv({
        panelDataArray: N
      }));
      const K = nc({
        layout: W,
        panelConstraints: N.map((I) => I.constraints)
      });
      tc(j, K) || (b(K), P.current.layout = K, ee && ee(K), fn(N, K, S.current));
    }
  }), en(() => {
    const G = P.current;
    return () => {
      G.layout = [];
    };
  }, []);
  const M = vt((G) => {
    let ee = !1;
    const ae = v.current;
    return ae && window.getComputedStyle(ae, null).getPropertyValue("direction") === "rtl" && (ee = !0), function(N) {
      N.preventDefault();
      const W = v.current;
      if (!W)
        return () => null;
      const {
        direction: K,
        dragState: I,
        id: L,
        keyboardResizeBy: X,
        onLayout: Y
      } = x.current, {
        layout: re,
        panelDataArray: pe
      } = P.current, {
        initialLayout: ie
      } = I ?? {}, ce = nh(L, G, W);
      let de = Xv(N, G, K, I, X, W);
      const ye = K === "horizontal";
      ye && ee && (de = -de);
      const tt = pe.map((ze) => ze.constraints), se = wa({
        delta: de,
        initialLayout: ie ?? re,
        panelConstraints: tt,
        pivotIndices: ce,
        prevLayout: re,
        trigger: Kp(N) ? "keyboard" : "mouse-or-touch"
      }), oe = !co(re, se);
      (Jp(N) || Qp(N)) && y.current != de && (y.current = de, !oe && de !== 0 ? ye ? zi(G, de < 0 ? Xp : Zp) : zi(G, de < 0 ? eh : th) : zi(G, 0)), oe && (b(se), P.current.layout = se, Y && Y(se), fn(pe, se, S.current));
    };
  }, []), B = vt((G, ee) => {
    const {
      onLayout: ae
    } = x.current, {
      layout: j,
      panelDataArray: N
    } = P.current, W = N.map((re) => re.constraints), {
      panelSize: K,
      pivotIndices: I
    } = Vr(N, G, j);
    ve(K != null, `Panel size not found for panel "${G.id}"`);
    const X = Rn(N, G) === N.length - 1 ? K - ee : ee - K, Y = wa({
      delta: X,
      initialLayout: j,
      panelConstraints: W,
      pivotIndices: I,
      prevLayout: j,
      trigger: "imperative-api"
    });
    co(j, Y) || (b(Y), P.current.layout = Y, ae && ae(Y), fn(N, Y, S.current));
  }, []), J = vt((G, ee) => {
    const {
      layout: ae,
      panelDataArray: j
    } = P.current, {
      collapsedSize: N = 0,
      collapsible: W
    } = ee, {
      collapsedSize: K = 0,
      collapsible: I,
      maxSize: L = 100,
      minSize: X = 0
    } = G.constraints, {
      panelSize: Y
    } = Vr(j, G, ae);
    Y != null && (W && I && Sr(Y, N) ? Sr(N, K) || B(G, K) : Y < X ? B(G, X) : Y > L && B(G, L));
  }, [B]), Q = vt((G, ee) => {
    const {
      direction: ae
    } = x.current, {
      layout: j
    } = P.current;
    if (!v.current)
      return;
    const N = ai(G, v.current);
    ve(N, `Drag handle element not found for id "${G}"`);
    const W = oh(ae, ee);
    h({
      dragHandleId: G,
      dragHandleRect: N.getBoundingClientRect(),
      initialCursorPosition: W,
      initialLayout: j
    });
  }, []), Z = vt(() => {
    h(null);
  }, []), te = vt((G) => {
    const {
      panelDataArray: ee
    } = P.current, ae = Rn(ee, G);
    ae >= 0 && (ee.splice(ae, 1), delete S.current[G.id], P.current.panelDataArrayChanged = !0, E());
  }, [E]), le = Dv(() => ({
    collapsePanel: C,
    direction: a,
    dragState: d,
    expandPanel: R,
    getPanelSize: m,
    getPanelStyle: _,
    groupId: l,
    isPanelCollapsed: O,
    isPanelExpanded: T,
    reevaluatePanelConstraints: J,
    registerPanel: A,
    registerResizeHandle: M,
    resizePanel: B,
    startDragging: Q,
    stopDragging: Z,
    unregisterPanel: te,
    panelGroupElement: v.current
  }), [C, d, a, R, m, _, l, O, T, J, A, M, B, Q, Z, te]), me = {
    display: "flex",
    flexDirection: a === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return Nn(ti.Provider, {
    value: le
  }, Nn(p, {
    ...c,
    children: t,
    className: n,
    id: o,
    ref: v,
    style: {
      ...me,
      ...f
    },
    // CSS selectors
    "data-panel-group": "",
    "data-panel-group-direction": a,
    "data-panel-group-id": l
  }));
}
const ul = Hp((e, t) => Nn(uh, {
  ...e,
  forwardedRef: t
}));
uh.displayName = "PanelGroup";
ul.displayName = "forwardRef(PanelGroup)";
function Rn(e, t) {
  return e.findIndex((n) => n === t || n.id === t.id);
}
function Vr(e, t, n) {
  const a = Rn(e, t), o = a === e.length - 1 ? [a - 1, a] : [a, a + 1], s = n[a];
  return {
    ...t.constraints,
    panelSize: s,
    pivotIndices: o
  };
}
function og({
  disabled: e,
  handleId: t,
  resizeHandler: n,
  panelGroupElement: a
}) {
  Zr(() => {
    if (e || n == null || a == null)
      return;
    const r = ai(t, a);
    if (r == null)
      return;
    const o = (s) => {
      if (!s.defaultPrevented)
        switch (s.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            s.preventDefault(), n(s);
            break;
          }
          case "F6": {
            s.preventDefault();
            const i = r.getAttribute("data-panel-group-id");
            ve(i, `No group element found for id "${i}"`);
            const u = ka(i, a), f = rh(i, t, a);
            ve(f !== null, `No resize element found for id "${t}"`);
            const p = s.shiftKey ? f > 0 ? f - 1 : u.length - 1 : f + 1 < u.length ? f + 1 : 0;
            u[p].focus();
            break;
          }
        }
    };
    return r.addEventListener("keydown", o), () => {
      r.removeEventListener("keydown", o);
    };
  }, [a, e, t, n]);
}
function cl({
  children: e = null,
  className: t = "",
  disabled: n = !1,
  hitAreaMargins: a,
  id: r,
  onBlur: o,
  onDragging: s,
  onFocus: i,
  style: u = {},
  tabIndex: f = 0,
  tagName: p = "div",
  ...c
}) {
  var l, v;
  const d = bt(null), h = bt({
    onDragging: s
  });
  Zr(() => {
    h.current.onDragging = s;
  });
  const g = Vp(ti);
  if (g === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    direction: b,
    groupId: E,
    registerResizeHandle: S,
    startDragging: w,
    stopDragging: y,
    panelGroupElement: x
  } = g, P = Il(r), [C, R] = Tn("inactive"), [m, _] = Tn(!1), [O, T] = Tn(null), A = bt({
    state: C
  });
  en(() => {
    A.current.state = C;
  }), Zr(() => {
    if (n)
      T(null);
    else {
      const Q = S(P);
      T(() => Q);
    }
  }, [n, P, S]);
  const M = (l = a?.coarse) !== null && l !== void 0 ? l : 15, B = (v = a?.fine) !== null && v !== void 0 ? v : 5;
  return Zr(() => {
    if (n || O == null)
      return;
    const Q = d.current;
    return ve(Q, "Element ref not attached"), Vv(P, Q, b, {
      coarse: M,
      fine: B
    }, (te, le, me) => {
      if (le)
        switch (te) {
          case "down": {
            R("drag"), ve(me, 'Expected event to be defined for "down" action'), w(P, me);
            const {
              onDragging: G
            } = h.current;
            G && G(!0);
            break;
          }
          case "move": {
            const {
              state: G
            } = A.current;
            G !== "drag" && R("hover"), ve(me, 'Expected event to be defined for "move" action'), O(me);
            break;
          }
          case "up": {
            R("hover"), y();
            const {
              onDragging: G
            } = h.current;
            G && G(!1);
            break;
          }
        }
      else
        R("inactive");
    });
  }, [M, b, n, B, S, P, O, w, y]), og({
    disabled: n,
    handleId: P,
    resizeHandler: O,
    panelGroupElement: x
  }), Nn(p, {
    ...c,
    children: e,
    className: t,
    id: r,
    onBlur: () => {
      _(!1), o?.();
    },
    onFocus: () => {
      _(!0), i?.();
    },
    ref: d,
    role: "separator",
    style: {
      ...{
        touchAction: "none",
        userSelect: "none"
      },
      ...u
    },
    tabIndex: f,
    // CSS selectors
    "data-panel-group-direction": b,
    "data-panel-group-id": E,
    "data-resize-handle": "",
    "data-resize-handle-active": C === "drag" ? "pointer" : m ? "keyboard" : void 0,
    "data-resize-handle-state": C,
    "data-panel-resize-handle-enabled": !n,
    "data-panel-resize-handle-id": P
  });
}
cl.displayName = "PanelResizeHandle";
var oc = { exports: {} }, oa = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ic;
function ig() {
  if (ic) return oa;
  ic = 1;
  var e = St, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(i, u, f) {
    var p, c = {}, l = null, v = null;
    f !== void 0 && (l = "" + f), u.key !== void 0 && (l = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (p in u) a.call(u, p) && !o.hasOwnProperty(p) && (c[p] = u[p]);
    if (i && i.defaultProps) for (p in u = i.defaultProps, u) c[p] === void 0 && (c[p] = u[p]);
    return { $$typeof: t, type: i, key: l, ref: v, props: c, _owner: r.current };
  }
  return oa.Fragment = n, oa.jsx = s, oa.jsxs = s, oa;
}
var sc;
function sg() {
  return sc || (sc = 1, oc.exports = ig()), oc.exports;
}
var lg = sg();
const oi = ({
  value: e,
  language: t,
  height: n = "100%",
  width: a = "100%",
  options: r,
  onChange: o,
  onMount: s
}) => {
  const i = ct(null), u = ct(null), f = ct(!0), p = ct(e);
  return Me(() => {
    if (i.current) {
      const c = Lr.editor.create(i.current, {
        value: e,
        language: t,
        automaticLayout: !0,
        //      model,
        ...r
      });
      u.current = c, s && s(c);
      const l = c.getModel(), v = l?.onDidChangeContent(() => {
        if (o && l) {
          const d = l.getValue();
          p.current = d, o(d);
        }
      });
      return () => {
        v?.dispose(), f.current = !1;
      };
    }
  }, []), Me(() => () => {
    var c;
    (c = u.current) == null || c.dispose();
  }, []), Me(() => {
    if (!f.current) return;
    const c = u.current;
    if (!c || c._isDisposed) return;
    const l = c.getModel();
    if (!(!l || l.isDisposed()) && e !== p.current) {
      const v = c.getPosition();
      l.setValue(e), p.current = e, v && c.setPosition(v);
    }
  }, [e]), Me(() => {
    if (!f.current) return;
    const c = u.current;
    if (c) {
      const l = c.getModel();
      l && Lr.editor.setModelLanguage(l, t);
    }
  }, [t]), /* @__PURE__ */ lg.jsx("div", { ref: i, style: { height: n, width: a } });
}, ch = Symbol.for("OPEN_RPC_GLOBAL_SCHEMA_DIAGNOSTICS"), fl = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  globalThis[ch] || {}
);
globalThis[ch] = fl;
function Fo(e, t, n, a) {
  fl[e] = t;
  const r = {
    enableSchemaRequest: !0,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schemas: Object.entries(fl).map(([o, s]) => ({
      fileMatch: [o],
      schema: s,
      uri: o
    })),
    validate: !0
  };
  n.languages.json.jsonDefaults.setDiagnosticsOptions(r);
}
var Bi, lc;
function ug() {
  if (lc) return Bi;
  lc = 1;
  let { useState: e, useEffect: t } = St;
  function n() {
    return {
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
      outerHeight: window.outerHeight,
      outerWidth: window.outerWidth
    };
  }
  function a() {
    let [r, o] = e(n());
    function s() {
      o(n());
    }
    return t(() => (window.addEventListener("resize", s), () => {
      window.removeEventListener("resize", s);
    }), []), r;
  }
  return Bi = a, Bi;
}
var cg = ug();
const fh = /* @__PURE__ */ xv(cg), uc = {
  properties: {
    jsonrpc: {
      type: "string",
      enum: ["2.0"],
      description: "JSON-RPC version string"
    },
    id: {
      description: "unique identifier for the JSON-RPC request",
      oneOf: [
        {
          type: "string"
        },
        {
          type: "number"
        }
      ]
    }
  }
}, fg = (e) => ({
  type: "object",
  properties: {
    id: {
      ...uc.properties.id
    },
    jsonrpc: {
      ...uc.properties.jsonrpc
    },
    method: {
      type: "string",
      oneOf: e && e.methods && e.methods.map((t) => {
        const n = t;
        return {
          const: n.name,
          description: n.description || n.summary,
          markdownDescription: n.description || n.summary
        };
      })
    }
  },
  allOf: e && e.methods && e.methods.map((t) => {
    const n = t;
    return {
      if: {
        properties: {
          method: {
            const: n.name
          }
        }
      },
      then: {
        properties: {
          params: {
            oneOf: [
              {
                type: "array",
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                minItems: n.params && n.params.filter((a) => a.required).length,
                maxItems: n.params && n.params.length,
                defaultSnippets: n.examples ? (
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  n.examples.map((a) => ({
                    label: a.name,
                    description: a.description || a.summary,
                    body: a.params && a.params.map((r) => r.value)
                  }))
                ) : [],
                items: n.params && // eslint-disable-next-line @typescript-eslint/no-explicit-any
                n.params.map((a) => ({
                  ...a.schema,
                  markdownDescription: a.description || a.summary,
                  description: a.description || a.summary,
                  additionalProperties: !1
                }))
              },
              {
                type: "object",
                properties: n.params && n.params.reduce(
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  (a, r) => (typeof r.schema == "object" ? a[r.name] = {
                    ...r.schema,
                    markdownDescription: r.description || r.summary,
                    description: r.description || r.summary,
                    additionalProperties: !1
                  } : a[r.name] = r.schema, a),
                  {}
                )
              }
            ]
          }
        }
      }
    };
  })
}), dg = (e) => {
  const t = ct(null), n = fh();
  Me(() => {
    t.current && t.current.layout();
  }, [n]), Me(() => {
    if (!t.current)
      return;
    const i = t.current.getModel();
    if (!i) return;
    const u = a(e.openrpcDocument);
    Fo(i?.uri.toString() || "", u, Lr);
  }, [e.openrpcDocument]);
  function a(i) {
    if (!t.current) return;
    let u = {
      type: "object",
      properties: {
        jsonrpc: {
          type: "string",
          const: "2.0"
        },
        id: {
          oneOf: [
            {
              type: "string"
            },
            {
              type: "number"
            }
          ]
        },
        method: {
          type: "string"
        }
      }
    };
    return i ? u = fg(i) : u = {
      additionalProperties: !1,
      properties: {
        ...u.properties,
        params: {
          oneOf: [{ type: "array" }, { type: "object" }]
        }
      }
    }, u;
  }
  function r(i) {
    t.current = i;
    const u = a(e.openrpcDocument), f = Lr.editor.createModel(e.value, "json");
    f.onDidChangeAttached(() => {
      Fo(f.uri.toString() || "", u, Lr);
    }), t.current?.setModel(f), t.current?.focus();
  }
  const o = (i) => {
    t.current?.getModel() && e.onChange && e.onChange(i);
  }, s = Ml();
  return /* @__PURE__ */ V.jsx(
    oi,
    {
      height: "100%",
      width: "100%",
      value: e.value,
      onMount: r,
      options: {
        theme: s.value ? "vs-dark" : "vs",
        minimap: {
          enabled: !1
        },
        automaticLayout: !0,
        fixedOverflowWidgets: !0
      },
      language: "json",
      onChange: o
    }
  );
};
var Ui = { exports: {} }, Re = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cc;
function pg() {
  if (cc) return Re;
  cc = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), i = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), l = Symbol.for("react.offscreen"), v = Symbol.for("react.client.reference");
  function d(h) {
    if (typeof h == "object" && h !== null) {
      var g = h.$$typeof;
      switch (g) {
        case e:
          switch (h = h.type, h) {
            case n:
            case r:
            case a:
            case u:
            case f:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case s:
                case i:
                case c:
                case p:
                  return h;
                case o:
                  return h;
                default:
                  return g;
              }
          }
        case t:
          return g;
      }
    }
  }
  return Re.ContextConsumer = o, Re.ContextProvider = s, Re.Element = e, Re.ForwardRef = i, Re.Fragment = n, Re.Lazy = c, Re.Memo = p, Re.Portal = t, Re.Profiler = r, Re.StrictMode = a, Re.Suspense = u, Re.SuspenseList = f, Re.isContextConsumer = function(h) {
    return d(h) === o;
  }, Re.isContextProvider = function(h) {
    return d(h) === s;
  }, Re.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, Re.isForwardRef = function(h) {
    return d(h) === i;
  }, Re.isFragment = function(h) {
    return d(h) === n;
  }, Re.isLazy = function(h) {
    return d(h) === c;
  }, Re.isMemo = function(h) {
    return d(h) === p;
  }, Re.isPortal = function(h) {
    return d(h) === t;
  }, Re.isProfiler = function(h) {
    return d(h) === r;
  }, Re.isStrictMode = function(h) {
    return d(h) === a;
  }, Re.isSuspense = function(h) {
    return d(h) === u;
  }, Re.isSuspenseList = function(h) {
    return d(h) === f;
  }, Re.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === n || h === r || h === a || h === u || h === f || h === l || typeof h == "object" && h !== null && (h.$$typeof === c || h.$$typeof === p || h.$$typeof === s || h.$$typeof === o || h.$$typeof === i || h.$$typeof === v || h.getModuleId !== void 0);
  }, Re.typeOf = d, Re;
}
var fc;
function hg() {
  return fc || (fc = 1, Ui.exports = /* @__PURE__ */ pg()), Ui.exports;
}
var dh = /* @__PURE__ */ hg();
function ir(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function ph(e) {
  if (/* @__PURE__ */ z.isValidElement(e) || dh.isValidElementType(e) || !ir(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = ph(e[n]);
  }), t;
}
function Rt(e, t, n = {
  clone: !0
}) {
  const a = n.clone ? {
    ...e
  } : e;
  return ir(e) && ir(t) && Object.keys(t).forEach((r) => {
    /* @__PURE__ */ z.isValidElement(t[r]) || dh.isValidElementType(t[r]) ? a[r] = t[r] : ir(t[r]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, r) && ir(e[r]) ? a[r] = Rt(e[r], t[r], n) : n.clone ? a[r] = ir(t[r]) ? ph(t[r]) : t[r] : a[r] = t[r];
  }), a;
}
function rn(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((a) => n.searchParams.append("args[]", a)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
function Ln(e) {
  if (typeof e != "string")
    throw new Error(rn(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function mg(e, t) {
  return /* @__PURE__ */ z.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? e.type?._payload?.value?.muiName
  ) !== -1;
}
function vg(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const hh = typeof window < "u" ? z.useLayoutEffect : z.useEffect;
function Co(e) {
  const t = z.useRef(e);
  return hh(() => {
    t.current = e;
  }), z.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function dl(...e) {
  return z.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      vg(n, t);
    });
  }, e);
}
const dc = {};
function mh(e, t) {
  const n = z.useRef(dc);
  return n.current === dc && (n.current = e(t)), n;
}
const gg = [];
function yg(e) {
  z.useEffect(e, gg);
}
class Fl {
  static create() {
    return new Fl();
  }
  currentId = null;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
  clear = () => {
    this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
  };
  disposeEffect = () => this.clear;
}
function bg() {
  const e = mh(Fl.create).current;
  return yg(e.disposeEffect), e;
}
function pc(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return !1;
}
function zo(e, t) {
  const n = {
    ...t
  };
  for (const a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      const r = a;
      if (r === "components" || r === "slots")
        n[r] = {
          ...e[r],
          ...n[r]
        };
      else if (r === "componentsProps" || r === "slotProps") {
        const o = e[r], s = t[r];
        if (!s)
          n[r] = o || {};
        else if (!o)
          n[r] = s;
        else {
          n[r] = {
            ...s
          };
          for (const i in o)
            if (Object.prototype.hasOwnProperty.call(o, i)) {
              const u = i;
              n[r][u] = zo(o[u], s[u]);
            }
        }
      } else n[r] === void 0 && (n[r] = e[r]);
    }
  return n;
}
function ii(e, t, n = void 0) {
  const a = {};
  for (const r in e) {
    const o = e[r];
    let s = "", i = !0;
    for (let u = 0; u < o.length; u += 1) {
      const f = o[u];
      f && (s += (i === !0 ? "" : " ") + t(f), i = !1, n && n[f] && (s += " " + n[f]));
    }
    a[r] = s;
  }
  return a;
}
const hc = (e) => e, wg = () => {
  let e = hc;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = hc;
    }
  };
}, Sg = wg(), Pg = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Ga(e, t, n = "Mui") {
  const a = Pg[t];
  return a ? `${n}-${a}` : `${Sg.generate(e)}-${t}`;
}
function si(e, t, n = "Mui") {
  const a = {};
  return t.forEach((r) => {
    a[r] = Ga(e, r, n);
  }), a;
}
function xg(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function vh(e) {
  var t, n, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = vh(e[t])) && (a && (a += " "), a += n);
  } else for (n in e) e[n] && (a && (a += " "), a += n);
  return a;
}
function wt() {
  for (var e, t, n = 0, a = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = vh(e)) && (a && (a += " "), a += t);
  return a;
}
function $a(e, t) {
  return t ? Rt(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
function Eg(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((a) => a.startsWith("@container")).sort((a, r) => {
    const o = /min-width:\s*([0-9.]+)/;
    return +(a.match(o)?.[1] || 0) - +(r.match(o)?.[1] || 0);
  });
  return n.length ? n.reduce((a, r) => {
    const o = t[r];
    return delete a[r], a[r] = o, a;
  }, {
    ...t
  }) : t;
}
function _g(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function Cg(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n)
    return null;
  const [, a, r] = n, o = Number.isNaN(+a) ? a || 0 : +a;
  return e.containerQueries(r).up(o);
}
function Rg(e) {
  const t = (o, s) => o.replace("@media", s ? `@container ${s}` : "@container");
  function n(o, s) {
    o.up = (...i) => t(e.breakpoints.up(...i), s), o.down = (...i) => t(e.breakpoints.down(...i), s), o.between = (...i) => t(e.breakpoints.between(...i), s), o.only = (...i) => t(e.breakpoints.only(...i), s), o.not = (...i) => {
      const u = t(e.breakpoints.not(...i), s);
      return u.includes("not all and") ? u.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : u;
    };
  }
  const a = {}, r = (o) => (n(a, o), a);
  return n(r), {
    ...e,
    containerQueries: r
  };
}
const li = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, mc = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${li[e]}px)`
}, Og = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : li[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function xr(e, t, n) {
  const a = e.theme || {};
  if (Array.isArray(t)) {
    const o = a.breakpoints || mc;
    return t.reduce((s, i, u) => (s[o.up(o.keys[u])] = n(t[u]), s), {});
  }
  if (typeof t == "object") {
    const o = a.breakpoints || mc;
    return Object.keys(t).reduce((s, i) => {
      if (_g(o.keys, i)) {
        const u = Cg(a.containerQueries ? a : Og, i);
        u && (s[u] = n(t[i], i));
      } else if (Object.keys(o.values || li).includes(i)) {
        const u = o.up(i);
        s[u] = n(t[i], i);
      } else {
        const u = i;
        s[u] = t[u];
      }
      return s;
    }, {});
  }
  return n(t);
}
function $g(e = {}) {
  return e.keys?.reduce((n, a) => {
    const r = e.up(a);
    return n[r] = {}, n;
  }, {}) || {};
}
function Tg(e, t) {
  return e.reduce((n, a) => {
    const r = n[a];
    return (!r || Object.keys(r).length === 0) && delete n[a], n;
  }, t);
}
function ui(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const a = `vars.${t}`.split(".").reduce((r, o) => r && r[o] ? r[o] : null, e);
    if (a != null)
      return a;
  }
  return t.split(".").reduce((a, r) => a && a[r] != null ? a[r] : null, e);
}
function Bo(e, t, n, a = n) {
  let r;
  return typeof e == "function" ? r = e(n) : Array.isArray(e) ? r = e[n] || a : r = ui(e, n) || a, t && (r = t(r, a, e)), r;
}
function Ke(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: a,
    transform: r
  } = e, o = (s) => {
    if (s[t] == null)
      return null;
    const i = s[t], u = s.theme, f = ui(u, a) || {};
    return xr(s, i, (c) => {
      let l = Bo(f, r, c);
      return c === l && typeof c == "string" && (l = Bo(f, r, `${t}${c === "default" ? "" : Ln(c)}`, c)), n === !1 ? l : {
        [n]: l
      };
    });
  };
  return o.propTypes = {}, o.filterProps = [t], o;
}
function jg(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const Dg = {
  m: "margin",
  p: "padding"
}, kg = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, vc = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Ag = jg((e) => {
  if (e.length > 2)
    if (vc[e])
      e = vc[e];
    else
      return [e];
  const [t, n] = e.split(""), a = Dg[t], r = kg[n] || "";
  return Array.isArray(r) ? r.map((o) => a + o) : [a + r];
}), zl = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Bl = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...zl, ...Bl];
function Ka(e, t, n, a) {
  const r = ui(e, t, !0) ?? n;
  return typeof r == "number" || typeof r == "string" ? (o) => typeof o == "string" ? o : typeof r == "string" ? `calc(${o} * ${r})` : r * o : Array.isArray(r) ? (o) => {
    if (typeof o == "string")
      return o;
    const s = Math.abs(o), i = r[s];
    return o >= 0 ? i : typeof i == "number" ? -i : `-${i}`;
  } : typeof r == "function" ? r : () => {
  };
}
function Ul(e) {
  return Ka(e, "spacing", 8);
}
function Ja(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function Mg(e, t) {
  return (n) => e.reduce((a, r) => (a[r] = Ja(t, n), a), {});
}
function Ig(e, t, n, a) {
  if (!t.includes(n))
    return null;
  const r = Ag(n), o = Mg(r, a), s = e[n];
  return xr(e, s, o);
}
function gh(e, t) {
  const n = Ul(e.theme);
  return Object.keys(e).map((a) => Ig(e, t, a, n)).reduce($a, {});
}
function Be(e) {
  return gh(e, zl);
}
Be.propTypes = {};
Be.filterProps = zl;
function Ue(e) {
  return gh(e, Bl);
}
Ue.propTypes = {};
Ue.filterProps = Bl;
function ci(...e) {
  const t = e.reduce((a, r) => (r.filterProps.forEach((o) => {
    a[o] = r;
  }), a), {}), n = (a) => Object.keys(a).reduce((r, o) => t[o] ? $a(r, t[o](a)) : r, {});
  return n.propTypes = {}, n.filterProps = e.reduce((a, r) => a.concat(r.filterProps), []), n;
}
function Nt(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function qt(e, t) {
  return Ke({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const Ng = qt("border", Nt), Lg = qt("borderTop", Nt), qg = qt("borderRight", Nt), Fg = qt("borderBottom", Nt), zg = qt("borderLeft", Nt), Bg = qt("borderColor"), Ug = qt("borderTopColor"), Hg = qt("borderRightColor"), Vg = qt("borderBottomColor"), Wg = qt("borderLeftColor"), Gg = qt("outline", Nt), Kg = qt("outlineColor"), fi = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Ka(e.theme, "shape.borderRadius", 4), n = (a) => ({
      borderRadius: Ja(t, a)
    });
    return xr(e, e.borderRadius, n);
  }
  return null;
};
fi.propTypes = {};
fi.filterProps = ["borderRadius"];
ci(Ng, Lg, qg, Fg, zg, Bg, Ug, Hg, Vg, Wg, fi, Gg, Kg);
const di = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Ka(e.theme, "spacing", 8), n = (a) => ({
      gap: Ja(t, a)
    });
    return xr(e, e.gap, n);
  }
  return null;
};
di.propTypes = {};
di.filterProps = ["gap"];
const pi = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Ka(e.theme, "spacing", 8), n = (a) => ({
      columnGap: Ja(t, a)
    });
    return xr(e, e.columnGap, n);
  }
  return null;
};
pi.propTypes = {};
pi.filterProps = ["columnGap"];
const hi = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Ka(e.theme, "spacing", 8), n = (a) => ({
      rowGap: Ja(t, a)
    });
    return xr(e, e.rowGap, n);
  }
  return null;
};
hi.propTypes = {};
hi.filterProps = ["rowGap"];
const Jg = Ke({
  prop: "gridColumn"
}), Qg = Ke({
  prop: "gridRow"
}), Yg = Ke({
  prop: "gridAutoFlow"
}), Xg = Ke({
  prop: "gridAutoColumns"
}), Zg = Ke({
  prop: "gridAutoRows"
}), e0 = Ke({
  prop: "gridTemplateColumns"
}), t0 = Ke({
  prop: "gridTemplateRows"
}), r0 = Ke({
  prop: "gridTemplateAreas"
}), n0 = Ke({
  prop: "gridArea"
});
ci(di, pi, hi, Jg, Qg, Yg, Xg, Zg, e0, t0, r0, n0);
function Dn(e, t) {
  return t === "grey" ? t : e;
}
const a0 = Ke({
  prop: "color",
  themeKey: "palette",
  transform: Dn
}), o0 = Ke({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Dn
}), i0 = Ke({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Dn
});
ci(a0, o0, i0);
function _t(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const s0 = Ke({
  prop: "width",
  transform: _t
}), Hl = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      const a = e.theme?.breakpoints?.values?.[n] || li[n];
      return a ? e.theme?.breakpoints?.unit !== "px" ? {
        maxWidth: `${a}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: a
      } : {
        maxWidth: _t(n)
      };
    };
    return xr(e, e.maxWidth, t);
  }
  return null;
};
Hl.filterProps = ["maxWidth"];
const l0 = Ke({
  prop: "minWidth",
  transform: _t
}), u0 = Ke({
  prop: "height",
  transform: _t
}), c0 = Ke({
  prop: "maxHeight",
  transform: _t
}), f0 = Ke({
  prop: "minHeight",
  transform: _t
});
Ke({
  prop: "size",
  cssProperty: "width",
  transform: _t
});
Ke({
  prop: "size",
  cssProperty: "height",
  transform: _t
});
const d0 = Ke({
  prop: "boxSizing"
});
ci(s0, Hl, l0, u0, c0, f0, d0);
const Qa = {
  // borders
  border: {
    themeKey: "borders",
    transform: Nt
  },
  borderTop: {
    themeKey: "borders",
    transform: Nt
  },
  borderRight: {
    themeKey: "borders",
    transform: Nt
  },
  borderBottom: {
    themeKey: "borders",
    transform: Nt
  },
  borderLeft: {
    themeKey: "borders",
    transform: Nt
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Nt
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: fi
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Dn
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Dn
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Dn
  },
  // spacing
  p: {
    style: Ue
  },
  pt: {
    style: Ue
  },
  pr: {
    style: Ue
  },
  pb: {
    style: Ue
  },
  pl: {
    style: Ue
  },
  px: {
    style: Ue
  },
  py: {
    style: Ue
  },
  padding: {
    style: Ue
  },
  paddingTop: {
    style: Ue
  },
  paddingRight: {
    style: Ue
  },
  paddingBottom: {
    style: Ue
  },
  paddingLeft: {
    style: Ue
  },
  paddingX: {
    style: Ue
  },
  paddingY: {
    style: Ue
  },
  paddingInline: {
    style: Ue
  },
  paddingInlineStart: {
    style: Ue
  },
  paddingInlineEnd: {
    style: Ue
  },
  paddingBlock: {
    style: Ue
  },
  paddingBlockStart: {
    style: Ue
  },
  paddingBlockEnd: {
    style: Ue
  },
  m: {
    style: Be
  },
  mt: {
    style: Be
  },
  mr: {
    style: Be
  },
  mb: {
    style: Be
  },
  ml: {
    style: Be
  },
  mx: {
    style: Be
  },
  my: {
    style: Be
  },
  margin: {
    style: Be
  },
  marginTop: {
    style: Be
  },
  marginRight: {
    style: Be
  },
  marginBottom: {
    style: Be
  },
  marginLeft: {
    style: Be
  },
  marginX: {
    style: Be
  },
  marginY: {
    style: Be
  },
  marginInline: {
    style: Be
  },
  marginInlineStart: {
    style: Be
  },
  marginInlineEnd: {
    style: Be
  },
  marginBlock: {
    style: Be
  },
  marginBlockStart: {
    style: Be
  },
  marginBlockEnd: {
    style: Be
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: di
  },
  rowGap: {
    style: hi
  },
  columnGap: {
    style: pi
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: _t
  },
  maxWidth: {
    style: Hl
  },
  minWidth: {
    transform: _t
  },
  height: {
    transform: _t
  },
  maxHeight: {
    transform: _t
  },
  minHeight: {
    transform: _t
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function p0(...e) {
  const t = e.reduce((a, r) => a.concat(Object.keys(r)), []), n = new Set(t);
  return e.every((a) => n.size === Object.keys(a).length);
}
function h0(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function m0() {
  function e(n, a, r, o) {
    const s = {
      [n]: a,
      theme: r
    }, i = o[n];
    if (!i)
      return {
        [n]: a
      };
    const {
      cssProperty: u = n,
      themeKey: f,
      transform: p,
      style: c
    } = i;
    if (a == null)
      return null;
    if (f === "typography" && a === "inherit")
      return {
        [n]: a
      };
    const l = ui(r, f) || {};
    return c ? c(s) : xr(s, a, (d) => {
      let h = Bo(l, p, d);
      return d === h && typeof d == "string" && (h = Bo(l, p, `${n}${d === "default" ? "" : Ln(d)}`, d)), u === !1 ? h : {
        [u]: h
      };
    });
  }
  function t(n) {
    const {
      sx: a,
      theme: r = {}
    } = n || {};
    if (!a)
      return null;
    const o = r.unstable_sxConfig ?? Qa;
    function s(i) {
      let u = i;
      if (typeof i == "function")
        u = i(r);
      else if (typeof i != "object")
        return i;
      if (!u)
        return null;
      const f = $g(r.breakpoints), p = Object.keys(f);
      let c = f;
      return Object.keys(u).forEach((l) => {
        const v = h0(u[l], r);
        if (v != null)
          if (typeof v == "object")
            if (o[l])
              c = $a(c, e(l, v, r, o));
            else {
              const d = xr({
                theme: r
              }, v, (h) => ({
                [l]: h
              }));
              p0(d, v) ? c[l] = t({
                sx: v,
                theme: r
              }) : c = $a(c, d);
            }
          else
            c = $a(c, e(l, v, r, o));
      }), Eg(r, Tg(p, c));
    }
    return Array.isArray(a) ? a.map(s) : s(a);
  }
  return t;
}
const qn = m0();
qn.filterProps = ["sx"];
const v0 = (e) => {
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = e?.theme?.unstable_sxConfig ?? Qa;
  return Object.keys(e).forEach((a) => {
    n[a] ? t.systemProps[a] = e[a] : t.otherProps[a] = e[a];
  }), t;
};
function g0(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: a,
    otherProps: r
  } = v0(n);
  let o;
  return Array.isArray(t) ? o = [a, ...t] : typeof t == "function" ? o = (...s) => {
    const i = t(...s);
    return ir(i) ? {
      ...a,
      ...i
    } : a;
  } : o = {
    ...a,
    ...t
  }, {
    ...r,
    sx: o
  };
}
function Uo() {
  return Uo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) ({}).hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, Uo.apply(null, arguments);
}
function y0(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function b0(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var w0 = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(r) {
      var o;
      a.tags.length === 0 ? a.insertionPoint ? o = a.insertionPoint.nextSibling : a.prepend ? o = a.container.firstChild : o = a.before : o = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(r, o), a.tags.push(r);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, t.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(b0(this));
    var r = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = y0(r);
      try {
        o.insertRule(a, o.cssRules.length);
      } catch {
      }
    } else
      r.appendChild(document.createTextNode(a));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(a) {
      var r;
      return (r = a.parentNode) == null ? void 0 : r.removeChild(a);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), st = "-ms-", Ho = "-moz-", we = "-webkit-", yh = "comm", Vl = "rule", Wl = "decl", S0 = "@import", bh = "@keyframes", P0 = "@layer", x0 = Math.abs, mi = String.fromCharCode, E0 = Object.assign;
function _0(e, t) {
  return at(e, 0) ^ 45 ? (((t << 2 ^ at(e, 0)) << 2 ^ at(e, 1)) << 2 ^ at(e, 2)) << 2 ^ at(e, 3) : 0;
}
function wh(e) {
  return e.trim();
}
function C0(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Pe(e, t, n) {
  return e.replace(t, n);
}
function pl(e, t) {
  return e.indexOf(t);
}
function at(e, t) {
  return e.charCodeAt(t) | 0;
}
function Aa(e, t, n) {
  return e.slice(t, n);
}
function rr(e) {
  return e.length;
}
function Gl(e) {
  return e.length;
}
function fo(e, t) {
  return t.push(e), e;
}
function R0(e, t) {
  return e.map(t).join("");
}
var vi = 1, Fn = 1, Sh = 0, Pt = 0, Xe = 0, Un = "";
function gi(e, t, n, a, r, o, s) {
  return { value: e, root: t, parent: n, type: a, props: r, children: o, line: vi, column: Fn, length: s, return: "" };
}
function ia(e, t) {
  return E0(gi("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function O0() {
  return Xe;
}
function $0() {
  return Xe = Pt > 0 ? at(Un, --Pt) : 0, Fn--, Xe === 10 && (Fn = 1, vi--), Xe;
}
function Ot() {
  return Xe = Pt < Sh ? at(Un, Pt++) : 0, Fn++, Xe === 10 && (Fn = 1, vi++), Xe;
}
function sr() {
  return at(Un, Pt);
}
function Ro() {
  return Pt;
}
function Ya(e, t) {
  return Aa(Un, e, t);
}
function Ma(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Ph(e) {
  return vi = Fn = 1, Sh = rr(Un = e), Pt = 0, [];
}
function xh(e) {
  return Un = "", e;
}
function Oo(e) {
  return wh(Ya(Pt - 1, hl(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function T0(e) {
  for (; (Xe = sr()) && Xe < 33; )
    Ot();
  return Ma(e) > 2 || Ma(Xe) > 3 ? "" : " ";
}
function j0(e, t) {
  for (; --t && Ot() && !(Xe < 48 || Xe > 102 || Xe > 57 && Xe < 65 || Xe > 70 && Xe < 97); )
    ;
  return Ya(e, Ro() + (t < 6 && sr() == 32 && Ot() == 32));
}
function hl(e) {
  for (; Ot(); )
    switch (Xe) {
      // ] ) " '
      case e:
        return Pt;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && hl(Xe);
        break;
      // (
      case 40:
        e === 41 && hl(e);
        break;
      // \
      case 92:
        Ot();
        break;
    }
  return Pt;
}
function D0(e, t) {
  for (; Ot() && e + Xe !== 57; )
    if (e + Xe === 84 && sr() === 47)
      break;
  return "/*" + Ya(t, Pt - 1) + "*" + mi(e === 47 ? e : Ot());
}
function k0(e) {
  for (; !Ma(sr()); )
    Ot();
  return Ya(e, Pt);
}
function A0(e) {
  return xh($o("", null, null, null, [""], e = Ph(e), 0, [0], e));
}
function $o(e, t, n, a, r, o, s, i, u) {
  for (var f = 0, p = 0, c = s, l = 0, v = 0, d = 0, h = 1, g = 1, b = 1, E = 0, S = "", w = r, y = o, x = a, P = S; g; )
    switch (d = E, E = Ot()) {
      // (
      case 40:
        if (d != 108 && at(P, c - 1) == 58) {
          pl(P += Pe(Oo(E), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        P += Oo(E);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        P += T0(d);
        break;
      // \
      case 92:
        P += j0(Ro() - 1, 7);
        continue;
      // /
      case 47:
        switch (sr()) {
          case 42:
          case 47:
            fo(M0(D0(Ot(), Ro()), t, n), u);
            break;
          default:
            P += "/";
        }
        break;
      // {
      case 123 * h:
        i[f++] = rr(P) * b;
      // } ; \0
      case 125 * h:
      case 59:
      case 0:
        switch (E) {
          // \0 }
          case 0:
          case 125:
            g = 0;
          // ;
          case 59 + p:
            b == -1 && (P = Pe(P, /\f/g, "")), v > 0 && rr(P) - c && fo(v > 32 ? yc(P + ";", a, n, c - 1) : yc(Pe(P, " ", "") + ";", a, n, c - 2), u);
            break;
          // @ ;
          case 59:
            P += ";";
          // { rule/at-rule
          default:
            if (fo(x = gc(P, t, n, f, p, r, i, S, w = [], y = [], c), o), E === 123)
              if (p === 0)
                $o(P, t, x, x, w, o, c, i, y);
              else
                switch (l === 99 && at(P, 3) === 110 ? 100 : l) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    $o(e, x, x, a && fo(gc(e, x, x, 0, 0, r, i, S, r, w = [], c), y), r, y, c, i, a ? w : y);
                    break;
                  default:
                    $o(P, x, x, x, [""], y, 0, i, y);
                }
        }
        f = p = v = 0, h = b = 1, S = P = "", c = s;
        break;
      // :
      case 58:
        c = 1 + rr(P), v = d;
      default:
        if (h < 1) {
          if (E == 123)
            --h;
          else if (E == 125 && h++ == 0 && $0() == 125)
            continue;
        }
        switch (P += mi(E), E * h) {
          // &
          case 38:
            b = p > 0 ? 1 : (P += "\f", -1);
            break;
          // ,
          case 44:
            i[f++] = (rr(P) - 1) * b, b = 1;
            break;
          // @
          case 64:
            sr() === 45 && (P += Oo(Ot())), l = sr(), p = c = rr(S = P += k0(Ro())), E++;
            break;
          // -
          case 45:
            d === 45 && rr(P) == 2 && (h = 0);
        }
    }
  return o;
}
function gc(e, t, n, a, r, o, s, i, u, f, p) {
  for (var c = r - 1, l = r === 0 ? o : [""], v = Gl(l), d = 0, h = 0, g = 0; d < a; ++d)
    for (var b = 0, E = Aa(e, c + 1, c = x0(h = s[d])), S = e; b < v; ++b)
      (S = wh(h > 0 ? l[b] + " " + E : Pe(E, /&\f/g, l[b]))) && (u[g++] = S);
  return gi(e, t, n, r === 0 ? Vl : i, u, f, p);
}
function M0(e, t, n) {
  return gi(e, t, n, yh, mi(O0()), Aa(e, 2, -2), 0);
}
function yc(e, t, n, a) {
  return gi(e, t, n, Wl, Aa(e, 0, a), Aa(e, a + 1, -1), a);
}
function kn(e, t) {
  for (var n = "", a = Gl(e), r = 0; r < a; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function I0(e, t, n, a) {
  switch (e.type) {
    case P0:
      if (e.children.length) break;
    case S0:
    case Wl:
      return e.return = e.return || e.value;
    case yh:
      return "";
    case bh:
      return e.return = e.value + "{" + kn(e.children, a) + "}";
    case Vl:
      e.value = e.props.join(",");
  }
  return rr(n = kn(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function N0(e) {
  var t = Gl(e);
  return function(n, a, r, o) {
    for (var s = "", i = 0; i < t; i++)
      s += e[i](n, a, r, o) || "";
    return s;
  };
}
function L0(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function Eh(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var q0 = function(t, n, a) {
  for (var r = 0, o = 0; r = o, o = sr(), r === 38 && o === 12 && (n[a] = 1), !Ma(o); )
    Ot();
  return Ya(t, Pt);
}, F0 = function(t, n) {
  var a = -1, r = 44;
  do
    switch (Ma(r)) {
      case 0:
        r === 38 && sr() === 12 && (n[a] = 1), t[a] += q0(Pt - 1, n, a);
        break;
      case 2:
        t[a] += Oo(r);
        break;
      case 4:
        if (r === 44) {
          t[++a] = sr() === 58 ? "&\f" : "", n[a] = t[a].length;
          break;
        }
      // fallthrough
      default:
        t[a] += mi(r);
    }
  while (r = Ot());
  return t;
}, z0 = function(t, n) {
  return xh(F0(Ph(t), n));
}, bc = /* @__PURE__ */ new WeakMap(), B0 = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, a = t.parent, r = t.column === a.column && t.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !bc.get(a)) && !r) {
      bc.set(t, !0);
      for (var o = [], s = z0(n, o), i = a.props, u = 0, f = 0; u < s.length; u++)
        for (var p = 0; p < i.length; p++, f++)
          t.props[f] = o[u] ? s[u].replace(/&\f/g, i[p]) : i[p] + " " + s[u];
    }
  }
}, U0 = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function _h(e, t) {
  switch (_0(e, t)) {
    // color-adjust
    case 5103:
      return we + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return we + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return we + e + Ho + e + st + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return we + e + st + e + e;
    // order
    case 6165:
      return we + e + st + "flex-" + e + e;
    // align-items
    case 5187:
      return we + e + Pe(e, /(\w+).+(:[^]+)/, we + "box-$1$2" + st + "flex-$1$2") + e;
    // align-self
    case 5443:
      return we + e + st + "flex-item-" + Pe(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return we + e + st + "flex-line-pack" + Pe(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return we + e + st + Pe(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return we + e + st + Pe(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return we + "box-" + Pe(e, "-grow", "") + we + e + st + Pe(e, "grow", "positive") + e;
    // transition
    case 4554:
      return we + Pe(e, /([^-])(transform)/g, "$1" + we + "$2") + e;
    // cursor
    case 6187:
      return Pe(Pe(Pe(e, /(zoom-|grab)/, we + "$1"), /(image-set)/, we + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return Pe(e, /(image-set\([^]*)/, we + "$1$`$1");
    // justify-content
    case 4968:
      return Pe(Pe(e, /(.+:)(flex-)?(.*)/, we + "box-pack:$3" + st + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + we + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Pe(e, /(.+)-inline(.+)/, we + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (rr(e) - 1 - t > 6) switch (at(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (at(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return Pe(e, /(.+:)(.+)-([^]+)/, "$1" + we + "$2-$3$1" + Ho + (at(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~pl(e, "stretch") ? _h(Pe(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (at(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (at(e, rr(e) - 3 - (~pl(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return Pe(e, ":", ":" + we) + e;
        // (inline-)?fl(e)x
        case 101:
          return Pe(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + we + (at(e, 14) === 45 ? "inline-" : "") + "box$3$1" + we + "$2$3$1" + st + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (at(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return we + e + st + Pe(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return we + e + st + Pe(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return we + e + st + Pe(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return we + e + st + e + e;
  }
  return e;
}
var H0 = function(t, n, a, r) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case Wl:
      t.return = _h(t.value, t.length);
      break;
    case bh:
      return kn([ia(t, {
        value: Pe(t.value, "@", "@" + we)
      })], r);
    case Vl:
      if (t.length) return R0(t.props, function(o) {
        switch (C0(o, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return kn([ia(t, {
              props: [Pe(o, /:(read-\w+)/, ":" + Ho + "$1")]
            })], r);
          // :placeholder
          case "::placeholder":
            return kn([ia(t, {
              props: [Pe(o, /:(plac\w+)/, ":" + we + "input-$1")]
            }), ia(t, {
              props: [Pe(o, /:(plac\w+)/, ":" + Ho + "$1")]
            }), ia(t, {
              props: [Pe(o, /:(plac\w+)/, st + "input-$1")]
            })], r);
        }
        return "";
      });
  }
}, V0 = [H0], W0 = function(t) {
  var n = t.key;
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(h) {
      var g = h.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(h), h.setAttribute("data-s", ""));
    });
  }
  var r = t.stylisPlugins || V0, o = {}, s, i = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(h) {
      for (var g = h.getAttribute("data-emotion").split(" "), b = 1; b < g.length; b++)
        o[g[b]] = !0;
      i.push(h);
    }
  );
  var u, f = [B0, U0];
  {
    var p, c = [I0, L0(function(h) {
      p.insert(h);
    })], l = N0(f.concat(r, c)), v = function(g) {
      return kn(A0(g), l);
    };
    u = function(g, b, E, S) {
      p = E, v(g ? g + "{" + b.styles + "}" : b.styles), S && (d.inserted[b.name] = !0);
    };
  }
  var d = {
    key: n,
    sheet: new w0({
      key: n,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: o,
    registered: {},
    insert: u
  };
  return d.sheet.hydrate(i), d;
}, Hi = { exports: {} }, Ee = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wc;
function G0() {
  if (wc) return Ee;
  wc = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, l = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, d = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function S(y) {
    if (typeof y == "object" && y !== null) {
      var x = y.$$typeof;
      switch (x) {
        case t:
          switch (y = y.type, y) {
            case u:
            case f:
            case a:
            case o:
            case r:
            case c:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case i:
                case p:
                case d:
                case v:
                case s:
                  return y;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function w(y) {
    return S(y) === f;
  }
  return Ee.AsyncMode = u, Ee.ConcurrentMode = f, Ee.ContextConsumer = i, Ee.ContextProvider = s, Ee.Element = t, Ee.ForwardRef = p, Ee.Fragment = a, Ee.Lazy = d, Ee.Memo = v, Ee.Portal = n, Ee.Profiler = o, Ee.StrictMode = r, Ee.Suspense = c, Ee.isAsyncMode = function(y) {
    return w(y) || S(y) === u;
  }, Ee.isConcurrentMode = w, Ee.isContextConsumer = function(y) {
    return S(y) === i;
  }, Ee.isContextProvider = function(y) {
    return S(y) === s;
  }, Ee.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, Ee.isForwardRef = function(y) {
    return S(y) === p;
  }, Ee.isFragment = function(y) {
    return S(y) === a;
  }, Ee.isLazy = function(y) {
    return S(y) === d;
  }, Ee.isMemo = function(y) {
    return S(y) === v;
  }, Ee.isPortal = function(y) {
    return S(y) === n;
  }, Ee.isProfiler = function(y) {
    return S(y) === o;
  }, Ee.isStrictMode = function(y) {
    return S(y) === r;
  }, Ee.isSuspense = function(y) {
    return S(y) === c;
  }, Ee.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === a || y === f || y === o || y === r || y === c || y === l || typeof y == "object" && y !== null && (y.$$typeof === d || y.$$typeof === v || y.$$typeof === s || y.$$typeof === i || y.$$typeof === p || y.$$typeof === g || y.$$typeof === b || y.$$typeof === E || y.$$typeof === h);
  }, Ee.typeOf = S, Ee;
}
var Sc;
function K0() {
  return Sc || (Sc = 1, Hi.exports = G0()), Hi.exports;
}
var Vi, Pc;
function J0() {
  if (Pc) return Vi;
  Pc = 1;
  var e = K0(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, a = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, r = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, o = {};
  o[e.ForwardRef] = a, o[e.Memo] = r;
  function s(d) {
    return e.isMemo(d) ? r : o[d.$$typeof] || t;
  }
  var i = Object.defineProperty, u = Object.getOwnPropertyNames, f = Object.getOwnPropertySymbols, p = Object.getOwnPropertyDescriptor, c = Object.getPrototypeOf, l = Object.prototype;
  function v(d, h, g) {
    if (typeof h != "string") {
      if (l) {
        var b = c(h);
        b && b !== l && v(d, b, g);
      }
      var E = u(h);
      f && (E = E.concat(f(h)));
      for (var S = s(d), w = s(h), y = 0; y < E.length; ++y) {
        var x = E[y];
        if (!n[x] && !(g && g[x]) && !(w && w[x]) && !(S && S[x])) {
          var P = p(h, x);
          try {
            i(d, x, P);
          } catch {
          }
        }
      }
    }
    return d;
  }
  return Vi = v, Vi;
}
J0();
var Q0 = !0;
function Ch(e, t, n) {
  var a = "";
  return n.split(" ").forEach(function(r) {
    e[r] !== void 0 ? t.push(e[r] + ";") : r && (a += r + " ");
  }), a;
}
var Kl = function(t, n, a) {
  var r = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Q0 === !1) && t.registered[r] === void 0 && (t.registered[r] = n.styles);
}, Rh = function(t, n, a) {
  Kl(t, n, a);
  var r = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var o = n;
    do
      t.insert(n === o ? "." + r : "", o, t.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function Y0(e) {
  for (var t = 0, n, a = 0, r = e.length; r >= 4; ++a, r -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (r) {
    case 3:
      t ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(a) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var X0 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Z0 = /[A-Z]|^ms/g, ey = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Oh = function(t) {
  return t.charCodeAt(1) === 45;
}, xc = function(t) {
  return t != null && typeof t != "boolean";
}, Wi = /* @__PURE__ */ Eh(function(e) {
  return Oh(e) ? e : e.replace(Z0, "-$&").toLowerCase();
}), Ec = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(ey, function(a, r, o) {
          return nr = {
            name: r,
            styles: o,
            next: nr
          }, r;
        });
  }
  return X0[t] !== 1 && !Oh(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function Ia(e, t, n) {
  if (n == null)
    return "";
  var a = n;
  if (a.__emotion_styles !== void 0)
    return a;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var r = n;
      if (r.anim === 1)
        return nr = {
          name: r.name,
          styles: r.styles,
          next: nr
        }, r.name;
      var o = n;
      if (o.styles !== void 0) {
        var s = o.next;
        if (s !== void 0)
          for (; s !== void 0; )
            nr = {
              name: s.name,
              styles: s.styles,
              next: nr
            }, s = s.next;
        var i = o.styles + ";";
        return i;
      }
      return ty(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var u = nr, f = n(e);
        return nr = u, Ia(e, t, f);
      }
      break;
    }
  }
  var p = n;
  if (t == null)
    return p;
  var c = t[p];
  return c !== void 0 ? c : p;
}
function ty(e, t, n) {
  var a = "";
  if (Array.isArray(n))
    for (var r = 0; r < n.length; r++)
      a += Ia(e, t, n[r]) + ";";
  else
    for (var o in n) {
      var s = n[o];
      if (typeof s != "object") {
        var i = s;
        t != null && t[i] !== void 0 ? a += o + "{" + t[i] + "}" : xc(i) && (a += Wi(o) + ":" + Ec(o, i) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
        for (var u = 0; u < s.length; u++)
          xc(s[u]) && (a += Wi(o) + ":" + Ec(o, s[u]) + ";");
      else {
        var f = Ia(e, t, s);
        switch (o) {
          case "animation":
          case "animationName": {
            a += Wi(o) + ":" + f + ";";
            break;
          }
          default:
            a += o + "{" + f + "}";
        }
      }
    }
  return a;
}
var _c = /label:\s*([^\s;{]+)\s*(;|$)/g, nr;
function yi(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var a = !0, r = "";
  nr = void 0;
  var o = e[0];
  if (o == null || o.raw === void 0)
    a = !1, r += Ia(n, t, o);
  else {
    var s = o;
    r += s[0];
  }
  for (var i = 1; i < e.length; i++)
    if (r += Ia(n, t, e[i]), a) {
      var u = o;
      r += u[i];
    }
  _c.lastIndex = 0;
  for (var f = "", p; (p = _c.exec(r)) !== null; )
    f += "-" + p[1];
  var c = Y0(r) + f;
  return {
    name: c,
    styles: r,
    next: nr
  };
}
var ry = function(t) {
  return t();
}, ny = z.useInsertionEffect ? z.useInsertionEffect : !1, $h = ny || ry, Th = /* @__PURE__ */ z.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ W0({
    key: "css"
  }) : null
);
Th.Provider;
var jh = function(t) {
  return /* @__PURE__ */ Mp(function(n, a) {
    var r = Ip(Th);
    return t(n, r, a);
  });
}, Jl = /* @__PURE__ */ z.createContext({}), Ql = {}.hasOwnProperty, ml = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", ay = function(t, n) {
  var a = {};
  for (var r in n)
    Ql.call(n, r) && (a[r] = n[r]);
  return a[ml] = t, a;
}, oy = function(t) {
  var n = t.cache, a = t.serialized, r = t.isStringTag;
  return Kl(n, a, r), $h(function() {
    return Rh(n, a, r);
  }), null;
}, iy = /* @__PURE__ */ jh(function(e, t, n) {
  var a = e.css;
  typeof a == "string" && t.registered[a] !== void 0 && (a = t.registered[a]);
  var r = e[ml], o = [a], s = "";
  typeof e.className == "string" ? s = Ch(t.registered, o, e.className) : e.className != null && (s = e.className + " ");
  var i = yi(o, void 0, z.useContext(Jl));
  s += t.key + "-" + i.name;
  var u = {};
  for (var f in e)
    Ql.call(e, f) && f !== "css" && f !== ml && (u[f] = e[f]);
  return u.className = s, n && (u.ref = n), /* @__PURE__ */ z.createElement(z.Fragment, null, /* @__PURE__ */ z.createElement(oy, {
    cache: t,
    serialized: i,
    isStringTag: typeof r == "string"
  }), /* @__PURE__ */ z.createElement(r, u));
}), sy = iy, Cc = function(t, n) {
  var a = arguments;
  if (n == null || !Ql.call(n, "css"))
    return z.createElement.apply(void 0, a);
  var r = a.length, o = new Array(r);
  o[0] = sy, o[1] = ay(t, n);
  for (var s = 2; s < r; s++)
    o[s] = a[s];
  return z.createElement.apply(null, o);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(Cc || (Cc = {}));
function ly() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return yi(t);
}
function Yl() {
  var e = ly.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var uy = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, cy = /* @__PURE__ */ Eh(
  function(e) {
    return uy.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), fy = cy, dy = function(t) {
  return t !== "theme";
}, Rc = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? fy : dy;
}, Oc = function(t, n, a) {
  var r;
  if (n) {
    var o = n.shouldForwardProp;
    r = t.__emotion_forwardProp && o ? function(s) {
      return t.__emotion_forwardProp(s) && o(s);
    } : o;
  }
  return typeof r != "function" && a && (r = t.__emotion_forwardProp), r;
}, py = function(t) {
  var n = t.cache, a = t.serialized, r = t.isStringTag;
  return Kl(n, a, r), $h(function() {
    return Rh(n, a, r);
  }), null;
}, hy = function e(t, n) {
  var a = t.__emotion_real === t, r = a && t.__emotion_base || t, o, s;
  n !== void 0 && (o = n.label, s = n.target);
  var i = Oc(t, n, a), u = i || Rc(r), f = !u("as");
  return function() {
    var p = arguments, c = a && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (o !== void 0 && c.push("label:" + o + ";"), p[0] == null || p[0].raw === void 0)
      c.push.apply(c, p);
    else {
      var l = p[0];
      c.push(l[0]);
      for (var v = p.length, d = 1; d < v; d++)
        c.push(p[d], l[d]);
    }
    var h = jh(function(g, b, E) {
      var S = f && g.as || r, w = "", y = [], x = g;
      if (g.theme == null) {
        x = {};
        for (var P in g)
          x[P] = g[P];
        x.theme = z.useContext(Jl);
      }
      typeof g.className == "string" ? w = Ch(b.registered, y, g.className) : g.className != null && (w = g.className + " ");
      var C = yi(c.concat(y), b.registered, x);
      w += b.key + "-" + C.name, s !== void 0 && (w += " " + s);
      var R = f && i === void 0 ? Rc(S) : u, m = {};
      for (var _ in g)
        f && _ === "as" || R(_) && (m[_] = g[_]);
      return m.className = w, E && (m.ref = E), /* @__PURE__ */ z.createElement(z.Fragment, null, /* @__PURE__ */ z.createElement(py, {
        cache: b,
        serialized: C,
        isStringTag: typeof S == "string"
      }), /* @__PURE__ */ z.createElement(S, m));
    });
    return h.displayName = o !== void 0 ? o : "Styled(" + (typeof r == "string" ? r : r.displayName || r.name || "Component") + ")", h.defaultProps = t.defaultProps, h.__emotion_real = h, h.__emotion_base = r, h.__emotion_styles = c, h.__emotion_forwardProp = i, Object.defineProperty(h, "toString", {
      value: function() {
        return "." + s;
      }
    }), h.withComponent = function(g, b) {
      var E = e(g, Uo({}, n, b, {
        shouldForwardProp: Oc(h, b, !0)
      }));
      return E.apply(void 0, c);
    }, h;
  };
}, my = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], vl = hy.bind(null);
my.forEach(function(e) {
  vl[e] = vl(e);
});
/**
 * @mui/styled-engine v6.4.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function vy(e, t) {
  return vl(e, t);
}
function gy(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const $c = [];
function Tc(e) {
  return $c[0] = e, yi($c);
}
const yy = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, a) => n.val - a.val), t.reduce((n, a) => ({
    ...n,
    [a.key]: a.val
  }), {});
};
function by(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: a = 5,
    ...r
  } = e, o = yy(t), s = Object.keys(o);
  function i(l) {
    return `@media (min-width:${typeof t[l] == "number" ? t[l] : l}${n})`;
  }
  function u(l) {
    return `@media (max-width:${(typeof t[l] == "number" ? t[l] : l) - a / 100}${n})`;
  }
  function f(l, v) {
    const d = s.indexOf(v);
    return `@media (min-width:${typeof t[l] == "number" ? t[l] : l}${n}) and (max-width:${(d !== -1 && typeof t[s[d]] == "number" ? t[s[d]] : v) - a / 100}${n})`;
  }
  function p(l) {
    return s.indexOf(l) + 1 < s.length ? f(l, s[s.indexOf(l) + 1]) : i(l);
  }
  function c(l) {
    const v = s.indexOf(l);
    return v === 0 ? i(s[1]) : v === s.length - 1 ? u(s[v]) : f(l, s[s.indexOf(l) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: o,
    up: i,
    down: u,
    between: f,
    only: p,
    not: c,
    unit: n,
    ...r
  };
}
const wy = {
  borderRadius: 4
};
function Dh(e = 8, t = Ul({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...a) => (a.length === 0 ? [1] : a).map((o) => {
    const s = t(o);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" ");
  return n.mui = !0, n;
}
function Sy(e, t) {
  const n = this;
  if (n.vars) {
    if (!n.colorSchemes?.[e] || typeof n.getColorSchemeSelector != "function")
      return {};
    let a = n.getColorSchemeSelector(e);
    return a === "&" ? t : ((a.includes("data-") || a.includes(".")) && (a = `*:where(${a.replace(/\s*&$/, "")}) &`), {
      [a]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function bi(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: a = {},
    spacing: r,
    shape: o = {},
    ...s
  } = e, i = by(n), u = Dh(r);
  let f = Rt({
    breakpoints: i,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...a
    },
    spacing: u,
    shape: {
      ...wy,
      ...o
    }
  }, s);
  return f = Rg(f), f.applyStyles = Sy, f = t.reduce((p, c) => Rt(p, c), f), f.unstable_sxConfig = {
    ...Qa,
    ...s?.unstable_sxConfig
  }, f.unstable_sx = function(c) {
    return qn({
      sx: c,
      theme: this
    });
  }, f;
}
function Py(e) {
  return Object.keys(e).length === 0;
}
function xy(e = null) {
  const t = z.useContext(Jl);
  return !t || Py(t) ? e : t;
}
const Ey = bi();
function Xl(e = Ey) {
  return xy(e);
}
function kh(e) {
  const {
    variants: t,
    ...n
  } = e, a = {
    variants: t,
    style: Tc(n),
    isProcessed: !0
  };
  return a.style === n || t && t.forEach((r) => {
    typeof r.style != "function" && (r.style = Tc(r.style));
  }), a;
}
const _y = bi();
function Gi(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function Cy(e) {
  return e ? (t, n) => n[e] : null;
}
function Ry(e, t, n) {
  e.theme = $y(e.theme) ? n : e.theme[t] || e.theme;
}
function To(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((a) => To(e, a));
  if (Array.isArray(n?.variants)) {
    let a;
    if (n.isProcessed)
      a = n.style;
    else {
      const {
        variants: r,
        ...o
      } = n;
      a = o;
    }
    return Ah(e, n.variants, [a]);
  }
  return n?.isProcessed ? n.style : n;
}
function Ah(e, t, n = []) {
  let a;
  e: for (let r = 0; r < t.length; r += 1) {
    const o = t[r];
    if (typeof o.props == "function") {
      if (a ??= {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }, !o.props(a))
        continue;
    } else
      for (const s in o.props)
        if (e[s] !== o.props[s] && e.ownerState?.[s] !== o.props[s])
          continue e;
    typeof o.style == "function" ? (a ??= {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }, n.push(o.style(a))) : n.push(o.style);
  }
  return n;
}
function Mh(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = _y,
    rootShouldForwardProp: a = Gi,
    slotShouldForwardProp: r = Gi
  } = e;
  function o(i) {
    Ry(i, t, n);
  }
  return (i, u = {}) => {
    gy(i, (y) => y.filter((x) => x !== qn));
    const {
      name: f,
      slot: p,
      skipVariantsResolver: c,
      skipSx: l,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: v = Cy(jy(p)),
      ...d
    } = u, h = c !== void 0 ? c : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      p && p !== "Root" && p !== "root" || !1
    ), g = l || !1;
    let b = Gi;
    p === "Root" || p === "root" ? b = a : p ? b = r : Ty(i) && (b = void 0);
    const E = vy(i, {
      shouldForwardProp: b,
      label: Oy(),
      ...d
    }), S = (y) => {
      if (typeof y == "function" && y.__emotion_real !== y)
        return function(P) {
          return To(P, y);
        };
      if (ir(y)) {
        const x = kh(y);
        return x.variants ? function(C) {
          return To(C, x);
        } : x.style;
      }
      return y;
    }, w = (...y) => {
      const x = [], P = y.map(S), C = [];
      if (x.push(o), f && v && C.push(function(O) {
        const A = O.theme.components?.[f]?.styleOverrides;
        if (!A)
          return null;
        const M = {};
        for (const B in A)
          M[B] = To(O, A[B]);
        return v(O, M);
      }), f && !h && C.push(function(O) {
        const A = O.theme?.components?.[f]?.variants;
        return A ? Ah(O, A) : null;
      }), g || C.push(qn), Array.isArray(P[0])) {
        const _ = P.shift(), O = new Array(x.length).fill(""), T = new Array(C.length).fill("");
        let A;
        A = [...O, ..._, ...T], A.raw = [...O, ..._.raw, ...T], x.unshift(A);
      }
      const R = [...x, ...P, ...C], m = E(...R);
      return i.muiName && (m.muiName = i.muiName), m;
    };
    return E.withConfig && (w.withConfig = E.withConfig), w;
  };
}
function Oy(e, t) {
  return void 0;
}
function $y(e) {
  for (const t in e)
    return !1;
  return !0;
}
function Ty(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function jy(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const Dy = Mh();
function ky(e) {
  const {
    theme: t,
    name: n,
    props: a
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? a : zo(t.components[n].defaultProps, a);
}
function Ay({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: a
}) {
  let r = Xl(n);
  return a && (r = r[a] || r), ky({
    theme: r,
    name: t,
    props: e
  });
}
function Zl(e, t = 0, n = 1) {
  return xg(e, t, n);
}
function My(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((a) => a + a)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((a, r) => r < 3 ? parseInt(a, 16) : Math.round(parseInt(a, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function qr(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return qr(My(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(rn(9, e));
  let a = e.substring(t + 1, e.length - 1), r;
  if (n === "color") {
    if (a = a.split(" "), r = a.shift(), a.length === 4 && a[3].charAt(0) === "/" && (a[3] = a[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(r))
      throw new Error(rn(10, r));
  } else
    a = a.split(",");
  return a = a.map((o) => parseFloat(o)), {
    type: n,
    values: a,
    colorSpace: r
  };
}
const Iy = (e) => {
  const t = qr(e);
  return t.values.slice(0, 3).map((n, a) => t.type.includes("hsl") && a !== 0 ? `${n}%` : n).join(" ");
}, Pa = (e, t) => {
  try {
    return Iy(e);
  } catch {
    return e;
  }
};
function wi(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: a
  } = e;
  return t.includes("rgb") ? a = a.map((r, o) => o < 3 ? parseInt(r, 10) : r) : t.includes("hsl") && (a[1] = `${a[1]}%`, a[2] = `${a[2]}%`), t.includes("color") ? a = `${n} ${a.join(" ")}` : a = `${a.join(", ")}`, `${t}(${a})`;
}
function Ih(e) {
  e = qr(e);
  const {
    values: t
  } = e, n = t[0], a = t[1] / 100, r = t[2] / 100, o = a * Math.min(r, 1 - r), s = (f, p = (f + n / 30) % 12) => r - o * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  let i = "rgb";
  const u = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (i += "a", u.push(t[3])), wi({
    type: i,
    values: u
  });
}
function gl(e) {
  e = qr(e);
  let t = e.type === "hsl" || e.type === "hsla" ? qr(Ih(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function Ny(e, t) {
  const n = gl(e), a = gl(t);
  return (Math.max(n, a) + 0.05) / (Math.min(n, a) + 0.05);
}
function xa(e, t) {
  return e = qr(e), t = Zl(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, wi(e);
}
function po(e, t, n) {
  try {
    return xa(e, t);
  } catch {
    return e;
  }
}
function eu(e, t) {
  if (e = qr(e), t = Zl(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return wi(e);
}
function $e(e, t, n) {
  try {
    return eu(e, t);
  } catch {
    return e;
  }
}
function tu(e, t) {
  if (e = qr(e), t = Zl(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return wi(e);
}
function Te(e, t, n) {
  try {
    return tu(e, t);
  } catch {
    return e;
  }
}
function Ly(e, t = 0.15) {
  return gl(e) > 0.5 ? eu(e, t) : tu(e, t);
}
function ho(e, t, n) {
  try {
    return Ly(e, t);
  } catch {
    return e;
  }
}
const qy = /* @__PURE__ */ z.createContext(void 0);
function Fy(e) {
  const {
    theme: t,
    name: n,
    props: a
  } = e;
  if (!t || !t.components || !t.components[n])
    return a;
  const r = t.components[n];
  return r.defaultProps ? zo(r.defaultProps, a) : !r.styleOverrides && !r.variants ? zo(r, a) : a;
}
function zy({
  props: e,
  name: t
}) {
  const n = z.useContext(qy);
  return Fy({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const jc = {
  theme: void 0
};
function By(e) {
  let t, n;
  return function(r) {
    let o = t;
    return (o === void 0 || r.theme !== n) && (jc.theme = r.theme, o = kh(e(jc)), t = o, n = r.theme), o;
  };
}
function Uy(e = "") {
  function t(...a) {
    if (!a.length)
      return "";
    const r = a[0];
    return typeof r == "string" && !r.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${r}${t(...a.slice(1))})` : `, ${r}`;
  }
  return (a, ...r) => `var(--${e ? `${e}-` : ""}${a}${t(...r)})`;
}
const Dc = (e, t, n, a = []) => {
  let r = e;
  t.forEach((o, s) => {
    s === t.length - 1 ? Array.isArray(r) ? r[Number(o)] = n : r && typeof r == "object" && (r[o] = n) : r && typeof r == "object" && (r[o] || (r[o] = a.includes(o) ? [] : {}), r = r[o]);
  });
}, Hy = (e, t, n) => {
  function a(r, o = [], s = []) {
    Object.entries(r).forEach(([i, u]) => {
      (!n || n && !n([...o, i])) && u != null && (typeof u == "object" && Object.keys(u).length > 0 ? a(u, [...o, i], Array.isArray(u) ? [...s, i] : s) : t([...o, i], u, s));
    });
  }
  a(e);
}, Vy = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((a) => e.includes(a)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function Ki(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: a
  } = t || {}, r = {}, o = {}, s = {};
  return Hy(
    e,
    (i, u, f) => {
      if ((typeof u == "string" || typeof u == "number") && (!a || !a(i, u))) {
        const p = `--${n ? `${n}-` : ""}${i.join("-")}`, c = Vy(i, u);
        Object.assign(r, {
          [p]: c
        }), Dc(o, i, `var(${p})`, f), Dc(s, i, `var(${p}, ${c})`, f);
      }
    },
    (i) => i[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: r,
    vars: o,
    varsWithDefaults: s
  };
}
function Wy(e, t = {}) {
  const {
    getSelector: n = g,
    disableCssColorScheme: a,
    colorSchemeSelector: r
  } = t, {
    colorSchemes: o = {},
    components: s,
    defaultColorScheme: i = "light",
    ...u
  } = e, {
    vars: f,
    css: p,
    varsWithDefaults: c
  } = Ki(u, t);
  let l = c;
  const v = {}, {
    [i]: d,
    ...h
  } = o;
  if (Object.entries(h || {}).forEach(([S, w]) => {
    const {
      vars: y,
      css: x,
      varsWithDefaults: P
    } = Ki(w, t);
    l = Rt(l, P), v[S] = {
      css: x,
      vars: y
    };
  }), d) {
    const {
      css: S,
      vars: w,
      varsWithDefaults: y
    } = Ki(d, t);
    l = Rt(l, y), v[i] = {
      css: S,
      vars: w
    };
  }
  function g(S, w) {
    let y = r;
    if (r === "class" && (y = ".%s"), r === "data" && (y = "[data-%s]"), r?.startsWith("data-") && !r.includes("%s") && (y = `[${r}="%s"]`), S) {
      if (y === "media")
        return e.defaultColorScheme === S ? ":root" : {
          [`@media (prefers-color-scheme: ${o[S]?.palette?.mode || S})`]: {
            ":root": w
          }
        };
      if (y)
        return e.defaultColorScheme === S ? `:root, ${y.replace("%s", String(S))}` : y.replace("%s", String(S));
    }
    return ":root";
  }
  return {
    vars: l,
    generateThemeVars: () => {
      let S = {
        ...f
      };
      return Object.entries(v).forEach(([, {
        vars: w
      }]) => {
        S = Rt(S, w);
      }), S;
    },
    generateStyleSheets: () => {
      const S = [], w = e.defaultColorScheme || "light";
      function y(C, R) {
        Object.keys(R).length && S.push(typeof C == "string" ? {
          [C]: {
            ...R
          }
        } : C);
      }
      y(n(void 0, {
        ...p
      }), p);
      const {
        [w]: x,
        ...P
      } = v;
      if (x) {
        const {
          css: C
        } = x, R = o[w]?.palette?.mode, m = !a && R ? {
          colorScheme: R,
          ...C
        } : {
          ...C
        };
        y(n(w, {
          ...m
        }), m);
      }
      return Object.entries(P).forEach(([C, {
        css: R
      }]) => {
        const m = o[C]?.palette?.mode, _ = !a && m ? {
          colorScheme: m,
          ...R
        } : {
          ...R
        };
        y(n(C, {
          ..._
        }), _);
      }), S;
    }
  };
}
function Gy(e) {
  return function(n) {
    return e === "media" ? `@media (prefers-color-scheme: ${n})` : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const Ky = (e, t) => e.filter((n) => t.includes(n)), Hn = (e, t, n) => {
  const a = e.keys[0];
  Array.isArray(t) ? t.forEach((r, o) => {
    n((s, i) => {
      o <= e.keys.length - 1 && (o === 0 ? Object.assign(s, i) : s[e.up(e.keys[o])] = i);
    }, r);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : Ky(e.keys, Object.keys(t))).forEach((o) => {
    if (e.keys.includes(o)) {
      const s = t[o];
      s !== void 0 && n((i, u) => {
        a === o ? Object.assign(i, u) : i[e.up(o)] = u;
      }, s);
    }
  }) : (typeof t == "number" || typeof t == "string") && n((r, o) => {
    Object.assign(r, o);
  }, t);
};
function Vo(e) {
  return `--Grid-${e}Spacing`;
}
function Si(e) {
  return `--Grid-parent-${e}Spacing`;
}
const kc = "--Grid-columns", An = "--Grid-parent-columns", Jy = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return Hn(e.breakpoints, t.size, (a, r) => {
    let o = {};
    r === "grow" && (o = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), r === "auto" && (o = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof r == "number" && (o = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${r} / var(${An}) - (var(${An}) - ${r}) * (var(${Si("column")}) / var(${An})))`
    }), a(n, o);
  }), n;
}, Qy = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return Hn(e.breakpoints, t.offset, (a, r) => {
    let o = {};
    r === "auto" && (o = {
      marginLeft: "auto"
    }), typeof r == "number" && (o = {
      marginLeft: r === 0 ? "0px" : `calc(100% * ${r} / var(${An}) + var(${Si("column")}) * ${r} / var(${An}))`
    }), a(n, o);
  }), n;
}, Yy = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {
    [kc]: 12
  };
  return Hn(e.breakpoints, t.columns, (a, r) => {
    const o = r ?? 12;
    a(n, {
      [kc]: o,
      "> *": {
        [An]: o
      }
    });
  }), n;
}, Xy = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Hn(e.breakpoints, t.rowSpacing, (a, r) => {
    const o = typeof r == "string" ? r : e.spacing?.(r);
    a(n, {
      [Vo("row")]: o,
      "> *": {
        [Si("row")]: o
      }
    });
  }), n;
}, Zy = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Hn(e.breakpoints, t.columnSpacing, (a, r) => {
    const o = typeof r == "string" ? r : e.spacing?.(r);
    a(n, {
      [Vo("column")]: o,
      "> *": {
        [Si("column")]: o
      }
    });
  }), n;
}, eb = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Hn(e.breakpoints, t.direction, (a, r) => {
    a(n, {
      flexDirection: r
    });
  }), n;
}, tb = ({
  ownerState: e
}) => ({
  minWidth: 0,
  boxSizing: "border-box",
  ...e.container && {
    display: "flex",
    flexWrap: "wrap",
    ...e.wrap && e.wrap !== "wrap" && {
      flexWrap: e.wrap
    },
    gap: `var(${Vo("row")}) var(${Vo("column")})`
  }
}), rb = (e) => {
  const t = [];
  return Object.entries(e).forEach(([n, a]) => {
    a !== !1 && a !== void 0 && t.push(`grid-${n}-${String(a)}`);
  }), t;
}, nb = (e, t = "xs") => {
  function n(a) {
    return a === void 0 ? !1 : typeof a == "string" && !Number.isNaN(Number(a)) || typeof a == "number" && a > 0;
  }
  if (n(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const a = [];
    return Object.entries(e).forEach(([r, o]) => {
      n(o) && a.push(`spacing-${r}-${String(o)}`);
    }), a;
  }
  return [];
}, ab = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, n]) => `direction-${t}-${n}`) : [`direction-xs-${String(e)}`], ob = bi(), ib = Dy("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function sb(e) {
  return Ay({
    props: e,
    name: "MuiGrid",
    defaultTheme: ob
  });
}
function lb(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = ib,
    useThemeProps: n = sb,
    useTheme: a = Xl,
    componentName: r = "MuiGrid"
  } = e, o = (f, p) => {
    const {
      container: c,
      direction: l,
      spacing: v,
      wrap: d,
      size: h
    } = f, g = {
      root: ["root", c && "container", d !== "wrap" && `wrap-xs-${String(d)}`, ...ab(l), ...rb(h), ...c ? nb(v, p.breakpoints.keys[0]) : []]
    };
    return ii(g, (b) => Ga(r, b), {});
  };
  function s(f, p, c = () => !0) {
    const l = {};
    return f === null || (Array.isArray(f) ? f.forEach((v, d) => {
      v !== null && c(v) && p.keys[d] && (l[p.keys[d]] = v);
    }) : typeof f == "object" ? Object.keys(f).forEach((v) => {
      const d = f[v];
      d != null && c(d) && (l[v] = d);
    }) : l[p.keys[0]] = f), l;
  }
  const i = t(Yy, Zy, Xy, Jy, eb, tb, Qy), u = /* @__PURE__ */ z.forwardRef(function(p, c) {
    const l = a(), v = n(p), d = g0(v), {
      className: h,
      children: g,
      columns: b = 12,
      container: E = !1,
      component: S = "div",
      direction: w = "row",
      wrap: y = "wrap",
      size: x = {},
      offset: P = {},
      spacing: C = 0,
      rowSpacing: R = C,
      columnSpacing: m = C,
      unstable_level: _ = 0,
      ...O
    } = d, T = s(x, l.breakpoints, (le) => le !== !1), A = s(P, l.breakpoints), M = p.columns ?? (_ ? void 0 : b), B = p.spacing ?? (_ ? void 0 : C), J = p.rowSpacing ?? p.spacing ?? (_ ? void 0 : R), Q = p.columnSpacing ?? p.spacing ?? (_ ? void 0 : m), Z = {
      ...d,
      level: _,
      columns: M,
      container: E,
      direction: w,
      wrap: y,
      spacing: B,
      rowSpacing: J,
      columnSpacing: Q,
      size: T,
      offset: A
    }, te = o(Z, l);
    return /* @__PURE__ */ V.jsx(i, {
      ref: c,
      as: S,
      ownerState: Z,
      className: wt(te.root, h),
      ...O,
      children: z.Children.map(g, (le) => /* @__PURE__ */ z.isValidElement(le) && mg(le, ["Grid"]) && E && le.props.container ? /* @__PURE__ */ z.cloneElement(le, {
        unstable_level: le.props?.unstable_level ?? _ + 1
      }) : le)
    });
  });
  return u.muiName = "Grid", u;
}
const Na = {
  black: "#000",
  white: "#fff"
}, dn = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, pn = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, sa = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, hn = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, mn = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, Dr = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function Nh() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Na.white,
      default: Na.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const ub = Nh();
function Lh() {
  return {
    text: {
      primary: Na.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Na.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const Ac = Lh();
function Mc(e, t, n, a) {
  const r = a.light || a, o = a.dark || a * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = tu(e.main, r) : t === "dark" && (e.dark = eu(e.main, o)));
}
function cb(e = "light") {
  return e === "dark" ? {
    main: hn[200],
    light: hn[50],
    dark: hn[400]
  } : {
    main: hn[700],
    light: hn[400],
    dark: hn[800]
  };
}
function fb(e = "light") {
  return e === "dark" ? {
    main: dn[200],
    light: dn[50],
    dark: dn[400]
  } : {
    main: dn[500],
    light: dn[300],
    dark: dn[700]
  };
}
function db(e = "light") {
  return e === "dark" ? {
    main: pn[500],
    light: pn[300],
    dark: pn[700]
  } : {
    main: pn[700],
    light: pn[400],
    dark: pn[800]
  };
}
function pb(e = "light") {
  return e === "dark" ? {
    main: mn[400],
    light: mn[300],
    dark: mn[700]
  } : {
    main: mn[700],
    light: mn[500],
    dark: mn[900]
  };
}
function hb(e = "light") {
  return e === "dark" ? {
    main: Dr[400],
    light: Dr[300],
    dark: Dr[700]
  } : {
    main: Dr[800],
    light: Dr[500],
    dark: Dr[900]
  };
}
function mb(e = "light") {
  return e === "dark" ? {
    main: sa[400],
    light: sa[300],
    dark: sa[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: sa[500],
    dark: sa[900]
  };
}
function ru(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: a = 0.2,
    ...r
  } = e, o = e.primary || cb(t), s = e.secondary || fb(t), i = e.error || db(t), u = e.info || pb(t), f = e.success || hb(t), p = e.warning || mb(t);
  function c(h) {
    return Ny(h, Ac.text.primary) >= n ? Ac.text.primary : ub.text.primary;
  }
  const l = ({
    color: h,
    name: g,
    mainShade: b = 500,
    lightShade: E = 300,
    darkShade: S = 700
  }) => {
    if (h = {
      ...h
    }, !h.main && h[b] && (h.main = h[b]), !h.hasOwnProperty("main"))
      throw new Error(rn(11, g ? ` (${g})` : "", b));
    if (typeof h.main != "string")
      throw new Error(rn(12, g ? ` (${g})` : "", JSON.stringify(h.main)));
    return Mc(h, "light", E, a), Mc(h, "dark", S, a), h.contrastText || (h.contrastText = c(h.main)), h;
  };
  let v;
  return t === "light" ? v = Nh() : t === "dark" && (v = Lh()), Rt({
    // A collection of common colors.
    common: {
      ...Na
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: l({
      color: o,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: l({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: l({
      color: i,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: l({
      color: p,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: l({
      color: u,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: l({
      color: f,
      name: "success"
    }),
    // The grey colors.
    grey: _o,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: c,
    // Generate a rich color object.
    augmentColor: l,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: a,
    // The light and dark mode object.
    ...v
  }, r);
}
function vb(e) {
  const t = {};
  return Object.entries(e).forEach((a) => {
    const [r, o] = a;
    typeof o == "object" && (t[r] = `${o.fontStyle ? `${o.fontStyle} ` : ""}${o.fontVariant ? `${o.fontVariant} ` : ""}${o.fontWeight ? `${o.fontWeight} ` : ""}${o.fontStretch ? `${o.fontStretch} ` : ""}${o.fontSize || ""}${o.lineHeight ? `/${o.lineHeight} ` : ""}${o.fontFamily || ""}`);
  }), t;
}
function gb(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function yb(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Ic = {
  textTransform: "uppercase"
}, Nc = '"Roboto", "Helvetica", "Arial", sans-serif';
function bb(e, t) {
  const {
    fontFamily: n = Nc,
    // The default font size of the Material Specification.
    fontSize: a = 14,
    // px
    fontWeightLight: r = 300,
    fontWeightRegular: o = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: i = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: u = 16,
    // Apply the CSS properties to all the variants.
    allVariants: f,
    pxToRem: p,
    ...c
  } = typeof t == "function" ? t(e) : t, l = a / 14, v = p || ((g) => `${g / u * l}rem`), d = (g, b, E, S, w) => ({
    fontFamily: n,
    fontWeight: g,
    fontSize: v(b),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: E,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === Nc ? {
      letterSpacing: `${yb(S / b)}em`
    } : {},
    ...w,
    ...f
  }), h = {
    h1: d(r, 96, 1.167, -1.5),
    h2: d(r, 60, 1.2, -0.5),
    h3: d(o, 48, 1.167, 0),
    h4: d(o, 34, 1.235, 0.25),
    h5: d(o, 24, 1.334, 0),
    h6: d(s, 20, 1.6, 0.15),
    subtitle1: d(o, 16, 1.75, 0.15),
    subtitle2: d(s, 14, 1.57, 0.1),
    body1: d(o, 16, 1.5, 0.15),
    body2: d(o, 14, 1.43, 0.15),
    button: d(s, 14, 1.75, 0.4, Ic),
    caption: d(o, 12, 1.66, 0.4),
    overline: d(o, 12, 2.66, 1, Ic),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Rt({
    htmlFontSize: u,
    pxToRem: v,
    fontFamily: n,
    fontSize: a,
    fontWeightLight: r,
    fontWeightRegular: o,
    fontWeightMedium: s,
    fontWeightBold: i,
    ...h
  }, c, {
    clone: !1
    // No need to clone deep
  });
}
const wb = 0.2, Sb = 0.14, Pb = 0.12;
function qe(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${wb})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Sb})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Pb})`].join(",");
}
const xb = ["none", qe(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), qe(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), qe(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), qe(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), qe(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), qe(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), qe(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), qe(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), qe(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), qe(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), qe(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), qe(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), qe(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), qe(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), qe(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), qe(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), qe(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), qe(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), qe(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), qe(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), qe(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), qe(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), qe(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), qe(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], Eb = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, _b = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Lc(e) {
  return `${Math.round(e)}ms`;
}
function Cb(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function Rb(e) {
  const t = {
    ...Eb,
    ...e.easing
  }, n = {
    ..._b,
    ...e.duration
  };
  return {
    getAutoHeightDuration: Cb,
    create: (r = ["all"], o = {}) => {
      const {
        duration: s = n.standard,
        easing: i = t.easeInOut,
        delay: u = 0,
        ...f
      } = o;
      return (Array.isArray(r) ? r : [r]).map((p) => `${p} ${typeof s == "string" ? s : Lc(s)} ${i} ${typeof u == "string" ? u : Lc(u)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const Ob = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function $b(e) {
  return ir(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function qh(e = {}) {
  const t = {
    ...e
  };
  function n(a) {
    const r = Object.entries(a);
    for (let o = 0; o < r.length; o++) {
      const [s, i] = r[o];
      !$b(i) || s.startsWith("unstable_") ? delete a[s] : ir(i) && (a[s] = {
        ...i
      }, n(a[s]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function yl(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: a = {},
    spacing: r,
    palette: o = {},
    transitions: s = {},
    typography: i = {},
    shape: u,
    ...f
  } = e;
  if (e.vars)
    throw new Error(rn(20));
  const p = ru(o), c = bi(e);
  let l = Rt(c, {
    mixins: gb(c.breakpoints, a),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: xb.slice(),
    typography: bb(p, i),
    transitions: Rb(s),
    zIndex: {
      ...Ob
    }
  });
  return l = Rt(l, f), l = t.reduce((v, d) => Rt(v, d), l), l.unstable_sxConfig = {
    ...Qa,
    ...f?.unstable_sxConfig
  }, l.unstable_sx = function(d) {
    return qn({
      sx: d,
      theme: this
    });
  }, l.toRuntimeSource = qh, l;
}
function Tb(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const jb = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = Tb(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function Fh(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function zh(e) {
  return e === "dark" ? jb : [];
}
function Db(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: a,
    ...r
  } = e, o = ru(t);
  return {
    palette: o,
    opacity: {
      ...Fh(o.mode),
      ...n
    },
    overlays: a || zh(o.mode),
    ...r
  };
}
function kb(e) {
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!e[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}
const Ab = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], Mb = (e) => (t, n) => {
  const a = e.rootSelector || ":root", r = e.colorSchemeSelector;
  let o = r;
  if (r === "class" && (o = ".%s"), r === "data" && (o = "[data-%s]"), r?.startsWith("data-") && !r.includes("%s") && (o = `[${r}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return Ab(e.cssVarPrefix).forEach((i) => {
        s[i] = n[i], delete n[i];
      }), o === "media" ? {
        [a]: n,
        "@media (prefers-color-scheme: dark)": {
          [a]: s
        }
      } : o ? {
        [o.replace("%s", t)]: s,
        [`${a}, ${o.replace("%s", t)}`]: n
      } : {
        [a]: {
          ...n,
          ...s
        }
      };
    }
    if (o && o !== "media")
      return `${a}, ${o.replace("%s", String(t))}`;
  } else if (t) {
    if (o === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [a]: n
        }
      };
    if (o)
      return o.replace("%s", String(t));
  }
  return a;
};
function Ib(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function U(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function Ea(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : Ih(e);
}
function hr(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = Pa(Ea(e[t])));
}
function Nb(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Jt = (e) => {
  try {
    return e();
  } catch {
  }
}, Lb = (e = "mui") => Uy(e);
function Ji(e, t, n, a) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const r = a === "dark" ? "dark" : "light";
  if (!n) {
    e[a] = Db({
      ...t,
      palette: {
        mode: r,
        ...t?.palette
      }
    });
    return;
  }
  const {
    palette: o,
    ...s
  } = yl({
    ...n,
    palette: {
      mode: r,
      ...t?.palette
    }
  });
  return e[a] = {
    ...t,
    palette: o,
    opacity: {
      ...Fh(r),
      ...t?.opacity
    },
    overlays: t?.overlays || zh(r)
  }, s;
}
function qb(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: a,
    disableCssColorScheme: r = !1,
    cssVarPrefix: o = "mui",
    shouldSkipGeneratingVar: s = kb,
    colorSchemeSelector: i = n.light && n.dark ? "media" : void 0,
    rootSelector: u = ":root",
    ...f
  } = e, p = Object.keys(n)[0], c = a || (n.light && p !== "light" ? "light" : p), l = Lb(o), {
    [c]: v,
    light: d,
    dark: h,
    ...g
  } = n, b = {
    ...g
  };
  let E = v;
  if ((c === "dark" && !("dark" in n) || c === "light" && !("light" in n)) && (E = !0), !E)
    throw new Error(rn(21, c));
  const S = Ji(b, E, f, c);
  d && !b.light && Ji(b, d, void 0, "light"), h && !b.dark && Ji(b, h, void 0, "dark");
  let w = {
    defaultColorScheme: c,
    ...S,
    cssVarPrefix: o,
    colorSchemeSelector: i,
    rootSelector: u,
    getCssVar: l,
    colorSchemes: b,
    font: {
      ...vb(S.typography),
      ...S.font
    },
    spacing: Nb(f.spacing)
  };
  Object.keys(w.colorSchemes).forEach((R) => {
    const m = w.colorSchemes[R].palette, _ = (O) => {
      const T = O.split("-"), A = T[1], M = T[2];
      return l(O, m[A][M]);
    };
    if (m.mode === "light" && (U(m.common, "background", "#fff"), U(m.common, "onBackground", "#000")), m.mode === "dark" && (U(m.common, "background", "#000"), U(m.common, "onBackground", "#fff")), Ib(m, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), m.mode === "light") {
      U(m.Alert, "errorColor", $e(m.error.light, 0.6)), U(m.Alert, "infoColor", $e(m.info.light, 0.6)), U(m.Alert, "successColor", $e(m.success.light, 0.6)), U(m.Alert, "warningColor", $e(m.warning.light, 0.6)), U(m.Alert, "errorFilledBg", _("palette-error-main")), U(m.Alert, "infoFilledBg", _("palette-info-main")), U(m.Alert, "successFilledBg", _("palette-success-main")), U(m.Alert, "warningFilledBg", _("palette-warning-main")), U(m.Alert, "errorFilledColor", Jt(() => m.getContrastText(m.error.main))), U(m.Alert, "infoFilledColor", Jt(() => m.getContrastText(m.info.main))), U(m.Alert, "successFilledColor", Jt(() => m.getContrastText(m.success.main))), U(m.Alert, "warningFilledColor", Jt(() => m.getContrastText(m.warning.main))), U(m.Alert, "errorStandardBg", Te(m.error.light, 0.9)), U(m.Alert, "infoStandardBg", Te(m.info.light, 0.9)), U(m.Alert, "successStandardBg", Te(m.success.light, 0.9)), U(m.Alert, "warningStandardBg", Te(m.warning.light, 0.9)), U(m.Alert, "errorIconColor", _("palette-error-main")), U(m.Alert, "infoIconColor", _("palette-info-main")), U(m.Alert, "successIconColor", _("palette-success-main")), U(m.Alert, "warningIconColor", _("palette-warning-main")), U(m.AppBar, "defaultBg", _("palette-grey-100")), U(m.Avatar, "defaultBg", _("palette-grey-400")), U(m.Button, "inheritContainedBg", _("palette-grey-300")), U(m.Button, "inheritContainedHoverBg", _("palette-grey-A100")), U(m.Chip, "defaultBorder", _("palette-grey-400")), U(m.Chip, "defaultAvatarColor", _("palette-grey-700")), U(m.Chip, "defaultIconColor", _("palette-grey-700")), U(m.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), U(m.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), U(m.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), U(m.LinearProgress, "primaryBg", Te(m.primary.main, 0.62)), U(m.LinearProgress, "secondaryBg", Te(m.secondary.main, 0.62)), U(m.LinearProgress, "errorBg", Te(m.error.main, 0.62)), U(m.LinearProgress, "infoBg", Te(m.info.main, 0.62)), U(m.LinearProgress, "successBg", Te(m.success.main, 0.62)), U(m.LinearProgress, "warningBg", Te(m.warning.main, 0.62)), U(m.Skeleton, "bg", `rgba(${_("palette-text-primaryChannel")} / 0.11)`), U(m.Slider, "primaryTrack", Te(m.primary.main, 0.62)), U(m.Slider, "secondaryTrack", Te(m.secondary.main, 0.62)), U(m.Slider, "errorTrack", Te(m.error.main, 0.62)), U(m.Slider, "infoTrack", Te(m.info.main, 0.62)), U(m.Slider, "successTrack", Te(m.success.main, 0.62)), U(m.Slider, "warningTrack", Te(m.warning.main, 0.62));
      const O = ho(m.background.default, 0.8);
      U(m.SnackbarContent, "bg", O), U(m.SnackbarContent, "color", Jt(() => m.getContrastText(O))), U(m.SpeedDialAction, "fabHoverBg", ho(m.background.paper, 0.15)), U(m.StepConnector, "border", _("palette-grey-400")), U(m.StepContent, "border", _("palette-grey-400")), U(m.Switch, "defaultColor", _("palette-common-white")), U(m.Switch, "defaultDisabledColor", _("palette-grey-100")), U(m.Switch, "primaryDisabledColor", Te(m.primary.main, 0.62)), U(m.Switch, "secondaryDisabledColor", Te(m.secondary.main, 0.62)), U(m.Switch, "errorDisabledColor", Te(m.error.main, 0.62)), U(m.Switch, "infoDisabledColor", Te(m.info.main, 0.62)), U(m.Switch, "successDisabledColor", Te(m.success.main, 0.62)), U(m.Switch, "warningDisabledColor", Te(m.warning.main, 0.62)), U(m.TableCell, "border", Te(po(m.divider, 1), 0.88)), U(m.Tooltip, "bg", po(m.grey[700], 0.92));
    }
    if (m.mode === "dark") {
      U(m.Alert, "errorColor", Te(m.error.light, 0.6)), U(m.Alert, "infoColor", Te(m.info.light, 0.6)), U(m.Alert, "successColor", Te(m.success.light, 0.6)), U(m.Alert, "warningColor", Te(m.warning.light, 0.6)), U(m.Alert, "errorFilledBg", _("palette-error-dark")), U(m.Alert, "infoFilledBg", _("palette-info-dark")), U(m.Alert, "successFilledBg", _("palette-success-dark")), U(m.Alert, "warningFilledBg", _("palette-warning-dark")), U(m.Alert, "errorFilledColor", Jt(() => m.getContrastText(m.error.dark))), U(m.Alert, "infoFilledColor", Jt(() => m.getContrastText(m.info.dark))), U(m.Alert, "successFilledColor", Jt(() => m.getContrastText(m.success.dark))), U(m.Alert, "warningFilledColor", Jt(() => m.getContrastText(m.warning.dark))), U(m.Alert, "errorStandardBg", $e(m.error.light, 0.9)), U(m.Alert, "infoStandardBg", $e(m.info.light, 0.9)), U(m.Alert, "successStandardBg", $e(m.success.light, 0.9)), U(m.Alert, "warningStandardBg", $e(m.warning.light, 0.9)), U(m.Alert, "errorIconColor", _("palette-error-main")), U(m.Alert, "infoIconColor", _("palette-info-main")), U(m.Alert, "successIconColor", _("palette-success-main")), U(m.Alert, "warningIconColor", _("palette-warning-main")), U(m.AppBar, "defaultBg", _("palette-grey-900")), U(m.AppBar, "darkBg", _("palette-background-paper")), U(m.AppBar, "darkColor", _("palette-text-primary")), U(m.Avatar, "defaultBg", _("palette-grey-600")), U(m.Button, "inheritContainedBg", _("palette-grey-800")), U(m.Button, "inheritContainedHoverBg", _("palette-grey-700")), U(m.Chip, "defaultBorder", _("palette-grey-700")), U(m.Chip, "defaultAvatarColor", _("palette-grey-300")), U(m.Chip, "defaultIconColor", _("palette-grey-300")), U(m.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), U(m.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), U(m.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), U(m.LinearProgress, "primaryBg", $e(m.primary.main, 0.5)), U(m.LinearProgress, "secondaryBg", $e(m.secondary.main, 0.5)), U(m.LinearProgress, "errorBg", $e(m.error.main, 0.5)), U(m.LinearProgress, "infoBg", $e(m.info.main, 0.5)), U(m.LinearProgress, "successBg", $e(m.success.main, 0.5)), U(m.LinearProgress, "warningBg", $e(m.warning.main, 0.5)), U(m.Skeleton, "bg", `rgba(${_("palette-text-primaryChannel")} / 0.13)`), U(m.Slider, "primaryTrack", $e(m.primary.main, 0.5)), U(m.Slider, "secondaryTrack", $e(m.secondary.main, 0.5)), U(m.Slider, "errorTrack", $e(m.error.main, 0.5)), U(m.Slider, "infoTrack", $e(m.info.main, 0.5)), U(m.Slider, "successTrack", $e(m.success.main, 0.5)), U(m.Slider, "warningTrack", $e(m.warning.main, 0.5));
      const O = ho(m.background.default, 0.98);
      U(m.SnackbarContent, "bg", O), U(m.SnackbarContent, "color", Jt(() => m.getContrastText(O))), U(m.SpeedDialAction, "fabHoverBg", ho(m.background.paper, 0.15)), U(m.StepConnector, "border", _("palette-grey-600")), U(m.StepContent, "border", _("palette-grey-600")), U(m.Switch, "defaultColor", _("palette-grey-300")), U(m.Switch, "defaultDisabledColor", _("palette-grey-600")), U(m.Switch, "primaryDisabledColor", $e(m.primary.main, 0.55)), U(m.Switch, "secondaryDisabledColor", $e(m.secondary.main, 0.55)), U(m.Switch, "errorDisabledColor", $e(m.error.main, 0.55)), U(m.Switch, "infoDisabledColor", $e(m.info.main, 0.55)), U(m.Switch, "successDisabledColor", $e(m.success.main, 0.55)), U(m.Switch, "warningDisabledColor", $e(m.warning.main, 0.55)), U(m.TableCell, "border", $e(po(m.divider, 1), 0.68)), U(m.Tooltip, "bg", po(m.grey[700], 0.92));
    }
    hr(m.background, "default"), hr(m.background, "paper"), hr(m.common, "background"), hr(m.common, "onBackground"), hr(m, "divider"), Object.keys(m).forEach((O) => {
      const T = m[O];
      O !== "tonalOffset" && T && typeof T == "object" && (T.main && U(m[O], "mainChannel", Pa(Ea(T.main))), T.light && U(m[O], "lightChannel", Pa(Ea(T.light))), T.dark && U(m[O], "darkChannel", Pa(Ea(T.dark))), T.contrastText && U(m[O], "contrastTextChannel", Pa(Ea(T.contrastText))), O === "text" && (hr(m[O], "primary"), hr(m[O], "secondary")), O === "action" && (T.active && hr(m[O], "active"), T.selected && hr(m[O], "selected")));
    });
  }), w = t.reduce((R, m) => Rt(R, m), w);
  const y = {
    prefix: o,
    disableCssColorScheme: r,
    shouldSkipGeneratingVar: s,
    getSelector: Mb(w)
  }, {
    vars: x,
    generateThemeVars: P,
    generateStyleSheets: C
  } = Wy(w, y);
  return w.vars = x, Object.entries(w.colorSchemes[w.defaultColorScheme]).forEach(([R, m]) => {
    w[R] = m;
  }), w.generateThemeVars = P, w.generateStyleSheets = C, w.generateSpacing = function() {
    return Dh(f.spacing, Ul(this));
  }, w.getColorSchemeSelector = Gy(i), w.spacing = w.generateSpacing(), w.shouldSkipGeneratingVar = s, w.unstable_sxConfig = {
    ...Qa,
    ...f?.unstable_sxConfig
  }, w.unstable_sx = function(m) {
    return qn({
      sx: m,
      theme: this
    });
  }, w.toRuntimeSource = qh, w;
}
function qc(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: ru({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function Fb(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: a = !1,
    colorSchemes: r = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: o = n?.mode,
    ...s
  } = e, i = o || "light", u = r?.[i], f = {
    ...r,
    ...n ? {
      [i]: {
        ...typeof u != "boolean" && u,
        palette: n
      }
    } : void 0
  };
  if (a === !1) {
    if (!("colorSchemes" in e))
      return yl(e, ...t);
    let p = n;
    "palette" in e || f[i] && (f[i] !== !0 ? p = f[i].palette : i === "dark" && (p = {
      mode: "dark"
    }));
    const c = yl({
      ...e,
      palette: p
    }, ...t);
    return c.defaultColorScheme = i, c.colorSchemes = f, c.palette.mode === "light" && (c.colorSchemes.light = {
      ...f.light !== !0 && f.light,
      palette: c.palette
    }, qc(c, "dark", f.dark)), c.palette.mode === "dark" && (c.colorSchemes.dark = {
      ...f.dark !== !0 && f.dark,
      palette: c.palette
    }, qc(c, "light", f.light)), c;
  }
  return !n && !("light" in f) && i === "light" && (f.light = !0), qb({
    ...s,
    colorSchemes: f,
    defaultColorScheme: i,
    ...typeof a != "boolean" && a
  }, ...t);
}
const Bh = Fb(), Uh = "$$material";
function zb() {
  const e = Xl(Bh);
  return e[Uh] || e;
}
function Bb(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Hh = (e) => Bb(e) && e !== "classes", Vn = Mh({
  themeId: Uh,
  defaultTheme: Bh,
  rootShouldForwardProp: Hh
}), Vh = By;
function Xa(e) {
  return zy(e);
}
function Ub(e) {
  return Ga("MuiSvgIcon", e);
}
si("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const Hb = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: a
  } = e, r = {
    root: ["root", t !== "inherit" && `color${Ln(t)}`, `fontSize${Ln(n)}`]
  };
  return ii(r, Ub, a);
}, Vb = Vn("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Ln(n.color)}`], t[`fontSize${Ln(n.fontSize)}`]];
  }
})(Vh(({
  theme: e
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  display: "inline-block",
  flexShrink: 0,
  transition: e.transitions?.create?.("fill", {
    duration: (e.vars ?? e).transitions?.duration?.shorter
  }),
  variants: [
    {
      props: (t) => !t.hasSvgAsChild,
      style: {
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: "currentColor"
      }
    },
    {
      props: {
        fontSize: "inherit"
      },
      style: {
        fontSize: "inherit"
      }
    },
    {
      props: {
        fontSize: "small"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(20) || "1.25rem"
      }
    },
    {
      props: {
        fontSize: "medium"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(24) || "1.5rem"
      }
    },
    {
      props: {
        fontSize: "large"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(35) || "2.1875rem"
      }
    },
    // TODO v5 deprecate color prop, v6 remove for sx
    ...Object.entries((e.vars ?? e).palette).filter(([, t]) => t && t.main).map(([t]) => ({
      props: {
        color: t
      },
      style: {
        color: (e.vars ?? e).palette?.[t]?.main
      }
    })),
    {
      props: {
        color: "action"
      },
      style: {
        color: (e.vars ?? e).palette?.action?.active
      }
    },
    {
      props: {
        color: "disabled"
      },
      style: {
        color: (e.vars ?? e).palette?.action?.disabled
      }
    },
    {
      props: {
        color: "inherit"
      },
      style: {
        color: void 0
      }
    }
  ]
}))), bl = /* @__PURE__ */ z.forwardRef(function(t, n) {
  const a = Xa({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: r,
    className: o,
    color: s = "inherit",
    component: i = "svg",
    fontSize: u = "medium",
    htmlColor: f,
    inheritViewBox: p = !1,
    titleAccess: c,
    viewBox: l = "0 0 24 24",
    ...v
  } = a, d = /* @__PURE__ */ z.isValidElement(r) && r.type === "svg", h = {
    ...a,
    color: s,
    component: i,
    fontSize: u,
    instanceFontSize: t.fontSize,
    inheritViewBox: p,
    viewBox: l,
    hasSvgAsChild: d
  }, g = {};
  p || (g.viewBox = l);
  const b = Hb(h);
  return /* @__PURE__ */ V.jsxs(Vb, {
    as: i,
    className: wt(b.root, o),
    focusable: "false",
    color: f,
    "aria-hidden": c ? void 0 : !0,
    role: c ? "img" : void 0,
    ref: n,
    ...g,
    ...v,
    ...d && r.props,
    ownerState: h,
    children: [d ? r.props.children : r, c ? /* @__PURE__ */ V.jsx("title", {
      children: c
    }) : null]
  });
});
bl.muiName = "SvgIcon";
function cr(e, t) {
  function n(a, r) {
    return /* @__PURE__ */ V.jsx(bl, {
      "data-testid": `${t}Icon`,
      ref: r,
      ...a,
      children: e
    });
  }
  return n.muiName = bl.muiName, /* @__PURE__ */ z.memo(/* @__PURE__ */ z.forwardRef(n));
}
const Fc = cr(/* @__PURE__ */ V.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 14.5v-9l6 4.5z"
}), "PlayCircleFilled"), Wb = cr(/* @__PURE__ */ V.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), Gb = cr(/* @__PURE__ */ V.jsx("path", {
  d: "M7 2v11h3v9l7-12h-4l4-8z"
}), "FlashOn"), Kb = cr(/* @__PURE__ */ V.jsx("path", {
  d: "M3.27 3 2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73zM17 10h-4l4-8H7v2.18l8.46 8.46z"
}), "FlashOff"), Jb = cr(/* @__PURE__ */ V.jsx("path", {
  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z"
}), "History"), Qb = cr(/* @__PURE__ */ V.jsx("path", {
  d: "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m-9 3h2v2h-2zm0 3h2v2h-2zM8 8h2v2H8zm0 3h2v2H8zm-1 2H5v-2h2zm0-3H5V8h2zm9 7H8v-2h8zm0-4h-2v-2h2zm0-3h-2V8h2zm3 3h-2v-2h2zm0-3h-2V8h2z"
}), "Keyboard"), Wh = cr(/* @__PURE__ */ V.jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add"), Yb = cr(/* @__PURE__ */ V.jsx("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm2 16H8v-2h8zm0-4H8v-2h8zm-3-5V3.5L18.5 9z"
}), "Description"), Ar = lb({
  createStyledComponent: Vn("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: n
      } = e;
      return [t.root, n.container && t.container];
    }
  }),
  componentName: "MuiGrid2",
  useThemeProps: (e) => Xa({
    props: e,
    name: "MuiGrid2"
  }),
  useTheme: zb
}), Xb = cr(/* @__PURE__ */ V.jsx("path", {
  d: "M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54s-2.94 8.27-7 9.54c.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2"
}), "Brightness3"), Zb = cr(/* @__PURE__ */ V.jsx("path", {
  d: "m6.76 4.84-1.8-1.79-1.41 1.41 1.79 1.79zM4 10.5H1v2h3zm9-9.95h-2V3.5h2zm7.45 3.91-1.41-1.41-1.79 1.79 1.41 1.41zm-3.21 13.7 1.79 1.8 1.41-1.41-1.8-1.79zM20 10.5v2h3v-2zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6m-1 16.95h2V19.5h-2zm-7.45-3.91 1.41 1.41 1.79-1.8-1.41-1.41z"
}), "WbSunny"), e1 = {
  jsonrpc: "2.0",
  method: "",
  params: [],
  id: 0
}, t1 = (e) => {
  const [t, n] = ke(0), [a, r] = ke(
    e || [{ name: "New Tab", content: e1, url: void 0, logs: [] }]
  ), o = (v, d) => {
    if (a.length === 1)
      return;
    const h = a.filter((g, b) => b !== d);
    r(h);
  };
  Me(() => {
    if (a.length === 0) {
      n(0);
      return;
    }
    if (t >= a.length) {
      n(a.length - 1);
      return;
    }
    a[t] || n(a.length - 1);
  }, [a, t]);
  const s = (v, d) => {
    const h = a.map((g) => g === v ? {
      ...g,
      name: d
    } : g);
    r(h);
  };
  return {
    setTabContent: (v, d) => {
      const h = a.map((g, b) => b === v ? {
        ...g,
        content: d
      } : g);
      r(h);
    },
    setTabEditing: (v, d) => {
      const h = a.map((g) => g === v ? {
        ...g,
        editing: d
      } : g);
      r(h);
    },
    setTabIndex: n,
    setTabName: s,
    tabs: a,
    setTabs: r,
    handleClose: o,
    tabIndex: t,
    handleLabelChange: (v, d) => {
      s(d, v.target.value);
    },
    setTabUrl: (v, d) => {
      const h = a.map((g, b) => b === v ? {
        ...g,
        url: d
      } : g);
      r(h);
    },
    setTabLogs: (v, d) => {
      const h = a.map((g, b) => b === v ? {
        ...g,
        logs: d
      } : g);
      r(h);
    },
    setTabOpenRPCDocument: (v, d) => {
      const h = a.map((g, b) => b === v ? d ? {
        ...g,
        openrpcDocument: d
      } : {
        name: g.name,
        content: g.content,
        logs: g.logs,
        editing: g.editing,
        url: g.url
      } : g);
      r(h);
    }
  };
};
function r1(e, t, n) {
  n === void 0 && (n = {});
  var a = n.maxWait, r = ct(null), o = ct([]), s = n.leading, i = n.trailing === void 0 ? !0 : n.trailing, u = ct(!1), f = ct(null), p = ct(!1), c = ct(e);
  c.current = e;
  var l = Mr(function() {
    clearTimeout(f.current), clearTimeout(r.current), r.current = null, o.current = [], f.current = null, u.current = !1;
  }, []);
  Me(function() {
    return p.current = !1, function() {
      p.current = !0;
    };
  }, []);
  var v = Mr(function() {
    for (var h = [], g = 0; g < arguments.length; g++)
      h[g] = arguments[g];
    o.current = h, clearTimeout(f.current), u.current && (u.current = !1), !f.current && s && !u.current && (c.current.apply(c, h), u.current = !0), f.current = setTimeout(function() {
      var b = !0;
      s && u.current && (b = !1), l(), !p.current && i && b && c.current.apply(c, h);
    }, t), a && !r.current && i && (r.current = setTimeout(function() {
      var b = o.current;
      l(), p.current || c.current.apply(null, b);
    }, a));
  }, [a, t, l, s, i]), d = Mr(function() {
    f.current && (c.current.apply(null, o.current), l());
  }, [l]);
  return [v, l, d];
}
function n1(e, t) {
  return e === t;
}
function zc(e, t, n) {
  var a = n1, r = ke(e), o = r[0], s = r[1], i = r1(Mr(function(l) {
    return s(l);
  }, []), t, n), u = i[0], f = i[1], p = i[2], c = ct(e);
  return Me(function() {
    a(c.current, e) || (u(e), c.current = e);
  }, [e, u, a]), [o, f, p];
}
var zt = {}, Ye = {}, pt = {}, la = {}, ht = {}, Wr = {}, Bc;
function a1() {
  return Bc || (Bc = 1, function(e) {
    var t = Wr && Wr.__assign || function() {
      return t = Object.assign || function(i) {
        for (var u, f = 1, p = arguments.length; f < p; f++) {
          u = arguments[f];
          for (var c in u) Object.prototype.hasOwnProperty.call(u, c) && (i[c] = u[c]);
        }
        return i;
      }, t.apply(this, arguments);
    }, n = Wr && Wr.__spreadArray || function(i, u, f) {
      if (f || arguments.length === 2) for (var p = 0, c = u.length, l; p < c; p++)
        (l || !(p in u)) && (l || (l = Array.prototype.slice.call(u, 0, p)), l[p] = u[p]);
      return i.concat(l || Array.prototype.slice.call(u));
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.defaultOptions = void 0, e.defaultOptions = {
      skipFirstMutation: !1,
      mutable: !1,
      bfs: !1
    };
    var a = function(i) {
      return i.map(function(u) {
        return u === "" ? "$" : ".".concat(u);
      }).join("");
    }, r = function(i, u) {
      var f = u.find(function(p) {
        return p === i;
      });
      return f || !1;
    }, o = function(i, u) {
      return u === void 0 && (u = 1), i[i.length - u];
    };
    function s(i, u, f, p, c, l, v, d, h) {
      f === void 0 && (f = e.defaultOptions), p === void 0 && (p = 0), c === void 0 && (c = []), l === void 0 && (l = []), v === void 0 && (v = []), d === void 0 && (d = []), h === void 0 && (h = []);
      var g = t(t({}, e.defaultOptions), f);
      if (p === 0 && (v = [""]), typeof i == "boolean" || i instanceof Boolean)
        return g.skipFirstMutation === !0 && p === 0 ? i : u(i, !1, a(v), o(l));
      var b = i;
      g.mutable === !1 && (b = t({}, i)), l.push(b), g.bfs === !0 && (g.skipFirstMutation === !1 || p !== 0) && (b = u(b, !1, a(v), o(l, 2))), c.push(i), d.push([i, b]);
      var E = function(_, O) {
        var T = r(_, c);
        if (T) {
          if (h.push(T), g.skipFirstMutation === !0 && T === c[0])
            return u(_, !0, a(O), o(l));
          var A = d.find(function(B) {
            var J = B[0];
            return T === J;
          }), M = A[1];
          return M;
        }
        return s(_, u, f, p + 1, c, l, O, d, h);
      };
      if (i.anyOf)
        b.anyOf = i.anyOf.map(function(_, O) {
          var T = E(_, n(n([], v, !0), ["anyOf[".concat(O, "]")], !1));
          return T;
        });
      else if (i.allOf)
        b.allOf = i.allOf.map(function(_, O) {
          var T = E(_, n(n([], v, !0), ["allOf[".concat(O, "]")], !1));
          return T;
        });
      else if (i.oneOf)
        b.oneOf = i.oneOf.map(function(_, O) {
          var T = E(_, n(n([], v, !0), ["oneOf[".concat(O, "]")], !1));
          return T;
        });
      else {
        if (i.items)
          if (i.items instanceof Array)
            b.items = i.items.map(function(_, O) {
              var T = E(_, n(n([], v, !0), ["items[".concat(O, "]")], !1));
              return T;
            });
          else {
            var S = r(i.items, c);
            if (S)
              if (h.push(S), g.skipFirstMutation === !0 && S === c[0])
                b.items = u(i.items, !0, a(v), o(l));
              else {
                var w = d.find(function(_) {
                  var O = _[0];
                  return S === O;
                }), y = w[1];
                b.items = y;
              }
            else
              b.items = s(i.items, u, f, p + 1, c, l, n(n([], v, !0), ["items"], !1), d, h);
          }
        if (i.additionalItems !== void 0 && (b.additionalItems = E(i.additionalItems, n(n([], v, !0), ["additionalItems"], !1))), i.properties !== void 0) {
          var x = i.properties, P = {};
          Object.keys(i.properties).forEach(function(_) {
            P[_] = E(x[_], n(n([], v, !0), ["properties", _.toString()], !1));
          }), b.properties = P;
        }
        if (i.patternProperties !== void 0) {
          var C = i.patternProperties, R = {};
          Object.keys(i.patternProperties).forEach(function(_) {
            R[_] = E(C[_], n(n([], v, !0), ["patternProperties", _.toString()], !1));
          }), b.patternProperties = R;
        }
        i.additionalProperties !== void 0 && i.additionalProperties && (b.additionalProperties = E(i.additionalProperties, n(n([], v, !0), ["additionalProperties"], !1)));
      }
      if (g.skipFirstMutation === !0 && p === 0)
        return b;
      if (g.bfs === !0)
        return l.pop(), b;
      var m = h.indexOf(i) !== -1;
      return l.pop(), u(b, m, a(v), o(l));
    }
    e.default = s;
  }(Wr)), Wr;
}
var kt = {}, Qt = {}, Bt = {}, Uc;
function Gh() {
  if (Uc) return Bt;
  Uc = 1, Object.defineProperty(Bt, "__esModule", { value: !0 }), Bt.InvalidFileSystemPathError = Bt.InvalidRemoteURLError = Bt.NotResolvableError = Bt.NonJsonRefError = void 0;
  var e = (
    /** @class */
    /* @__PURE__ */ function() {
      function r(o, s) {
        this.name = "NonJsonRefError", this.message = [
          "NonJsonRefError",
          "The resolved value at the reference: ".concat(o.$ref, " was not JSON.parse 'able"),
          "The non-json content in question: ".concat(s)
        ].join(`
`);
      }
      return r;
    }()
  );
  Bt.NonJsonRefError = e;
  var t = (
    /** @class */
    /* @__PURE__ */ function() {
      function r(o) {
        this.name = "NotResolvableError", this.message = [
          "NotResolvableError",
          "Could not resolve the reference: ".concat(o),
          "No protocol handler was found, and it was not found to be an internal reference"
        ].join(`
`);
      }
      return r;
    }()
  );
  Bt.NotResolvableError = t;
  var n = (
    /** @class */
    /* @__PURE__ */ function() {
      function r(o) {
        this.name = "InvalidRemoteURLError", this.message = [
          "InvalidRemoteURLError",
          "The url was not resolvable: ".concat(o)
        ].join(`
`);
      }
      return r;
    }()
  );
  Bt.InvalidRemoteURLError = n;
  var a = (
    /** @class */
    /* @__PURE__ */ function() {
      function r(o) {
        this.name = "InvalidFileSystemPathError", this.message = [
          "InvalidFileSystemPathError",
          "The path was not resolvable: ".concat(o)
        ].join(`
`);
      }
      return r;
    }()
  );
  return Bt.InvalidFileSystemPathError = a, Bt;
}
var it = typeof globalThis < "u" && globalThis || typeof self < "u" && self || // eslint-disable-next-line no-undef
typeof globalThis < "u" && globalThis || {}, ut = {
  searchParams: "URLSearchParams" in it,
  iterable: "Symbol" in it && "iterator" in Symbol,
  blob: "FileReader" in it && "Blob" in it && function() {
    try {
      return new Blob(), !0;
    } catch {
      return !1;
    }
  }(),
  formData: "FormData" in it,
  arrayBuffer: "ArrayBuffer" in it
};
function o1(e) {
  return e && DataView.prototype.isPrototypeOf(e);
}
if (ut.arrayBuffer)
  var i1 = [
    "[object Int8Array]",
    "[object Uint8Array]",
    "[object Uint8ClampedArray]",
    "[object Int16Array]",
    "[object Uint16Array]",
    "[object Int32Array]",
    "[object Uint32Array]",
    "[object Float32Array]",
    "[object Float64Array]"
  ], s1 = ArrayBuffer.isView || function(e) {
    return e && i1.indexOf(Object.prototype.toString.call(e)) > -1;
  };
function Wn(e) {
  if (typeof e != "string" && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || e === "")
    throw new TypeError('Invalid character in header field name: "' + e + '"');
  return e.toLowerCase();
}
function nu(e) {
  return typeof e != "string" && (e = String(e)), e;
}
function au(e) {
  var t = {
    next: function() {
      var n = e.shift();
      return { done: n === void 0, value: n };
    }
  };
  return ut.iterable && (t[Symbol.iterator] = function() {
    return t;
  }), t;
}
function et(e) {
  this.map = {}, e instanceof et ? e.forEach(function(t, n) {
    this.append(n, t);
  }, this) : Array.isArray(e) ? e.forEach(function(t) {
    if (t.length != 2)
      throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + t.length);
    this.append(t[0], t[1]);
  }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
    this.append(t, e[t]);
  }, this);
}
et.prototype.append = function(e, t) {
  e = Wn(e), t = nu(t);
  var n = this.map[e];
  this.map[e] = n ? n + ", " + t : t;
};
et.prototype.delete = function(e) {
  delete this.map[Wn(e)];
};
et.prototype.get = function(e) {
  return e = Wn(e), this.has(e) ? this.map[e] : null;
};
et.prototype.has = function(e) {
  return this.map.hasOwnProperty(Wn(e));
};
et.prototype.set = function(e, t) {
  this.map[Wn(e)] = nu(t);
};
et.prototype.forEach = function(e, t) {
  for (var n in this.map)
    this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
};
et.prototype.keys = function() {
  var e = [];
  return this.forEach(function(t, n) {
    e.push(n);
  }), au(e);
};
et.prototype.values = function() {
  var e = [];
  return this.forEach(function(t) {
    e.push(t);
  }), au(e);
};
et.prototype.entries = function() {
  var e = [];
  return this.forEach(function(t, n) {
    e.push([n, t]);
  }), au(e);
};
ut.iterable && (et.prototype[Symbol.iterator] = et.prototype.entries);
function Qi(e) {
  if (!e._noBody) {
    if (e.bodyUsed)
      return Promise.reject(new TypeError("Already read"));
    e.bodyUsed = !0;
  }
}
function Kh(e) {
  return new Promise(function(t, n) {
    e.onload = function() {
      t(e.result);
    }, e.onerror = function() {
      n(e.error);
    };
  });
}
function l1(e) {
  var t = new FileReader(), n = Kh(t);
  return t.readAsArrayBuffer(e), n;
}
function u1(e) {
  var t = new FileReader(), n = Kh(t), a = /charset=([A-Za-z0-9_-]+)/.exec(e.type), r = a ? a[1] : "utf-8";
  return t.readAsText(e, r), n;
}
function c1(e) {
  for (var t = new Uint8Array(e), n = new Array(t.length), a = 0; a < t.length; a++)
    n[a] = String.fromCharCode(t[a]);
  return n.join("");
}
function Hc(e) {
  if (e.slice)
    return e.slice(0);
  var t = new Uint8Array(e.byteLength);
  return t.set(new Uint8Array(e)), t.buffer;
}
function Jh() {
  return this.bodyUsed = !1, this._initBody = function(e) {
    this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? typeof e == "string" ? this._bodyText = e : ut.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : ut.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : ut.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : ut.arrayBuffer && ut.blob && o1(e) ? (this._bodyArrayBuffer = Hc(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : ut.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || s1(e)) ? this._bodyArrayBuffer = Hc(e) : this._bodyText = e = Object.prototype.toString.call(e) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof e == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : ut.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
  }, ut.blob && (this.blob = function() {
    var e = Qi(this);
    if (e)
      return e;
    if (this._bodyBlob)
      return Promise.resolve(this._bodyBlob);
    if (this._bodyArrayBuffer)
      return Promise.resolve(new Blob([this._bodyArrayBuffer]));
    if (this._bodyFormData)
      throw new Error("could not read FormData body as blob");
    return Promise.resolve(new Blob([this._bodyText]));
  }), this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var e = Qi(this);
      return e || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
        this._bodyArrayBuffer.buffer.slice(
          this._bodyArrayBuffer.byteOffset,
          this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
        )
      ) : Promise.resolve(this._bodyArrayBuffer));
    } else {
      if (ut.blob)
        return this.blob().then(l1);
      throw new Error("could not read as ArrayBuffer");
    }
  }, this.text = function() {
    var e = Qi(this);
    if (e)
      return e;
    if (this._bodyBlob)
      return u1(this._bodyBlob);
    if (this._bodyArrayBuffer)
      return Promise.resolve(c1(this._bodyArrayBuffer));
    if (this._bodyFormData)
      throw new Error("could not read FormData body as text");
    return Promise.resolve(this._bodyText);
  }, ut.formData && (this.formData = function() {
    return this.text().then(p1);
  }), this.json = function() {
    return this.text().then(JSON.parse);
  }, this;
}
var f1 = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
function d1(e) {
  var t = e.toUpperCase();
  return f1.indexOf(t) > -1 ? t : e;
}
function nn(e, t) {
  if (!(this instanceof nn))
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  t = t || {};
  var n = t.body;
  if (e instanceof nn) {
    if (e.bodyUsed)
      throw new TypeError("Already read");
    this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new et(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, !n && e._bodyInit != null && (n = e._bodyInit, e.bodyUsed = !0);
  } else
    this.url = String(e);
  if (this.credentials = t.credentials || this.credentials || "same-origin", (t.headers || !this.headers) && (this.headers = new et(t.headers)), this.method = d1(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal || function() {
    if ("AbortController" in it) {
      var o = new AbortController();
      return o.signal;
    }
  }(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && n)
    throw new TypeError("Body not allowed for GET or HEAD requests");
  if (this._initBody(n), (this.method === "GET" || this.method === "HEAD") && (t.cache === "no-store" || t.cache === "no-cache")) {
    var a = /([?&])_=[^&]*/;
    if (a.test(this.url))
      this.url = this.url.replace(a, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
    else {
      var r = /\?/;
      this.url += (r.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
    }
  }
}
nn.prototype.clone = function() {
  return new nn(this, { body: this._bodyInit });
};
function p1(e) {
  var t = new FormData();
  return e.trim().split("&").forEach(function(n) {
    if (n) {
      var a = n.split("="), r = a.shift().replace(/\+/g, " "), o = a.join("=").replace(/\+/g, " ");
      t.append(decodeURIComponent(r), decodeURIComponent(o));
    }
  }), t;
}
function h1(e) {
  var t = new et(), n = e.replace(/\r?\n[\t ]+/g, " ");
  return n.split("\r").map(function(a) {
    return a.indexOf(`
`) === 0 ? a.substr(1, a.length) : a;
  }).forEach(function(a) {
    var r = a.split(":"), o = r.shift().trim();
    if (o) {
      var s = r.join(":").trim();
      try {
        t.append(o, s);
      } catch (i) {
        console.warn("Response " + i.message);
      }
    }
  }), t;
}
Jh.call(nn.prototype);
function ur(e, t) {
  if (!(this instanceof ur))
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  if (t || (t = {}), this.type = "default", this.status = t.status === void 0 ? 200 : t.status, this.status < 200 || this.status > 599)
    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
  this.ok = this.status >= 200 && this.status < 300, this.statusText = t.statusText === void 0 ? "" : "" + t.statusText, this.headers = new et(t.headers), this.url = t.url || "", this._initBody(e);
}
Jh.call(ur.prototype);
ur.prototype.clone = function() {
  return new ur(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new et(this.headers),
    url: this.url
  });
};
ur.error = function() {
  var e = new ur(null, { status: 200, statusText: "" });
  return e.ok = !1, e.status = 0, e.type = "error", e;
};
var m1 = [301, 302, 303, 307, 308];
ur.redirect = function(e, t) {
  if (m1.indexOf(t) === -1)
    throw new RangeError("Invalid status code");
  return new ur(null, { status: t, headers: { location: e } });
};
var Jr = it.DOMException;
try {
  new Jr();
} catch {
  Jr = function(t, n) {
    this.message = t, this.name = n;
    var a = Error(t);
    this.stack = a.stack;
  }, Jr.prototype = Object.create(Error.prototype), Jr.prototype.constructor = Jr;
}
function Qh(e, t) {
  return new Promise(function(n, a) {
    var r = new nn(e, t);
    if (r.signal && r.signal.aborted)
      return a(new Jr("Aborted", "AbortError"));
    var o = new XMLHttpRequest();
    function s() {
      o.abort();
    }
    o.onload = function() {
      var f = {
        statusText: o.statusText,
        headers: h1(o.getAllResponseHeaders() || "")
      };
      r.url.indexOf("file://") === 0 && (o.status < 200 || o.status > 599) ? f.status = 200 : f.status = o.status, f.url = "responseURL" in o ? o.responseURL : f.headers.get("X-Request-URL");
      var p = "response" in o ? o.response : o.responseText;
      setTimeout(function() {
        n(new ur(p, f));
      }, 0);
    }, o.onerror = function() {
      setTimeout(function() {
        a(new TypeError("Network request failed"));
      }, 0);
    }, o.ontimeout = function() {
      setTimeout(function() {
        a(new TypeError("Network request timed out"));
      }, 0);
    }, o.onabort = function() {
      setTimeout(function() {
        a(new Jr("Aborted", "AbortError"));
      }, 0);
    };
    function i(f) {
      try {
        return f === "" && it.location.href ? it.location.href : f;
      } catch {
        return f;
      }
    }
    if (o.open(r.method, i(r.url), !0), r.credentials === "include" ? o.withCredentials = !0 : r.credentials === "omit" && (o.withCredentials = !1), "responseType" in o && (ut.blob ? o.responseType = "blob" : ut.arrayBuffer && (o.responseType = "arraybuffer")), t && typeof t.headers == "object" && !(t.headers instanceof et || it.Headers && t.headers instanceof it.Headers)) {
      var u = [];
      Object.getOwnPropertyNames(t.headers).forEach(function(f) {
        u.push(Wn(f)), o.setRequestHeader(f, nu(t.headers[f]));
      }), r.headers.forEach(function(f, p) {
        u.indexOf(p) === -1 && o.setRequestHeader(p, f);
      });
    } else
      r.headers.forEach(function(f, p) {
        o.setRequestHeader(p, f);
      });
    r.signal && (r.signal.addEventListener("abort", s), o.onreadystatechange = function() {
      o.readyState === 4 && r.signal.removeEventListener("abort", s);
    }), o.send(typeof r._bodyInit > "u" ? null : r._bodyInit);
  });
}
Qh.polyfill = !0;
it.fetch || (it.fetch = Qh, it.Headers = et, it.Request = nn, it.Response = ur);
var Yi, Vc;
function ou() {
  return Vc || (Vc = 1, Yi = self.fetch.bind(self)), Yi;
}
var Wc;
function v1() {
  if (Wc) return Qt;
  Wc = 1;
  var e = Qt && Qt.__awaiter || function(s, i, u, f) {
    function p(c) {
      return c instanceof u ? c : new u(function(l) {
        l(c);
      });
    }
    return new (u || (u = Promise))(function(c, l) {
      function v(g) {
        try {
          h(f.next(g));
        } catch (b) {
          l(b);
        }
      }
      function d(g) {
        try {
          h(f.throw(g));
        } catch (b) {
          l(b);
        }
      }
      function h(g) {
        g.done ? c(g.value) : p(g.value).then(v, d);
      }
      h((f = f.apply(s, i || [])).next());
    });
  }, t = Qt && Qt.__generator || function(s, i) {
    var u = { label: 0, sent: function() {
      if (c[0] & 1) throw c[1];
      return c[1];
    }, trys: [], ops: [] }, f, p, c, l;
    return l = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
      return this;
    }), l;
    function v(h) {
      return function(g) {
        return d([h, g]);
      };
    }
    function d(h) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; l && (l = 0, h[0] && (u = 0)), u; ) try {
        if (f = 1, p && (c = h[0] & 2 ? p.return : h[0] ? p.throw || ((c = p.return) && c.call(p), 0) : p.next) && !(c = c.call(p, h[1])).done) return c;
        switch (p = 0, c && (h = [h[0] & 2, c.value]), h[0]) {
          case 0:
          case 1:
            c = h;
            break;
          case 4:
            return u.label++, { value: h[1], done: !1 };
          case 5:
            u.label++, p = h[1], h = [0];
            continue;
          case 7:
            h = u.ops.pop(), u.trys.pop();
            continue;
          default:
            if (c = u.trys, !(c = c.length > 0 && c[c.length - 1]) && (h[0] === 6 || h[0] === 2)) {
              u = 0;
              continue;
            }
            if (h[0] === 3 && (!c || h[1] > c[0] && h[1] < c[3])) {
              u.label = h[1];
              break;
            }
            if (h[0] === 6 && u.label < c[1]) {
              u.label = c[1], c = h;
              break;
            }
            if (c && u.label < c[2]) {
              u.label = c[2], u.ops.push(h);
              break;
            }
            c[2] && u.ops.pop(), u.trys.pop();
            continue;
        }
        h = i.call(s, u);
      } catch (g) {
        h = [6, g], p = 0;
      } finally {
        f = c = 0;
      }
      if (h[0] & 5) throw h[1];
      return { value: h[0] ? h[1] : void 0, done: !0 };
    }
  }, n = Qt && Qt.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(Qt, "__esModule", { value: !0 });
  var a = Gh(), r = n(ou()), o = function(s) {
    return e(void 0, void 0, void 0, function() {
      var i, u;
      return t(this, function(f) {
        switch (f.label) {
          case 0:
            return f.trys.push([0, 2, , 3]), [4, (0, r.default)(s)];
          case 1:
            return i = f.sent(), [3, 3];
          case 2:
            throw f.sent(), new a.InvalidRemoteURLError(s);
          case 3:
            return f.trys.push([3, 5, , 6]), [4, i.json()];
          case 4:
            return [2, f.sent()];
          case 5:
            throw u = f.sent(), new a.NonJsonRefError({ $ref: s }, u.message);
          case 6:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
  return Qt.default = {
    https: o,
    http: o
  }, Qt;
}
var Yt = {}, Cr = {}, vn = {}, Gc;
function g1() {
  if (Gc) return vn;
  Gc = 1, Object.defineProperty(vn, "__esModule", { value: !0 });
  class e {
    static parse(r) {
      if (r === "")
        return new e([]);
      if (!r.startsWith("/"))
        throw new t(r);
      const [, ...o] = r.split("/");
      return new e(o.map((s) => s.replace(/~1/g, "/").replace(/~0/g, "~")));
    }
    constructor(r) {
      this.tokens = r;
    }
    toString() {
      return this.tokens.length === 0 ? "" : `/${this.tokens.map((o) => o.replace(/~/g, "~0").replace(/\//g, "~1")).join("/")}`;
    }
    eval(r) {
      for (const o of this.tokens)
        if (r.hasOwnProperty(o))
          r = r[o];
        else
          throw new n(r, o);
      return r;
    }
  }
  vn.default = e;
  class t extends Error {
    constructor(r) {
      super(`Invalid JSON Pointer: ${r}`), this.ptr = r;
    }
  }
  vn.InvalidPtrError = t;
  class n extends Error {
    constructor(r, o) {
      super(`Error evaluating JSON Pointer: no attribute ${o} on ${r}`), this.instance = r, this.token = o;
    }
  }
  return vn.EvalError = n, vn;
}
var Kc;
function y1() {
  if (Kc) return Cr;
  Kc = 1;
  var e = Cr && Cr.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(Cr, "__esModule", { value: !0 }), Cr.InvalidJsonPointerRefError = void 0;
  var t = e(g1()), n = (
    /** @class */
    /* @__PURE__ */ function() {
      function a(r, o) {
        this.name = "InvalidJsonPointerRefError", this.message = [
          "InvalidJsonPointerRefError",
          "The provided RFC6901 JSON Pointer is invalid: ".concat(r),
          "",
          "addition info: ",
          o
        ].join(`
`);
      }
      return a;
    }()
  );
  return Cr.InvalidJsonPointerRefError = n, Cr.default = function(a, r) {
    try {
      var o = a.replace("#", ""), s = t.default.parse(o);
      return s.eval(r);
    } catch (i) {
      throw new n(a, i.message);
    }
  }, Cr;
}
var Jc;
function Yh() {
  if (Jc) return Yt;
  Jc = 1;
  var e = Yt && Yt.__awaiter || function(i, u, f, p) {
    function c(l) {
      return l instanceof f ? l : new f(function(v) {
        v(l);
      });
    }
    return new (f || (f = Promise))(function(l, v) {
      function d(b) {
        try {
          g(p.next(b));
        } catch (E) {
          v(E);
        }
      }
      function h(b) {
        try {
          g(p.throw(b));
        } catch (E) {
          v(E);
        }
      }
      function g(b) {
        b.done ? l(b.value) : c(b.value).then(d, h);
      }
      g((p = p.apply(i, u || [])).next());
    });
  }, t = Yt && Yt.__generator || function(i, u) {
    var f = { label: 0, sent: function() {
      if (l[0] & 1) throw l[1];
      return l[1];
    }, trys: [], ops: [] }, p, c, l, v;
    return v = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
      return this;
    }), v;
    function d(g) {
      return function(b) {
        return h([g, b]);
      };
    }
    function h(g) {
      if (p) throw new TypeError("Generator is already executing.");
      for (; v && (v = 0, g[0] && (f = 0)), f; ) try {
        if (p = 1, c && (l = g[0] & 2 ? c.return : g[0] ? c.throw || ((l = c.return) && l.call(c), 0) : c.next) && !(l = l.call(c, g[1])).done) return l;
        switch (c = 0, l && (g = [g[0] & 2, l.value]), g[0]) {
          case 0:
          case 1:
            l = g;
            break;
          case 4:
            return f.label++, { value: g[1], done: !1 };
          case 5:
            f.label++, c = g[1], g = [0];
            continue;
          case 7:
            g = f.ops.pop(), f.trys.pop();
            continue;
          default:
            if (l = f.trys, !(l = l.length > 0 && l[l.length - 1]) && (g[0] === 6 || g[0] === 2)) {
              f = 0;
              continue;
            }
            if (g[0] === 3 && (!l || g[1] > l[0] && g[1] < l[3])) {
              f.label = g[1];
              break;
            }
            if (g[0] === 6 && f.label < l[1]) {
              f.label = l[1], l = g;
              break;
            }
            if (l && f.label < l[2]) {
              f.label = l[2], f.ops.push(g);
              break;
            }
            l[2] && f.ops.pop(), f.trys.pop();
            continue;
        }
        g = u.call(i, f);
      } catch (b) {
        g = [6, b], c = 0;
      } finally {
        p = l = 0;
      }
      if (g[0] & 5) throw g[1];
      return { value: g[0] ? g[1] : void 0, done: !0 };
    }
  }, n = Yt && Yt.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Yt, "__esModule", { value: !0 });
  var a = Gh(), r = n(y1()), o = function(i) {
    return i.includes("://");
  }, s = (
    /** @class */
    function() {
      function i(u) {
        this.protocolHandlerMap = u;
      }
      return i.prototype.resolve = function(u) {
        return e(this, arguments, void 0, function(f, p) {
          var c, l, v, d, h, w, g, b, E, S, w;
          return p === void 0 && (p = {}), t(this, function(y) {
            switch (y.label) {
              case 0:
                if (f[0] === "#")
                  return [2, Promise.resolve((0, r.default)(f, p))];
                c = f.split("#"), c.length > 1 && (l = c[c.length - 1]), v = c[0], y.label = 1;
              case 1:
                return y.trys.push([1, 3, , 4]), [4, this.protocolHandlerMap.file(v, p)];
              case 2:
                return d = y.sent(), [3, 4];
              case 3:
                throw h = y.sent(), new a.NonJsonRefError({ $ref: f }, h.message);
              case 4:
                if (d !== void 0)
                  return w = d, l && (w = (0, r.default)(l, w)), [2, w];
                if (o(f) === !1)
                  throw new a.InvalidFileSystemPathError(f);
                g = 0, b = Object.keys(this.protocolHandlerMap), y.label = 5;
              case 5:
                return g < b.length ? (E = b[g], v.startsWith(E) ? [4, this.protocolHandlerMap[E](v, p)] : [3, 7]) : [3, 8];
              case 6:
                if (S = y.sent(), S !== void 0)
                  return w = S, l && (w = (0, r.default)(l, w)), [2, w];
                y.label = 7;
              case 7:
                return g++, [3, 5];
              case 8:
                throw new a.NotResolvableError(f);
            }
          });
        });
      }, i;
    }()
  );
  return Yt.default = s, Yt;
}
var Qc;
function iu() {
  if (Qc) return kt;
  Qc = 1;
  var e = kt && kt.__assign || function() {
    return e = Object.assign || function(i) {
      for (var u, f = 1, p = arguments.length; f < p; f++) {
        u = arguments[f];
        for (var c in u) Object.prototype.hasOwnProperty.call(u, c) && (i[c] = u[c]);
      }
      return i;
    }, e.apply(this, arguments);
  }, t = kt && kt.__awaiter || function(i, u, f, p) {
    function c(l) {
      return l instanceof f ? l : new f(function(v) {
        v(l);
      });
    }
    return new (f || (f = Promise))(function(l, v) {
      function d(b) {
        try {
          g(p.next(b));
        } catch (E) {
          v(E);
        }
      }
      function h(b) {
        try {
          g(p.throw(b));
        } catch (E) {
          v(E);
        }
      }
      function g(b) {
        b.done ? l(b.value) : c(b.value).then(d, h);
      }
      g((p = p.apply(i, u || [])).next());
    });
  }, n = kt && kt.__generator || function(i, u) {
    var f = { label: 0, sent: function() {
      if (l[0] & 1) throw l[1];
      return l[1];
    }, trys: [], ops: [] }, p, c, l, v;
    return v = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
      return this;
    }), v;
    function d(g) {
      return function(b) {
        return h([g, b]);
      };
    }
    function h(g) {
      if (p) throw new TypeError("Generator is already executing.");
      for (; v && (v = 0, g[0] && (f = 0)), f; ) try {
        if (p = 1, c && (l = g[0] & 2 ? c.return : g[0] ? c.throw || ((l = c.return) && l.call(c), 0) : c.next) && !(l = l.call(c, g[1])).done) return l;
        switch (c = 0, l && (g = [g[0] & 2, l.value]), g[0]) {
          case 0:
          case 1:
            l = g;
            break;
          case 4:
            return f.label++, { value: g[1], done: !1 };
          case 5:
            f.label++, c = g[1], g = [0];
            continue;
          case 7:
            g = f.ops.pop(), f.trys.pop();
            continue;
          default:
            if (l = f.trys, !(l = l.length > 0 && l[l.length - 1]) && (g[0] === 6 || g[0] === 2)) {
              f = 0;
              continue;
            }
            if (g[0] === 3 && (!l || g[1] > l[0] && g[1] < l[3])) {
              f.label = g[1];
              break;
            }
            if (g[0] === 6 && f.label < l[1]) {
              f.label = l[1], l = g;
              break;
            }
            if (l && f.label < l[2]) {
              f.label = l[2], f.ops.push(g);
              break;
            }
            l[2] && f.ops.pop(), f.trys.pop();
            continue;
        }
        g = u.call(i, f);
      } catch (b) {
        g = [6, b], c = 0;
      } finally {
        p = l = 0;
      }
      if (g[0] & 5) throw g[1];
      return { value: g[0] ? g[1] : void 0, done: !0 };
    }
  }, a = kt && kt.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(kt, "__esModule", { value: !0 });
  var r = a(v1()), o = a(Yh()), s = e(e({}, r.default), { file: function() {
    return t(void 0, void 0, void 0, function() {
      return n(this, function(i) {
        return [2, void 0];
      });
    });
  } });
  return kt.default = new o.default(s), kt;
}
var Xi, Yc;
function Xh() {
  if (Yc) return Xi;
  Yc = 1, Xi = o, o.default = o, o.stable = f, o.stableStringify = f;
  var e = "[...]", t = "[Circular]", n = [], a = [];
  function r() {
    return {
      depthLimit: Number.MAX_SAFE_INTEGER,
      edgesLimit: Number.MAX_SAFE_INTEGER
    };
  }
  function o(l, v, d, h) {
    typeof h > "u" && (h = r()), i(l, "", 0, [], void 0, 0, h);
    var g;
    try {
      a.length === 0 ? g = JSON.stringify(l, v, d) : g = JSON.stringify(l, c(v), d);
    } catch {
      return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally {
      for (; n.length !== 0; ) {
        var b = n.pop();
        b.length === 4 ? Object.defineProperty(b[0], b[1], b[3]) : b[0][b[1]] = b[2];
      }
    }
    return g;
  }
  function s(l, v, d, h) {
    var g = Object.getOwnPropertyDescriptor(h, d);
    g.get !== void 0 ? g.configurable ? (Object.defineProperty(h, d, { value: l }), n.push([h, d, v, g])) : a.push([v, d, l]) : (h[d] = l, n.push([h, d, v]));
  }
  function i(l, v, d, h, g, b, E) {
    b += 1;
    var S;
    if (typeof l == "object" && l !== null) {
      for (S = 0; S < h.length; S++)
        if (h[S] === l) {
          s(t, l, v, g);
          return;
        }
      if (typeof E.depthLimit < "u" && b > E.depthLimit) {
        s(e, l, v, g);
        return;
      }
      if (typeof E.edgesLimit < "u" && d + 1 > E.edgesLimit) {
        s(e, l, v, g);
        return;
      }
      if (h.push(l), Array.isArray(l))
        for (S = 0; S < l.length; S++)
          i(l[S], S, S, h, l, b, E);
      else {
        var w = Object.keys(l);
        for (S = 0; S < w.length; S++) {
          var y = w[S];
          i(l[y], y, S, h, l, b, E);
        }
      }
      h.pop();
    }
  }
  function u(l, v) {
    return l < v ? -1 : l > v ? 1 : 0;
  }
  function f(l, v, d, h) {
    typeof h > "u" && (h = r());
    var g = p(l, "", 0, [], void 0, 0, h) || l, b;
    try {
      a.length === 0 ? b = JSON.stringify(g, v, d) : b = JSON.stringify(g, c(v), d);
    } catch {
      return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally {
      for (; n.length !== 0; ) {
        var E = n.pop();
        E.length === 4 ? Object.defineProperty(E[0], E[1], E[3]) : E[0][E[1]] = E[2];
      }
    }
    return b;
  }
  function p(l, v, d, h, g, b, E) {
    b += 1;
    var S;
    if (typeof l == "object" && l !== null) {
      for (S = 0; S < h.length; S++)
        if (h[S] === l) {
          s(t, l, v, g);
          return;
        }
      try {
        if (typeof l.toJSON == "function")
          return;
      } catch {
        return;
      }
      if (typeof E.depthLimit < "u" && b > E.depthLimit) {
        s(e, l, v, g);
        return;
      }
      if (typeof E.edgesLimit < "u" && d + 1 > E.edgesLimit) {
        s(e, l, v, g);
        return;
      }
      if (h.push(l), Array.isArray(l))
        for (S = 0; S < l.length; S++)
          p(l[S], S, S, h, l, b, E);
      else {
        var w = {}, y = Object.keys(l).sort(u);
        for (S = 0; S < y.length; S++) {
          var x = y[S];
          p(l[x], x, S, h, l, b, E), w[x] = l[x];
        }
        if (typeof g < "u")
          n.push([g, v, l]), g[v] = w;
        else
          return w;
      }
      h.pop();
    }
  }
  function c(l) {
    return l = typeof l < "u" ? l : function(v, d) {
      return d;
    }, function(v, d) {
      if (a.length > 0)
        for (var h = 0; h < a.length; h++) {
          var g = a[h];
          if (g[1] === v && g[0] === d) {
            d = g[2], a.splice(h, 1);
            break;
          }
        }
      return l.call(this, v, d);
    };
  }
  return Xi;
}
var Xc;
function Zc() {
  if (Xc) return ht;
  Xc = 1;
  var e = ht && ht.__assign || function() {
    return e = Object.assign || function(p) {
      for (var c, l = 1, v = arguments.length; l < v; l++) {
        c = arguments[l];
        for (var d in c) Object.prototype.hasOwnProperty.call(c, d) && (p[d] = c[d]);
      }
      return p;
    }, e.apply(this, arguments);
  }, t = ht && ht.__awaiter || function(p, c, l, v) {
    function d(h) {
      return h instanceof l ? h : new l(function(g) {
        g(h);
      });
    }
    return new (l || (l = Promise))(function(h, g) {
      function b(w) {
        try {
          S(v.next(w));
        } catch (y) {
          g(y);
        }
      }
      function E(w) {
        try {
          S(v.throw(w));
        } catch (y) {
          g(y);
        }
      }
      function S(w) {
        w.done ? h(w.value) : d(w.value).then(b, E);
      }
      S((v = v.apply(p, c || [])).next());
    });
  }, n = ht && ht.__generator || function(p, c) {
    var l = { label: 0, sent: function() {
      if (h[0] & 1) throw h[1];
      return h[1];
    }, trys: [], ops: [] }, v, d, h, g;
    return g = { next: b(0), throw: b(1), return: b(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function b(S) {
      return function(w) {
        return E([S, w]);
      };
    }
    function E(S) {
      if (v) throw new TypeError("Generator is already executing.");
      for (; g && (g = 0, S[0] && (l = 0)), l; ) try {
        if (v = 1, d && (h = S[0] & 2 ? d.return : S[0] ? d.throw || ((h = d.return) && h.call(d), 0) : d.next) && !(h = h.call(d, S[1])).done) return h;
        switch (d = 0, h && (S = [S[0] & 2, h.value]), S[0]) {
          case 0:
          case 1:
            h = S;
            break;
          case 4:
            return l.label++, { value: S[1], done: !1 };
          case 5:
            l.label++, d = S[1], S = [0];
            continue;
          case 7:
            S = l.ops.pop(), l.trys.pop();
            continue;
          default:
            if (h = l.trys, !(h = h.length > 0 && h[h.length - 1]) && (S[0] === 6 || S[0] === 2)) {
              l = 0;
              continue;
            }
            if (S[0] === 3 && (!h || S[1] > h[0] && S[1] < h[3])) {
              l.label = S[1];
              break;
            }
            if (S[0] === 6 && l.label < h[1]) {
              l.label = h[1], h = S;
              break;
            }
            if (h && l.label < h[2]) {
              l.label = h[2], l.ops.push(S);
              break;
            }
            h[2] && l.ops.pop(), l.trys.pop();
            continue;
        }
        S = c.call(p, l);
      } catch (w) {
        S = [6, w], d = 0;
      } finally {
        v = h = 0;
      }
      if (S[0] & 5) throw S[1];
      return { value: S[0] ? S[1] : void 0, done: !0 };
    }
  }, a = ht && ht.__importDefault || function(p) {
    return p && p.__esModule ? p : { default: p };
  };
  Object.defineProperty(ht, "__esModule", { value: !0 }), ht.NonStringRefError = void 0;
  var r = a(a1()), o = a(iu()), s = a(Xh()), i = (
    /** @class */
    /* @__PURE__ */ function() {
      function p(c) {
        this.name = "NonStringRefError", this.message = [
          "NonStringRefError",
          "Found an improperly formatted $ref in schema. $ref must be a string",
          "schema in question: ".concat((0, s.default)(c))
        ].join(`
`);
      }
      return p;
    }()
  );
  ht.NonStringRefError = i;
  var u = function(p, c) {
    if (p.$ref !== void 0 && Object.keys(p).length > 1 && c !== !0 && c !== !1) {
      var l = e(e({}, c), p);
      return delete l.$ref, l;
    } else
      return c;
  }, f = (
    /** @class */
    function() {
      function p(c, l) {
        l === void 0 && (l = {}), this.options = l, this.refCache = {};
        var v;
        if (this.options.mutate === !0 ? v = c : v = c === !0 || c === !1 ? c : e({}, c), this.options.recursive === void 0 && (this.options.recursive = !0), this.options.rootSchema === void 0 && (this.options.rootSchema = v), c !== !0 && c !== !1 && c.$id && (this.options.rootSchema = v), this.options.refCache && (this.refCache = this.options.refCache), this.options.protocolHandlerMap)
          for (var d = 0, h = Object.keys(this.options.protocolHandlerMap); d < h.length; d++) {
            var g = h[d];
            o.default.protocolHandlerMap[g] = this.options.protocolHandlerMap[g];
          }
        this.schema = v, this.refs = this.collectRefs();
      }
      return p.prototype.resolve = function() {
        return t(this, void 0, void 0, function() {
          return n(this, function(c) {
            switch (c.label) {
              case 0:
                return [4, this._resolve()];
              case 1:
                return c.sent(), delete this.schema.definitions, delete this.schema.components, [2, this.schema];
            }
          });
        });
      }, p.prototype._resolve = function() {
        return t(this, void 0, void 0, function() {
          var c, l, v, d, h, g, b, E, S, w, y, x = this;
          return n(this, function(P) {
            switch (P.label) {
              case 0:
                if (this.schema === !0 || this.schema === !1)
                  return [2, Promise.resolve(this.schema)];
                if (this.refs.length === 0)
                  return [2, Promise.resolve(this.schema)];
                c = this.refs.filter(function(C) {
                  return x.refCache[C] === void 0;
                }), l = [], v = 0, d = c, P.label = 1;
              case 1:
                return v < d.length ? (h = d[v], g = void 0, this.refCache[h] === void 0 ? [3, 2] : (g = this.refCache[h], [3, 5])) : [3, 11];
              case 2:
                if (h !== "#") return [3, 3];
                if (this.options.rootSchema === void 0)
                  throw new Error("options.rootSchema was not provided, but one of the schemas references '#'");
                return g = this.options.rootSchema, [3, 5];
              case 3:
                return b = o.default.resolve(h, this.options.rootSchema), l.push(b), [4, b];
              case 4:
                g = P.sent(), P.label = 5;
              case 5:
                return this.options.recursive === !0 && g !== !0 && g !== !1 && h !== "#" ? (E = e(e({}, this.options), { refCache: this.refCache }), S = new p(g, E), S.refs.length === 0 ? [3, 7] : (w = S._resolve(), l.push(w), [4, w])) : [3, 9];
              case 6:
                return y = P.sent(), this.refCache[h] = u(g, y), [3, 8];
              case 7:
                this.refCache[h] = g, P.label = 8;
              case 8:
                return [3, 10];
              case 9:
                this.refCache[h] = g, P.label = 10;
              case 10:
                return v++, [3, 1];
              case 11:
                return this.schema.$ref !== void 0 ? this.schema = u(this.schema, this.refCache[this.schema.$ref]) : (0, r.default)(this.schema, function(C) {
                  if (C === !0 || C === !1)
                    return C;
                  if (C.$ref !== void 0) {
                    var R = x.refCache[C.$ref];
                    return u(C, R);
                  }
                  return C;
                }, { mutable: !0 }), [4, Promise.all(l)];
              case 12:
                return P.sent(), [2, this.schema];
            }
          });
        });
      }, p.prototype.collectRefs = function() {
        var c = [];
        return (0, r.default)(this.schema, function(l) {
          if (l === !0 || l === !1)
            return l;
          if (l.$ref && c.indexOf(l.$ref) === -1) {
            if (typeof l.$ref != "string")
              throw new i(l);
            c.push(l.$ref);
          }
          return l;
        }), c;
      }, p;
    }()
  );
  return ht.default = f, ht;
}
var ef;
function b1() {
  return ef || (ef = 1, function(e) {
    var t = la && la.__importDefault || function(r) {
      return r && r.__esModule ? r : { default: r };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.NonStringRefError = void 0;
    var n = t(Zc()), a = Zc();
    Object.defineProperty(e, "NonStringRefError", { enumerable: !0, get: function() {
      return a.NonStringRefError;
    } }), e.default = n.default;
  }(la)), la;
}
var Zi = {}, tf;
function Zh() {
  return tf || (tf = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.openrpcDocument = void 0, e.openrpcDocument = { $schema: "https://meta.json-schema.tools/", $id: "https://meta.open-rpc.org/", title: "openrpcDocument", type: "object", required: ["info", "methods", "openrpc"], additionalProperties: !1, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } }, properties: { openrpc: { title: "openrpc", type: "string", enum: ["1.3.2", "1.3.1", "1.3.0", "1.2.6", "1.2.5", "1.2.4", "1.2.3", "1.2.2", "1.2.1", "1.2.0", "1.1.12", "1.1.11", "1.1.10", "1.1.9", "1.1.8", "1.1.7", "1.1.6", "1.1.5", "1.1.4", "1.1.3", "1.1.2", "1.1.1", "1.1.0", "1.0.0", "1.0.0-rc1", "1.0.0-rc0"] }, info: { $ref: "#/definitions/infoObject" }, externalDocs: { $ref: "#/definitions/externalDocumentationObject" }, servers: { title: "servers", type: "array", additionalItems: !1, items: { $ref: "#/definitions/serverObject" } }, methods: { title: "methods", type: "array", additionalItems: !1, items: { title: "methodOrReference", oneOf: [{ $ref: "#/definitions/methodObject" }, { $ref: "#/definitions/referenceObject" }] } }, components: { title: "components", type: "object", properties: { schemas: { title: "schemaComponents", type: "object", patternProperties: { "[0-z]+": { $ref: "#/definitions/JSONSchema" } } }, links: { title: "linkComponents", type: "object", patternProperties: { "[0-z]+": { $ref: "#/definitions/linkObject" } } }, errors: { title: "errorComponents", type: "object", patternProperties: { "[0-z]+": { $ref: "#/definitions/errorObject" } } }, examples: { title: "exampleComponents", type: "object", patternProperties: { "[0-z]+": { $ref: "#/definitions/exampleObject" } } }, examplePairings: { title: "examplePairingComponents", type: "object", patternProperties: { "[0-z]+": { $ref: "#/definitions/examplePairingObject" } } }, contentDescriptors: { title: "contentDescriptorComponents", type: "object", patternProperties: { "[0-z]+": { $ref: "#/definitions/contentDescriptorObject" } } }, tags: { title: "tagComponents", type: "object", patternProperties: { "[0-z]+": { $ref: "#/definitions/tagObject" } } } } }, $schema: { title: "metaSchema", description: "JSON Schema URI (used by some editors)", type: "string", default: "https://meta.open-rpc.org/" } }, definitions: { specificationExtension: { title: "specificationExtension" }, JSONSchema: { $ref: "https://meta.json-schema.tools" }, referenceObject: { title: "referenceObject", type: "object", additionalProperties: !1, required: ["$ref"], properties: { $ref: { $ref: "https://meta.json-schema.tools/#/definitions/JSONSchemaObject/properties/$ref" } } }, errorObject: { title: "errorObject", type: "object", description: "Defines an application level error.", additionalProperties: !1, required: ["code", "message"], properties: { code: { title: "errorObjectCode", description: "A Number that indicates the error type that occurred. This MUST be an integer. The error codes from and including -32768 to -32000 are reserved for pre-defined errors. These pre-defined errors SHOULD be assumed to be returned from any JSON-RPC api.", type: "integer" }, message: { title: "errorObjectMessage", description: "A String providing a short description of the error. The message SHOULD be limited to a concise single sentence.", type: "string" }, data: { title: "errorObjectData", description: "A Primitive or Structured value that contains additional information about the error. This may be omitted. The value of this member is defined by the Server (e.g. detailed error information, nested errors etc.)." } } }, licenseObject: { title: "licenseObject", type: "object", additionalProperties: !1, properties: { name: { title: "licenseObjectName", type: "string" }, url: { title: "licenseObjectUrl", type: "string" } }, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } } }, contactObject: { title: "contactObject", type: "object", additionalProperties: !1, properties: { name: { title: "contactObjectName", type: "string" }, email: { title: "contactObjectEmail", type: "string" }, url: { title: "contactObjectUrl", type: "string" } }, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } } }, infoObject: { title: "infoObject", type: "object", additionalProperties: !1, required: ["title", "version"], properties: { title: { title: "infoObjectProperties", type: "string" }, description: { title: "infoObjectDescription", type: "string" }, termsOfService: { title: "infoObjectTermsOfService", type: "string", format: "uri" }, version: { title: "infoObjectVersion", type: "string" }, contact: { $ref: "#/definitions/contactObject" }, license: { $ref: "#/definitions/licenseObject" } }, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } } }, serverObject: { title: "serverObject", type: "object", required: ["url"], additionalProperties: !1, properties: { url: { title: "serverObjectUrl", type: "string", format: "uri" }, name: { title: "serverObjectName", type: "string" }, description: { title: "serverObjectDescription", type: "string" }, summary: { title: "serverObjectSummary", type: "string" }, variables: { title: "serverObjectVariables", type: "object", patternProperties: { "[0-z]+": { title: "serverObjectVariable", type: "object", required: ["default"], properties: { default: { title: "serverObjectVariableDefault", type: "string" }, description: { title: "serverObjectVariableDescription", type: "string" }, enum: { title: "serverObjectVariableEnum", type: "array", items: { title: "serverObjectVariableEnumItem", type: "string" } } } } } } }, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } } }, linkObject: { title: "linkObject", type: "object", additionalProperties: !1, properties: { name: { title: "linkObjectName", type: "string", minLength: 1 }, summary: { title: "linkObjectSummary", type: "string" }, method: { title: "linkObjectMethod", type: "string" }, description: { title: "linkObjectDescription", type: "string" }, params: { title: "linkObjectParams" }, server: { title: "linkObjectServer", $ref: "#/definitions/serverObject" } }, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } } }, externalDocumentationObject: { title: "externalDocumentationObject", type: "object", additionalProperties: !1, description: "information about external documentation", required: ["url"], properties: { description: { title: "externalDocumentationObjectDescription", type: "string" }, url: { title: "externalDocumentationObjectUrl", type: "string", format: "uri" } }, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } } }, methodObject: { title: "methodObject", type: "object", required: ["name", "params"], additionalProperties: !1, properties: { name: { title: "methodObjectName", description: "The cannonical name for the method. The name MUST be unique within the methods array.", type: "string", minLength: 1 }, description: { title: "methodObjectDescription", description: "A verbose explanation of the method behavior. GitHub Flavored Markdown syntax MAY be used for rich text representation.", type: "string" }, summary: { title: "methodObjectSummary", description: "A short summary of what the method does.", type: "string" }, servers: { title: "servers", type: "array", additionalItems: !1, items: { $ref: "#/definitions/serverObject" } }, tags: { title: "methodObjectTags", type: "array", items: { title: "tagOrReference", oneOf: [{ $ref: "#/definitions/tagObject" }, { $ref: "#/definitions/referenceObject" }] } }, paramStructure: { title: "methodObjectParamStructure", type: "string", description: "Format the server expects the params. Defaults to 'either'.", enum: ["by-position", "by-name", "either"], default: "either" }, params: { title: "methodObjectParams", type: "array", items: { title: "contentDescriptorOrReference", oneOf: [{ $ref: "#/definitions/contentDescriptorObject" }, { $ref: "#/definitions/referenceObject" }] } }, result: { title: "methodObjectResult", oneOf: [{ $ref: "#/definitions/contentDescriptorObject" }, { $ref: "#/definitions/referenceObject" }] }, errors: { title: "methodObjectErrors", description: "Defines an application level error.", type: "array", items: { title: "errorOrReference", oneOf: [{ $ref: "#/definitions/errorObject" }, { $ref: "#/definitions/referenceObject" }] } }, links: { title: "methodObjectLinks", type: "array", items: { title: "linkOrReference", oneOf: [{ $ref: "#/definitions/linkObject" }, { $ref: "#/definitions/referenceObject" }] } }, examples: { title: "methodObjectExamples", type: "array", items: { title: "examplePairingOrReference", oneOf: [{ $ref: "#/definitions/examplePairingObject" }, { $ref: "#/definitions/referenceObject" }] } }, deprecated: { title: "methodObjectDeprecated", type: "boolean", default: !1 }, externalDocs: { $ref: "#/definitions/externalDocumentationObject" } }, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } } }, tagObject: { title: "tagObject", type: "object", additionalProperties: !1, required: ["name"], properties: { name: { title: "tagObjectName", type: "string", minLength: 1 }, description: { title: "tagObjectDescription", type: "string" }, externalDocs: { $ref: "#/definitions/externalDocumentationObject" } }, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } } }, exampleObject: { title: "exampleObject", type: "object", required: ["name", "value"], properties: { summary: { title: "exampleObjectSummary", type: "string" }, value: { title: "exampleObjectValue" }, description: { title: "exampleObjectDescription", type: "string" }, name: { title: "exampleObjectName", type: "string", minLength: 1 } }, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } } }, examplePairingObject: { title: "examplePairingObject", type: "object", required: ["name", "params"], properties: { name: { title: "examplePairingObjectName", type: "string", minLength: 1 }, description: { title: "examplePairingObjectDescription", type: "string" }, params: { title: "examplePairingObjectParams", type: "array", items: { title: "exampleOrReference", oneOf: [{ $ref: "#/definitions/exampleObject" }, { $ref: "#/definitions/referenceObject" }] } }, result: { title: "examplePairingObjectResult", oneOf: [{ $ref: "#/definitions/exampleObject" }, { $ref: "#/definitions/referenceObject" }] } } }, contentDescriptorObject: { title: "contentDescriptorObject", type: "object", additionalProperties: !1, required: ["name", "schema"], properties: { name: { title: "contentDescriptorObjectName", type: "string", minLength: 1 }, description: { title: "contentDescriptorObjectDescription", type: "string" }, summary: { title: "contentDescriptorObjectSummary", type: "string" }, schema: { $ref: "#/definitions/JSONSchema" }, required: { title: "contentDescriptorObjectRequired", type: "boolean", default: !1 }, deprecated: { title: "contentDescriptorObjectDeprecated", type: "boolean", default: !1 } }, patternProperties: { "^x-": { $ref: "#/definitions/specificationExtension" } } } } }, e.default = e.openrpcDocument;
  }(Zi)), Zi;
}
var rf;
function w1() {
  if (rf) return pt;
  rf = 1;
  var e = pt && pt.__assign || function() {
    return e = Object.assign || function(x) {
      for (var P, C = 1, R = arguments.length; C < R; C++) {
        P = arguments[C];
        for (var m in P) Object.prototype.hasOwnProperty.call(P, m) && (x[m] = P[m]);
      }
      return x;
    }, e.apply(this, arguments);
  }, t = pt && pt.__awaiter || function(x, P, C, R) {
    function m(_) {
      return _ instanceof C ? _ : new C(function(O) {
        O(_);
      });
    }
    return new (C || (C = Promise))(function(_, O) {
      function T(B) {
        try {
          M(R.next(B));
        } catch (J) {
          O(J);
        }
      }
      function A(B) {
        try {
          M(R.throw(B));
        } catch (J) {
          O(J);
        }
      }
      function M(B) {
        B.done ? _(B.value) : m(B.value).then(T, A);
      }
      M((R = R.apply(x, P || [])).next());
    });
  }, n = pt && pt.__generator || function(x, P) {
    var C = { label: 0, sent: function() {
      if (_[0] & 1) throw _[1];
      return _[1];
    }, trys: [], ops: [] }, R, m, _, O;
    return O = { next: T(0), throw: T(1), return: T(2) }, typeof Symbol == "function" && (O[Symbol.iterator] = function() {
      return this;
    }), O;
    function T(M) {
      return function(B) {
        return A([M, B]);
      };
    }
    function A(M) {
      if (R) throw new TypeError("Generator is already executing.");
      for (; O && (O = 0, M[0] && (C = 0)), C; ) try {
        if (R = 1, m && (_ = M[0] & 2 ? m.return : M[0] ? m.throw || ((_ = m.return) && _.call(m), 0) : m.next) && !(_ = _.call(m, M[1])).done) return _;
        switch (m = 0, _ && (M = [M[0] & 2, _.value]), M[0]) {
          case 0:
          case 1:
            _ = M;
            break;
          case 4:
            return C.label++, { value: M[1], done: !1 };
          case 5:
            C.label++, m = M[1], M = [0];
            continue;
          case 7:
            M = C.ops.pop(), C.trys.pop();
            continue;
          default:
            if (_ = C.trys, !(_ = _.length > 0 && _[_.length - 1]) && (M[0] === 6 || M[0] === 2)) {
              C = 0;
              continue;
            }
            if (M[0] === 3 && (!_ || M[1] > _[0] && M[1] < _[3])) {
              C.label = M[1];
              break;
            }
            if (M[0] === 6 && C.label < _[1]) {
              C.label = _[1], _ = M;
              break;
            }
            if (_ && C.label < _[2]) {
              C.label = _[2], C.ops.push(M);
              break;
            }
            _[2] && C.ops.pop(), C.trys.pop();
            continue;
        }
        M = P.call(x, C);
      } catch (B) {
        M = [6, B], m = 0;
      } finally {
        R = _ = 0;
      }
      if (M[0] & 5) throw M[1];
      return { value: M[0] ? M[1] : void 0, done: !0 };
    }
  }, a = pt && pt.__importDefault || function(x) {
    return x && x.__esModule ? x : { default: x };
  };
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.OpenRPCDocumentDereferencingError = void 0;
  var r = a(b1()), o = a(Zh()), s = a(iu()), i = a(Xh()), u = (
    /** @class */
    /* @__PURE__ */ function() {
      function x(P) {
        this.name = "OpenRPCDocumentDereferencingError", this.message = `The json schema provided cannot be dereferenced. Received Error: 
 `.concat(P);
      }
      return x;
    }()
  );
  pt.OpenRPCDocumentDereferencingError = u;
  var f = function(x, P, C) {
    return t(void 0, void 0, void 0, function() {
      var R, m;
      return n(this, function(_) {
        switch (_.label) {
          case 0:
            if (R = x.$ref, R === void 0)
              return [2, x];
            _.label = 1;
          case 1:
            return _.trys.push([1, 3, , 4]), [4, C.resolve(R, P)];
          case 2:
            return [2, _.sent()];
          case 3:
            throw m = _.sent(), new u([
              "unable to eval pointer against OpenRPC Document.",
              "error type: ".concat(m.name),
              "instance: ".concat(m.instance),
              "token: ".concat(m.token),
              "pointer: ".concat(R),
              "reference object: ".concat((0, i.default)(x))
            ].join(`
`));
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, p = function(x, P, C) {
    return t(void 0, void 0, void 0, function() {
      var R, m, _, O, T, A;
      return n(this, function(M) {
        switch (M.label) {
          case 0:
            R = [], m = 0, _ = x, M.label = 1;
          case 1:
            return m < _.length ? (O = _[m], A = (T = R).push, [4, f(O, P, C)]) : [3, 4];
          case 2:
            A.apply(T, [M.sent()]), M.label = 3;
          case 3:
            return m++, [3, 1];
          case 4:
            return [2, R];
        }
      });
    });
  }, c = function(x, P, C) {
    return t(void 0, void 0, void 0, function() {
      return n(this, function(R) {
        return Array.isArray(x) ? [2, p(x, P, C)] : [2, f(x, P, C)];
      });
    });
  }, l = function(x, P) {
    return t(void 0, void 0, void 0, function() {
      var C, R, m;
      return n(this, function(_) {
        switch (_.label) {
          case 0:
            if (x === !0 || x === !1)
              return [2, Promise.resolve(x)];
            P !== void 0 && (x.components = { schemas: P }), C = new r.default(x), _.label = 1;
          case 1:
            return _.trys.push([1, 3, , 4]), [4, C.resolve()];
          case 2:
            return R = _.sent(), R !== !0 && R !== !1 && (delete R.components, delete x.components), [2, R];
          case 3:
            throw m = _.sent(), new u([
              "Unable to parse reference inside of JSONSchema",
              x.title ? "Schema Title: ".concat(x.title) : "",
              "error message: ".concat(m.message),
              "schema in question: ".concat((0, i.default)(x))
            ].join(`
`));
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, v = function(x) {
    return t(void 0, void 0, void 0, function() {
      var P, C, R, m, _, O, T;
      return n(this, function(A) {
        switch (A.label) {
          case 0:
            if (x.components === void 0)
              return [2, Promise.resolve(x)];
            if (x.components.schemas === void 0)
              return [2, Promise.resolve(x)];
            P = x.components.schemas, C = Object.keys(P), R = 0, m = C, A.label = 1;
          case 1:
            return R < m.length ? (_ = m[R], O = P, T = _, [4, l(P[_], P)]) : [3, 4];
          case 2:
            O[T] = A.sent(), A.label = 3;
          case 3:
            return R++, [3, 1];
          case 4:
            return [2, x];
        }
      });
    });
  }, d = function(x) {
    return t(void 0, void 0, void 0, function() {
      var P, C, R, m, _, O, T;
      return n(this, function(A) {
        switch (A.label) {
          case 0:
            if (x.components === void 0)
              return [2, Promise.resolve(x)];
            if (x.components.contentDescriptors === void 0)
              return [2, Promise.resolve(x)];
            P = x.components.contentDescriptors, C = Object.keys(P), R = {}, x.components.schemas && (R = x.components.schemas), m = 0, _ = C, A.label = 1;
          case 1:
            return m < _.length ? (O = _[m], T = P[O], [4, l(P[O].schema, R)]) : [3, 4];
          case 2:
            T.schema = A.sent(), A.label = 3;
          case 3:
            return m++, [3, 1];
          case 4:
            return [2, x];
        }
      });
    });
  }, h = function(x) {
    for (var P, C, R = {}, m = /* @__PURE__ */ new Map(), _ = /* @__PURE__ */ new Set(), O = 0, T = Object.entries(x); O < T.length; O++) {
      var A = T[O], M = A[0], B = A[1];
      m.set(M, /* @__PURE__ */ new Set());
      for (var J = 0, Q = B; J < Q.length; J++) {
        var Z = Q[J], te = Z.split(".");
        if (te.length === 1)
          (P = m.get(M)) === null || P === void 0 || P.add(Z);
        else if (Z.startsWith("definitions.")) {
          te.shift();
          var le = te[0];
          le && le !== M && ((C = m.get(M)) === null || C === void 0 || C.add(le));
        }
      }
    }
    var me = function(G) {
      var ee;
      if (!_.has(G)) {
        if ((ee = m.get(G)) === null || ee === void 0 || ee.forEach(function(j) {
          return me(j);
        }), !x[G])
          return G;
        var ae = [];
        x[G].forEach(function(j) {
          if (!j.startsWith("definitions.")) {
            ae.push(j);
            return;
          }
          var N = j.split(".");
          N.shift();
          var W = N.shift(), K = N.join(".");
          if (!W || !R[W]) {
            ae.push(K);
            return;
          }
          R[W].forEach(function(I) {
            var L = I ? "".concat(I, ".").concat(K) : K;
            ae.push(L);
          });
        }), R[G] = ae, _.add(G);
      }
    };
    return Object.keys(x).forEach(me), R;
  };
  function g(x, P) {
    P === void 0 && (P = "");
    var C = {}, R = function(O) {
      return O.split(/\.(items|patternProperties)/)[0];
    }, m = function(O, T) {
      if (O && O !== "referenceObject") {
        C[O] || (C[O] = []);
        var A = R(T);
        A && !C[O].includes(A) && C[O].push(A);
      }
    }, _ = function(O, T) {
      if (!(!O || typeof O != "object")) {
        if ("$ref" in O) {
          var A = O.$ref.split("/").pop();
          m(A, T);
        }
        if ("items" in O) {
          if (O.items.$ref) {
            var A = O.items.$ref.split("/").pop();
            m(A, "".concat(T, ".items"));
          }
          O.items.oneOf && O.items.oneOf.forEach(function(M) {
            if (M.$ref) {
              var B = M.$ref.split("/").pop();
              m(B, "".concat(T, ".items"));
            }
          });
        }
        "properties" in O && Object.entries(O.properties).forEach(function(M) {
          var B = M[0], J = M[1], Q = T ? "".concat(T, ".").concat(B) : B;
          _(J, Q);
        }), "oneOf" in O && O.oneOf.forEach(function(M) {
          if (M.$ref) {
            var B = M.$ref.split("/").pop();
            m(B, T);
          }
          _(M, T);
        }), Object.entries(O).forEach(function(M) {
          var B = M[0], J = M[1];
          if (J && typeof J == "object" && B !== "properties" && B !== "items" && B !== "oneOf") {
            var Q = T ? "".concat(T, ".").concat(B) : B;
            _(J, Q);
          }
        });
      }
    };
    return _(x, P), h(C);
  }
  function b(x, P) {
    return x[P] || [];
  }
  var E = function(x, P) {
    var C = x.split("."), R = function(m, _) {
      var O = [], T = function(A, M) {
        if (A) {
          if (M === _.length) {
            O.push(A);
            return;
          }
          var B = _[M], J = A[B];
          Array.isArray(J) ? J.forEach(function(Q) {
            return T(Q, M + 1);
          }) : J && typeof J == "object" && T(J, M + 1);
        }
      };
      return T(m, 0), O;
    };
    return { items: R(P, C) };
  }, S = function(x, P, C) {
    return t(void 0, void 0, void 0, function() {
      var R, m;
      return n(this, function(_) {
        switch (_.label) {
          case 0:
            return x.$ref === void 0 ? [3, 2] : [4, f({ $ref: x.$ref }, P, C)];
          case 1:
            x = _.sent(), _.label = 2;
          case 2:
            return R = {}, P.components && P.components.schemas && (R = P.components.schemas), x.schema === void 0 ? [3, 4] : (m = x, [4, l(x.schema, R)]);
          case 3:
            m.schema = _.sent(), _.label = 4;
          case 4:
            return [2, x];
        }
      });
    });
  }, w = function(x, P, C) {
    return t(void 0, void 0, void 0, function() {
      var R, m, _, O, T, A, M, B, J, Q, Z, te, le, me, G, ee, ae, j, N, W;
      return n(this, function(K) {
        switch (K.label) {
          case 0:
            return R = x, x.$ref === void 0 ? [3, 2] : [4, f({ $ref: x.$ref }, P, C)];
          case 1:
            R = K.sent(), K.label = 2;
          case 2:
            return R.tags === void 0 ? [3, 4] : (m = R, [4, p(R.tags, P, C)]);
          case 3:
            m.tags = K.sent(), K.label = 4;
          case 4:
            return R.errors === void 0 ? [3, 6] : (_ = R, [4, p(R.errors, P, C)]);
          case 5:
            _.errors = K.sent(), K.label = 6;
          case 6:
            return R.links === void 0 ? [3, 8] : (O = R, [4, p(R.links, P, C)]);
          case 7:
            O.links = K.sent(), K.label = 8;
          case 8:
            return R.examples === void 0 ? [3, 14] : (T = R, [4, p(R.examples, P, C)]);
          case 9:
            T.examples = K.sent(), A = 0, M = R.examples, K.label = 10;
          case 10:
            return A < M.length ? (B = M[A], J = B, [4, p(B.params, P, C)]) : [3, 14];
          case 11:
            return J.params = K.sent(), B.result === void 0 ? [3, 13] : (Q = B, [4, f(B.result, P, C)]);
          case 12:
            Q.result = K.sent(), K.label = 13;
          case 13:
            return A++, [3, 10];
          case 14:
            return Z = R, [4, p(R.params, P, C)];
          case 15:
            return Z.params = K.sent(), R.result === void 0 ? [3, 17] : (te = R, [4, f(R.result, P, C)]);
          case 16:
            te.result = K.sent(), K.label = 17;
          case 17:
            le = {}, P.components && P.components.schemas && (le = P.components.schemas), me = R.params, G = 0, ee = me, K.label = 18;
          case 18:
            return G < ee.length ? (ae = ee[G], j = ae, [4, l(ae.schema, le)]) : [3, 21];
          case 19:
            j.schema = K.sent(), K.label = 20;
          case 20:
            return G++, [3, 18];
          case 21:
            return R.result === void 0 ? [3, 23] : (N = R.result, W = N, [4, l(N.schema, le)]);
          case 22:
            W.schema = K.sent(), K.label = 23;
          case 23:
            return [2, R];
        }
      });
    });
  };
  function y(x, P) {
    return P === void 0 && (P = s.default), t(this, void 0, void 0, function() {
      var C, R, m, _, O, T, j, A, M, B, J, Q, Z, te, le, me, G, ee, ae, j, N, W, K, I, L, X, Y, re, pe;
      return n(this, function(ie) {
        switch (ie.label) {
          case 0:
            return C = e({}, x), [4, v(C)];
          case 1:
            return C = ie.sent(), [4, d(C)];
          case 2:
            if (C = ie.sent(), R = g(o.default), m = [], _ = [], !C["x-extensions"]) return [3, 7];
            O = 0, T = C["x-extensions"], ie.label = 3;
          case 3:
            return O < T.length ? (j = T[O], [4, S(j, C, P)]) : [3, 6];
          case 4:
            for (A = ie.sent(), m.push(A), M = 0, B = A.restricted; M < B.length; M++)
              J = B[M], _.push({
                extensionName: A.name,
                docNames: b(R, J)
              });
            ie.label = 5;
          case 5:
            return O++, [3, 3];
          case 6:
            C["x-extensions"] = m, ie.label = 7;
          case 7:
            Q = [], Z = 0, te = C.methods, ie.label = 8;
          case 8:
            return Z < te.length ? (le = te[Z], G = (me = Q).push, [4, w(le, C, P)]) : [3, 11];
          case 9:
            G.apply(me, [ie.sent()]), ie.label = 10;
          case 10:
            return Z++, [3, 8];
          case 11:
            ee = 0, ae = _, ie.label = 12;
          case 12:
            if (!(ee < ae.length)) return [3, 19];
            j = ae[ee], N = 0, W = j.docNames, ie.label = 13;
          case 13:
            if (!(N < W.length)) return [3, 18];
            K = W[N], I = E(K, C).items, L = 0, X = I, ie.label = 14;
          case 14:
            return L < X.length ? (Y = X[L], Y && Y[j.extensionName] ? (re = Y, pe = j.extensionName, [4, c(Y[j.extensionName], C, P)]) : [3, 16]) : [3, 17];
          case 15:
            re[pe] = ie.sent(), ie.label = 16;
          case 16:
            return L++, [3, 14];
          case 17:
            return N++, [3, 13];
          case 18:
            return ee++, [3, 12];
          case 19:
            return C.methods = Q, [2, C];
        }
      });
    });
  }
  return pt.default = y, pt;
}
var Rr = {}, _a = { exports: {} };
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
var S1 = _a.exports, nf;
function P1() {
  return nf || (nf = 1, function(e, t) {
    (function(n, a) {
      a(t);
    })(S1, function(n) {
      function a() {
        for (var D = arguments.length, $ = Array(D), k = 0; k < D; k++)
          $[k] = arguments[k];
        if ($.length > 1) {
          $[0] = $[0].slice(0, -1);
          for (var F = $.length - 1, q = 1; q < F; ++q)
            $[q] = $[q].slice(1, -1);
          return $[F] = $[F].slice(1), $.join("");
        } else
          return $[0];
      }
      function r(D) {
        return "(?:" + D + ")";
      }
      function o(D) {
        return D === void 0 ? "undefined" : D === null ? "null" : Object.prototype.toString.call(D).split(" ").pop().split("]").shift().toLowerCase();
      }
      function s(D) {
        return D.toUpperCase();
      }
      function i(D) {
        return D != null ? D instanceof Array ? D : typeof D.length != "number" || D.split || D.setInterval || D.call ? [D] : Array.prototype.slice.call(D) : [];
      }
      function u(D, $) {
        var k = D;
        if ($)
          for (var F in $)
            k[F] = $[F];
        return k;
      }
      function f(D) {
        var $ = "[A-Za-z]", k = "[0-9]", F = a(k, "[A-Fa-f]"), q = r(r("%[EFef]" + F + "%" + F + F + "%" + F + F) + "|" + r("%[89A-Fa-f]" + F + "%" + F + F) + "|" + r("%" + F + F)), ue = "[\\:\\/\\?\\#\\[\\]\\@]", fe = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", be = a(ue, fe), Ie = D ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", We = D ? "[\\uE000-\\uF8FF]" : "[]", ge = a($, k, "[\\-\\.\\_\\~]", Ie);
        r($ + a($, k, "[\\+\\-\\.]") + "*"), r(r(q + "|" + a(ge, fe, "[\\:]")) + "*");
        var Ae = r(r("25[0-5]") + "|" + r("2[0-4]" + k) + "|" + r("1" + k + k) + "|" + r("0?[1-9]" + k) + "|0?0?" + k), Ge = r(Ae + "\\." + Ae + "\\." + Ae + "\\." + Ae), he = r(F + "{1,4}"), Ne = r(r(he + "\\:" + he) + "|" + Ge), Qe = r(r(he + "\\:") + "{6}" + Ne), Le = r("\\:\\:" + r(he + "\\:") + "{5}" + Ne), _r = r(r(he) + "?\\:\\:" + r(he + "\\:") + "{4}" + Ne), Wt = r(r(r(he + "\\:") + "{0,1}" + he) + "?\\:\\:" + r(he + "\\:") + "{3}" + Ne), Gt = r(r(r(he + "\\:") + "{0,2}" + he) + "?\\:\\:" + r(he + "\\:") + "{2}" + Ne), ln = r(r(r(he + "\\:") + "{0,3}" + he) + "?\\:\\:" + he + "\\:" + Ne), Br = r(r(r(he + "\\:") + "{0,4}" + he) + "?\\:\\:" + Ne), Dt = r(r(r(he + "\\:") + "{0,5}" + he) + "?\\:\\:" + he), Kt = r(r(r(he + "\\:") + "{0,6}" + he) + "?\\:\\:"), Ur = r([Qe, Le, _r, Wt, Gt, ln, Br, Dt, Kt].join("|")), pr = r(r(ge + "|" + q) + "+");
        r("[vV]" + F + "+\\." + a(ge, fe, "[\\:]") + "+"), r(r(q + "|" + a(ge, fe)) + "*");
        var ta = r(q + "|" + a(ge, fe, "[\\:\\@]"));
        return r(r(q + "|" + a(ge, fe, "[\\@]")) + "+"), r(r(ta + "|" + a("[\\/\\?]", We)) + "*"), {
          NOT_SCHEME: new RegExp(a("[^]", $, k, "[\\+\\-\\.]"), "g"),
          NOT_USERINFO: new RegExp(a("[^\\%\\:]", ge, fe), "g"),
          NOT_HOST: new RegExp(a("[^\\%\\[\\]\\:]", ge, fe), "g"),
          NOT_PATH: new RegExp(a("[^\\%\\/\\:\\@]", ge, fe), "g"),
          NOT_PATH_NOSCHEME: new RegExp(a("[^\\%\\/\\@]", ge, fe), "g"),
          NOT_QUERY: new RegExp(a("[^\\%]", ge, fe, "[\\:\\@\\/\\?]", We), "g"),
          NOT_FRAGMENT: new RegExp(a("[^\\%]", ge, fe, "[\\:\\@\\/\\?]"), "g"),
          ESCAPE: new RegExp(a("[^]", ge, fe), "g"),
          UNRESERVED: new RegExp(ge, "g"),
          OTHER_CHARS: new RegExp(a("[^\\%]", ge, be), "g"),
          PCT_ENCODED: new RegExp(q, "g"),
          IPV4ADDRESS: new RegExp("^(" + Ge + ")$"),
          IPV6ADDRESS: new RegExp("^\\[?(" + Ur + ")" + r(r("\\%25|\\%(?!" + F + "{2})") + "(" + pr + ")") + "?\\]?$")
          //RFC 6874, with relaxed parsing rules
        };
      }
      var p = f(!1), c = f(!0), l = /* @__PURE__ */ function() {
        function D($, k) {
          var F = [], q = !0, ue = !1, fe = void 0;
          try {
            for (var be = $[Symbol.iterator](), Ie; !(q = (Ie = be.next()).done) && (F.push(Ie.value), !(k && F.length === k)); q = !0)
              ;
          } catch (We) {
            ue = !0, fe = We;
          } finally {
            try {
              !q && be.return && be.return();
            } finally {
              if (ue) throw fe;
            }
          }
          return F;
        }
        return function($, k) {
          if (Array.isArray($))
            return $;
          if (Symbol.iterator in Object($))
            return D($, k);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(), v = function(D) {
        if (Array.isArray(D)) {
          for (var $ = 0, k = Array(D.length); $ < D.length; $++) k[$] = D[$];
          return k;
        } else
          return Array.from(D);
      }, d = 2147483647, h = 36, g = 1, b = 26, E = 38, S = 700, w = 72, y = 128, x = "-", P = /^xn--/, C = /[^\0-\x7E]/, R = /[\x2E\u3002\uFF0E\uFF61]/g, m = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      }, _ = h - g, O = Math.floor, T = String.fromCharCode;
      function A(D) {
        throw new RangeError(m[D]);
      }
      function M(D, $) {
        for (var k = [], F = D.length; F--; )
          k[F] = $(D[F]);
        return k;
      }
      function B(D, $) {
        var k = D.split("@"), F = "";
        k.length > 1 && (F = k[0] + "@", D = k[1]), D = D.replace(R, ".");
        var q = D.split("."), ue = M(q, $).join(".");
        return F + ue;
      }
      function J(D) {
        for (var $ = [], k = 0, F = D.length; k < F; ) {
          var q = D.charCodeAt(k++);
          if (q >= 55296 && q <= 56319 && k < F) {
            var ue = D.charCodeAt(k++);
            (ue & 64512) == 56320 ? $.push(((q & 1023) << 10) + (ue & 1023) + 65536) : ($.push(q), k--);
          } else
            $.push(q);
        }
        return $;
      }
      var Q = function($) {
        return String.fromCodePoint.apply(String, v($));
      }, Z = function($) {
        return $ - 48 < 10 ? $ - 22 : $ - 65 < 26 ? $ - 65 : $ - 97 < 26 ? $ - 97 : h;
      }, te = function($, k) {
        return $ + 22 + 75 * ($ < 26) - ((k != 0) << 5);
      }, le = function($, k, F) {
        var q = 0;
        for (
          $ = F ? O($ / S) : $ >> 1, $ += O($ / k);
          /* no initialization */
          $ > _ * b >> 1;
          q += h
        )
          $ = O($ / _);
        return O(q + (_ + 1) * $ / ($ + E));
      }, me = function($) {
        var k = [], F = $.length, q = 0, ue = y, fe = w, be = $.lastIndexOf(x);
        be < 0 && (be = 0);
        for (var Ie = 0; Ie < be; ++Ie)
          $.charCodeAt(Ie) >= 128 && A("not-basic"), k.push($.charCodeAt(Ie));
        for (var We = be > 0 ? be + 1 : 0; We < F; ) {
          for (
            var ge = q, Ae = 1, Ge = h;
            ;
            /* no condition */
            Ge += h
          ) {
            We >= F && A("invalid-input");
            var he = Z($.charCodeAt(We++));
            (he >= h || he > O((d - q) / Ae)) && A("overflow"), q += he * Ae;
            var Ne = Ge <= fe ? g : Ge >= fe + b ? b : Ge - fe;
            if (he < Ne)
              break;
            var Qe = h - Ne;
            Ae > O(d / Qe) && A("overflow"), Ae *= Qe;
          }
          var Le = k.length + 1;
          fe = le(q - ge, Le, ge == 0), O(q / Le) > d - ue && A("overflow"), ue += O(q / Le), q %= Le, k.splice(q++, 0, ue);
        }
        return String.fromCodePoint.apply(String, k);
      }, G = function($) {
        var k = [];
        $ = J($);
        var F = $.length, q = y, ue = 0, fe = w, be = !0, Ie = !1, We = void 0;
        try {
          for (var ge = $[Symbol.iterator](), Ae; !(be = (Ae = ge.next()).done); be = !0) {
            var Ge = Ae.value;
            Ge < 128 && k.push(T(Ge));
          }
        } catch (ra) {
          Ie = !0, We = ra;
        } finally {
          try {
            !be && ge.return && ge.return();
          } finally {
            if (Ie)
              throw We;
          }
        }
        var he = k.length, Ne = he;
        for (he && k.push(x); Ne < F; ) {
          var Qe = d, Le = !0, _r = !1, Wt = void 0;
          try {
            for (var Gt = $[Symbol.iterator](), ln; !(Le = (ln = Gt.next()).done); Le = !0) {
              var Br = ln.value;
              Br >= q && Br < Qe && (Qe = Br);
            }
          } catch (ra) {
            _r = !0, Wt = ra;
          } finally {
            try {
              !Le && Gt.return && Gt.return();
            } finally {
              if (_r)
                throw Wt;
            }
          }
          var Dt = Ne + 1;
          Qe - q > O((d - ue) / Dt) && A("overflow"), ue += (Qe - q) * Dt, q = Qe;
          var Kt = !0, Ur = !1, pr = void 0;
          try {
            for (var ta = $[Symbol.iterator](), qu; !(Kt = (qu = ta.next()).done); Kt = !0) {
              var Fu = qu.value;
              if (Fu < q && ++ue > d && A("overflow"), Fu == q) {
                for (
                  var so = ue, lo = h;
                  ;
                  /* no condition */
                  lo += h
                ) {
                  var uo = lo <= fe ? g : lo >= fe + b ? b : lo - fe;
                  if (so < uo)
                    break;
                  var zu = so - uo, Bu = h - uo;
                  k.push(T(te(uo + zu % Bu, 0))), so = O(zu / Bu);
                }
                k.push(T(te(so, 0))), fe = le(ue, Dt, Ne == he), ue = 0, ++Ne;
              }
            }
          } catch (ra) {
            Ur = !0, pr = ra;
          } finally {
            try {
              !Kt && ta.return && ta.return();
            } finally {
              if (Ur)
                throw pr;
            }
          }
          ++ue, ++q;
        }
        return k.join("");
      }, ee = function($) {
        return B($, function(k) {
          return P.test(k) ? me(k.slice(4).toLowerCase()) : k;
        });
      }, ae = function($) {
        return B($, function(k) {
          return C.test(k) ? "xn--" + G(k) : k;
        });
      }, j = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        version: "2.1.0",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        ucs2: {
          decode: J,
          encode: Q
        },
        decode: me,
        encode: G,
        toASCII: ae,
        toUnicode: ee
      }, N = {};
      function W(D) {
        var $ = D.charCodeAt(0), k = void 0;
        return $ < 16 ? k = "%0" + $.toString(16).toUpperCase() : $ < 128 ? k = "%" + $.toString(16).toUpperCase() : $ < 2048 ? k = "%" + ($ >> 6 | 192).toString(16).toUpperCase() + "%" + ($ & 63 | 128).toString(16).toUpperCase() : k = "%" + ($ >> 12 | 224).toString(16).toUpperCase() + "%" + ($ >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + ($ & 63 | 128).toString(16).toUpperCase(), k;
      }
      function K(D) {
        for (var $ = "", k = 0, F = D.length; k < F; ) {
          var q = parseInt(D.substr(k + 1, 2), 16);
          if (q < 128)
            $ += String.fromCharCode(q), k += 3;
          else if (q >= 194 && q < 224) {
            if (F - k >= 6) {
              var ue = parseInt(D.substr(k + 4, 2), 16);
              $ += String.fromCharCode((q & 31) << 6 | ue & 63);
            } else
              $ += D.substr(k, 6);
            k += 6;
          } else if (q >= 224) {
            if (F - k >= 9) {
              var fe = parseInt(D.substr(k + 4, 2), 16), be = parseInt(D.substr(k + 7, 2), 16);
              $ += String.fromCharCode((q & 15) << 12 | (fe & 63) << 6 | be & 63);
            } else
              $ += D.substr(k, 9);
            k += 9;
          } else
            $ += D.substr(k, 3), k += 3;
        }
        return $;
      }
      function I(D, $) {
        function k(F) {
          var q = K(F);
          return q.match($.UNRESERVED) ? q : F;
        }
        return D.scheme && (D.scheme = String(D.scheme).replace($.PCT_ENCODED, k).toLowerCase().replace($.NOT_SCHEME, "")), D.userinfo !== void 0 && (D.userinfo = String(D.userinfo).replace($.PCT_ENCODED, k).replace($.NOT_USERINFO, W).replace($.PCT_ENCODED, s)), D.host !== void 0 && (D.host = String(D.host).replace($.PCT_ENCODED, k).toLowerCase().replace($.NOT_HOST, W).replace($.PCT_ENCODED, s)), D.path !== void 0 && (D.path = String(D.path).replace($.PCT_ENCODED, k).replace(D.scheme ? $.NOT_PATH : $.NOT_PATH_NOSCHEME, W).replace($.PCT_ENCODED, s)), D.query !== void 0 && (D.query = String(D.query).replace($.PCT_ENCODED, k).replace($.NOT_QUERY, W).replace($.PCT_ENCODED, s)), D.fragment !== void 0 && (D.fragment = String(D.fragment).replace($.PCT_ENCODED, k).replace($.NOT_FRAGMENT, W).replace($.PCT_ENCODED, s)), D;
      }
      function L(D) {
        return D.replace(/^0*(.*)/, "$1") || "0";
      }
      function X(D, $) {
        var k = D.match($.IPV4ADDRESS) || [], F = l(k, 2), q = F[1];
        return q ? q.split(".").map(L).join(".") : D;
      }
      function Y(D, $) {
        var k = D.match($.IPV6ADDRESS) || [], F = l(k, 3), q = F[1], ue = F[2];
        if (q) {
          for (var fe = q.toLowerCase().split("::").reverse(), be = l(fe, 2), Ie = be[0], We = be[1], ge = We ? We.split(":").map(L) : [], Ae = Ie.split(":").map(L), Ge = $.IPV4ADDRESS.test(Ae[Ae.length - 1]), he = Ge ? 7 : 8, Ne = Ae.length - he, Qe = Array(he), Le = 0; Le < he; ++Le)
            Qe[Le] = ge[Le] || Ae[Ne + Le] || "";
          Ge && (Qe[he - 1] = X(Qe[he - 1], $));
          var _r = Qe.reduce(function(Dt, Kt, Ur) {
            if (!Kt || Kt === "0") {
              var pr = Dt[Dt.length - 1];
              pr && pr.index + pr.length === Ur ? pr.length++ : Dt.push({ index: Ur, length: 1 });
            }
            return Dt;
          }, []), Wt = _r.sort(function(Dt, Kt) {
            return Kt.length - Dt.length;
          })[0], Gt = void 0;
          if (Wt && Wt.length > 1) {
            var ln = Qe.slice(0, Wt.index), Br = Qe.slice(Wt.index + Wt.length);
            Gt = ln.join(":") + "::" + Br.join(":");
          } else
            Gt = Qe.join(":");
          return ue && (Gt += "%" + ue), Gt;
        } else
          return D;
      }
      var re = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, pe = "".match(/(){0}/)[1] === void 0;
      function ie(D) {
        var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, k = {}, F = $.iri !== !1 ? c : p;
        $.reference === "suffix" && (D = ($.scheme ? $.scheme + ":" : "") + "//" + D);
        var q = D.match(re);
        if (q) {
          pe ? (k.scheme = q[1], k.userinfo = q[3], k.host = q[4], k.port = parseInt(q[5], 10), k.path = q[6] || "", k.query = q[7], k.fragment = q[8], isNaN(k.port) && (k.port = q[5])) : (k.scheme = q[1] || void 0, k.userinfo = D.indexOf("@") !== -1 ? q[3] : void 0, k.host = D.indexOf("//") !== -1 ? q[4] : void 0, k.port = parseInt(q[5], 10), k.path = q[6] || "", k.query = D.indexOf("?") !== -1 ? q[7] : void 0, k.fragment = D.indexOf("#") !== -1 ? q[8] : void 0, isNaN(k.port) && (k.port = D.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? q[4] : void 0)), k.host && (k.host = Y(X(k.host, F), F)), k.scheme === void 0 && k.userinfo === void 0 && k.host === void 0 && k.port === void 0 && !k.path && k.query === void 0 ? k.reference = "same-document" : k.scheme === void 0 ? k.reference = "relative" : k.fragment === void 0 ? k.reference = "absolute" : k.reference = "uri", $.reference && $.reference !== "suffix" && $.reference !== k.reference && (k.error = k.error || "URI is not a " + $.reference + " reference.");
          var ue = N[($.scheme || k.scheme || "").toLowerCase()];
          if (!$.unicodeSupport && (!ue || !ue.unicodeSupport)) {
            if (k.host && ($.domainHost || ue && ue.domainHost))
              try {
                k.host = j.toASCII(k.host.replace(F.PCT_ENCODED, K).toLowerCase());
              } catch (fe) {
                k.error = k.error || "Host's domain name can not be converted to ASCII via punycode: " + fe;
              }
            I(k, p);
          } else
            I(k, F);
          ue && ue.parse && ue.parse(k, $);
        } else
          k.error = k.error || "URI can not be parsed.";
        return k;
      }
      function ce(D, $) {
        var k = $.iri !== !1 ? c : p, F = [];
        return D.userinfo !== void 0 && (F.push(D.userinfo), F.push("@")), D.host !== void 0 && F.push(Y(X(String(D.host), k), k).replace(k.IPV6ADDRESS, function(q, ue, fe) {
          return "[" + ue + (fe ? "%25" + fe : "") + "]";
        })), (typeof D.port == "number" || typeof D.port == "string") && (F.push(":"), F.push(String(D.port))), F.length ? F.join("") : void 0;
      }
      var de = /^\.\.?\//, ye = /^\/\.(\/|$)/, tt = /^\/\.\.(\/|$)/, se = /^\/?(?:.|\n)*?(?=\/|$)/;
      function oe(D) {
        for (var $ = []; D.length; )
          if (D.match(de))
            D = D.replace(de, "");
          else if (D.match(ye))
            D = D.replace(ye, "/");
          else if (D.match(tt))
            D = D.replace(tt, "/"), $.pop();
          else if (D === "." || D === "..")
            D = "";
          else {
            var k = D.match(se);
            if (k) {
              var F = k[0];
              D = D.slice(F.length), $.push(F);
            } else
              throw new Error("Unexpected dot segment condition");
          }
        return $.join("");
      }
      function ze(D) {
        var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, k = $.iri ? c : p, F = [], q = N[($.scheme || D.scheme || "").toLowerCase()];
        if (q && q.serialize && q.serialize(D, $), D.host && !k.IPV6ADDRESS.test(D.host)) {
          if ($.domainHost || q && q.domainHost)
            try {
              D.host = $.iri ? j.toUnicode(D.host) : j.toASCII(D.host.replace(k.PCT_ENCODED, K).toLowerCase());
            } catch (be) {
              D.error = D.error || "Host's domain name can not be converted to " + ($.iri ? "Unicode" : "ASCII") + " via punycode: " + be;
            }
        }
        I(D, k), $.reference !== "suffix" && D.scheme && (F.push(D.scheme), F.push(":"));
        var ue = ce(D, $);
        if (ue !== void 0 && ($.reference !== "suffix" && F.push("//"), F.push(ue), D.path && D.path.charAt(0) !== "/" && F.push("/")), D.path !== void 0) {
          var fe = D.path;
          !$.absolutePath && (!q || !q.absolutePath) && (fe = oe(fe)), ue === void 0 && (fe = fe.replace(/^\/\//, "/%2F")), F.push(fe);
        }
        return D.query !== void 0 && (F.push("?"), F.push(D.query)), D.fragment !== void 0 && (F.push("#"), F.push(D.fragment)), F.join("");
      }
      function dt(D, $) {
        var k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, F = arguments[3], q = {};
        return F || (D = ie(ze(D, k), k), $ = ie(ze($, k), k)), k = k || {}, !k.tolerant && $.scheme ? (q.scheme = $.scheme, q.userinfo = $.userinfo, q.host = $.host, q.port = $.port, q.path = oe($.path || ""), q.query = $.query) : ($.userinfo !== void 0 || $.host !== void 0 || $.port !== void 0 ? (q.userinfo = $.userinfo, q.host = $.host, q.port = $.port, q.path = oe($.path || ""), q.query = $.query) : ($.path ? ($.path.charAt(0) === "/" ? q.path = oe($.path) : ((D.userinfo !== void 0 || D.host !== void 0 || D.port !== void 0) && !D.path ? q.path = "/" + $.path : D.path ? q.path = D.path.slice(0, D.path.lastIndexOf("/") + 1) + $.path : q.path = $.path, q.path = oe(q.path)), q.query = $.query) : (q.path = D.path, $.query !== void 0 ? q.query = $.query : q.query = D.query), q.userinfo = D.userinfo, q.host = D.host, q.port = D.port), q.scheme = D.scheme), q.fragment = $.fragment, q;
      }
      function io(D, $, k) {
        var F = u({ scheme: "null" }, k);
        return ze(dt(ie(D, F), ie($, F), F, !0), F);
      }
      function Mi(D, $) {
        return typeof D == "string" ? D = ze(ie(D, $), $) : o(D) === "object" && (D = ie(ze(D, $), $)), D;
      }
      function Ii(D, $, k) {
        return typeof D == "string" ? D = ze(ie(D, k), k) : o(D) === "object" && (D = ze(D, k)), typeof $ == "string" ? $ = ze(ie($, k), k) : o($) === "object" && ($ = ze($, k)), D === $;
      }
      function Ym(D, $) {
        return D && D.toString().replace(!$ || !$.iri ? p.ESCAPE : c.ESCAPE, W);
      }
      function dr(D, $) {
        return D && D.toString().replace(!$ || !$.iri ? p.PCT_ENCODED : c.PCT_ENCODED, K);
      }
      var Zn = {
        scheme: "http",
        domainHost: !0,
        parse: function($, k) {
          return $.host || ($.error = $.error || "HTTP URIs must have a host."), $;
        },
        serialize: function($, k) {
          var F = String($.scheme).toLowerCase() === "https";
          return ($.port === (F ? 443 : 80) || $.port === "") && ($.port = void 0), $.path || ($.path = "/"), $;
        }
      }, ju = {
        scheme: "https",
        domainHost: Zn.domainHost,
        parse: Zn.parse,
        serialize: Zn.serialize
      };
      function Du(D) {
        return typeof D.secure == "boolean" ? D.secure : String(D.scheme).toLowerCase() === "wss";
      }
      var ea = {
        scheme: "ws",
        domainHost: !0,
        parse: function($, k) {
          var F = $;
          return F.secure = Du(F), F.resourceName = (F.path || "/") + (F.query ? "?" + F.query : ""), F.path = void 0, F.query = void 0, F;
        },
        serialize: function($, k) {
          if (($.port === (Du($) ? 443 : 80) || $.port === "") && ($.port = void 0), typeof $.secure == "boolean" && ($.scheme = $.secure ? "wss" : "ws", $.secure = void 0), $.resourceName) {
            var F = $.resourceName.split("?"), q = l(F, 2), ue = q[0], fe = q[1];
            $.path = ue && ue !== "/" ? ue : void 0, $.query = fe, $.resourceName = void 0;
          }
          return $.fragment = void 0, $;
        }
      }, ku = {
        scheme: "wss",
        domainHost: ea.domainHost,
        parse: ea.parse,
        serialize: ea.serialize
      }, Xm = {}, Au = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", Vt = "[0-9A-Fa-f]", Zm = r(r("%[EFef]" + Vt + "%" + Vt + Vt + "%" + Vt + Vt) + "|" + r("%[89A-Fa-f]" + Vt + "%" + Vt + Vt) + "|" + r("%" + Vt + Vt)), ev = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", tv = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", rv = a(tv, '[\\"\\\\]'), nv = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]", av = new RegExp(Au, "g"), sn = new RegExp(Zm, "g"), ov = new RegExp(a("[^]", ev, "[\\.]", '[\\"]', rv), "g"), Mu = new RegExp(a("[^]", Au, nv), "g"), iv = Mu;
      function Ni(D) {
        var $ = K(D);
        return $.match(av) ? $ : D;
      }
      var Iu = {
        scheme: "mailto",
        parse: function($, k) {
          var F = $, q = F.to = F.path ? F.path.split(",") : [];
          if (F.path = void 0, F.query) {
            for (var ue = !1, fe = {}, be = F.query.split("&"), Ie = 0, We = be.length; Ie < We; ++Ie) {
              var ge = be[Ie].split("=");
              switch (ge[0]) {
                case "to":
                  for (var Ae = ge[1].split(","), Ge = 0, he = Ae.length; Ge < he; ++Ge)
                    q.push(Ae[Ge]);
                  break;
                case "subject":
                  F.subject = dr(ge[1], k);
                  break;
                case "body":
                  F.body = dr(ge[1], k);
                  break;
                default:
                  ue = !0, fe[dr(ge[0], k)] = dr(ge[1], k);
                  break;
              }
            }
            ue && (F.headers = fe);
          }
          F.query = void 0;
          for (var Ne = 0, Qe = q.length; Ne < Qe; ++Ne) {
            var Le = q[Ne].split("@");
            if (Le[0] = dr(Le[0]), k.unicodeSupport)
              Le[1] = dr(Le[1], k).toLowerCase();
            else
              try {
                Le[1] = j.toASCII(dr(Le[1], k).toLowerCase());
              } catch (_r) {
                F.error = F.error || "Email address's domain name can not be converted to ASCII via punycode: " + _r;
              }
            q[Ne] = Le.join("@");
          }
          return F;
        },
        serialize: function($, k) {
          var F = $, q = i($.to);
          if (q) {
            for (var ue = 0, fe = q.length; ue < fe; ++ue) {
              var be = String(q[ue]), Ie = be.lastIndexOf("@"), We = be.slice(0, Ie).replace(sn, Ni).replace(sn, s).replace(ov, W), ge = be.slice(Ie + 1);
              try {
                ge = k.iri ? j.toUnicode(ge) : j.toASCII(dr(ge, k).toLowerCase());
              } catch (Ne) {
                F.error = F.error || "Email address's domain name can not be converted to " + (k.iri ? "Unicode" : "ASCII") + " via punycode: " + Ne;
              }
              q[ue] = We + "@" + ge;
            }
            F.path = q.join(",");
          }
          var Ae = $.headers = $.headers || {};
          $.subject && (Ae.subject = $.subject), $.body && (Ae.body = $.body);
          var Ge = [];
          for (var he in Ae)
            Ae[he] !== Xm[he] && Ge.push(he.replace(sn, Ni).replace(sn, s).replace(Mu, W) + "=" + Ae[he].replace(sn, Ni).replace(sn, s).replace(iv, W));
          return Ge.length && (F.query = Ge.join("&")), F;
        }
      }, sv = /^([^\:]+)\:(.*)/, Nu = {
        scheme: "urn",
        parse: function($, k) {
          var F = $.path && $.path.match(sv), q = $;
          if (F) {
            var ue = k.scheme || q.scheme || "urn", fe = F[1].toLowerCase(), be = F[2], Ie = ue + ":" + (k.nid || fe), We = N[Ie];
            q.nid = fe, q.nss = be, q.path = void 0, We && (q = We.parse(q, k));
          } else
            q.error = q.error || "URN can not be parsed.";
          return q;
        },
        serialize: function($, k) {
          var F = k.scheme || $.scheme || "urn", q = $.nid, ue = F + ":" + (k.nid || q), fe = N[ue];
          fe && ($ = fe.serialize($, k));
          var be = $, Ie = $.nss;
          return be.path = (q || k.nid) + ":" + Ie, be;
        }
      }, lv = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, Lu = {
        scheme: "urn:uuid",
        parse: function($, k) {
          var F = $;
          return F.uuid = F.nss, F.nss = void 0, !k.tolerant && (!F.uuid || !F.uuid.match(lv)) && (F.error = F.error || "UUID is not valid."), F;
        },
        serialize: function($, k) {
          var F = $;
          return F.nss = ($.uuid || "").toLowerCase(), F;
        }
      };
      N[Zn.scheme] = Zn, N[ju.scheme] = ju, N[ea.scheme] = ea, N[ku.scheme] = ku, N[Iu.scheme] = Iu, N[Nu.scheme] = Nu, N[Lu.scheme] = Lu, n.SCHEMES = N, n.pctEncChar = W, n.pctDecChars = K, n.parse = ie, n.removeDotSegments = oe, n.serialize = ze, n.resolveComponents = dt, n.resolve = io, n.normalize = Mi, n.equal = Ii, n.escapeComponent = Ym, n.unescapeComponent = dr, Object.defineProperty(n, "__esModule", { value: !0 });
    });
  }(_a, _a.exports)), _a.exports;
}
var es, af;
function su() {
  return af || (af = 1, es = function e(t, n) {
    if (t === n) return !0;
    if (t && n && typeof t == "object" && typeof n == "object") {
      if (t.constructor !== n.constructor) return !1;
      var a, r, o;
      if (Array.isArray(t)) {
        if (a = t.length, a != n.length) return !1;
        for (r = a; r-- !== 0; )
          if (!e(t[r], n[r])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
      if (o = Object.keys(t), a = o.length, a !== Object.keys(n).length) return !1;
      for (r = a; r-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, o[r])) return !1;
      for (r = a; r-- !== 0; ) {
        var s = o[r];
        if (!e(t[s], n[s])) return !1;
      }
      return !0;
    }
    return t !== t && n !== n;
  }), es;
}
var ts, of;
function x1() {
  return of || (of = 1, ts = function(t) {
    for (var n = 0, a = t.length, r = 0, o; r < a; )
      n++, o = t.charCodeAt(r++), o >= 55296 && o <= 56319 && r < a && (o = t.charCodeAt(r), (o & 64512) == 56320 && r++);
    return n;
  }), ts;
}
var rs, sf;
function Gn() {
  if (sf) return rs;
  sf = 1, rs = {
    copy: e,
    checkDataType: t,
    checkDataTypes: n,
    coerceToTypes: r,
    toHash: o,
    getProperty: u,
    escapeQuotes: f,
    equal: su(),
    ucs2length: x1(),
    varOccurences: p,
    varReplace: c,
    schemaHasRules: l,
    schemaHasRulesExcept: v,
    schemaUnknownRules: d,
    toQuotedString: h,
    getPathExpr: g,
    getPath: b,
    getData: w,
    unescapeFragment: x,
    unescapeJsonPointer: R,
    escapeFragment: P,
    escapeJsonPointer: C
  };
  function e(m, _) {
    _ = _ || {};
    for (var O in m) _[O] = m[O];
    return _;
  }
  function t(m, _, O, T) {
    var A = T ? " !== " : " === ", M = T ? " || " : " && ", B = T ? "!" : "", J = T ? "" : "!";
    switch (m) {
      case "null":
        return _ + A + "null";
      case "array":
        return B + "Array.isArray(" + _ + ")";
      case "object":
        return "(" + B + _ + M + "typeof " + _ + A + '"object"' + M + J + "Array.isArray(" + _ + "))";
      case "integer":
        return "(typeof " + _ + A + '"number"' + M + J + "(" + _ + " % 1)" + M + _ + A + _ + (O ? M + B + "isFinite(" + _ + ")" : "") + ")";
      case "number":
        return "(typeof " + _ + A + '"' + m + '"' + (O ? M + B + "isFinite(" + _ + ")" : "") + ")";
      default:
        return "typeof " + _ + A + '"' + m + '"';
    }
  }
  function n(m, _, O) {
    switch (m.length) {
      case 1:
        return t(m[0], _, O, !0);
      default:
        var T = "", A = o(m);
        A.array && A.object && (T = A.null ? "(" : "(!" + _ + " || ", T += "typeof " + _ + ' !== "object")', delete A.null, delete A.array, delete A.object), A.number && delete A.integer;
        for (var M in A)
          T += (T ? " && " : "") + t(M, _, O, !0);
        return T;
    }
  }
  var a = o(["string", "number", "integer", "boolean", "null"]);
  function r(m, _) {
    if (Array.isArray(_)) {
      for (var O = [], T = 0; T < _.length; T++) {
        var A = _[T];
        (a[A] || m === "array" && A === "array") && (O[O.length] = A);
      }
      if (O.length) return O;
    } else {
      if (a[_])
        return [_];
      if (m === "array" && _ === "array")
        return ["array"];
    }
  }
  function o(m) {
    for (var _ = {}, O = 0; O < m.length; O++) _[m[O]] = !0;
    return _;
  }
  var s = /^[a-z$_][a-z$_0-9]*$/i, i = /'|\\/g;
  function u(m) {
    return typeof m == "number" ? "[" + m + "]" : s.test(m) ? "." + m : "['" + f(m) + "']";
  }
  function f(m) {
    return m.replace(i, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
  }
  function p(m, _) {
    _ += "[^0-9]";
    var O = m.match(new RegExp(_, "g"));
    return O ? O.length : 0;
  }
  function c(m, _, O) {
    return _ += "([^0-9])", O = O.replace(/\$/g, "$$$$"), m.replace(new RegExp(_, "g"), O + "$1");
  }
  function l(m, _) {
    if (typeof m == "boolean") return !m;
    for (var O in m) if (_[O]) return !0;
  }
  function v(m, _, O) {
    if (typeof m == "boolean") return !m && O != "not";
    for (var T in m) if (T != O && _[T]) return !0;
  }
  function d(m, _) {
    if (typeof m != "boolean") {
      for (var O in m) if (!_[O]) return O;
    }
  }
  function h(m) {
    return "'" + f(m) + "'";
  }
  function g(m, _, O, T) {
    var A = O ? "'/' + " + _ + (T ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : T ? "'[' + " + _ + " + ']'" : "'[\\'' + " + _ + " + '\\']'";
    return y(m, A);
  }
  function b(m, _, O) {
    var T = h(O ? "/" + C(_) : u(_));
    return y(m, T);
  }
  var E = /^\/(?:[^~]|~0|~1)*$/, S = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
  function w(m, _, O) {
    var T, A, M, B;
    if (m === "") return "rootData";
    if (m[0] == "/") {
      if (!E.test(m)) throw new Error("Invalid JSON-pointer: " + m);
      A = m, M = "rootData";
    } else {
      if (B = m.match(S), !B) throw new Error("Invalid JSON-pointer: " + m);
      if (T = +B[1], A = B[2], A == "#") {
        if (T >= _) throw new Error("Cannot access property/index " + T + " levels up, current level is " + _);
        return O[_ - T];
      }
      if (T > _) throw new Error("Cannot access data " + T + " levels up, current level is " + _);
      if (M = "data" + (_ - T || ""), !A) return M;
    }
    for (var J = M, Q = A.split("/"), Z = 0; Z < Q.length; Z++) {
      var te = Q[Z];
      te && (M += u(R(te)), J += " && " + M);
    }
    return J;
  }
  function y(m, _) {
    return m == '""' ? _ : (m + " + " + _).replace(/([^\\])' \+ '/g, "$1");
  }
  function x(m) {
    return R(decodeURIComponent(m));
  }
  function P(m) {
    return encodeURIComponent(C(m));
  }
  function C(m) {
    return m.replace(/~/g, "~0").replace(/\//g, "~1");
  }
  function R(m) {
    return m.replace(/~1/g, "/").replace(/~0/g, "~");
  }
  return rs;
}
var ns, lf;
function em() {
  if (lf) return ns;
  lf = 1;
  var e = Gn();
  ns = t;
  function t(n) {
    e.copy(n, this);
  }
  return ns;
}
var as = { exports: {} }, uf;
function E1() {
  if (uf) return as.exports;
  uf = 1;
  var e = as.exports = function(a, r, o) {
    typeof r == "function" && (o = r, r = {}), o = r.cb || o;
    var s = typeof o == "function" ? o : o.pre || function() {
    }, i = o.post || function() {
    };
    t(r, s, i, a, "", a);
  };
  e.keywords = {
    additionalItems: !0,
    items: !0,
    contains: !0,
    additionalProperties: !0,
    propertyNames: !0,
    not: !0
  }, e.arrayKeywords = {
    items: !0,
    allOf: !0,
    anyOf: !0,
    oneOf: !0
  }, e.propsKeywords = {
    definitions: !0,
    properties: !0,
    patternProperties: !0,
    dependencies: !0
  }, e.skipKeywords = {
    default: !0,
    enum: !0,
    const: !0,
    required: !0,
    maximum: !0,
    minimum: !0,
    exclusiveMaximum: !0,
    exclusiveMinimum: !0,
    multipleOf: !0,
    maxLength: !0,
    minLength: !0,
    pattern: !0,
    format: !0,
    maxItems: !0,
    minItems: !0,
    uniqueItems: !0,
    maxProperties: !0,
    minProperties: !0
  };
  function t(a, r, o, s, i, u, f, p, c, l) {
    if (s && typeof s == "object" && !Array.isArray(s)) {
      r(s, i, u, f, p, c, l);
      for (var v in s) {
        var d = s[v];
        if (Array.isArray(d)) {
          if (v in e.arrayKeywords)
            for (var h = 0; h < d.length; h++)
              t(a, r, o, d[h], i + "/" + v + "/" + h, u, i, v, s, h);
        } else if (v in e.propsKeywords) {
          if (d && typeof d == "object")
            for (var g in d)
              t(a, r, o, d[g], i + "/" + v + "/" + n(g), u, i, v, s, g);
        } else (v in e.keywords || a.allKeys && !(v in e.skipKeywords)) && t(a, r, o, d, i + "/" + v, u, i, v, s);
      }
      o(s, i, u, f, p, c, l);
    }
  }
  function n(a) {
    return a.replace(/~/g, "~0").replace(/\//g, "~1");
  }
  return as.exports;
}
var os, cf;
function lu() {
  if (cf) return os;
  cf = 1;
  var e = P1(), t = su(), n = Gn(), a = em(), r = E1();
  os = o, o.normalizeId = b, o.fullPath = d, o.url = E, o.ids = S, o.inlineRef = c, o.schema = s;
  function o(w, y, x) {
    var P = this._refs[x];
    if (typeof P == "string")
      if (this._refs[P]) P = this._refs[P];
      else return o.call(this, w, y, P);
    if (P = P || this._schemas[x], P instanceof a)
      return c(P.schema, this._opts.inlineRefs) ? P.schema : P.validate || this._compile(P);
    var C = s.call(this, y, x), R, m, _;
    return C && (R = C.schema, y = C.root, _ = C.baseId), R instanceof a ? m = R.validate || w.call(this, R.schema, y, void 0, _) : R !== void 0 && (m = c(R, this._opts.inlineRefs) ? R : w.call(this, R, y, void 0, _)), m;
  }
  function s(w, y) {
    var x = e.parse(y), P = h(x), C = d(this._getId(w.schema));
    if (Object.keys(w.schema).length === 0 || P !== C) {
      var R = b(P), m = this._refs[R];
      if (typeof m == "string")
        return i.call(this, w, m, x);
      if (m instanceof a)
        m.validate || this._compile(m), w = m;
      else if (m = this._schemas[R], m instanceof a) {
        if (m.validate || this._compile(m), R == b(y))
          return { schema: m, root: w, baseId: C };
        w = m;
      } else
        return;
      if (!w.schema) return;
      C = d(this._getId(w.schema));
    }
    return f.call(this, x, C, w.schema, w);
  }
  function i(w, y, x) {
    var P = s.call(this, w, y);
    if (P) {
      var C = P.schema, R = P.baseId;
      w = P.root;
      var m = this._getId(C);
      return m && (R = E(R, m)), f.call(this, x, R, C, w);
    }
  }
  var u = n.toHash(["properties", "patternProperties", "enum", "dependencies", "definitions"]);
  function f(w, y, x, P) {
    if (w.fragment = w.fragment || "", w.fragment.slice(0, 1) == "/") {
      for (var C = w.fragment.split("/"), R = 1; R < C.length; R++) {
        var m = C[R];
        if (m) {
          if (m = n.unescapeFragment(m), x = x[m], x === void 0) break;
          var _;
          if (!u[m] && (_ = this._getId(x), _ && (y = E(y, _)), x.$ref)) {
            var O = E(y, x.$ref), T = s.call(this, P, O);
            T && (x = T.schema, P = T.root, y = T.baseId);
          }
        }
      }
      if (x !== void 0 && x !== P.schema)
        return { schema: x, root: P, baseId: y };
    }
  }
  var p = n.toHash([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum"
  ]);
  function c(w, y) {
    if (y === !1) return !1;
    if (y === void 0 || y === !0) return l(w);
    if (y) return v(w) <= y;
  }
  function l(w) {
    var y;
    if (Array.isArray(w)) {
      for (var x = 0; x < w.length; x++)
        if (y = w[x], typeof y == "object" && !l(y)) return !1;
    } else
      for (var P in w)
        if (P == "$ref" || (y = w[P], typeof y == "object" && !l(y))) return !1;
    return !0;
  }
  function v(w) {
    var y = 0, x;
    if (Array.isArray(w)) {
      for (var P = 0; P < w.length; P++)
        if (x = w[P], typeof x == "object" && (y += v(x)), y == 1 / 0) return 1 / 0;
    } else
      for (var C in w) {
        if (C == "$ref") return 1 / 0;
        if (p[C])
          y++;
        else if (x = w[C], typeof x == "object" && (y += v(x) + 1), y == 1 / 0) return 1 / 0;
      }
    return y;
  }
  function d(w, y) {
    y !== !1 && (w = b(w));
    var x = e.parse(w);
    return h(x);
  }
  function h(w) {
    return e.serialize(w).split("#")[0] + "#";
  }
  var g = /#\/?$/;
  function b(w) {
    return w ? w.replace(g, "") : "";
  }
  function E(w, y) {
    return y = b(y), e.resolve(w, y);
  }
  function S(w) {
    var y = b(this._getId(w)), x = { "": y }, P = { "": d(y, !1) }, C = {}, R = this;
    return r(w, { allKeys: !0 }, function(m, _, O, T, A, M, B) {
      if (_ !== "") {
        var J = R._getId(m), Q = x[T], Z = P[T] + "/" + A;
        if (B !== void 0 && (Z += "/" + (typeof B == "number" ? B : n.escapeFragment(B))), typeof J == "string") {
          J = Q = b(Q ? e.resolve(Q, J) : J);
          var te = R._refs[J];
          if (typeof te == "string" && (te = R._refs[te]), te && te.schema) {
            if (!t(m, te.schema))
              throw new Error('id "' + J + '" resolves to more than one schema');
          } else if (J != b(Z))
            if (J[0] == "#") {
              if (C[J] && !t(m, C[J]))
                throw new Error('id "' + J + '" resolves to more than one schema');
              C[J] = m;
            } else
              R._refs[J] = Z;
        }
        x[_] = Q, P[_] = Z;
      }
    }), C;
  }
  return os;
}
var is, ff;
function uu() {
  if (ff) return is;
  ff = 1;
  var e = lu();
  is = {
    Validation: a(t),
    MissingRef: a(n)
  };
  function t(r) {
    this.message = "validation failed", this.errors = r, this.ajv = this.validation = !0;
  }
  n.message = function(r, o) {
    return "can't resolve reference " + o + " from id " + r;
  };
  function n(r, o, s) {
    this.message = s || n.message(r, o), this.missingRef = e.url(r, o), this.missingSchema = e.normalizeId(e.fullPath(this.missingRef));
  }
  function a(r) {
    return r.prototype = Object.create(Error.prototype), r.prototype.constructor = r, r;
  }
  return is;
}
var ss, df;
function tm() {
  return df || (df = 1, ss = function(e, t) {
    t || (t = {}), typeof t == "function" && (t = { cmp: t });
    var n = typeof t.cycles == "boolean" ? t.cycles : !1, a = t.cmp && /* @__PURE__ */ function(o) {
      return function(s) {
        return function(i, u) {
          var f = { key: i, value: s[i] }, p = { key: u, value: s[u] };
          return o(f, p);
        };
      };
    }(t.cmp), r = [];
    return function o(s) {
      if (s && s.toJSON && typeof s.toJSON == "function" && (s = s.toJSON()), s !== void 0) {
        if (typeof s == "number") return isFinite(s) ? "" + s : "null";
        if (typeof s != "object") return JSON.stringify(s);
        var i, u;
        if (Array.isArray(s)) {
          for (u = "[", i = 0; i < s.length; i++)
            i && (u += ","), u += o(s[i]) || "null";
          return u + "]";
        }
        if (s === null) return "null";
        if (r.indexOf(s) !== -1) {
          if (n) return JSON.stringify("__cycle__");
          throw new TypeError("Converting circular structure to JSON");
        }
        var f = r.push(s) - 1, p = Object.keys(s).sort(a && a(s));
        for (u = "", i = 0; i < p.length; i++) {
          var c = p[i], l = o(s[c]);
          l && (u && (u += ","), u += JSON.stringify(c) + ":" + l);
        }
        return r.splice(f, 1), "{" + u + "}";
      }
    }(e);
  }), ss;
}
var ls, pf;
function rm() {
  return pf || (pf = 1, ls = function(t, n, a) {
    var r = "", o = t.schema.$async === !0, s = t.util.schemaHasRulesExcept(t.schema, t.RULES.all, "$ref"), i = t.self._getId(t.schema);
    if (t.opts.strictKeywords) {
      var u = t.util.schemaUnknownRules(t.schema, t.RULES.keywords);
      if (u) {
        var f = "unknown keyword: " + u;
        if (t.opts.strictKeywords === "log") t.logger.warn(f);
        else throw new Error(f);
      }
    }
    if (t.isTop && (r += " var validate = ", o && (t.async = !0, r += "async "), r += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", i && (t.opts.sourceCode || t.opts.processCode) && (r += " " + ("/*# sourceURL=" + i + " */") + " ")), typeof t.schema == "boolean" || !(s || t.schema.$ref)) {
      var n = "false schema", p = t.level, c = t.dataLevel, l = t.schema[n], v = t.schemaPath + t.util.getProperty(n), d = t.errSchemaPath + "/" + n, y = !t.opts.allErrors, C, h = "data" + (c || ""), w = "valid" + p;
      if (t.schema === !1) {
        t.isTop ? y = !0 : r += " var " + w + " = false; ";
        var g = g || [];
        g.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '" + (C || "false schema") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(d) + " , params: {} ", t.opts.messages !== !1 && (r += " , message: 'boolean schema is false' "), t.opts.verbose && (r += " , schema: false , parentSchema: validate.schema" + t.schemaPath + " , data: " + h + " "), r += " } ") : r += " {} ";
        var b = r;
        r = g.pop(), !t.compositeRule && y ? t.async ? r += " throw new ValidationError([" + b + "]); " : r += " validate.errors = [" + b + "]; return false; " : r += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      } else
        t.isTop ? o ? r += " return data; " : r += " validate.errors = null; return true; " : r += " var " + w + " = true; ";
      return t.isTop && (r += " }; return validate; "), r;
    }
    if (t.isTop) {
      var E = t.isTop, p = t.level = 0, c = t.dataLevel = 0, h = "data";
      if (t.rootId = t.resolve.fullPath(t.self._getId(t.root.schema)), t.baseId = t.baseId || t.rootId, delete t.isTop, t.dataPathArr = [""], t.schema.default !== void 0 && t.opts.useDefaults && t.opts.strictDefaults) {
        var S = "default is ignored in the schema root";
        if (t.opts.strictDefaults === "log") t.logger.warn(S);
        else throw new Error(S);
      }
      r += " var vErrors = null; ", r += " var errors = 0;     ", r += " if (rootData === undefined) rootData = data; ";
    } else {
      var p = t.level, c = t.dataLevel, h = "data" + (c || "");
      if (i && (t.baseId = t.resolve.url(t.baseId, i)), o && !t.async) throw new Error("async schema in sync schema");
      r += " var errs_" + p + " = errors;";
    }
    var w = "valid" + p, y = !t.opts.allErrors, x = "", P = "", C, R = t.schema.type, m = Array.isArray(R);
    if (R && t.opts.nullable && t.schema.nullable === !0 && (m ? R.indexOf("null") == -1 && (R = R.concat("null")) : R != "null" && (R = [R, "null"], m = !0)), m && R.length == 1 && (R = R[0], m = !1), t.schema.$ref && s) {
      if (t.opts.extendRefs == "fail")
        throw new Error('$ref: validation keywords used in schema at path "' + t.errSchemaPath + '" (see option extendRefs)');
      t.opts.extendRefs !== !0 && (s = !1, t.logger.warn('$ref: keywords ignored in schema at path "' + t.errSchemaPath + '"'));
    }
    if (t.schema.$comment && t.opts.$comment && (r += " " + t.RULES.all.$comment.code(t, "$comment")), R) {
      if (t.opts.coerceTypes)
        var _ = t.util.coerceToTypes(t.opts.coerceTypes, R);
      var O = t.RULES.types[R];
      if (_ || m || O === !0 || O && !ye(O)) {
        var v = t.schemaPath + ".type", d = t.errSchemaPath + "/type", v = t.schemaPath + ".type", d = t.errSchemaPath + "/type", T = m ? "checkDataTypes" : "checkDataType";
        if (r += " if (" + t.util[T](R, h, t.opts.strictNumbers, !0) + ") { ", _) {
          var A = "dataType" + p, M = "coerced" + p;
          r += " var " + A + " = typeof " + h + "; var " + M + " = undefined; ", t.opts.coerceTypes == "array" && (r += " if (" + A + " == 'object' && Array.isArray(" + h + ") && " + h + ".length == 1) { " + h + " = " + h + "[0]; " + A + " = typeof " + h + "; if (" + t.util.checkDataType(t.schema.type, h, t.opts.strictNumbers) + ") " + M + " = " + h + "; } "), r += " if (" + M + " !== undefined) ; ";
          var B = _;
          if (B)
            for (var J, Q = -1, Z = B.length - 1; Q < Z; )
              J = B[Q += 1], J == "string" ? r += " else if (" + A + " == 'number' || " + A + " == 'boolean') " + M + " = '' + " + h + "; else if (" + h + " === null) " + M + " = ''; " : J == "number" || J == "integer" ? (r += " else if (" + A + " == 'boolean' || " + h + " === null || (" + A + " == 'string' && " + h + " && " + h + " == +" + h + " ", J == "integer" && (r += " && !(" + h + " % 1)"), r += ")) " + M + " = +" + h + "; ") : J == "boolean" ? r += " else if (" + h + " === 'false' || " + h + " === 0 || " + h + " === null) " + M + " = false; else if (" + h + " === 'true' || " + h + " === 1) " + M + " = true; " : J == "null" ? r += " else if (" + h + " === '' || " + h + " === 0 || " + h + " === false) " + M + " = null; " : t.opts.coerceTypes == "array" && J == "array" && (r += " else if (" + A + " == 'string' || " + A + " == 'number' || " + A + " == 'boolean' || " + h + " == null) " + M + " = [" + h + "]; ");
          r += " else {   ";
          var g = g || [];
          g.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '" + (C || "type") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(d) + " , params: { type: '", m ? r += "" + R.join(",") : r += "" + R, r += "' } ", t.opts.messages !== !1 && (r += " , message: 'should be ", m ? r += "" + R.join(",") : r += "" + R, r += "' "), t.opts.verbose && (r += " , schema: validate.schema" + v + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + h + " "), r += " } ") : r += " {} ";
          var b = r;
          r = g.pop(), !t.compositeRule && y ? t.async ? r += " throw new ValidationError([" + b + "]); " : r += " validate.errors = [" + b + "]; return false; " : r += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } if (" + M + " !== undefined) {  ";
          var te = c ? "data" + (c - 1 || "") : "parentData", le = c ? t.dataPathArr[c] : "parentDataProperty";
          r += " " + h + " = " + M + "; ", c || (r += "if (" + te + " !== undefined)"), r += " " + te + "[" + le + "] = " + M + "; } ";
        } else {
          var g = g || [];
          g.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '" + (C || "type") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(d) + " , params: { type: '", m ? r += "" + R.join(",") : r += "" + R, r += "' } ", t.opts.messages !== !1 && (r += " , message: 'should be ", m ? r += "" + R.join(",") : r += "" + R, r += "' "), t.opts.verbose && (r += " , schema: validate.schema" + v + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + h + " "), r += " } ") : r += " {} ";
          var b = r;
          r = g.pop(), !t.compositeRule && y ? t.async ? r += " throw new ValidationError([" + b + "]); " : r += " validate.errors = [" + b + "]; return false; " : r += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        }
        r += " } ";
      }
    }
    if (t.schema.$ref && !s)
      r += " " + t.RULES.all.$ref.code(t, "$ref") + " ", y && (r += " } if (errors === ", E ? r += "0" : r += "errs_" + p, r += ") { ", P += "}");
    else {
      var me = t.RULES;
      if (me) {
        for (var O, G = -1, ee = me.length - 1; G < ee; )
          if (O = me[G += 1], ye(O)) {
            if (O.type && (r += " if (" + t.util.checkDataType(O.type, h, t.opts.strictNumbers) + ") { "), t.opts.useDefaults) {
              if (O.type == "object" && t.schema.properties) {
                var l = t.schema.properties, ae = Object.keys(l), j = ae;
                if (j)
                  for (var N, W = -1, K = j.length - 1; W < K; ) {
                    N = j[W += 1];
                    var I = l[N];
                    if (I.default !== void 0) {
                      var L = h + t.util.getProperty(N);
                      if (t.compositeRule) {
                        if (t.opts.strictDefaults) {
                          var S = "default is ignored for: " + L;
                          if (t.opts.strictDefaults === "log") t.logger.warn(S);
                          else throw new Error(S);
                        }
                      } else
                        r += " if (" + L + " === undefined ", t.opts.useDefaults == "empty" && (r += " || " + L + " === null || " + L + " === '' "), r += " ) " + L + " = ", t.opts.useDefaults == "shared" ? r += " " + t.useDefault(I.default) + " " : r += " " + JSON.stringify(I.default) + " ", r += "; ";
                    }
                  }
              } else if (O.type == "array" && Array.isArray(t.schema.items)) {
                var X = t.schema.items;
                if (X) {
                  for (var I, Q = -1, Y = X.length - 1; Q < Y; )
                    if (I = X[Q += 1], I.default !== void 0) {
                      var L = h + "[" + Q + "]";
                      if (t.compositeRule) {
                        if (t.opts.strictDefaults) {
                          var S = "default is ignored for: " + L;
                          if (t.opts.strictDefaults === "log") t.logger.warn(S);
                          else throw new Error(S);
                        }
                      } else
                        r += " if (" + L + " === undefined ", t.opts.useDefaults == "empty" && (r += " || " + L + " === null || " + L + " === '' "), r += " ) " + L + " = ", t.opts.useDefaults == "shared" ? r += " " + t.useDefault(I.default) + " " : r += " " + JSON.stringify(I.default) + " ", r += "; ";
                    }
                }
              }
            }
            var re = O.rules;
            if (re) {
              for (var pe, ie = -1, ce = re.length - 1; ie < ce; )
                if (pe = re[ie += 1], tt(pe)) {
                  var de = pe.code(t, pe.keyword, O.type);
                  de && (r += " " + de + " ", y && (x += "}"));
                }
            }
            if (y && (r += " " + x + " ", x = ""), O.type && (r += " } ", R && R === O.type && !_)) {
              r += " else { ";
              var v = t.schemaPath + ".type", d = t.errSchemaPath + "/type", g = g || [];
              g.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '" + (C || "type") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(d) + " , params: { type: '", m ? r += "" + R.join(",") : r += "" + R, r += "' } ", t.opts.messages !== !1 && (r += " , message: 'should be ", m ? r += "" + R.join(",") : r += "" + R, r += "' "), t.opts.verbose && (r += " , schema: validate.schema" + v + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + h + " "), r += " } ") : r += " {} ";
              var b = r;
              r = g.pop(), !t.compositeRule && y ? t.async ? r += " throw new ValidationError([" + b + "]); " : r += " validate.errors = [" + b + "]; return false; " : r += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ";
            }
            y && (r += " if (errors === ", E ? r += "0" : r += "errs_" + p, r += ") { ", P += "}");
          }
      }
    }
    y && (r += " " + P + " "), E ? (o ? (r += " if (errors === 0) return data;           ", r += " else throw new ValidationError(vErrors); ") : (r += " validate.errors = vErrors; ", r += " return errors === 0;       "), r += " }; return validate;") : r += " var " + w + " = errors === errs_" + p + ";";
    function ye(oe) {
      for (var ze = oe.rules, dt = 0; dt < ze.length; dt++)
        if (tt(ze[dt])) return !0;
    }
    function tt(oe) {
      return t.schema[oe.keyword] !== void 0 || oe.implements && se(oe);
    }
    function se(oe) {
      for (var ze = oe.implements, dt = 0; dt < ze.length; dt++)
        if (t.schema[ze[dt]] !== void 0) return !0;
    }
    return r;
  }), ls;
}
var us, hf;
function _1() {
  if (hf) return us;
  hf = 1;
  var e = lu(), t = Gn(), n = uu(), a = tm(), r = rm(), o = t.ucs2length, s = su(), i = n.Validation;
  us = u;
  function u(b, E, S, w) {
    var y = this, x = this._opts, P = [void 0], C = {}, R = [], m = {}, _ = [], O = {}, T = [];
    E = E || { schema: b, refVal: P, refs: C };
    var A = f.call(this, b, E, w), M = this._compilations[A.index];
    if (A.compiling) return M.callValidate = te;
    var B = this._formats, J = this.RULES;
    try {
      var Q = le(b, E, S, w);
      M.validate = Q;
      var Z = M.callValidate;
      return Z && (Z.schema = Q.schema, Z.errors = null, Z.refs = Q.refs, Z.refVal = Q.refVal, Z.root = Q.root, Z.$async = Q.$async, x.sourceCode && (Z.source = Q.source)), Q;
    } finally {
      p.call(this, b, E, w);
    }
    function te() {
      var I = M.validate, L = I.apply(this, arguments);
      return te.errors = I.errors, L;
    }
    function le(I, L, X, Y) {
      var re = !L || L && L.schema == I;
      if (L.schema != E.schema)
        return u.call(y, I, L, X, Y);
      var pe = I.$async === !0, ie = r({
        isTop: !0,
        schema: I,
        isRoot: re,
        baseId: Y,
        root: L,
        schemaPath: "",
        errSchemaPath: "#",
        errorPath: '""',
        MissingRefError: n.MissingRef,
        RULES: J,
        validate: r,
        util: t,
        resolve: e,
        resolveRef: me,
        usePattern: N,
        useDefault: W,
        useCustomRule: K,
        opts: x,
        formats: B,
        logger: y.logger,
        self: y
      });
      ie = g(P, d) + g(R, l) + g(_, v) + g(T, h) + ie, x.processCode && (ie = x.processCode(ie, I));
      var ce;
      try {
        var de = new Function(
          "self",
          "RULES",
          "formats",
          "root",
          "refVal",
          "defaults",
          "customRules",
          "equal",
          "ucs2length",
          "ValidationError",
          ie
        );
        ce = de(
          y,
          J,
          B,
          E,
          P,
          _,
          T,
          s,
          o,
          i
        ), P[0] = ce;
      } catch (ye) {
        throw y.logger.error("Error compiling schema, function code:", ie), ye;
      }
      return ce.schema = I, ce.errors = null, ce.refs = C, ce.refVal = P, ce.root = re ? ce : L, pe && (ce.$async = !0), x.sourceCode === !0 && (ce.source = {
        code: ie,
        patterns: R,
        defaults: _
      }), ce;
    }
    function me(I, L, X) {
      L = e.url(I, L);
      var Y = C[L], re, pe;
      if (Y !== void 0)
        return re = P[Y], pe = "refVal[" + Y + "]", j(re, pe);
      if (!X && E.refs) {
        var ie = E.refs[L];
        if (ie !== void 0)
          return re = E.refVal[ie], pe = G(L, re), j(re, pe);
      }
      pe = G(L);
      var ce = e.call(y, le, E, L);
      if (ce === void 0) {
        var de = S && S[L];
        de && (ce = e.inlineRef(de, x.inlineRefs) ? de : u.call(y, de, E, S, I));
      }
      if (ce === void 0)
        ee(L);
      else
        return ae(L, ce), j(ce, pe);
    }
    function G(I, L) {
      var X = P.length;
      return P[X] = L, C[I] = X, "refVal" + X;
    }
    function ee(I) {
      delete C[I];
    }
    function ae(I, L) {
      var X = C[I];
      P[X] = L;
    }
    function j(I, L) {
      return typeof I == "object" || typeof I == "boolean" ? { code: L, schema: I, inline: !0 } : { code: L, $async: I && !!I.$async };
    }
    function N(I) {
      var L = m[I];
      return L === void 0 && (L = m[I] = R.length, R[L] = I), "pattern" + L;
    }
    function W(I) {
      switch (typeof I) {
        case "boolean":
        case "number":
          return "" + I;
        case "string":
          return t.toQuotedString(I);
        case "object":
          if (I === null) return "null";
          var L = a(I), X = O[L];
          return X === void 0 && (X = O[L] = _.length, _[X] = I), "default" + X;
      }
    }
    function K(I, L, X, Y) {
      if (y._opts.validateSchema !== !1) {
        var re = I.definition.dependencies;
        if (re && !re.every(function(ze) {
          return Object.prototype.hasOwnProperty.call(X, ze);
        }))
          throw new Error("parent schema must have all required keywords: " + re.join(","));
        var pe = I.definition.validateSchema;
        if (pe) {
          var ie = pe(L);
          if (!ie) {
            var ce = "keyword schema is invalid: " + y.errorsText(pe.errors);
            if (y._opts.validateSchema == "log") y.logger.error(ce);
            else throw new Error(ce);
          }
        }
      }
      var de = I.definition.compile, ye = I.definition.inline, tt = I.definition.macro, se;
      if (de)
        se = de.call(y, L, X, Y);
      else if (tt)
        se = tt.call(y, L, X, Y), x.validateSchema !== !1 && y.validateSchema(se, !0);
      else if (ye)
        se = ye.call(y, Y, I.keyword, L, X);
      else if (se = I.definition.validate, !se) return;
      if (se === void 0)
        throw new Error('custom keyword "' + I.keyword + '"failed to compile');
      var oe = T.length;
      return T[oe] = se, {
        code: "customRule" + oe,
        validate: se
      };
    }
  }
  function f(b, E, S) {
    var w = c.call(this, b, E, S);
    return w >= 0 ? { index: w, compiling: !0 } : (w = this._compilations.length, this._compilations[w] = {
      schema: b,
      root: E,
      baseId: S
    }, { index: w, compiling: !1 });
  }
  function p(b, E, S) {
    var w = c.call(this, b, E, S);
    w >= 0 && this._compilations.splice(w, 1);
  }
  function c(b, E, S) {
    for (var w = 0; w < this._compilations.length; w++) {
      var y = this._compilations[w];
      if (y.schema == b && y.root == E && y.baseId == S) return w;
    }
    return -1;
  }
  function l(b, E) {
    return "var pattern" + b + " = new RegExp(" + t.toQuotedString(E[b]) + ");";
  }
  function v(b) {
    return "var default" + b + " = defaults[" + b + "];";
  }
  function d(b, E) {
    return E[b] === void 0 ? "" : "var refVal" + b + " = refVal[" + b + "];";
  }
  function h(b) {
    return "var customRule" + b + " = customRules[" + b + "];";
  }
  function g(b, E) {
    if (!b.length) return "";
    for (var S = "", w = 0; w < b.length; w++)
      S += E(w, b);
    return S;
  }
  return us;
}
var cs = { exports: {} }, mf;
function C1() {
  if (mf) return cs.exports;
  mf = 1;
  var e = cs.exports = function() {
    this._cache = {};
  };
  return e.prototype.put = function(n, a) {
    this._cache[n] = a;
  }, e.prototype.get = function(n) {
    return this._cache[n];
  }, e.prototype.del = function(n) {
    delete this._cache[n];
  }, e.prototype.clear = function() {
    this._cache = {};
  }, cs.exports;
}
var fs, vf;
function R1() {
  if (vf) return fs;
  vf = 1;
  var e = Gn(), t = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, n = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], a = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i, r = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i, o = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, s = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, i = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i, u = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i, f = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i, p = /^(?:\/(?:[^~/]|~0|~1)*)*$/, c = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i, l = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
  fs = v;
  function v(P) {
    return P = P == "full" ? "full" : "fast", e.copy(v[P]);
  }
  v.fast = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
    "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    "uri-template": i,
    url: u,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
    hostname: r,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex: x,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: f,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": p,
    "json-pointer-uri-fragment": c,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": l
  }, v.full = {
    date: h,
    time: g,
    "date-time": E,
    uri: w,
    "uri-reference": s,
    "uri-template": i,
    url: u,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: r,
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex: x,
    uuid: f,
    "json-pointer": p,
    "json-pointer-uri-fragment": c,
    "relative-json-pointer": l
  };
  function d(P) {
    return P % 4 === 0 && (P % 100 !== 0 || P % 400 === 0);
  }
  function h(P) {
    var C = P.match(t);
    if (!C) return !1;
    var R = +C[1], m = +C[2], _ = +C[3];
    return m >= 1 && m <= 12 && _ >= 1 && _ <= (m == 2 && d(R) ? 29 : n[m]);
  }
  function g(P, C) {
    var R = P.match(a);
    if (!R) return !1;
    var m = R[1], _ = R[2], O = R[3], T = R[5];
    return (m <= 23 && _ <= 59 && O <= 59 || m == 23 && _ == 59 && O == 60) && (!C || T);
  }
  var b = /t|\s/i;
  function E(P) {
    var C = P.split(b);
    return C.length == 2 && h(C[0]) && g(C[1], !0);
  }
  var S = /\/|:/;
  function w(P) {
    return S.test(P) && o.test(P);
  }
  var y = /[^\\]\\Z/;
  function x(P) {
    if (y.test(P)) return !1;
    try {
      return new RegExp(P), !0;
    } catch {
      return !1;
    }
  }
  return fs;
}
var ds, gf;
function O1() {
  return gf || (gf = 1, ds = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.errSchemaPath + "/" + n, f = !t.opts.allErrors, p = "data" + (s || ""), c = "valid" + o, l, v;
    if (i == "#" || i == "#/")
      t.isRoot ? (l = t.async, v = "validate") : (l = t.root.schema.$async === !0, v = "root.refVal[0]");
    else {
      var d = t.resolveRef(t.baseId, i, t.isRoot);
      if (d === void 0) {
        var h = t.MissingRefError.message(t.baseId, i);
        if (t.opts.missingRefs == "fail") {
          t.logger.error(h);
          var g = g || [];
          g.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '$ref' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(u) + " , params: { ref: '" + t.util.escapeQuotes(i) + "' } ", t.opts.messages !== !1 && (r += " , message: 'can\\'t resolve reference " + t.util.escapeQuotes(i) + "' "), t.opts.verbose && (r += " , schema: " + t.util.toQuotedString(i) + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + p + " "), r += " } ") : r += " {} ";
          var b = r;
          r = g.pop(), !t.compositeRule && f ? t.async ? r += " throw new ValidationError([" + b + "]); " : r += " validate.errors = [" + b + "]; return false; " : r += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", f && (r += " if (false) { ");
        } else if (t.opts.missingRefs == "ignore")
          t.logger.warn(h), f && (r += " if (true) { ");
        else
          throw new t.MissingRefError(t.baseId, i, h);
      } else if (d.inline) {
        var E = t.util.copy(t);
        E.level++;
        var S = "valid" + E.level;
        E.schema = d.schema, E.schemaPath = "", E.errSchemaPath = i;
        var w = t.validate(E).replace(/validate\.schema/g, d.code);
        r += " " + w + " ", f && (r += " if (" + S + ") { ");
      } else
        l = d.$async === !0 || t.async && d.$async !== !1, v = d.code;
    }
    if (v) {
      var g = g || [];
      g.push(r), r = "", t.opts.passContext ? r += " " + v + ".call(this, " : r += " " + v + "( ", r += " " + p + ", (dataPath || '')", t.errorPath != '""' && (r += " + " + t.errorPath);
      var y = s ? "data" + (s - 1 || "") : "parentData", x = s ? t.dataPathArr[s] : "parentDataProperty";
      r += " , " + y + " , " + x + ", rootData)  ";
      var P = r;
      if (r = g.pop(), l) {
        if (!t.async) throw new Error("async schema referenced by sync schema");
        f && (r += " var " + c + "; "), r += " try { await " + P + "; ", f && (r += " " + c + " = true; "), r += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", f && (r += " " + c + " = false; "), r += " } ", f && (r += " if (" + c + ") { ");
      } else
        r += " if (!" + P + ") { if (vErrors === null) vErrors = " + v + ".errors; else vErrors = vErrors.concat(" + v + ".errors); errors = vErrors.length; } ", f && (r += " else { ");
    }
    return r;
  }), ds;
}
var ps, yf;
function $1() {
  return yf || (yf = 1, ps = function(t, n, a) {
    var r = " ", o = t.schema[n], s = t.schemaPath + t.util.getProperty(n), i = t.errSchemaPath + "/" + n, u = !t.opts.allErrors, f = t.util.copy(t), p = "";
    f.level++;
    var c = "valid" + f.level, l = f.baseId, v = !0, d = o;
    if (d)
      for (var h, g = -1, b = d.length - 1; g < b; )
        h = d[g += 1], (t.opts.strictKeywords ? typeof h == "object" && Object.keys(h).length > 0 || h === !1 : t.util.schemaHasRules(h, t.RULES.all)) && (v = !1, f.schema = h, f.schemaPath = s + "[" + g + "]", f.errSchemaPath = i + "/" + g, r += "  " + t.validate(f) + " ", f.baseId = l, u && (r += " if (" + c + ") { ", p += "}"));
    return u && (v ? r += " if (true) { " : r += " " + p.slice(0, -1) + " "), r;
  }), ps;
}
var hs, bf;
function T1() {
  return bf || (bf = 1, hs = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "valid" + o, v = "errs__" + o, d = t.util.copy(t), h = "";
    d.level++;
    var g = "valid" + d.level, b = i.every(function(C) {
      return t.opts.strictKeywords ? typeof C == "object" && Object.keys(C).length > 0 || C === !1 : t.util.schemaHasRules(C, t.RULES.all);
    });
    if (b) {
      var E = d.baseId;
      r += " var " + v + " = errors; var " + l + " = false;  ";
      var S = t.compositeRule;
      t.compositeRule = d.compositeRule = !0;
      var w = i;
      if (w)
        for (var y, x = -1, P = w.length - 1; x < P; )
          y = w[x += 1], d.schema = y, d.schemaPath = u + "[" + x + "]", d.errSchemaPath = f + "/" + x, r += "  " + t.validate(d) + " ", d.baseId = E, r += " " + l + " = " + l + " || " + g + "; if (!" + l + ") { ", h += "}";
      t.compositeRule = d.compositeRule = S, r += " " + h + " if (!" + l + ") {   var err =   ", t.createErrors !== !1 ? (r += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: {} ", t.opts.messages !== !1 && (r += " , message: 'should match some schema in anyOf' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !t.compositeRule && p && (t.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), r += " } else {  errors = " + v + "; if (vErrors !== null) { if (" + v + ") vErrors.length = " + v + "; else vErrors = null; } ", t.opts.allErrors && (r += " } ");
    } else
      p && (r += " if (true) { ");
    return r;
  }), hs;
}
var ms, wf;
function j1() {
  return wf || (wf = 1, ms = function(t, n, a) {
    var r = " ", o = t.schema[n], s = t.errSchemaPath + "/" + n;
    t.opts.allErrors;
    var i = t.util.toQuotedString(o);
    return t.opts.$comment === !0 ? r += " console.log(" + i + ");" : typeof t.opts.$comment == "function" && (r += " self._opts.$comment(" + i + ", " + t.util.toQuotedString(s) + ", validate.root.schema);"), r;
  }), ms;
}
var vs, Sf;
function D1() {
  return Sf || (Sf = 1, vs = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "valid" + o, v = t.opts.$data && i && i.$data;
    v && (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; "), v || (r += " var schema" + o + " = validate.schema" + u + ";"), r += "var " + l + " = equal(" + c + ", schema" + o + "); if (!" + l + ") {   ";
    var d = d || [];
    d.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'const' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { allowedValue: schema" + o + " } ", t.opts.messages !== !1 && (r += " , message: 'should be equal to constant' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
    var h = r;
    return r = d.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + h + "]); " : r += " validate.errors = [" + h + "]; return false; " : r += " var err = " + h + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " }", p && (r += " else { "), r;
  }), vs;
}
var gs, Pf;
function k1() {
  return Pf || (Pf = 1, gs = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "valid" + o, v = "errs__" + o, d = t.util.copy(t), h = "";
    d.level++;
    var g = "valid" + d.level, b = "i" + o, E = d.dataLevel = t.dataLevel + 1, S = "data" + E, w = t.baseId, y = t.opts.strictKeywords ? typeof i == "object" && Object.keys(i).length > 0 || i === !1 : t.util.schemaHasRules(i, t.RULES.all);
    if (r += "var " + v + " = errors;var " + l + ";", y) {
      var x = t.compositeRule;
      t.compositeRule = d.compositeRule = !0, d.schema = i, d.schemaPath = u, d.errSchemaPath = f, r += " var " + g + " = false; for (var " + b + " = 0; " + b + " < " + c + ".length; " + b + "++) { ", d.errorPath = t.util.getPathExpr(t.errorPath, b, t.opts.jsonPointers, !0);
      var P = c + "[" + b + "]";
      d.dataPathArr[E] = b;
      var C = t.validate(d);
      d.baseId = w, t.util.varOccurences(C, S) < 2 ? r += " " + t.util.varReplace(C, S, P) + " " : r += " var " + S + " = " + P + "; " + C + " ", r += " if (" + g + ") break; }  ", t.compositeRule = d.compositeRule = x, r += " " + h + " if (!" + g + ") {";
    } else
      r += " if (" + c + ".length == 0) {";
    var R = R || [];
    R.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'contains' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: {} ", t.opts.messages !== !1 && (r += " , message: 'should contain a valid item' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
    var m = r;
    return r = R.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + m + "]); " : r += " validate.errors = [" + m + "]; return false; " : r += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else { ", y && (r += "  errors = " + v + "; if (vErrors !== null) { if (" + v + ") vErrors.length = " + v + "; else vErrors = null; } "), t.opts.allErrors && (r += " } "), r;
  }), gs;
}
var ys, xf;
function A1() {
  return xf || (xf = 1, ys = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "errs__" + o, v = t.util.copy(t), d = "";
    v.level++;
    var h = "valid" + v.level, g = {}, b = {}, E = t.opts.ownProperties;
    for (x in i)
      if (x != "__proto__") {
        var S = i[x], w = Array.isArray(S) ? b : g;
        w[x] = S;
      }
    r += "var " + l + " = errors;";
    var y = t.errorPath;
    r += "var missing" + o + ";";
    for (var x in b)
      if (w = b[x], w.length) {
        if (r += " if ( " + c + t.util.getProperty(x) + " !== undefined ", E && (r += " && Object.prototype.hasOwnProperty.call(" + c + ", '" + t.util.escapeQuotes(x) + "') "), p) {
          r += " && ( ";
          var P = w;
          if (P)
            for (var C, R = -1, m = P.length - 1; R < m; ) {
              C = P[R += 1], R && (r += " || ");
              var _ = t.util.getProperty(C), O = c + _;
              r += " ( ( " + O + " === undefined ", E && (r += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + t.util.escapeQuotes(C) + "') "), r += ") && (missing" + o + " = " + t.util.toQuotedString(t.opts.jsonPointers ? C : _) + ") ) ";
            }
          r += ")) {  ";
          var T = "missing" + o, A = "' + " + T + " + '";
          t.opts._errorDataPathProperty && (t.errorPath = t.opts.jsonPointers ? t.util.getPathExpr(y, T, !0) : y + " + " + T);
          var M = M || [];
          M.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { property: '" + t.util.escapeQuotes(x) + "', missingProperty: '" + A + "', depsCount: " + w.length + ", deps: '" + t.util.escapeQuotes(w.length == 1 ? w[0] : w.join(", ")) + "' } ", t.opts.messages !== !1 && (r += " , message: 'should have ", w.length == 1 ? r += "property " + t.util.escapeQuotes(w[0]) : r += "properties " + t.util.escapeQuotes(w.join(", ")), r += " when property " + t.util.escapeQuotes(x) + " is present' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
          var B = r;
          r = M.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + B + "]); " : r += " validate.errors = [" + B + "]; return false; " : r += " var err = " + B + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        } else {
          r += " ) { ";
          var J = w;
          if (J)
            for (var C, Q = -1, Z = J.length - 1; Q < Z; ) {
              C = J[Q += 1];
              var _ = t.util.getProperty(C), A = t.util.escapeQuotes(C), O = c + _;
              t.opts._errorDataPathProperty && (t.errorPath = t.util.getPath(y, C, t.opts.jsonPointers)), r += " if ( " + O + " === undefined ", E && (r += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + t.util.escapeQuotes(C) + "') "), r += ") {  var err =   ", t.createErrors !== !1 ? (r += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { property: '" + t.util.escapeQuotes(x) + "', missingProperty: '" + A + "', depsCount: " + w.length + ", deps: '" + t.util.escapeQuotes(w.length == 1 ? w[0] : w.join(", ")) + "' } ", t.opts.messages !== !1 && (r += " , message: 'should have ", w.length == 1 ? r += "property " + t.util.escapeQuotes(w[0]) : r += "properties " + t.util.escapeQuotes(w.join(", ")), r += " when property " + t.util.escapeQuotes(x) + " is present' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
            }
        }
        r += " }   ", p && (d += "}", r += " else { ");
      }
    t.errorPath = y;
    var te = v.baseId;
    for (var x in g) {
      var S = g[x];
      (t.opts.strictKeywords ? typeof S == "object" && Object.keys(S).length > 0 || S === !1 : t.util.schemaHasRules(S, t.RULES.all)) && (r += " " + h + " = true; if ( " + c + t.util.getProperty(x) + " !== undefined ", E && (r += " && Object.prototype.hasOwnProperty.call(" + c + ", '" + t.util.escapeQuotes(x) + "') "), r += ") { ", v.schema = S, v.schemaPath = u + t.util.getProperty(x), v.errSchemaPath = f + "/" + t.util.escapeFragment(x), r += "  " + t.validate(v) + " ", v.baseId = te, r += " }  ", p && (r += " if (" + h + ") { ", d += "}"));
    }
    return p && (r += "   " + d + " if (" + l + " == errors) {"), r;
  }), ys;
}
var bs, Ef;
function M1() {
  return Ef || (Ef = 1, bs = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "valid" + o, v = t.opts.$data && i && i.$data;
    v && (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ");
    var d = "i" + o, h = "schema" + o;
    v || (r += " var " + h + " = validate.schema" + u + ";"), r += "var " + l + ";", v && (r += " if (schema" + o + " === undefined) " + l + " = true; else if (!Array.isArray(schema" + o + ")) " + l + " = false; else {"), r += "" + l + " = false;for (var " + d + "=0; " + d + "<" + h + ".length; " + d + "++) if (equal(" + c + ", " + h + "[" + d + "])) { " + l + " = true; break; }", v && (r += "  }  "), r += " if (!" + l + ") {   ";
    var g = g || [];
    g.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'enum' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { allowedValues: schema" + o + " } ", t.opts.messages !== !1 && (r += " , message: 'should be equal to one of the allowed values' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
    var b = r;
    return r = g.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + b + "]); " : r += " validate.errors = [" + b + "]; return false; " : r += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " }", p && (r += " else { "), r;
  }), bs;
}
var ws, _f;
function I1() {
  return _f || (_f = 1, ws = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || "");
    if (t.opts.format === !1)
      return p && (r += " if (true) { "), r;
    var l = t.opts.$data && i && i.$data, v;
    l ? (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ", v = "schema" + o) : v = i;
    var d = t.opts.unknownFormats, h = Array.isArray(d);
    if (l) {
      var g = "format" + o, b = "isObject" + o, E = "formatType" + o;
      r += " var " + g + " = formats[" + v + "]; var " + b + " = typeof " + g + " == 'object' && !(" + g + " instanceof RegExp) && " + g + ".validate; var " + E + " = " + b + " && " + g + ".type || 'string'; if (" + b + ") { ", t.async && (r += " var async" + o + " = " + g + ".async; "), r += " " + g + " = " + g + ".validate; } if (  ", l && (r += " (" + v + " !== undefined && typeof " + v + " != 'string') || "), r += " (", d != "ignore" && (r += " (" + v + " && !" + g + " ", h && (r += " && self._opts.unknownFormats.indexOf(" + v + ") == -1 "), r += ") || "), r += " (" + g + " && " + E + " == '" + a + "' && !(typeof " + g + " == 'function' ? ", t.async ? r += " (async" + o + " ? await " + g + "(" + c + ") : " + g + "(" + c + ")) " : r += " " + g + "(" + c + ") ", r += " : " + g + ".test(" + c + "))))) {";
    } else {
      var g = t.formats[i];
      if (!g) {
        if (d == "ignore")
          return t.logger.warn('unknown format "' + i + '" ignored in schema at path "' + t.errSchemaPath + '"'), p && (r += " if (true) { "), r;
        if (h && d.indexOf(i) >= 0)
          return p && (r += " if (true) { "), r;
        throw new Error('unknown format "' + i + '" is used in schema at path "' + t.errSchemaPath + '"');
      }
      var b = typeof g == "object" && !(g instanceof RegExp) && g.validate, E = b && g.type || "string";
      if (b) {
        var S = g.async === !0;
        g = g.validate;
      }
      if (E != a)
        return p && (r += " if (true) { "), r;
      if (S) {
        if (!t.async) throw new Error("async format in sync schema");
        var w = "formats" + t.util.getProperty(i) + ".validate";
        r += " if (!(await " + w + "(" + c + "))) { ";
      } else {
        r += " if (! ";
        var w = "formats" + t.util.getProperty(i);
        b && (w += ".validate"), typeof g == "function" ? r += " " + w + "(" + c + ") " : r += " " + w + ".test(" + c + ") ", r += ") { ";
      }
    }
    var y = y || [];
    y.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'format' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { format:  ", l ? r += "" + v : r += "" + t.util.toQuotedString(i), r += "  } ", t.opts.messages !== !1 && (r += ` , message: 'should match format "`, l ? r += "' + " + v + " + '" : r += "" + t.util.escapeQuotes(i), r += `"' `), t.opts.verbose && (r += " , schema:  ", l ? r += "validate.schema" + u : r += "" + t.util.toQuotedString(i), r += "         , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
    var x = r;
    return r = y.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + x + "]); " : r += " validate.errors = [" + x + "]; return false; " : r += " var err = " + x + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", p && (r += " else { "), r;
  }), ws;
}
var Ss, Cf;
function N1() {
  return Cf || (Cf = 1, Ss = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "valid" + o, v = "errs__" + o, d = t.util.copy(t);
    d.level++;
    var h = "valid" + d.level, g = t.schema.then, b = t.schema.else, E = g !== void 0 && (t.opts.strictKeywords ? typeof g == "object" && Object.keys(g).length > 0 || g === !1 : t.util.schemaHasRules(g, t.RULES.all)), S = b !== void 0 && (t.opts.strictKeywords ? typeof b == "object" && Object.keys(b).length > 0 || b === !1 : t.util.schemaHasRules(b, t.RULES.all)), w = d.baseId;
    if (E || S) {
      var y;
      d.createErrors = !1, d.schema = i, d.schemaPath = u, d.errSchemaPath = f, r += " var " + v + " = errors; var " + l + " = true;  ";
      var x = t.compositeRule;
      t.compositeRule = d.compositeRule = !0, r += "  " + t.validate(d) + " ", d.baseId = w, d.createErrors = !0, r += "  errors = " + v + "; if (vErrors !== null) { if (" + v + ") vErrors.length = " + v + "; else vErrors = null; }  ", t.compositeRule = d.compositeRule = x, E ? (r += " if (" + h + ") {  ", d.schema = t.schema.then, d.schemaPath = t.schemaPath + ".then", d.errSchemaPath = t.errSchemaPath + "/then", r += "  " + t.validate(d) + " ", d.baseId = w, r += " " + l + " = " + h + "; ", E && S ? (y = "ifClause" + o, r += " var " + y + " = 'then'; ") : y = "'then'", r += " } ", S && (r += " else { ")) : r += " if (!" + h + ") { ", S && (d.schema = t.schema.else, d.schemaPath = t.schemaPath + ".else", d.errSchemaPath = t.errSchemaPath + "/else", r += "  " + t.validate(d) + " ", d.baseId = w, r += " " + l + " = " + h + "; ", E && S ? (y = "ifClause" + o, r += " var " + y + " = 'else'; ") : y = "'else'", r += " } "), r += " if (!" + l + ") {   var err =   ", t.createErrors !== !1 ? (r += " { keyword: 'if' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { failingKeyword: " + y + " } ", t.opts.messages !== !1 && (r += ` , message: 'should match "' + ` + y + ` + '" schema' `), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !t.compositeRule && p && (t.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), r += " }   ", p && (r += " else { ");
    } else
      p && (r += " if (true) { ");
    return r;
  }), Ss;
}
var Ps, Rf;
function L1() {
  return Rf || (Rf = 1, Ps = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "valid" + o, v = "errs__" + o, d = t.util.copy(t), h = "";
    d.level++;
    var g = "valid" + d.level, b = "i" + o, E = d.dataLevel = t.dataLevel + 1, S = "data" + E, w = t.baseId;
    if (r += "var " + v + " = errors;var " + l + ";", Array.isArray(i)) {
      var y = t.schema.additionalItems;
      if (y === !1) {
        r += " " + l + " = " + c + ".length <= " + i.length + "; ";
        var x = f;
        f = t.errSchemaPath + "/additionalItems", r += "  if (!" + l + ") {   ";
        var P = P || [];
        P.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { limit: " + i.length + " } ", t.opts.messages !== !1 && (r += " , message: 'should NOT have more than " + i.length + " items' "), t.opts.verbose && (r += " , schema: false , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
        var C = r;
        r = P.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + C + "]); " : r += " validate.errors = [" + C + "]; return false; " : r += " var err = " + C + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", f = x, p && (h += "}", r += " else { ");
      }
      var R = i;
      if (R) {
        for (var m, _ = -1, O = R.length - 1; _ < O; )
          if (m = R[_ += 1], t.opts.strictKeywords ? typeof m == "object" && Object.keys(m).length > 0 || m === !1 : t.util.schemaHasRules(m, t.RULES.all)) {
            r += " " + g + " = true; if (" + c + ".length > " + _ + ") { ";
            var T = c + "[" + _ + "]";
            d.schema = m, d.schemaPath = u + "[" + _ + "]", d.errSchemaPath = f + "/" + _, d.errorPath = t.util.getPathExpr(t.errorPath, _, t.opts.jsonPointers, !0), d.dataPathArr[E] = _;
            var A = t.validate(d);
            d.baseId = w, t.util.varOccurences(A, S) < 2 ? r += " " + t.util.varReplace(A, S, T) + " " : r += " var " + S + " = " + T + "; " + A + " ", r += " }  ", p && (r += " if (" + g + ") { ", h += "}");
          }
      }
      if (typeof y == "object" && (t.opts.strictKeywords ? typeof y == "object" && Object.keys(y).length > 0 || y === !1 : t.util.schemaHasRules(y, t.RULES.all))) {
        d.schema = y, d.schemaPath = t.schemaPath + ".additionalItems", d.errSchemaPath = t.errSchemaPath + "/additionalItems", r += " " + g + " = true; if (" + c + ".length > " + i.length + ") {  for (var " + b + " = " + i.length + "; " + b + " < " + c + ".length; " + b + "++) { ", d.errorPath = t.util.getPathExpr(t.errorPath, b, t.opts.jsonPointers, !0);
        var T = c + "[" + b + "]";
        d.dataPathArr[E] = b;
        var A = t.validate(d);
        d.baseId = w, t.util.varOccurences(A, S) < 2 ? r += " " + t.util.varReplace(A, S, T) + " " : r += " var " + S + " = " + T + "; " + A + " ", p && (r += " if (!" + g + ") break; "), r += " } }  ", p && (r += " if (" + g + ") { ", h += "}");
      }
    } else if (t.opts.strictKeywords ? typeof i == "object" && Object.keys(i).length > 0 || i === !1 : t.util.schemaHasRules(i, t.RULES.all)) {
      d.schema = i, d.schemaPath = u, d.errSchemaPath = f, r += "  for (var " + b + " = 0; " + b + " < " + c + ".length; " + b + "++) { ", d.errorPath = t.util.getPathExpr(t.errorPath, b, t.opts.jsonPointers, !0);
      var T = c + "[" + b + "]";
      d.dataPathArr[E] = b;
      var A = t.validate(d);
      d.baseId = w, t.util.varOccurences(A, S) < 2 ? r += " " + t.util.varReplace(A, S, T) + " " : r += " var " + S + " = " + T + "; " + A + " ", p && (r += " if (!" + g + ") break; "), r += " }";
    }
    return p && (r += " " + h + " if (" + v + " == errors) {"), r;
  }), Ps;
}
var xs, Of;
function $f() {
  return Of || (Of = 1, xs = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, w, c = "data" + (s || ""), l = t.opts.$data && i && i.$data, v;
    l ? (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ", v = "schema" + o) : v = i;
    var d = n == "maximum", h = d ? "exclusiveMaximum" : "exclusiveMinimum", g = t.schema[h], b = t.opts.$data && g && g.$data, E = d ? "<" : ">", S = d ? ">" : "<", w = void 0;
    if (!(l || typeof i == "number" || i === void 0))
      throw new Error(n + " must be number");
    if (!(b || g === void 0 || typeof g == "number" || typeof g == "boolean"))
      throw new Error(h + " must be number or boolean");
    if (b) {
      var y = t.util.getData(g.$data, s, t.dataPathArr), x = "exclusive" + o, P = "exclType" + o, C = "exclIsNumber" + o, R = "op" + o, m = "' + " + R + " + '";
      r += " var schemaExcl" + o + " = " + y + "; ", y = "schemaExcl" + o, r += " var " + x + "; var " + P + " = typeof " + y + "; if (" + P + " != 'boolean' && " + P + " != 'undefined' && " + P + " != 'number') { ";
      var w = h, _ = _ || [];
      _.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '" + (w || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: {} ", t.opts.messages !== !1 && (r += " , message: '" + h + " should be boolean' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
      var O = r;
      r = _.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + O + "]); " : r += " validate.errors = [" + O + "]; return false; " : r += " var err = " + O + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else if ( ", l && (r += " (" + v + " !== undefined && typeof " + v + " != 'number') || "), r += " " + P + " == 'number' ? ( (" + x + " = " + v + " === undefined || " + y + " " + E + "= " + v + ") ? " + c + " " + S + "= " + y + " : " + c + " " + S + " " + v + " ) : ( (" + x + " = " + y + " === true) ? " + c + " " + S + "= " + v + " : " + c + " " + S + " " + v + " ) || " + c + " !== " + c + ") { var op" + o + " = " + x + " ? '" + E + "' : '" + E + "='; ", i === void 0 && (w = h, f = t.errSchemaPath + "/" + h, v = y, l = b);
    } else {
      var C = typeof g == "number", m = E;
      if (C && l) {
        var R = "'" + m + "'";
        r += " if ( ", l && (r += " (" + v + " !== undefined && typeof " + v + " != 'number') || "), r += " ( " + v + " === undefined || " + g + " " + E + "= " + v + " ? " + c + " " + S + "= " + g + " : " + c + " " + S + " " + v + " ) || " + c + " !== " + c + ") { ";
      } else {
        C && i === void 0 ? (x = !0, w = h, f = t.errSchemaPath + "/" + h, v = g, S += "=") : (C && (v = Math[d ? "min" : "max"](g, i)), g === (C ? v : !0) ? (x = !0, w = h, f = t.errSchemaPath + "/" + h, S += "=") : (x = !1, m += "="));
        var R = "'" + m + "'";
        r += " if ( ", l && (r += " (" + v + " !== undefined && typeof " + v + " != 'number') || "), r += " " + c + " " + S + " " + v + " || " + c + " !== " + c + ") { ";
      }
    }
    w = w || n;
    var _ = _ || [];
    _.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '" + (w || "_limit") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { comparison: " + R + ", limit: " + v + ", exclusive: " + x + " } ", t.opts.messages !== !1 && (r += " , message: 'should be " + m + " ", l ? r += "' + " + v : r += "" + v + "'"), t.opts.verbose && (r += " , schema:  ", l ? r += "validate.schema" + u : r += "" + i, r += "         , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
    var O = r;
    return r = _.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + O + "]); " : r += " validate.errors = [" + O + "]; return false; " : r += " var err = " + O + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", p && (r += " else { "), r;
  }), xs;
}
var Es, Tf;
function jf() {
  return Tf || (Tf = 1, Es = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, h, c = "data" + (s || ""), l = t.opts.$data && i && i.$data, v;
    if (l ? (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ", v = "schema" + o) : v = i, !(l || typeof i == "number"))
      throw new Error(n + " must be number");
    var d = n == "maxItems" ? ">" : "<";
    r += "if ( ", l && (r += " (" + v + " !== undefined && typeof " + v + " != 'number') || "), r += " " + c + ".length " + d + " " + v + ") { ";
    var h = n, g = g || [];
    g.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '" + (h || "_limitItems") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { limit: " + v + " } ", t.opts.messages !== !1 && (r += " , message: 'should NOT have ", n == "maxItems" ? r += "more" : r += "fewer", r += " than ", l ? r += "' + " + v + " + '" : r += "" + i, r += " items' "), t.opts.verbose && (r += " , schema:  ", l ? r += "validate.schema" + u : r += "" + i, r += "         , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
    var b = r;
    return r = g.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + b + "]); " : r += " validate.errors = [" + b + "]; return false; " : r += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += "} ", p && (r += " else { "), r;
  }), Es;
}
var _s, Df;
function kf() {
  return Df || (Df = 1, _s = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, h, c = "data" + (s || ""), l = t.opts.$data && i && i.$data, v;
    if (l ? (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ", v = "schema" + o) : v = i, !(l || typeof i == "number"))
      throw new Error(n + " must be number");
    var d = n == "maxLength" ? ">" : "<";
    r += "if ( ", l && (r += " (" + v + " !== undefined && typeof " + v + " != 'number') || "), t.opts.unicode === !1 ? r += " " + c + ".length " : r += " ucs2length(" + c + ") ", r += " " + d + " " + v + ") { ";
    var h = n, g = g || [];
    g.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '" + (h || "_limitLength") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { limit: " + v + " } ", t.opts.messages !== !1 && (r += " , message: 'should NOT be ", n == "maxLength" ? r += "longer" : r += "shorter", r += " than ", l ? r += "' + " + v + " + '" : r += "" + i, r += " characters' "), t.opts.verbose && (r += " , schema:  ", l ? r += "validate.schema" + u : r += "" + i, r += "         , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
    var b = r;
    return r = g.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + b + "]); " : r += " validate.errors = [" + b + "]; return false; " : r += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += "} ", p && (r += " else { "), r;
  }), _s;
}
var Cs, Af;
function Mf() {
  return Af || (Af = 1, Cs = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, h, c = "data" + (s || ""), l = t.opts.$data && i && i.$data, v;
    if (l ? (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ", v = "schema" + o) : v = i, !(l || typeof i == "number"))
      throw new Error(n + " must be number");
    var d = n == "maxProperties" ? ">" : "<";
    r += "if ( ", l && (r += " (" + v + " !== undefined && typeof " + v + " != 'number') || "), r += " Object.keys(" + c + ").length " + d + " " + v + ") { ";
    var h = n, g = g || [];
    g.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '" + (h || "_limitProperties") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { limit: " + v + " } ", t.opts.messages !== !1 && (r += " , message: 'should NOT have ", n == "maxProperties" ? r += "more" : r += "fewer", r += " than ", l ? r += "' + " + v + " + '" : r += "" + i, r += " properties' "), t.opts.verbose && (r += " , schema:  ", l ? r += "validate.schema" + u : r += "" + i, r += "         , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
    var b = r;
    return r = g.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + b + "]); " : r += " validate.errors = [" + b + "]; return false; " : r += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += "} ", p && (r += " else { "), r;
  }), Cs;
}
var Rs, If;
function q1() {
  return If || (If = 1, Rs = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = t.opts.$data && i && i.$data, v;
    if (l ? (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ", v = "schema" + o) : v = i, !(l || typeof i == "number"))
      throw new Error(n + " must be number");
    r += "var division" + o + ";if (", l && (r += " " + v + " !== undefined && ( typeof " + v + " != 'number' || "), r += " (division" + o + " = " + c + " / " + v + ", ", t.opts.multipleOfPrecision ? r += " Math.abs(Math.round(division" + o + ") - division" + o + ") > 1e-" + t.opts.multipleOfPrecision + " " : r += " division" + o + " !== parseInt(division" + o + ") ", r += " ) ", l && (r += "  )  "), r += " ) {   ";
    var d = d || [];
    d.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { multipleOf: " + v + " } ", t.opts.messages !== !1 && (r += " , message: 'should be multiple of ", l ? r += "' + " + v : r += "" + v + "'"), t.opts.verbose && (r += " , schema:  ", l ? r += "validate.schema" + u : r += "" + i, r += "         , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
    var h = r;
    return r = d.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + h + "]); " : r += " validate.errors = [" + h + "]; return false; " : r += " var err = " + h + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += "} ", p && (r += " else { "), r;
  }), Rs;
}
var Os, Nf;
function F1() {
  return Nf || (Nf = 1, Os = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "errs__" + o, v = t.util.copy(t);
    v.level++;
    var d = "valid" + v.level;
    if (t.opts.strictKeywords ? typeof i == "object" && Object.keys(i).length > 0 || i === !1 : t.util.schemaHasRules(i, t.RULES.all)) {
      v.schema = i, v.schemaPath = u, v.errSchemaPath = f, r += " var " + l + " = errors;  ";
      var h = t.compositeRule;
      t.compositeRule = v.compositeRule = !0, v.createErrors = !1;
      var g;
      v.opts.allErrors && (g = v.opts.allErrors, v.opts.allErrors = !1), r += " " + t.validate(v) + " ", v.createErrors = !0, g && (v.opts.allErrors = g), t.compositeRule = v.compositeRule = h, r += " if (" + d + ") {   ";
      var b = b || [];
      b.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: {} ", t.opts.messages !== !1 && (r += " , message: 'should NOT be valid' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
      var E = r;
      r = b.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + E + "]); " : r += " validate.errors = [" + E + "]; return false; " : r += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else {  errors = " + l + "; if (vErrors !== null) { if (" + l + ") vErrors.length = " + l + "; else vErrors = null; } ", t.opts.allErrors && (r += " } ");
    } else
      r += "  var err =   ", t.createErrors !== !1 ? (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: {} ", t.opts.messages !== !1 && (r += " , message: 'should NOT be valid' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", p && (r += " if (false) { ");
    return r;
  }), Os;
}
var $s, Lf;
function z1() {
  return Lf || (Lf = 1, $s = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "valid" + o, v = "errs__" + o, d = t.util.copy(t), h = "";
    d.level++;
    var g = "valid" + d.level, b = d.baseId, E = "prevValid" + o, S = "passingSchemas" + o;
    r += "var " + v + " = errors , " + E + " = false , " + l + " = false , " + S + " = null; ";
    var w = t.compositeRule;
    t.compositeRule = d.compositeRule = !0;
    var y = i;
    if (y)
      for (var x, P = -1, C = y.length - 1; P < C; )
        x = y[P += 1], (t.opts.strictKeywords ? typeof x == "object" && Object.keys(x).length > 0 || x === !1 : t.util.schemaHasRules(x, t.RULES.all)) ? (d.schema = x, d.schemaPath = u + "[" + P + "]", d.errSchemaPath = f + "/" + P, r += "  " + t.validate(d) + " ", d.baseId = b) : r += " var " + g + " = true; ", P && (r += " if (" + g + " && " + E + ") { " + l + " = false; " + S + " = [" + S + ", " + P + "]; } else { ", h += "}"), r += " if (" + g + ") { " + l + " = " + E + " = true; " + S + " = " + P + "; }";
    return t.compositeRule = d.compositeRule = w, r += "" + h + "if (!" + l + ") {   var err =   ", t.createErrors !== !1 ? (r += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { passingSchemas: " + S + " } ", t.opts.messages !== !1 && (r += " , message: 'should match exactly one schema in oneOf' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !t.compositeRule && p && (t.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), r += "} else {  errors = " + v + "; if (vErrors !== null) { if (" + v + ") vErrors.length = " + v + "; else vErrors = null; }", t.opts.allErrors && (r += " } "), r;
  }), $s;
}
var Ts, qf;
function B1() {
  return qf || (qf = 1, Ts = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = t.opts.$data && i && i.$data, v;
    l ? (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ", v = "schema" + o) : v = i;
    var d = l ? "(new RegExp(" + v + "))" : t.usePattern(i);
    r += "if ( ", l && (r += " (" + v + " !== undefined && typeof " + v + " != 'string') || "), r += " !" + d + ".test(" + c + ") ) {   ";
    var h = h || [];
    h.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { pattern:  ", l ? r += "" + v : r += "" + t.util.toQuotedString(i), r += "  } ", t.opts.messages !== !1 && (r += ` , message: 'should match pattern "`, l ? r += "' + " + v + " + '" : r += "" + t.util.escapeQuotes(i), r += `"' `), t.opts.verbose && (r += " , schema:  ", l ? r += "validate.schema" + u : r += "" + t.util.toQuotedString(i), r += "         , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
    var g = r;
    return r = h.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + g + "]); " : r += " validate.errors = [" + g + "]; return false; " : r += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += "} ", p && (r += " else { "), r;
  }), Ts;
}
var js, Ff;
function U1() {
  return Ff || (Ff = 1, js = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "errs__" + o, v = t.util.copy(t), d = "";
    v.level++;
    var h = "valid" + v.level, g = "key" + o, b = "idx" + o, E = v.dataLevel = t.dataLevel + 1, S = "data" + E, w = "dataProperties" + o, y = Object.keys(i || {}).filter(Q), x = t.schema.patternProperties || {}, P = Object.keys(x).filter(Q), C = t.schema.additionalProperties, R = y.length || P.length, m = C === !1, _ = typeof C == "object" && Object.keys(C).length, O = t.opts.removeAdditional, T = m || _ || O, A = t.opts.ownProperties, M = t.baseId, B = t.schema.required;
    if (B && !(t.opts.$data && B.$data) && B.length < t.opts.loopRequired)
      var J = t.util.toHash(B);
    function Q(Ii) {
      return Ii !== "__proto__";
    }
    if (r += "var " + l + " = errors;var " + h + " = true;", A && (r += " var " + w + " = undefined;"), T) {
      if (A ? r += " " + w + " = " + w + " || Object.keys(" + c + "); for (var " + b + "=0; " + b + "<" + w + ".length; " + b + "++) { var " + g + " = " + w + "[" + b + "]; " : r += " for (var " + g + " in " + c + ") { ", R) {
        if (r += " var isAdditional" + o + " = !(false ", y.length)
          if (y.length > 8)
            r += " || validate.schema" + u + ".hasOwnProperty(" + g + ") ";
          else {
            var Z = y;
            if (Z)
              for (var te, le = -1, me = Z.length - 1; le < me; )
                te = Z[le += 1], r += " || " + g + " == " + t.util.toQuotedString(te) + " ";
          }
        if (P.length) {
          var G = P;
          if (G)
            for (var ee, ae = -1, j = G.length - 1; ae < j; )
              ee = G[ae += 1], r += " || " + t.usePattern(ee) + ".test(" + g + ") ";
        }
        r += " ); if (isAdditional" + o + ") { ";
      }
      if (O == "all")
        r += " delete " + c + "[" + g + "]; ";
      else {
        var N = t.errorPath, W = "' + " + g + " + '";
        if (t.opts._errorDataPathProperty && (t.errorPath = t.util.getPathExpr(t.errorPath, g, t.opts.jsonPointers)), m)
          if (O)
            r += " delete " + c + "[" + g + "]; ";
          else {
            r += " " + h + " = false; ";
            var K = f;
            f = t.errSchemaPath + "/additionalProperties";
            var I = I || [];
            I.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { additionalProperty: '" + W + "' } ", t.opts.messages !== !1 && (r += " , message: '", t.opts._errorDataPathProperty ? r += "is an invalid additional property" : r += "should NOT have additional properties", r += "' "), t.opts.verbose && (r += " , schema: false , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
            var L = r;
            r = I.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + L + "]); " : r += " validate.errors = [" + L + "]; return false; " : r += " var err = " + L + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", f = K, p && (r += " break; ");
          }
        else if (_)
          if (O == "failing") {
            r += " var " + l + " = errors;  ";
            var X = t.compositeRule;
            t.compositeRule = v.compositeRule = !0, v.schema = C, v.schemaPath = t.schemaPath + ".additionalProperties", v.errSchemaPath = t.errSchemaPath + "/additionalProperties", v.errorPath = t.opts._errorDataPathProperty ? t.errorPath : t.util.getPathExpr(t.errorPath, g, t.opts.jsonPointers);
            var Y = c + "[" + g + "]";
            v.dataPathArr[E] = g;
            var re = t.validate(v);
            v.baseId = M, t.util.varOccurences(re, S) < 2 ? r += " " + t.util.varReplace(re, S, Y) + " " : r += " var " + S + " = " + Y + "; " + re + " ", r += " if (!" + h + ") { errors = " + l + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + c + "[" + g + "]; }  ", t.compositeRule = v.compositeRule = X;
          } else {
            v.schema = C, v.schemaPath = t.schemaPath + ".additionalProperties", v.errSchemaPath = t.errSchemaPath + "/additionalProperties", v.errorPath = t.opts._errorDataPathProperty ? t.errorPath : t.util.getPathExpr(t.errorPath, g, t.opts.jsonPointers);
            var Y = c + "[" + g + "]";
            v.dataPathArr[E] = g;
            var re = t.validate(v);
            v.baseId = M, t.util.varOccurences(re, S) < 2 ? r += " " + t.util.varReplace(re, S, Y) + " " : r += " var " + S + " = " + Y + "; " + re + " ", p && (r += " if (!" + h + ") break; ");
          }
        t.errorPath = N;
      }
      R && (r += " } "), r += " }  ", p && (r += " if (" + h + ") { ", d += "}");
    }
    var pe = t.opts.useDefaults && !t.compositeRule;
    if (y.length) {
      var ie = y;
      if (ie)
        for (var te, ce = -1, de = ie.length - 1; ce < de; ) {
          te = ie[ce += 1];
          var ye = i[te];
          if (t.opts.strictKeywords ? typeof ye == "object" && Object.keys(ye).length > 0 || ye === !1 : t.util.schemaHasRules(ye, t.RULES.all)) {
            var tt = t.util.getProperty(te), Y = c + tt, se = pe && ye.default !== void 0;
            v.schema = ye, v.schemaPath = u + tt, v.errSchemaPath = f + "/" + t.util.escapeFragment(te), v.errorPath = t.util.getPath(t.errorPath, te, t.opts.jsonPointers), v.dataPathArr[E] = t.util.toQuotedString(te);
            var re = t.validate(v);
            if (v.baseId = M, t.util.varOccurences(re, S) < 2) {
              re = t.util.varReplace(re, S, Y);
              var oe = Y;
            } else {
              var oe = S;
              r += " var " + S + " = " + Y + "; ";
            }
            if (se)
              r += " " + re + " ";
            else {
              if (J && J[te]) {
                r += " if ( " + oe + " === undefined ", A && (r += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + t.util.escapeQuotes(te) + "') "), r += ") { " + h + " = false; ";
                var N = t.errorPath, K = f, ze = t.util.escapeQuotes(te);
                t.opts._errorDataPathProperty && (t.errorPath = t.util.getPath(N, te, t.opts.jsonPointers)), f = t.errSchemaPath + "/required";
                var I = I || [];
                I.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { missingProperty: '" + ze + "' } ", t.opts.messages !== !1 && (r += " , message: '", t.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + ze + "\\'", r += "' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
                var L = r;
                r = I.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + L + "]); " : r += " validate.errors = [" + L + "]; return false; " : r += " var err = " + L + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", f = K, t.errorPath = N, r += " } else { ";
              } else
                p ? (r += " if ( " + oe + " === undefined ", A && (r += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + t.util.escapeQuotes(te) + "') "), r += ") { " + h + " = true; } else { ") : (r += " if (" + oe + " !== undefined ", A && (r += " &&   Object.prototype.hasOwnProperty.call(" + c + ", '" + t.util.escapeQuotes(te) + "') "), r += " ) { ");
              r += " " + re + " } ";
            }
          }
          p && (r += " if (" + h + ") { ", d += "}");
        }
    }
    if (P.length) {
      var dt = P;
      if (dt)
        for (var ee, io = -1, Mi = dt.length - 1; io < Mi; ) {
          ee = dt[io += 1];
          var ye = x[ee];
          if (t.opts.strictKeywords ? typeof ye == "object" && Object.keys(ye).length > 0 || ye === !1 : t.util.schemaHasRules(ye, t.RULES.all)) {
            v.schema = ye, v.schemaPath = t.schemaPath + ".patternProperties" + t.util.getProperty(ee), v.errSchemaPath = t.errSchemaPath + "/patternProperties/" + t.util.escapeFragment(ee), A ? r += " " + w + " = " + w + " || Object.keys(" + c + "); for (var " + b + "=0; " + b + "<" + w + ".length; " + b + "++) { var " + g + " = " + w + "[" + b + "]; " : r += " for (var " + g + " in " + c + ") { ", r += " if (" + t.usePattern(ee) + ".test(" + g + ")) { ", v.errorPath = t.util.getPathExpr(t.errorPath, g, t.opts.jsonPointers);
            var Y = c + "[" + g + "]";
            v.dataPathArr[E] = g;
            var re = t.validate(v);
            v.baseId = M, t.util.varOccurences(re, S) < 2 ? r += " " + t.util.varReplace(re, S, Y) + " " : r += " var " + S + " = " + Y + "; " + re + " ", p && (r += " if (!" + h + ") break; "), r += " } ", p && (r += " else " + h + " = true; "), r += " }  ", p && (r += " if (" + h + ") { ", d += "}");
          }
        }
    }
    return p && (r += " " + d + " if (" + l + " == errors) {"), r;
  }), js;
}
var Ds, zf;
function H1() {
  return zf || (zf = 1, Ds = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "errs__" + o, v = t.util.copy(t), d = "";
    v.level++;
    var h = "valid" + v.level;
    if (r += "var " + l + " = errors;", t.opts.strictKeywords ? typeof i == "object" && Object.keys(i).length > 0 || i === !1 : t.util.schemaHasRules(i, t.RULES.all)) {
      v.schema = i, v.schemaPath = u, v.errSchemaPath = f;
      var g = "key" + o, b = "idx" + o, E = "i" + o, S = "' + " + g + " + '", w = v.dataLevel = t.dataLevel + 1, y = "data" + w, x = "dataProperties" + o, P = t.opts.ownProperties, C = t.baseId;
      P && (r += " var " + x + " = undefined; "), P ? r += " " + x + " = " + x + " || Object.keys(" + c + "); for (var " + b + "=0; " + b + "<" + x + ".length; " + b + "++) { var " + g + " = " + x + "[" + b + "]; " : r += " for (var " + g + " in " + c + ") { ", r += " var startErrs" + o + " = errors; ";
      var R = g, m = t.compositeRule;
      t.compositeRule = v.compositeRule = !0;
      var _ = t.validate(v);
      v.baseId = C, t.util.varOccurences(_, y) < 2 ? r += " " + t.util.varReplace(_, y, R) + " " : r += " var " + y + " = " + R + "; " + _ + " ", t.compositeRule = v.compositeRule = m, r += " if (!" + h + ") { for (var " + E + "=startErrs" + o + "; " + E + "<errors; " + E + "++) { vErrors[" + E + "].propertyName = " + g + "; }   var err =   ", t.createErrors !== !1 ? (r += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { propertyName: '" + S + "' } ", t.opts.messages !== !1 && (r += " , message: 'property name \\'" + S + "\\' is invalid' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !t.compositeRule && p && (t.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), p && (r += " break; "), r += " } }";
    }
    return p && (r += " " + d + " if (" + l + " == errors) {"), r;
  }), Ds;
}
var ks, Bf;
function V1() {
  return Bf || (Bf = 1, ks = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "valid" + o, v = t.opts.$data && i && i.$data;
    v && (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ");
    var d = "schema" + o;
    if (!v)
      if (i.length < t.opts.loopRequired && t.schema.properties && Object.keys(t.schema.properties).length) {
        var h = [], g = i;
        if (g)
          for (var b, E = -1, S = g.length - 1; E < S; ) {
            b = g[E += 1];
            var w = t.schema.properties[b];
            w && (t.opts.strictKeywords ? typeof w == "object" && Object.keys(w).length > 0 || w === !1 : t.util.schemaHasRules(w, t.RULES.all)) || (h[h.length] = b);
          }
      } else
        var h = i;
    if (v || h.length) {
      var y = t.errorPath, x = v || h.length >= t.opts.loopRequired, P = t.opts.ownProperties;
      if (p)
        if (r += " var missing" + o + "; ", x) {
          v || (r += " var " + d + " = validate.schema" + u + "; ");
          var C = "i" + o, R = "schema" + o + "[" + C + "]", m = "' + " + R + " + '";
          t.opts._errorDataPathProperty && (t.errorPath = t.util.getPathExpr(y, R, t.opts.jsonPointers)), r += " var " + l + " = true; ", v && (r += " if (schema" + o + " === undefined) " + l + " = true; else if (!Array.isArray(schema" + o + ")) " + l + " = false; else {"), r += " for (var " + C + " = 0; " + C + " < " + d + ".length; " + C + "++) { " + l + " = " + c + "[" + d + "[" + C + "]] !== undefined ", P && (r += " &&   Object.prototype.hasOwnProperty.call(" + c + ", " + d + "[" + C + "]) "), r += "; if (!" + l + ") break; } ", v && (r += "  }  "), r += "  if (!" + l + ") {   ";
          var _ = _ || [];
          _.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { missingProperty: '" + m + "' } ", t.opts.messages !== !1 && (r += " , message: '", t.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + m + "\\'", r += "' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
          var O = r;
          r = _.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + O + "]); " : r += " validate.errors = [" + O + "]; return false; " : r += " var err = " + O + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else { ";
        } else {
          r += " if ( ";
          var T = h;
          if (T)
            for (var A, C = -1, M = T.length - 1; C < M; ) {
              A = T[C += 1], C && (r += " || ");
              var B = t.util.getProperty(A), J = c + B;
              r += " ( ( " + J + " === undefined ", P && (r += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + t.util.escapeQuotes(A) + "') "), r += ") && (missing" + o + " = " + t.util.toQuotedString(t.opts.jsonPointers ? A : B) + ") ) ";
            }
          r += ") {  ";
          var R = "missing" + o, m = "' + " + R + " + '";
          t.opts._errorDataPathProperty && (t.errorPath = t.opts.jsonPointers ? t.util.getPathExpr(y, R, !0) : y + " + " + R);
          var _ = _ || [];
          _.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { missingProperty: '" + m + "' } ", t.opts.messages !== !1 && (r += " , message: '", t.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + m + "\\'", r += "' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
          var O = r;
          r = _.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + O + "]); " : r += " validate.errors = [" + O + "]; return false; " : r += " var err = " + O + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else { ";
        }
      else if (x) {
        v || (r += " var " + d + " = validate.schema" + u + "; ");
        var C = "i" + o, R = "schema" + o + "[" + C + "]", m = "' + " + R + " + '";
        t.opts._errorDataPathProperty && (t.errorPath = t.util.getPathExpr(y, R, t.opts.jsonPointers)), v && (r += " if (" + d + " && !Array.isArray(" + d + ")) {  var err =   ", t.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { missingProperty: '" + m + "' } ", t.opts.messages !== !1 && (r += " , message: '", t.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + m + "\\'", r += "' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + d + " !== undefined) { "), r += " for (var " + C + " = 0; " + C + " < " + d + ".length; " + C + "++) { if (" + c + "[" + d + "[" + C + "]] === undefined ", P && (r += " || ! Object.prototype.hasOwnProperty.call(" + c + ", " + d + "[" + C + "]) "), r += ") {  var err =   ", t.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { missingProperty: '" + m + "' } ", t.opts.messages !== !1 && (r += " , message: '", t.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + m + "\\'", r += "' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", v && (r += "  }  ");
      } else {
        var Q = h;
        if (Q)
          for (var A, Z = -1, te = Q.length - 1; Z < te; ) {
            A = Q[Z += 1];
            var B = t.util.getProperty(A), m = t.util.escapeQuotes(A), J = c + B;
            t.opts._errorDataPathProperty && (t.errorPath = t.util.getPath(y, A, t.opts.jsonPointers)), r += " if ( " + J + " === undefined ", P && (r += " || ! Object.prototype.hasOwnProperty.call(" + c + ", '" + t.util.escapeQuotes(A) + "') "), r += ") {  var err =   ", t.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { missingProperty: '" + m + "' } ", t.opts.messages !== !1 && (r += " , message: '", t.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + m + "\\'", r += "' "), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
          }
      }
      t.errorPath = y;
    } else p && (r += " if (true) {");
    return r;
  }), ks;
}
var As, Uf;
function W1() {
  return Uf || (Uf = 1, As = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c = "data" + (s || ""), l = "valid" + o, v = t.opts.$data && i && i.$data, d;
    if (v ? (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ", d = "schema" + o) : d = i, (i || v) && t.opts.uniqueItems !== !1) {
      v && (r += " var " + l + "; if (" + d + " === false || " + d + " === undefined) " + l + " = true; else if (typeof " + d + " != 'boolean') " + l + " = false; else { "), r += " var i = " + c + ".length , " + l + " = true , j; if (i > 1) { ";
      var h = t.schema.items && t.schema.items.type, g = Array.isArray(h);
      if (!h || h == "object" || h == "array" || g && (h.indexOf("object") >= 0 || h.indexOf("array") >= 0))
        r += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + c + "[i], " + c + "[j])) { " + l + " = false; break outer; } } } ";
      else {
        r += " var itemIndices = {}, item; for (;i--;) { var item = " + c + "[i]; ";
        var b = "checkDataType" + (g ? "s" : "");
        r += " if (" + t.util[b](h, "item", t.opts.strictNumbers, !0) + ") continue; ", g && (r += ` if (typeof item == 'string') item = '"' + item; `), r += " if (typeof itemIndices[item] == 'number') { " + l + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
      }
      r += " } ", v && (r += "  }  "), r += " if (!" + l + ") {   ";
      var E = E || [];
      E.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { i: i, j: j } ", t.opts.messages !== !1 && (r += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), t.opts.verbose && (r += " , schema:  ", v ? r += "validate.schema" + u : r += "" + i, r += "         , parentSchema: validate.schema" + t.schemaPath + " , data: " + c + " "), r += " } ") : r += " {} ";
      var S = r;
      r = E.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + S + "]); " : r += " validate.errors = [" + S + "]; return false; " : r += " var err = " + S + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", p && (r += " else { ");
    } else
      p && (r += " if (true) { ");
    return r;
  }), As;
}
var Ms, Hf;
function G1() {
  return Hf || (Hf = 1, Ms = {
    $ref: O1(),
    allOf: $1(),
    anyOf: T1(),
    $comment: j1(),
    const: D1(),
    contains: k1(),
    dependencies: A1(),
    enum: M1(),
    format: I1(),
    if: N1(),
    items: L1(),
    maximum: $f(),
    minimum: $f(),
    maxItems: jf(),
    minItems: jf(),
    maxLength: kf(),
    minLength: kf(),
    maxProperties: Mf(),
    minProperties: Mf(),
    multipleOf: q1(),
    not: F1(),
    oneOf: z1(),
    pattern: B1(),
    properties: U1(),
    propertyNames: H1(),
    required: V1(),
    uniqueItems: W1(),
    validate: rm()
  }), Ms;
}
var Is, Vf;
function K1() {
  if (Vf) return Is;
  Vf = 1;
  var e = G1(), t = Gn().toHash;
  return Is = function() {
    var a = [
      {
        type: "number",
        rules: [
          { maximum: ["exclusiveMaximum"] },
          { minimum: ["exclusiveMinimum"] },
          "multipleOf",
          "format"
        ]
      },
      {
        type: "string",
        rules: ["maxLength", "minLength", "pattern", "format"]
      },
      {
        type: "array",
        rules: ["maxItems", "minItems", "items", "contains", "uniqueItems"]
      },
      {
        type: "object",
        rules: [
          "maxProperties",
          "minProperties",
          "required",
          "dependencies",
          "propertyNames",
          { properties: ["additionalProperties", "patternProperties"] }
        ]
      },
      { rules: ["$ref", "const", "enum", "not", "anyOf", "oneOf", "allOf", "if"] }
    ], r = ["type", "$comment"], o = [
      "$schema",
      "$id",
      "id",
      "$data",
      "$async",
      "title",
      "description",
      "default",
      "definitions",
      "examples",
      "readOnly",
      "writeOnly",
      "contentMediaType",
      "contentEncoding",
      "additionalItems",
      "then",
      "else"
    ], s = ["number", "integer", "string", "array", "object", "boolean", "null"];
    return a.all = t(r), a.types = t(s), a.forEach(function(i) {
      i.rules = i.rules.map(function(u) {
        var f;
        if (typeof u == "object") {
          var p = Object.keys(u)[0];
          f = u[p], u = p, f.forEach(function(l) {
            r.push(l), a.all[l] = !0;
          });
        }
        r.push(u);
        var c = a.all[u] = {
          keyword: u,
          code: e[u],
          implements: f
        };
        return c;
      }), a.all.$comment = {
        keyword: "$comment",
        code: e.$comment
      }, i.type && (a.types[i.type] = i);
    }), a.keywords = t(r.concat(o)), a.custom = {}, a;
  }, Is;
}
var Ns, Wf;
function J1() {
  if (Wf) return Ns;
  Wf = 1;
  var e = [
    "multipleOf",
    "maximum",
    "exclusiveMaximum",
    "minimum",
    "exclusiveMinimum",
    "maxLength",
    "minLength",
    "pattern",
    "additionalItems",
    "maxItems",
    "minItems",
    "uniqueItems",
    "maxProperties",
    "minProperties",
    "required",
    "additionalProperties",
    "enum",
    "format",
    "const"
  ];
  return Ns = function(t, n) {
    for (var a = 0; a < n.length; a++) {
      t = JSON.parse(JSON.stringify(t));
      var r = n[a].split("/"), o = t, s;
      for (s = 1; s < r.length; s++)
        o = o[r[s]];
      for (s = 0; s < e.length; s++) {
        var i = e[s], u = o[i];
        u && (o[i] = {
          anyOf: [
            u,
            { $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#" }
          ]
        });
      }
    }
    return t;
  }, Ns;
}
var Ls, Gf;
function Q1() {
  if (Gf) return Ls;
  Gf = 1;
  var e = uu().MissingRef;
  Ls = t;
  function t(n, a, r) {
    var o = this;
    if (typeof this._opts.loadSchema != "function")
      throw new Error("options.loadSchema should be a function");
    typeof a == "function" && (r = a, a = void 0);
    var s = i(n).then(function() {
      var f = o._addSchema(n, void 0, a);
      return f.validate || u(f);
    });
    return r && s.then(
      function(f) {
        r(null, f);
      },
      r
    ), s;
    function i(f) {
      var p = f.$schema;
      return p && !o.getSchema(p) ? t.call(o, { $ref: p }, !0) : Promise.resolve();
    }
    function u(f) {
      try {
        return o._compile(f);
      } catch (c) {
        if (c instanceof e) return p(c);
        throw c;
      }
      function p(c) {
        var l = c.missingSchema;
        if (h(l)) throw new Error("Schema " + l + " is loaded but " + c.missingRef + " cannot be resolved");
        var v = o._loadingSchemas[l];
        return v || (v = o._loadingSchemas[l] = o._opts.loadSchema(l), v.then(d, d)), v.then(function(g) {
          if (!h(l))
            return i(g).then(function() {
              h(l) || o.addSchema(g, l, void 0, a);
            });
        }).then(function() {
          return u(f);
        });
        function d() {
          delete o._loadingSchemas[l];
        }
        function h(g) {
          return o._refs[g] || o._schemas[g];
        }
      }
    }
  }
  return Ls;
}
var qs, Kf;
function Y1() {
  return Kf || (Kf = 1, qs = function(t, n, a) {
    var r = " ", o = t.level, s = t.dataLevel, i = t.schema[n], u = t.schemaPath + t.util.getProperty(n), f = t.errSchemaPath + "/" + n, p = !t.opts.allErrors, c, l = "data" + (s || ""), v = "valid" + o, d = "errs__" + o, h = t.opts.$data && i && i.$data, g;
    h ? (r += " var schema" + o + " = " + t.util.getData(i.$data, s, t.dataPathArr) + "; ", g = "schema" + o) : g = i;
    var b = this, E = "definition" + o, S = b.definition, w = "", y, x, P, C, R;
    if (h && S.$data) {
      R = "keywordValidate" + o;
      var m = S.validateSchema;
      r += " var " + E + " = RULES.custom['" + n + "'].definition; var " + R + " = " + E + ".validate;";
    } else {
      if (C = t.useCustomRule(b, i, t.schema, t), !C) return;
      g = "validate.schema" + u, R = C.code, y = S.compile, x = S.inline, P = S.macro;
    }
    var _ = R + ".errors", O = "i" + o, T = "ruleErr" + o, A = S.async;
    if (A && !t.async) throw new Error("async keyword in sync schema");
    if (x || P || (r += "" + _ + " = null;"), r += "var " + d + " = errors;var " + v + ";", h && S.$data && (w += "}", r += " if (" + g + " === undefined) { " + v + " = true; } else { ", m && (w += "}", r += " " + v + " = " + E + ".validateSchema(" + g + "); if (" + v + ") { ")), x)
      S.statements ? r += " " + C.validate + " " : r += " " + v + " = " + C.validate + "; ";
    else if (P) {
      var M = t.util.copy(t), w = "";
      M.level++;
      var B = "valid" + M.level;
      M.schema = C.validate, M.schemaPath = "";
      var J = t.compositeRule;
      t.compositeRule = M.compositeRule = !0;
      var Q = t.validate(M).replace(/validate\.schema/g, R);
      t.compositeRule = M.compositeRule = J, r += " " + Q;
    } else {
      var Z = Z || [];
      Z.push(r), r = "", r += "  " + R + ".call( ", t.opts.passContext ? r += "this" : r += "self", y || S.schema === !1 ? r += " , " + l + " " : r += " , " + g + " , " + l + " , validate.schema" + t.schemaPath + " ", r += " , (dataPath || '')", t.errorPath != '""' && (r += " + " + t.errorPath);
      var te = s ? "data" + (s - 1 || "") : "parentData", le = s ? t.dataPathArr[s] : "parentDataProperty";
      r += " , " + te + " , " + le + " , rootData )  ";
      var me = r;
      r = Z.pop(), S.errors === !1 ? (r += " " + v + " = ", A && (r += "await "), r += "" + me + "; ") : A ? (_ = "customErrors" + o, r += " var " + _ + " = null; try { " + v + " = await " + me + "; } catch (e) { " + v + " = false; if (e instanceof ValidationError) " + _ + " = e.errors; else throw e; } ") : r += " " + _ + " = null; " + v + " = " + me + "; ";
    }
    if (S.modifying && (r += " if (" + te + ") " + l + " = " + te + "[" + le + "];"), r += "" + w, S.valid)
      p && (r += " if (true) { ");
    else {
      r += " if ( ", S.valid === void 0 ? (r += " !", P ? r += "" + B : r += "" + v) : r += " " + !S.valid + " ", r += ") { ", c = b.keyword;
      var Z = Z || [];
      Z.push(r), r = "";
      var Z = Z || [];
      Z.push(r), r = "", t.createErrors !== !1 ? (r += " { keyword: '" + (c || "custom") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { keyword: '" + b.keyword + "' } ", t.opts.messages !== !1 && (r += ` , message: 'should pass "` + b.keyword + `" keyword validation' `), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + l + " "), r += " } ") : r += " {} ";
      var G = r;
      r = Z.pop(), !t.compositeRule && p ? t.async ? r += " throw new ValidationError([" + G + "]); " : r += " validate.errors = [" + G + "]; return false; " : r += " var err = " + G + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      var ee = r;
      r = Z.pop(), x ? S.errors ? S.errors != "full" && (r += "  for (var " + O + "=" + d + "; " + O + "<errors; " + O + "++) { var " + T + " = vErrors[" + O + "]; if (" + T + ".dataPath === undefined) " + T + ".dataPath = (dataPath || '') + " + t.errorPath + "; if (" + T + ".schemaPath === undefined) { " + T + '.schemaPath = "' + f + '"; } ', t.opts.verbose && (r += " " + T + ".schema = " + g + "; " + T + ".data = " + l + "; "), r += " } ") : S.errors === !1 ? r += " " + ee + " " : (r += " if (" + d + " == errors) { " + ee + " } else {  for (var " + O + "=" + d + "; " + O + "<errors; " + O + "++) { var " + T + " = vErrors[" + O + "]; if (" + T + ".dataPath === undefined) " + T + ".dataPath = (dataPath || '') + " + t.errorPath + "; if (" + T + ".schemaPath === undefined) { " + T + '.schemaPath = "' + f + '"; } ', t.opts.verbose && (r += " " + T + ".schema = " + g + "; " + T + ".data = " + l + "; "), r += " } } ") : P ? (r += "   var err =   ", t.createErrors !== !1 ? (r += " { keyword: '" + (c || "custom") + "' , dataPath: (dataPath || '') + " + t.errorPath + " , schemaPath: " + t.util.toQuotedString(f) + " , params: { keyword: '" + b.keyword + "' } ", t.opts.messages !== !1 && (r += ` , message: 'should pass "` + b.keyword + `" keyword validation' `), t.opts.verbose && (r += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + t.schemaPath + " , data: " + l + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !t.compositeRule && p && (t.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; ")) : S.errors === !1 ? r += " " + ee + " " : (r += " if (Array.isArray(" + _ + ")) { if (vErrors === null) vErrors = " + _ + "; else vErrors = vErrors.concat(" + _ + "); errors = vErrors.length;  for (var " + O + "=" + d + "; " + O + "<errors; " + O + "++) { var " + T + " = vErrors[" + O + "]; if (" + T + ".dataPath === undefined) " + T + ".dataPath = (dataPath || '') + " + t.errorPath + ";  " + T + '.schemaPath = "' + f + '";  ', t.opts.verbose && (r += " " + T + ".schema = " + g + "; " + T + ".data = " + l + "; "), r += " } } else { " + ee + " } "), r += " } ", p && (r += " else { ");
    }
    return r;
  }), qs;
}
const X1 = "http://json-schema.org/draft-07/schema#", Z1 = "http://json-schema.org/draft-07/schema#", ew = "Core schema meta-schema", tw = { schemaArray: { type: "array", minItems: 1, items: { $ref: "#" } }, nonNegativeInteger: { type: "integer", minimum: 0 }, nonNegativeIntegerDefault0: { allOf: [{ $ref: "#/definitions/nonNegativeInteger" }, { default: 0 }] }, simpleTypes: { enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { type: "array", items: { type: "string" }, uniqueItems: !0, default: [] } }, rw = ["object", "boolean"], nw = { $id: { type: "string", format: "uri-reference" }, $schema: { type: "string", format: "uri" }, $ref: { type: "string", format: "uri-reference" }, $comment: { type: "string" }, title: { type: "string" }, description: { type: "string" }, default: !0, readOnly: { type: "boolean", default: !1 }, examples: { type: "array", items: !0 }, multipleOf: { type: "number", exclusiveMinimum: 0 }, maximum: { type: "number" }, exclusiveMaximum: { type: "number" }, minimum: { type: "number" }, exclusiveMinimum: { type: "number" }, maxLength: { $ref: "#/definitions/nonNegativeInteger" }, minLength: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, pattern: { type: "string", format: "regex" }, additionalItems: { $ref: "#" }, items: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: !0 }, maxItems: { $ref: "#/definitions/nonNegativeInteger" }, minItems: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, uniqueItems: { type: "boolean", default: !1 }, contains: { $ref: "#" }, maxProperties: { $ref: "#/definitions/nonNegativeInteger" }, minProperties: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { $ref: "#" }, definitions: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { type: "object", additionalProperties: { $ref: "#" }, propertyNames: { format: "regex" }, default: {} }, dependencies: { type: "object", additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, propertyNames: { $ref: "#" }, const: !0, enum: { type: "array", items: !0, minItems: 1, uniqueItems: !0 }, type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, { type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: !0 }] }, format: { type: "string" }, contentMediaType: { type: "string" }, contentEncoding: { type: "string" }, if: { $ref: "#" }, then: { $ref: "#" }, else: { $ref: "#" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } }, nm = {
  $schema: X1,
  $id: Z1,
  title: ew,
  definitions: tw,
  type: rw,
  properties: nw,
  default: !0
};
var Fs, Jf;
function aw() {
  if (Jf) return Fs;
  Jf = 1;
  var e = nm;
  return Fs = {
    $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
    definitions: {
      simpleTypes: e.definitions.simpleTypes
    },
    type: "object",
    dependencies: {
      schema: ["validate"],
      $data: ["validate"],
      statements: ["inline"],
      valid: { not: { required: ["macro"] } }
    },
    properties: {
      type: e.properties.type,
      schema: { type: "boolean" },
      statements: { type: "boolean" },
      dependencies: {
        type: "array",
        items: { type: "string" }
      },
      metaSchema: { type: "object" },
      modifying: { type: "boolean" },
      valid: { type: "boolean" },
      $data: { type: "boolean" },
      async: { type: "boolean" },
      errors: {
        anyOf: [
          { type: "boolean" },
          { const: "full" }
        ]
      }
    }
  }, Fs;
}
var zs, Qf;
function ow() {
  if (Qf) return zs;
  Qf = 1;
  var e = /^[a-z_$][a-z0-9_$-]*$/i, t = Y1(), n = aw();
  zs = {
    add: a,
    get: r,
    remove: o,
    validate: s
  };
  function a(i, u) {
    var f = this.RULES;
    if (f.keywords[i])
      throw new Error("Keyword " + i + " is already defined");
    if (!e.test(i))
      throw new Error("Keyword " + i + " is not a valid identifier");
    if (u) {
      this.validateKeyword(u, !0);
      var p = u.type;
      if (Array.isArray(p))
        for (var c = 0; c < p.length; c++)
          v(i, p[c], u);
      else
        v(i, p, u);
      var l = u.metaSchema;
      l && (u.$data && this._opts.$data && (l = {
        anyOf: [
          l,
          { $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#" }
        ]
      }), u.validateSchema = this.compile(l, !0));
    }
    f.keywords[i] = f.all[i] = !0;
    function v(d, h, g) {
      for (var b, E = 0; E < f.length; E++) {
        var S = f[E];
        if (S.type == h) {
          b = S;
          break;
        }
      }
      b || (b = { type: h, rules: [] }, f.push(b));
      var w = {
        keyword: d,
        definition: g,
        custom: !0,
        code: t,
        implements: g.implements
      };
      b.rules.push(w), f.custom[d] = w;
    }
    return this;
  }
  function r(i) {
    var u = this.RULES.custom[i];
    return u ? u.definition : this.RULES.keywords[i] || !1;
  }
  function o(i) {
    var u = this.RULES;
    delete u.keywords[i], delete u.all[i], delete u.custom[i];
    for (var f = 0; f < u.length; f++)
      for (var p = u[f].rules, c = 0; c < p.length; c++)
        if (p[c].keyword == i) {
          p.splice(c, 1);
          break;
        }
    return this;
  }
  function s(i, u) {
    s.errors = null;
    var f = this._validateKeyword = this._validateKeyword || this.compile(n, !0);
    if (f(i)) return !0;
    if (s.errors = f.errors, u)
      throw new Error("custom keyword definition is invalid: " + this.errorsText(f.errors));
    return !1;
  }
  return zs;
}
const iw = "http://json-schema.org/draft-07/schema#", sw = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#", lw = "Meta-schema for $data reference (JSON Schema extension proposal)", uw = "object", cw = ["$data"], fw = { $data: { type: "string", anyOf: [{ format: "relative-json-pointer" }, { format: "json-pointer" }] } }, dw = !1, pw = {
  $schema: iw,
  $id: sw,
  description: lw,
  type: uw,
  required: cw,
  properties: fw,
  additionalProperties: dw
};
var Bs, Yf;
function am() {
  if (Yf) return Bs;
  Yf = 1;
  var e = _1(), t = lu(), n = C1(), a = em(), r = tm(), o = R1(), s = K1(), i = J1(), u = Gn();
  Bs = d, d.prototype.validate = h, d.prototype.compile = g, d.prototype.addSchema = b, d.prototype.addMetaSchema = E, d.prototype.validateSchema = S, d.prototype.getSchema = y, d.prototype.removeSchema = C, d.prototype.addFormat = J, d.prototype.errorsText = B, d.prototype._addSchema = m, d.prototype._compile = _, d.prototype.compileAsync = Q1();
  var f = ow();
  d.prototype.addKeyword = f.add, d.prototype.getKeyword = f.get, d.prototype.removeKeyword = f.remove, d.prototype.validateKeyword = f.validate;
  var p = uu();
  d.ValidationError = p.Validation, d.MissingRefError = p.MissingRef, d.$dataMetaSchema = i;
  var c = "http://json-schema.org/draft-07/schema", l = ["removeAdditional", "useDefaults", "coerceTypes", "strictDefaults"], v = ["/properties"];
  function d(j) {
    if (!(this instanceof d)) return new d(j);
    j = this._opts = u.copy(j) || {}, ee(this), this._schemas = {}, this._refs = {}, this._fragments = {}, this._formats = o(j.format), this._cache = j.cache || new n(), this._loadingSchemas = {}, this._compilations = [], this.RULES = s(), this._getId = O(j), j.loopRequired = j.loopRequired || 1 / 0, j.errorDataPath == "property" && (j._errorDataPathProperty = !0), j.serialize === void 0 && (j.serialize = r), this._metaOpts = G(this), j.formats && te(this), j.keywords && le(this), Q(this), typeof j.meta == "object" && this.addMetaSchema(j.meta), j.nullable && this.addKeyword("nullable", { metaSchema: { type: "boolean" } }), Z(this);
  }
  function h(j, N) {
    var W;
    if (typeof j == "string") {
      if (W = this.getSchema(j), !W) throw new Error('no schema with key or ref "' + j + '"');
    } else {
      var K = this._addSchema(j);
      W = K.validate || this._compile(K);
    }
    var I = W(N);
    return W.$async !== !0 && (this.errors = W.errors), I;
  }
  function g(j, N) {
    var W = this._addSchema(j, void 0, N);
    return W.validate || this._compile(W);
  }
  function b(j, N, W, K) {
    if (Array.isArray(j)) {
      for (var I = 0; I < j.length; I++) this.addSchema(j[I], void 0, W, K);
      return this;
    }
    var L = this._getId(j);
    if (L !== void 0 && typeof L != "string")
      throw new Error("schema id must be string");
    return N = t.normalizeId(N || L), me(this, N), this._schemas[N] = this._addSchema(j, W, K, !0), this;
  }
  function E(j, N, W) {
    return this.addSchema(j, N, W, !0), this;
  }
  function S(j, N) {
    var W = j.$schema;
    if (W !== void 0 && typeof W != "string")
      throw new Error("$schema must be a string");
    if (W = W || this._opts.defaultMeta || w(this), !W)
      return this.logger.warn("meta-schema not available"), this.errors = null, !0;
    var K = this.validate(W, j);
    if (!K && N) {
      var I = "schema is invalid: " + this.errorsText();
      if (this._opts.validateSchema == "log") this.logger.error(I);
      else throw new Error(I);
    }
    return K;
  }
  function w(j) {
    var N = j._opts.meta;
    return j._opts.defaultMeta = typeof N == "object" ? j._getId(N) || N : j.getSchema(c) ? c : void 0, j._opts.defaultMeta;
  }
  function y(j) {
    var N = P(this, j);
    switch (typeof N) {
      case "object":
        return N.validate || this._compile(N);
      case "string":
        return this.getSchema(N);
      case "undefined":
        return x(this, j);
    }
  }
  function x(j, N) {
    var W = t.schema.call(j, { schema: {} }, N);
    if (W) {
      var K = W.schema, I = W.root, L = W.baseId, X = e.call(j, K, I, void 0, L);
      return j._fragments[N] = new a({
        ref: N,
        fragment: !0,
        schema: K,
        root: I,
        baseId: L,
        validate: X
      }), X;
    }
  }
  function P(j, N) {
    return N = t.normalizeId(N), j._schemas[N] || j._refs[N] || j._fragments[N];
  }
  function C(j) {
    if (j instanceof RegExp)
      return R(this, this._schemas, j), R(this, this._refs, j), this;
    switch (typeof j) {
      case "undefined":
        return R(this, this._schemas), R(this, this._refs), this._cache.clear(), this;
      case "string":
        var N = P(this, j);
        return N && this._cache.del(N.cacheKey), delete this._schemas[j], delete this._refs[j], this;
      case "object":
        var W = this._opts.serialize, K = W ? W(j) : j;
        this._cache.del(K);
        var I = this._getId(j);
        I && (I = t.normalizeId(I), delete this._schemas[I], delete this._refs[I]);
    }
    return this;
  }
  function R(j, N, W) {
    for (var K in N) {
      var I = N[K];
      !I.meta && (!W || W.test(K)) && (j._cache.del(I.cacheKey), delete N[K]);
    }
  }
  function m(j, N, W, K) {
    if (typeof j != "object" && typeof j != "boolean")
      throw new Error("schema should be object or boolean");
    var I = this._opts.serialize, L = I ? I(j) : j, X = this._cache.get(L);
    if (X) return X;
    K = K || this._opts.addUsedSchema !== !1;
    var Y = t.normalizeId(this._getId(j));
    Y && K && me(this, Y);
    var re = this._opts.validateSchema !== !1 && !N, pe;
    re && !(pe = Y && Y == t.normalizeId(j.$schema)) && this.validateSchema(j, !0);
    var ie = t.ids.call(this, j), ce = new a({
      id: Y,
      schema: j,
      localRefs: ie,
      cacheKey: L,
      meta: W
    });
    return Y[0] != "#" && K && (this._refs[Y] = ce), this._cache.put(L, ce), re && pe && this.validateSchema(j, !0), ce;
  }
  function _(j, N) {
    if (j.compiling)
      return j.validate = I, I.schema = j.schema, I.errors = null, I.root = N || I, j.schema.$async === !0 && (I.$async = !0), I;
    j.compiling = !0;
    var W;
    j.meta && (W = this._opts, this._opts = this._metaOpts);
    var K;
    try {
      K = e.call(this, j.schema, N, j.localRefs);
    } catch (L) {
      throw delete j.validate, L;
    } finally {
      j.compiling = !1, j.meta && (this._opts = W);
    }
    return j.validate = K, j.refs = K.refs, j.refVal = K.refVal, j.root = K.root, K;
    function I() {
      var L = j.validate, X = L.apply(this, arguments);
      return I.errors = L.errors, X;
    }
  }
  function O(j) {
    switch (j.schemaId) {
      case "auto":
        return M;
      case "id":
        return T;
      default:
        return A;
    }
  }
  function T(j) {
    return j.$id && this.logger.warn("schema $id ignored", j.$id), j.id;
  }
  function A(j) {
    return j.id && this.logger.warn("schema id ignored", j.id), j.$id;
  }
  function M(j) {
    if (j.$id && j.id && j.$id != j.id)
      throw new Error("schema $id is different from id");
    return j.$id || j.id;
  }
  function B(j, N) {
    if (j = j || this.errors, !j) return "No errors";
    N = N || {};
    for (var W = N.separator === void 0 ? ", " : N.separator, K = N.dataVar === void 0 ? "data" : N.dataVar, I = "", L = 0; L < j.length; L++) {
      var X = j[L];
      X && (I += K + X.dataPath + " " + X.message + W);
    }
    return I.slice(0, -W.length);
  }
  function J(j, N) {
    return typeof N == "string" && (N = new RegExp(N)), this._formats[j] = N, this;
  }
  function Q(j) {
    var N;
    if (j._opts.$data && (N = pw, j.addMetaSchema(N, N.$id, !0)), j._opts.meta !== !1) {
      var W = nm;
      j._opts.$data && (W = i(W, v)), j.addMetaSchema(W, c, !0), j._refs["http://json-schema.org/schema"] = c;
    }
  }
  function Z(j) {
    var N = j._opts.schemas;
    if (N)
      if (Array.isArray(N)) j.addSchema(N);
      else for (var W in N) j.addSchema(N[W], W);
  }
  function te(j) {
    for (var N in j._opts.formats) {
      var W = j._opts.formats[N];
      j.addFormat(N, W);
    }
  }
  function le(j) {
    for (var N in j._opts.keywords) {
      var W = j._opts.keywords[N];
      j.addKeyword(N, W);
    }
  }
  function me(j, N) {
    if (j._schemas[N] || j._refs[N])
      throw new Error('schema with key or id "' + N + '" already exists');
  }
  function G(j) {
    for (var N = u.copy(j._opts), W = 0; W < l.length; W++)
      delete N[l[W]];
    return N;
  }
  function ee(j) {
    var N = j._opts.logger;
    if (N === !1)
      j.logger = { log: ae, warn: ae, error: ae };
    else {
      if (N === void 0 && (N = console), !(typeof N == "object" && N.log && N.warn && N.error))
        throw new Error("logger must implement log, warn and error methods");
      j.logger = N;
    }
  }
  function ae() {
  }
  return Bs;
}
var Us = {}, Xf;
function hw() {
  return Xf || (Xf = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.jsonSchema = void 0, e.jsonSchema = { $schema: "https://meta.json-schema.tools/", $id: "https://meta.json-schema.tools/", title: "JSONSchema", default: {}, oneOf: [{ $ref: "#/definitions/JSONSchemaObject" }, { $ref: "#/definitions/JSONSchemaBoolean" }], definitions: { JSONSchemaBoolean: { title: "JSONSchemaBoolean", description: "Always valid if true. Never valid if false. Is constant.", type: "boolean" }, JSONSchemaObject: { title: "JSONSchemaObject", type: "object", properties: { $id: { title: "$id", type: "string", format: "uri-reference" }, $schema: { title: "$schema", type: "string", format: "uri" }, $ref: { title: "$ref", type: "string", format: "uri-reference" }, $comment: { title: "$comment", type: "string" }, title: { title: "title", type: "string" }, description: { title: "description", type: "string" }, default: !0, readOnly: { title: "readOnly", type: "boolean", default: !1 }, examples: { title: "examples", type: "array", items: !0 }, multipleOf: { title: "multipleOf", type: "number", exclusiveMinimum: 0 }, maximum: { title: "maximum", type: "number" }, exclusiveMaximum: { title: "exclusiveMaximum", type: "number" }, minimum: { title: "minimum", type: "number" }, exclusiveMinimum: { title: "exclusiveMinimum", type: "number" }, maxLength: { $ref: "#/definitions/nonNegativeInteger" }, minLength: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, pattern: { title: "pattern", type: "string", format: "regex" }, additionalItems: { $ref: "#" }, items: { title: "items", anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: !0 }, maxItems: { $ref: "#/definitions/nonNegativeInteger" }, minItems: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, uniqueItems: { title: "uniqueItems", type: "boolean", default: !1 }, contains: { $ref: "#" }, maxProperties: { $ref: "#/definitions/nonNegativeInteger" }, minProperties: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { $ref: "#" }, definitions: { title: "definitions", type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { title: "properties", type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { title: "patternProperties", type: "object", additionalProperties: { $ref: "#" }, propertyNames: { title: "propertyNames", format: "regex" }, default: {} }, dependencies: { title: "dependencies", type: "object", additionalProperties: { title: "dependenciesSet", anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, propertyNames: { $ref: "#" }, const: !0, enum: { title: "enum", type: "array", items: !0, minItems: 1, uniqueItems: !0 }, type: { title: "type", anyOf: [{ $ref: "#/definitions/simpleTypes" }, { title: "arrayOfSimpleTypes", type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: !0 }] }, format: { title: "format", type: "string" }, contentMediaType: { title: "contentMediaType", type: "string" }, contentEncoding: { title: "contentEncoding", type: "string" }, if: { $ref: "#" }, then: { $ref: "#" }, else: { $ref: "#" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } } }, schemaArray: { title: "schemaArray", type: "array", minItems: 1, items: { $ref: "#" } }, nonNegativeInteger: { title: "nonNegativeInteger", type: "integer", minimum: 0 }, nonNegativeIntegerDefault0: { title: "nonNegativeIntegerDefaultZero", type: "integer", minimum: 0, default: 0 }, simpleTypes: { title: "simpleTypes", type: "string", enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { title: "stringArray", type: "array", items: { type: "string" }, uniqueItems: !0, default: [] } } }, e.default = e.jsonSchema;
  }(Us)), Us;
}
var gn = {}, Zf;
function om() {
  if (Zf) return gn;
  Zf = 1;
  var e = gn && gn.__assign || function() {
    return e = Object.assign || function(n) {
      for (var a, r = 1, o = arguments.length; r < o; r++) {
        a = arguments[r];
        for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (n[s] = a[s]);
      }
      return n;
    }, e.apply(this, arguments);
  };
  Object.defineProperty(gn, "__esModule", { value: !0 });
  function t(n, a) {
    var r = a;
    return n["x-extensions"] && n["x-extensions"].forEach(function(o) {
      var s = o.name, i = o.schema, u = o.summary, f = o.description, p = o.restricted;
      p.forEach(function(c) {
        var l = r.definitions[c];
        if (!l)
          throw new Error("".concat(c, " does not exist, cannot apply extension ").concat(s));
        if (l.properties[s])
          throw new Error("".concat(s, " already exists in ").concat(c, ", cannot apply extension ").concat(s));
        l.properties[s] = e({ title: s, description: f, summary: u }, i);
      });
    }), r;
  }
  return gn.default = t, gn;
}
var Or = {}, mr = {};
const mw = "https://meta.json-schema.tools/", vw = "OpenRPC Specification Extension", gw = "A standard way to define OpenRPC Specification Extensions. This makes it easier to provide support for Specification Extensions in other tools.", yw = "object", bw = ["name", "schema", "openrpcExtension", "version"], ww = { openrpcExtension: { title: "openrpcExtensionVersion", description: "**REQUIRED**. This string MUST be the semantic version number of the Specification that the document uses.", type: "string", enum: ["0.0.0-development"] }, name: { title: "specificationExtensionName", description: "**REQUIRED** Name of the Specification Extension. MUST start with `x-`", type: "string", pattern: "^x-", examples: ["x-foobarbaz"] }, version: { title: "specificationExtensionVersion", description: "**REQUIRED**. The version of the Extension (which is distinct from the `openrpcExtension` version and implementation version).", type: "string", examples: ["0.0.1"] }, required: { title: "specificationExtensionRequired", type: "boolean", description: "wether or not this specification extension is required or not" }, restricted: { title: "restrictedObjects", description: "A list of object names to restrict the usage of the specification extension to.", type: "array", items: { title: "restrictedObject", description: "restricted object", type: "string" } }, description: { title: "specificationExtensionDescription", type: "string", description: "Markdown description describing the specification extension." }, summary: { title: "specificationExtensionSummary", type: "string", description: "A short summary of what the specification extension is." }, schema: { $ref: "https://meta.json-schema.tools" }, externalDocumentation: { title: "specificationExtensionExternalDocumentationObject", type: "object", additionalProperties: !1, description: "Information about specification extension external documentation.", required: ["url"], properties: { description: { title: "specificationExtensionexternalDocumentationObjectDescription", description: "external documentation description.", type: "string" }, url: { title: "specificationExtensionexternalDocumentationObjectUrl", description: "external documentation description.", type: "string", format: "uri" } } } }, Sw = {
  $schema: mw,
  title: vw,
  description: gw,
  type: yw,
  required: bw,
  properties: ww
}, Pw = "0.0.0-development", xw = "x-error-group", Ew = "0.0.1", _w = "Describe error groups for OpenRPC methods", Cw = "OpenRPC Error Groups", Rw = { description: "github", url: "https://github.com/open-rpc/specification-extensions-spec/examples/x-error-group-openrpc-ext.json" }, Ow = ["methodObject"], $w = { type: "array", items: { type: "array", items: { type: "object", properties: { code: { type: "string", description: "The error code" }, message: { type: "string", description: "The error message" }, data: { type: "object", description: "The error data" } }, required: ["code", "message"] } } }, Tw = {
  openrpcExtension: Pw,
  name: xw,
  version: Ew,
  description: _w,
  summary: Cw,
  externalDocumentation: Rw,
  restricted: Ow,
  schema: $w
}, jw = "../meta-schema.json", Dw = "0.0.0-development", kw = "x-notification", Aw = "0.0.1", Mw = "Describe a notification for OpenRPC methods", Iw = "OpenRPC Notification", Nw = { description: "github", url: "https://github.com/open-rpc/specification-extensions-spec/examples/x-notification-openrpc-ext.json" }, Lw = ["methodObject"], qw = { type: "boolean", description: "wether or not this method is a notification or not" }, Fw = {
  $schema: jw,
  openrpcExtension: Dw,
  name: kw,
  version: Aw,
  description: Mw,
  summary: Iw,
  externalDocumentation: Nw,
  restricted: Lw,
  schema: qw
}, zw = "../meta-schema.json", Bw = "0.0.0-development", Uw = "x-transport", Hw = "0.0.1", Vw = "Describe a transport for OpenRPC", Ww = "OpenRPC Transports", Gw = { description: "github", url: "https://github.com/open-rpc/specification-extensions-spec/examples/x-transport-openrpc-ext.json" }, Kw = !0, Jw = ["serverObject"], Qw = { oneOf: [{ type: "object", title: "HTTP Transport", description: "HTTP Transport", required: ["name"], properties: { name: { type: "string", const: "HTTPTransport" }, options: { type: "object", properties: { headers: { patternProperties: { "": { type: "string" } } }, credentials: { type: "string", enum: ["omit", "same-origin", "include"] } } } }, examples: [{ "x-transport": { name: "HTTPTransport", options: { headers: { Bearer: "string" } } } }] }, { type: "object", title: "PostMessageWindow Transport", description: "Post Message Window Transport", required: ["name"], properties: { name: { type: "string", const: "PostMessageWindow" }, options: { type: "object", properties: { top: { type: "integer", title: "top", description: "top" }, left: { type: "integer", title: "left", description: "left" }, height: { type: "integer", title: "height", description: "height" }, width: { type: "integer", title: "width", description: "width" } } } } }] }, Yw = {
  $schema: zw,
  openrpcExtension: Bw,
  name: Uw,
  version: Hw,
  description: Vw,
  summary: Ww,
  externalDocumentation: Gw,
  required: Kw,
  restricted: Jw,
  schema: Qw
};
var ed;
function Xw() {
  if (ed) return mr;
  ed = 1;
  var e = mr && mr.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(mr, "__esModule", { value: !0 }), mr.examples = mr.metaSchema = void 0;
  const t = e(Sw);
  mr.metaSchema = t.default;
  const n = e(Tw), a = e(Fw), r = e(Yw), o = {
    errorGroups: n.default,
    notification: a.default,
    transport: r.default
  };
  return mr.examples = o, mr;
}
var td;
function cu() {
  if (td) return Or;
  td = 1;
  var e = Or && Or.__assign || function() {
    return e = Object.assign || function(o) {
      for (var s, i = 1, u = arguments.length; i < u; i++) {
        s = arguments[i];
        for (var f in s) Object.prototype.hasOwnProperty.call(s, f) && (o[f] = s[f]);
      }
      return o;
    }, e.apply(this, arguments);
  }, t = Or && Or.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(Or, "__esModule", { value: !0 });
  var n = t(Zh()), a = Xw();
  function r() {
    var o = JSON.parse(JSON.stringify(n.default)), s = e({}, a.metaSchema);
    return delete s.$schema, delete s.$id, delete o.definitions.JSONSchema.$id, delete o.definitions.JSONSchema.$schema, delete o.$schema, delete o.$id, o.properties["x-extensions"] = {
      $ref: "#/definitions/x-extensions"
    }, o.definitions["x-extensions"] = {
      type: "array",
      items: s
    }, o;
  }
  return Or.default = r, Or;
}
var rd;
function im() {
  if (rd) return Rr;
  rd = 1;
  var e = Rr && Rr.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Rr, "__esModule", { value: !0 }), Rr.OpenRPCDocumentValidationError = void 0;
  var t = e(am()), n = e(hw()), a = e(om()), r = e(cu()), o = (
    /** @class */
    /* @__PURE__ */ function() {
      function i(u) {
        this.name = "OpenRPCDocumentDereferencingError", this.message = [
          "Error validating OpenRPC Document against @open-rpc/meta-schema.",
          "The errors found are as follows:",
          JSON.stringify(u, void 0, "  ")
        ].join(`
`);
      }
      return i;
    }()
  );
  Rr.OpenRPCDocumentValidationError = o;
  function s(i) {
    var u = new t.default();
    u.addSchema(n.default, "https://meta.json-schema.tools");
    var f = (0, r.default)();
    try {
      f = (0, a.default)(i, f), u.validate(f, i);
    } catch (p) {
      throw new Error([
        "schema-utils-js: Internal Error",
        "-----",
        p,
        "-----",
        "If you see this report it: https://github.com/open-rpc/schema-utils-js/issues"
      ].join(`
`));
    }
    return u.errors ? new o(u.errors) : !0;
  }
  return Rr.default = s, Rr;
}
var Hs, nd;
function Zw() {
  if (nd) return Hs;
  nd = 1, Hs = a;
  var e = /^(?:\w+:)?\/\/(\S+)$/, t = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/, n = /^[^\s\.]+\.\S{2,}$/;
  function a(r) {
    if (typeof r != "string")
      return !1;
    var o = r.match(e);
    if (!o)
      return !1;
    var s = o[1];
    return s ? !!(t.test(s) || n.test(s)) : !1;
  }
  return Hs;
}
var ad;
function eS() {
  if (ad) return Ye;
  ad = 1;
  var e = Ye && Ye.__assign || function() {
    return e = Object.assign || function(g) {
      for (var b, E = 1, S = arguments.length; E < S; E++) {
        b = arguments[E];
        for (var w in b) Object.prototype.hasOwnProperty.call(b, w) && (g[w] = b[w]);
      }
      return g;
    }, e.apply(this, arguments);
  }, t = Ye && Ye.__createBinding || (Object.create ? function(g, b, E, S) {
    S === void 0 && (S = E);
    var w = Object.getOwnPropertyDescriptor(b, E);
    (!w || ("get" in w ? !b.__esModule : w.writable || w.configurable)) && (w = { enumerable: !0, get: function() {
      return b[E];
    } }), Object.defineProperty(g, S, w);
  } : function(g, b, E, S) {
    S === void 0 && (S = E), g[S] = b[E];
  }), n = Ye && Ye.__setModuleDefault || (Object.create ? function(g, b) {
    Object.defineProperty(g, "default", { enumerable: !0, value: b });
  } : function(g, b) {
    g.default = b;
  }), a = Ye && Ye.__importStar || function(g) {
    if (g && g.__esModule) return g;
    var b = {};
    if (g != null) for (var E in g) E !== "default" && Object.prototype.hasOwnProperty.call(g, E) && t(b, g, E);
    return n(b, g), b;
  }, r = Ye && Ye.__awaiter || function(g, b, E, S) {
    function w(y) {
      return y instanceof E ? y : new E(function(x) {
        x(y);
      });
    }
    return new (E || (E = Promise))(function(y, x) {
      function P(m) {
        try {
          R(S.next(m));
        } catch (_) {
          x(_);
        }
      }
      function C(m) {
        try {
          R(S.throw(m));
        } catch (_) {
          x(_);
        }
      }
      function R(m) {
        m.done ? y(m.value) : w(m.value).then(P, C);
      }
      R((S = S.apply(g, b || [])).next());
    });
  }, o = Ye && Ye.__generator || function(g, b) {
    var E = { label: 0, sent: function() {
      if (y[0] & 1) throw y[1];
      return y[1];
    }, trys: [], ops: [] }, S, w, y, x;
    return x = { next: P(0), throw: P(1), return: P(2) }, typeof Symbol == "function" && (x[Symbol.iterator] = function() {
      return this;
    }), x;
    function P(R) {
      return function(m) {
        return C([R, m]);
      };
    }
    function C(R) {
      if (S) throw new TypeError("Generator is already executing.");
      for (; x && (x = 0, R[0] && (E = 0)), E; ) try {
        if (S = 1, w && (y = R[0] & 2 ? w.return : R[0] ? w.throw || ((y = w.return) && y.call(w), 0) : w.next) && !(y = y.call(w, R[1])).done) return y;
        switch (w = 0, y && (R = [R[0] & 2, y.value]), R[0]) {
          case 0:
          case 1:
            y = R;
            break;
          case 4:
            return E.label++, { value: R[1], done: !1 };
          case 5:
            E.label++, w = R[1], R = [0];
            continue;
          case 7:
            R = E.ops.pop(), E.trys.pop();
            continue;
          default:
            if (y = E.trys, !(y = y.length > 0 && y[y.length - 1]) && (R[0] === 6 || R[0] === 2)) {
              E = 0;
              continue;
            }
            if (R[0] === 3 && (!y || R[1] > y[0] && R[1] < y[3])) {
              E.label = R[1];
              break;
            }
            if (R[0] === 6 && E.label < y[1]) {
              E.label = y[1], y = R;
              break;
            }
            if (y && E.label < y[2]) {
              E.label = y[2], E.ops.push(R);
              break;
            }
            y[2] && E.ops.pop(), E.trys.pop();
            continue;
        }
        R = b.call(g, E);
      } catch (m) {
        R = [6, m], w = 0;
      } finally {
        S = y = 0;
      }
      if (R[0] & 5) throw R[1];
      return { value: R[0] ? R[1] : void 0, done: !0 };
    }
  }, s = Ye && Ye.__importDefault || function(g) {
    return g && g.__esModule ? g : { default: g };
  };
  Object.defineProperty(Ye, "__esModule", { value: !0 }), Ye.makeCustomResolver = void 0;
  var i = s(w1()), u = a(im()), f = s(iu()), p = Zw(), c = s(Yh()), l = function(g) {
    try {
      return JSON.parse(g), !0;
    } catch {
      return !1;
    }
  }, v = {
    dereference: !0,
    validate: !0
  }, d = function(g, b) {
    return function(S, w) {
      return S === void 0 && (S = "./openrpc.json"), w === void 0 && (w = v), r(this, void 0, void 0, function() {
        var y, x, C, P, C;
        return o(this, function(R) {
          switch (R.label) {
            case 0:
              return x = e(e({}, v), w), typeof S == "string" ? [3, 1] : (y = S, [3, 6]);
            case 1:
              return l(S) ? (y = JSON.parse(S), [3, 6]) : [3, 2];
            case 2:
              return p(S) ? [4, g(S)] : [3, 4];
            case 3:
              return y = R.sent(), [3, 6];
            case 4:
              return [4, b(S)];
            case 5:
              y = R.sent(), R.label = 6;
            case 6:
              if (x.validate && (C = (0, u.default)(y), C instanceof u.OpenRPCDocumentValidationError))
                throw C;
              return P = y, x.dereference ? x.resolver === void 0 ? [3, 8] : [4, (0, i.default)(y, x.resolver)] : [3, 10];
            case 7:
              return P = R.sent(), [3, 10];
            case 8:
              return [4, (0, i.default)(y, f.default)];
            case 9:
              P = R.sent(), R.label = 10;
            case 10:
              if (x.validate && (C = (0, u.default)(P), C instanceof u.OpenRPCDocumentValidationError))
                throw C;
              return [2, P];
          }
        });
      });
    };
  };
  function h(g) {
    return new c.default(g);
  }
  return Ye.makeCustomResolver = h, Ye.default = d, Ye;
}
var vr = {}, Vs = {}, od;
function sm() {
  return od || (od = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.rpcDocIsEqual = e.find = e.compact = e.findIndex = void 0;
    var t = function(o, s) {
      var i = o == null ? 0 : o.length;
      if (!i)
        return -1;
      for (var u = -1; ++u < i; )
        if (s(o[u]))
          return u;
      return -1;
    };
    e.findIndex = t;
    var n = function(o) {
      for (var s = 0, i = [], u = 0, f = o; u < f.length; u++) {
        var p = f[u];
        p && (i[s++] = p);
      }
      return i;
    };
    e.compact = n;
    var a = function(o, s) {
      var i = o == null ? 0 : o.length;
      if (i) {
        for (var u = -1; ++u < i; )
          if (s(o[u]))
            return o[u];
      }
    };
    e.find = a;
    var r = function(o, s) {
      var i = Object.keys(o), u = Object.keys(s), f = i.length, p = u.length;
      if (f != p)
        return !1;
      for (var c, l = f; l--; )
        if (c = i[l], c in s) {
          if (typeof o[c] == "object" && typeof s[c] == "object") {
            if (!(0, e.rpcDocIsEqual)(o[c], s[c]))
              return !1;
          } else if (o[c] != s[c])
            return !1;
        } else return !1;
      return !0;
    };
    e.rpcDocIsEqual = r;
  }(Vs)), Vs;
}
var id;
function lm() {
  if (id) return vr;
  id = 1, Object.defineProperty(vr, "__esModule", { value: !0 }), vr.generateMethodResultId = vr.generateMethodParamId = vr.ContentDescriptorNotFoundInMethodError = void 0;
  var e = sm(), t = (
    /** @class */
    /* @__PURE__ */ function() {
      function r(o, s) {
        this.method = o, this.contentDescriptor = s, this.name = "OpenRPCDocumentDereferencingError", this.message = [
          "Content Descriptor not found in method.",
          "Method: ".concat(JSON.stringify(o, void 0, "  ")),
          "ContentDescriptor: ".concat(JSON.stringify(s, void 0, "  "))
        ].join(`
`);
      }
      return r;
    }()
  );
  vr.ContentDescriptorNotFoundInMethodError = t;
  function n(r, o) {
    var s = (0, e.findIndex)(r.params, function(f) {
      return f.name == o.name;
    });
    if (s === -1)
      throw new t(r, o);
    var i;
    if (r.paramStructure === "by-position")
      i = s.toString();
    else if (r.paramStructure === "by-name") {
      var u = r.params[s];
      i = u.name;
    } else {
      var u = r.params[s];
      i = "".concat(u.name, "/").concat(s.toString());
    }
    return "".concat(r.name, "/").concat(i);
  }
  vr.generateMethodParamId = n;
  function a(r, o) {
    var s = r.result;
    if (s.name !== o.name)
      throw new t(r, o);
    return "".concat(r.name, "/result");
  }
  return vr.generateMethodResultId = a, vr;
}
var Ut = {}, yn = {}, mo = {}, sd;
function um() {
  if (sd) return mo;
  sd = 1, Object.defineProperty(mo, "__esModule", { value: !0 });
  var e = (
    /** @class */
    /* @__PURE__ */ function() {
      function t(n, a, r, o) {
        this.paramIndex = n, this.expectedSchema = a, this.receievedParam = r, this.name = "ParameterValidationError", this.message = [
          "Expected param at ".concat(typeof n == "string" ? "key" : "position", ": "),
          n,
          " to match the json schema: ",
          JSON.stringify(a, void 0, "  "),
          ". The function received instead ",
          r,
          ".",
          `The Validation errors: 
`,
          JSON.stringify(o)
        ].join("");
      }
      return t;
    }()
  );
  return mo.default = e, mo;
}
var vo = {}, ld;
function cm() {
  if (ld) return vo;
  ld = 1, Object.defineProperty(vo, "__esModule", { value: !0 });
  var e = (
    /** @class */
    /* @__PURE__ */ function() {
      function t(n, a, r) {
        r === void 0 && (r = []), this.methodName = n, this.openrpcDocument = a, this.receievedParams = r, this.name = "MethodNotFoundError";
        var o = [
          'Method Not Found Error for OpenRPC API named "'.concat(a.info.title, '"'),
          'The requested method: "'.concat(n, '" not a valid method.')
        ];
        a.methods.length > 0 && o.push("Valid method names are as follows: ".concat(a.methods.map(function(i) {
          var u = i.name;
          return u;
        }).join(", ")));
        var s;
        r instanceof Array ? r.length > 0 && (s = r.map(function(i) {
          try {
            return JSON.stringify(i);
          } catch {
            return i;
          }
        }).join(`
`)) : s = JSON.stringify(r), s && (o.push("Params:"), o.push(s)), this.message = o.join(`
`);
      }
      return t;
    }()
  );
  return vo.default = e, vo;
}
var go = {}, ud;
function tS() {
  if (ud) return go;
  ud = 1, Object.defineProperty(go, "__esModule", { value: !0 });
  var e = (
    /** @class */
    /* @__PURE__ */ function() {
      function t(n, a) {
        this.methodRef = n, this.openrpcDocument = a, this.name = "MethodRefUnexpectedError";
        var r = [
          'Method Ref Unexpected Error for OpenRPC API named "'.concat(a.info.title, '"'),
          'The requested ref has not been resolved: "'.concat(n, '" not a valid dereferenced method.')
        ];
        this.message = r.join(`
`);
      }
      return t;
    }()
  );
  return go.default = e, go;
}
var cd;
function rS() {
  if (cd) return yn;
  cd = 1;
  var e = yn && yn.__importDefault || function(u) {
    return u && u.__esModule ? u : { default: u };
  };
  Object.defineProperty(yn, "__esModule", { value: !0 });
  var t = e(am()), n = lm(), a = e(um()), r = e(cm()), o = sm(), s = e(tS()), i = (
    /** @class */
    function() {
      function u(f) {
        var p = this;
        this.document = f, this.ajvValidator = new t.default(), f.methods.forEach(function(c) {
          if (c.$ref)
            throw new s.default(c.$ref, f);
        }), f.methods.forEach(function(c) {
          var l = c.params;
          l.forEach(function(v) {
            v.schema !== void 0 && p.ajvValidator.addSchema(v.schema, (0, n.generateMethodParamId)(c, v));
          });
        });
      }
      return u.prototype.validate = function(f, p) {
        var c = this;
        if (f === "rpc.discover")
          return [];
        var l = (0, o.find)(this.document.methods, function(d) {
          return d.name == f;
        });
        if (!l)
          return new r.default(f, this.document, p);
        var v = l.params;
        return (0, o.compact)(v.map(function(d, h) {
          var g;
          l.paramStructure === "by-position" ? g = h : l.paramStructure === "by-name" ? g = d.name : p[h] !== void 0 ? g = h : g = d.name;
          var b = p[g];
          if (!(b === void 0 && !d.required) && d.schema !== void 0) {
            var E = (0, n.generateMethodParamId)(l, d), S = c.ajvValidator.validate(E, b), w = c.ajvValidator.errors;
            if (!S)
              return new a.default(g, d.schema, b, w);
          }
        }));
      }, u;
    }()
  );
  return yn.default = i, yn;
}
var fd;
function nS() {
  if (fd) return Ut;
  fd = 1;
  var e = Ut && Ut.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(Ut, "__esModule", { value: !0 }), Ut.MethodNotFoundError = Ut.ParameterValidationError = Ut.MethodCallValidator = void 0;
  var t = e(rS());
  Ut.MethodCallValidator = t.default;
  var n = e(um());
  Ut.ParameterValidationError = n.default;
  var a = e(cm());
  return Ut.MethodNotFoundError = a.default, Ut;
}
var Xt = {}, dd;
function aS() {
  if (dd) return Xt;
  dd = 1;
  var e = Xt && Xt.__awaiter || function(o, s, i, u) {
    function f(p) {
      return p instanceof i ? p : new i(function(c) {
        c(p);
      });
    }
    return new (i || (i = Promise))(function(p, c) {
      function l(h) {
        try {
          d(u.next(h));
        } catch (g) {
          c(g);
        }
      }
      function v(h) {
        try {
          d(u.throw(h));
        } catch (g) {
          c(g);
        }
      }
      function d(h) {
        h.done ? p(h.value) : f(h.value).then(l, v);
      }
      d((u = u.apply(o, s || [])).next());
    });
  }, t = Xt && Xt.__generator || function(o, s) {
    var i = { label: 0, sent: function() {
      if (p[0] & 1) throw p[1];
      return p[1];
    }, trys: [], ops: [] }, u, f, p, c;
    return c = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
      return this;
    }), c;
    function l(d) {
      return function(h) {
        return v([d, h]);
      };
    }
    function v(d) {
      if (u) throw new TypeError("Generator is already executing.");
      for (; c && (c = 0, d[0] && (i = 0)), i; ) try {
        if (u = 1, f && (p = d[0] & 2 ? f.return : d[0] ? f.throw || ((p = f.return) && p.call(f), 0) : f.next) && !(p = p.call(f, d[1])).done) return p;
        switch (f = 0, p && (d = [d[0] & 2, p.value]), d[0]) {
          case 0:
          case 1:
            p = d;
            break;
          case 4:
            return i.label++, { value: d[1], done: !1 };
          case 5:
            i.label++, f = d[1], d = [0];
            continue;
          case 7:
            d = i.ops.pop(), i.trys.pop();
            continue;
          default:
            if (p = i.trys, !(p = p.length > 0 && p[p.length - 1]) && (d[0] === 6 || d[0] === 2)) {
              i = 0;
              continue;
            }
            if (d[0] === 3 && (!p || d[1] > p[0] && d[1] < p[3])) {
              i.label = d[1];
              break;
            }
            if (d[0] === 6 && i.label < p[1]) {
              i.label = p[1], p = d;
              break;
            }
            if (p && i.label < p[2]) {
              i.label = p[2], i.ops.push(d);
              break;
            }
            p[2] && i.ops.pop(), i.trys.pop();
            continue;
        }
        d = s.call(o, i);
      } catch (h) {
        d = [6, h], f = 0;
      } finally {
        u = p = 0;
      }
      if (d[0] & 5) throw d[1];
      return { value: d[0] ? d[1] : void 0, done: !0 };
    }
  }, n = Xt && Xt.__importDefault || function(o) {
    return o && o.__esModule ? o : { default: o };
  };
  Object.defineProperty(Xt, "__esModule", { value: !0 });
  var a = n(ou()), r = function(o) {
    return e(void 0, void 0, void 0, function() {
      var s;
      return t(this, function(i) {
        switch (i.label) {
          case 0:
            return i.trys.push([0, 3, , 4]), [4, (0, a.default)(o)];
          case 1:
            return s = i.sent(), [4, s.json()];
          case 2:
            return [2, i.sent()];
          case 3:
            throw i.sent(), new Error("Unable to download openrpc.json file located at the url: ".concat(o));
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
  return Xt.default = r, Xt;
}
var bn = {}, pd;
function oS() {
  if (pd) return bn;
  pd = 1;
  var e = bn && bn.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(bn, "__esModule", { value: !0 });
  var t = e(om()), n = e(cu());
  function a(r) {
    var o = (0, n.default)(), s = (0, t.default)(r, o);
    return s;
  }
  return bn.default = a, bn;
}
var hd;
function iS() {
  return hd || (hd = 1, function(e) {
    var t = zt && zt.__createBinding || (Object.create ? function(d, h, g, b) {
      b === void 0 && (b = g);
      var E = Object.getOwnPropertyDescriptor(h, g);
      (!E || ("get" in E ? !h.__esModule : E.writable || E.configurable)) && (E = { enumerable: !0, get: function() {
        return h[g];
      } }), Object.defineProperty(d, b, E);
    } : function(d, h, g, b) {
      b === void 0 && (b = g), d[b] = h[g];
    }), n = zt && zt.__setModuleDefault || (Object.create ? function(d, h) {
      Object.defineProperty(d, "default", { enumerable: !0, value: h });
    } : function(d, h) {
      d.default = h;
    }), a = zt && zt.__importStar || function(d) {
      if (d && d.__esModule) return d;
      var h = {};
      if (d != null) for (var g in d) g !== "default" && Object.prototype.hasOwnProperty.call(d, g) && t(h, d, g);
      return n(h, d), h;
    }, r = zt && zt.__importDefault || function(d) {
      return d && d.__esModule ? d : { default: d };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.ContentDescriptorNotFoundInMethodError = e.OpenRPCDocumentValidationError = e.ParameterValidationError = e.MethodCallValidator = e.MethodNotFoundError = e.getExtendedMetaSchema = e.getDocumentExtendedMetaSchema = e.validateOpenRPCDocument = e.generateMethodResultId = e.generateMethodParamId = e.parseOpenRPCDocument = void 0;
    var o = r(eS()), s = a(im());
    e.validateOpenRPCDocument = s.default, Object.defineProperty(e, "OpenRPCDocumentValidationError", { enumerable: !0, get: function() {
      return s.OpenRPCDocumentValidationError;
    } });
    var i = lm();
    Object.defineProperty(e, "generateMethodParamId", { enumerable: !0, get: function() {
      return i.generateMethodParamId;
    } }), Object.defineProperty(e, "generateMethodResultId", { enumerable: !0, get: function() {
      return i.generateMethodResultId;
    } }), Object.defineProperty(e, "ContentDescriptorNotFoundInMethodError", { enumerable: !0, get: function() {
      return i.ContentDescriptorNotFoundInMethodError;
    } });
    var u = nS();
    Object.defineProperty(e, "MethodCallValidator", { enumerable: !0, get: function() {
      return u.MethodCallValidator;
    } }), Object.defineProperty(e, "ParameterValidationError", { enumerable: !0, get: function() {
      return u.ParameterValidationError;
    } }), Object.defineProperty(e, "MethodNotFoundError", { enumerable: !0, get: function() {
      return u.MethodNotFoundError;
    } });
    var f = r(aS()), p = r(oS());
    e.getDocumentExtendedMetaSchema = p.default;
    var c = r(cu());
    e.getExtendedMetaSchema = c.default;
    var l = function(d) {
      return Promise.reject("Not Implemented, passed: ".concat(d));
    }, v = (0, o.default)(f.default, l);
    e.parseOpenRPCDocument = v;
  }(zt)), zt;
}
var sS = iS();
const lS = ({
  selectedTransport: e,
  transports: t,
  onChange: n,
  style: a,
  onAddTransport: r
}) => {
  const o = (P) => {
    u(P.currentTarget);
  }, s = () => {
    u(null);
  }, [i, u] = ke(null), [f, p] = ke(!1), [c, l] = ke(), [v, d] = ke(), [h, g] = ke(), [b, E] = ke(null), S = () => {
    E(null);
  }, w = (P) => {
    E(P.currentTarget);
  }, y = (P) => {
    E(null), l(P);
  }, x = () => {
    E(null), c && v && h && (r({
      type: "plugin",
      transport: c,
      name: v,
      uri: h
    }), p(!1));
  };
  return /* @__PURE__ */ V.jsxs("div", { style: a, children: [
    /* @__PURE__ */ V.jsx(
      Lp,
      {
        onClose: () => p(!1),
        "aria-labelledby": "simple-dialog-title",
        open: f,
        children: /* @__PURE__ */ V.jsx(sl, { maxWidth: "sm", children: /* @__PURE__ */ V.jsxs(
          Ar,
          {
            container: !0,
            justifyContent: "space-between",
            alignItems: "center",
            style: {
              padding: "30px",
              paddingTop: "10px",
              paddingBottom: "10px",
              marginTop: "10px"
            },
            children: [
              /* @__PURE__ */ V.jsx(gt, { variant: "h6", children: "Custom Transport Plugin" }),
              /* @__PURE__ */ V.jsx(gt, { variant: "caption", gutterBottom: !0, children: 'Transport plugins are created by implementing the "connect", "sendData", and "close" methods over JSON-RPC.' }),
              /* @__PURE__ */ V.jsxs(Ar, { container: !0, direction: "column", spacing: 1, children: [
                /* @__PURE__ */ V.jsx(Ar, { children: /* @__PURE__ */ V.jsx(
                  No,
                  {
                    placeholder: "Plugin Name",
                    onChange: (P) => {
                      d(P.target.value);
                    },
                    style: {
                      display: "block",
                      background: "rgba(0,0,0,0.1)",
                      borderRadius: "4px",
                      padding: "0px 10px",
                      marginRight: "5px"
                    }
                  }
                ) }),
                /* @__PURE__ */ V.jsx(Ar, { children: /* @__PURE__ */ V.jsx(
                  No,
                  {
                    placeholder: "Plugin URI",
                    onChange: (P) => {
                      g(P.target.value);
                    },
                    style: {
                      display: "block",
                      background: "rgba(0,0,0,0.1)",
                      borderRadius: "4px",
                      padding: "0px 10px",
                      marginRight: "5px"
                    }
                  }
                ) }),
                /* @__PURE__ */ V.jsx(Ar, { children: /* @__PURE__ */ V.jsx(Oa, { variant: "outlined", onClick: w, children: c ? c.name : "Select A Transport" }) })
              ] }),
              /* @__PURE__ */ V.jsx(
                Hu,
                {
                  id: "transport-menu",
                  anchorEl: b,
                  keepMounted: !0,
                  open: !!b,
                  onClose: S,
                  children: t.filter((P) => P && P.type !== "plugin").map((P) => /* @__PURE__ */ V.jsx(
                    Li,
                    {
                      onClick: () => y(P),
                      children: P.name
                    },
                    P.name
                  ))
                }
              ),
              /* @__PURE__ */ V.jsx(
                Oa,
                {
                  style: { marginTop: "10px", marginBottom: "10px" },
                  onClick: x,
                  disabled: !v || !h || !c,
                  variant: "contained",
                  children: "Add Transport"
                }
              )
            ]
          }
        ) })
      }
    ),
    /* @__PURE__ */ V.jsx(
      Oa,
      {
        style: {
          marginRight: "10px",
          marginLeft: "5px"
        },
        variant: "outlined",
        onClick: o,
        endIcon: /* @__PURE__ */ V.jsx("div", {}),
        children: e && e.name
      }
    ),
    /* @__PURE__ */ V.jsxs(
      Hu,
      {
        id: "inspector-transport-menu",
        anchorEl: i,
        keepMounted: !0,
        open: !!i,
        onClose: s,
        children: [
          t?.filter((P) => P).map((P, C) => /* @__PURE__ */ V.jsx(Li, { onClick: () => n(P), children: P.name }, `transport-sub-${C}`)),
          /* @__PURE__ */ V.jsxs(Li, { onClick: () => p(!0), children: [
            /* @__PURE__ */ V.jsx(Wh, { style: { marginRight: "5px" } }, "add-transport-menu-item-icon"),
            /* @__PURE__ */ V.jsx(gt, { variant: "caption", children: "Add Transport" })
          ] }, "add-transport-menu-item")
        ]
      }
    )
  ] });
};
var ua = {}, Gr = {}, yo = { exports: {} }, md;
function fm() {
  if (md) return yo.exports;
  md = 1;
  var e = typeof Reflect == "object" ? Reflect : null, t = e && typeof e.apply == "function" ? e.apply : function(y, x, P) {
    return Function.prototype.apply.call(y, x, P);
  }, n;
  e && typeof e.ownKeys == "function" ? n = e.ownKeys : Object.getOwnPropertySymbols ? n = function(y) {
    return Object.getOwnPropertyNames(y).concat(Object.getOwnPropertySymbols(y));
  } : n = function(y) {
    return Object.getOwnPropertyNames(y);
  };
  function a(w) {
    console && console.warn && console.warn(w);
  }
  var r = Number.isNaN || function(y) {
    return y !== y;
  };
  function o() {
    o.init.call(this);
  }
  yo.exports = o, yo.exports.once = b, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function i(w) {
    if (typeof w != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof w);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(w) {
      if (typeof w != "number" || w < 0 || r(w))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + w + ".");
      s = w;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(y) {
    if (typeof y != "number" || y < 0 || r(y))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + y + ".");
    return this._maxListeners = y, this;
  };
  function u(w) {
    return w._maxListeners === void 0 ? o.defaultMaxListeners : w._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return u(this);
  }, o.prototype.emit = function(y) {
    for (var x = [], P = 1; P < arguments.length; P++) x.push(arguments[P]);
    var C = y === "error", R = this._events;
    if (R !== void 0)
      C = C && R.error === void 0;
    else if (!C)
      return !1;
    if (C) {
      var m;
      if (x.length > 0 && (m = x[0]), m instanceof Error)
        throw m;
      var _ = new Error("Unhandled error." + (m ? " (" + m.message + ")" : ""));
      throw _.context = m, _;
    }
    var O = R[y];
    if (O === void 0)
      return !1;
    if (typeof O == "function")
      t(O, this, x);
    else
      for (var T = O.length, A = d(O, T), P = 0; P < T; ++P)
        t(A[P], this, x);
    return !0;
  };
  function f(w, y, x, P) {
    var C, R, m;
    if (i(x), R = w._events, R === void 0 ? (R = w._events = /* @__PURE__ */ Object.create(null), w._eventsCount = 0) : (R.newListener !== void 0 && (w.emit(
      "newListener",
      y,
      x.listener ? x.listener : x
    ), R = w._events), m = R[y]), m === void 0)
      m = R[y] = x, ++w._eventsCount;
    else if (typeof m == "function" ? m = R[y] = P ? [x, m] : [m, x] : P ? m.unshift(x) : m.push(x), C = u(w), C > 0 && m.length > C && !m.warned) {
      m.warned = !0;
      var _ = new Error("Possible EventEmitter memory leak detected. " + m.length + " " + String(y) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      _.name = "MaxListenersExceededWarning", _.emitter = w, _.type = y, _.count = m.length, a(_);
    }
    return w;
  }
  o.prototype.addListener = function(y, x) {
    return f(this, y, x, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(y, x) {
    return f(this, y, x, !0);
  };
  function p() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function c(w, y, x) {
    var P = { fired: !1, wrapFn: void 0, target: w, type: y, listener: x }, C = p.bind(P);
    return C.listener = x, P.wrapFn = C, C;
  }
  o.prototype.once = function(y, x) {
    return i(x), this.on(y, c(this, y, x)), this;
  }, o.prototype.prependOnceListener = function(y, x) {
    return i(x), this.prependListener(y, c(this, y, x)), this;
  }, o.prototype.removeListener = function(y, x) {
    var P, C, R, m, _;
    if (i(x), C = this._events, C === void 0)
      return this;
    if (P = C[y], P === void 0)
      return this;
    if (P === x || P.listener === x)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete C[y], C.removeListener && this.emit("removeListener", y, P.listener || x));
    else if (typeof P != "function") {
      for (R = -1, m = P.length - 1; m >= 0; m--)
        if (P[m] === x || P[m].listener === x) {
          _ = P[m].listener, R = m;
          break;
        }
      if (R < 0)
        return this;
      R === 0 ? P.shift() : h(P, R), P.length === 1 && (C[y] = P[0]), C.removeListener !== void 0 && this.emit("removeListener", y, _ || x);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(y) {
    var x, P, C;
    if (P = this._events, P === void 0)
      return this;
    if (P.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : P[y] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete P[y]), this;
    if (arguments.length === 0) {
      var R = Object.keys(P), m;
      for (C = 0; C < R.length; ++C)
        m = R[C], m !== "removeListener" && this.removeAllListeners(m);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (x = P[y], typeof x == "function")
      this.removeListener(y, x);
    else if (x !== void 0)
      for (C = x.length - 1; C >= 0; C--)
        this.removeListener(y, x[C]);
    return this;
  };
  function l(w, y, x) {
    var P = w._events;
    if (P === void 0)
      return [];
    var C = P[y];
    return C === void 0 ? [] : typeof C == "function" ? x ? [C.listener || C] : [C] : x ? g(C) : d(C, C.length);
  }
  o.prototype.listeners = function(y) {
    return l(this, y, !0);
  }, o.prototype.rawListeners = function(y) {
    return l(this, y, !1);
  }, o.listenerCount = function(w, y) {
    return typeof w.listenerCount == "function" ? w.listenerCount(y) : v.call(w, y);
  }, o.prototype.listenerCount = v;
  function v(w) {
    var y = this._events;
    if (y !== void 0) {
      var x = y[w];
      if (typeof x == "function")
        return 1;
      if (x !== void 0)
        return x.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? n(this._events) : [];
  };
  function d(w, y) {
    for (var x = new Array(y), P = 0; P < y; ++P)
      x[P] = w[P];
    return x;
  }
  function h(w, y) {
    for (; y + 1 < w.length; y++)
      w[y] = w[y + 1];
    w.pop();
  }
  function g(w) {
    for (var y = new Array(w.length), x = 0; x < y.length; ++x)
      y[x] = w[x].listener || w[x];
    return y;
  }
  function b(w, y) {
    return new Promise(function(x, P) {
      function C(m) {
        w.removeListener(y, R), P(m);
      }
      function R() {
        typeof w.removeListener == "function" && w.removeListener("error", C), x([].slice.call(arguments));
      }
      S(w, y, R, { once: !0 }), y !== "error" && E(w, C, { once: !0 });
    });
  }
  function E(w, y, x) {
    typeof w.on == "function" && S(w, "error", y, x);
  }
  function S(w, y, x, P) {
    if (typeof w.on == "function")
      P.once ? w.once(y, x) : w.on(y, x);
    else if (typeof w.addEventListener == "function")
      w.addEventListener(y, function C(R) {
        P.once && w.removeEventListener(y, C), x(R);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof w);
  }
  return yo.exports;
}
var vd;
function uS() {
  return vd || (vd = 1, function(e) {
    var t = Gr && Gr.__awaiter || function(o, s, i, u) {
      function f(p) {
        return p instanceof i ? p : new i(function(c) {
          c(p);
        });
      }
      return new (i || (i = Promise))(function(p, c) {
        function l(h) {
          try {
            d(u.next(h));
          } catch (g) {
            c(g);
          }
        }
        function v(h) {
          try {
            d(u.throw(h));
          } catch (g) {
            c(g);
          }
        }
        function d(h) {
          h.done ? p(h.value) : f(h.value).then(l, v);
        }
        d((u = u.apply(o, s || [])).next());
      });
    }, n = Gr && Gr.__generator || function(o, s) {
      var i = { label: 0, sent: function() {
        if (p[0] & 1) throw p[1];
        return p[1];
      }, trys: [], ops: [] }, u, f, p, c;
      return c = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
        return this;
      }), c;
      function l(d) {
        return function(h) {
          return v([d, h]);
        };
      }
      function v(d) {
        if (u) throw new TypeError("Generator is already executing.");
        for (; i; ) try {
          if (u = 1, f && (p = d[0] & 2 ? f.return : d[0] ? f.throw || ((p = f.return) && p.call(f), 0) : f.next) && !(p = p.call(f, d[1])).done) return p;
          switch (f = 0, p && (d = [d[0] & 2, p.value]), d[0]) {
            case 0:
            case 1:
              p = d;
              break;
            case 4:
              return i.label++, { value: d[1], done: !1 };
            case 5:
              i.label++, f = d[1], d = [0];
              continue;
            case 7:
              d = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (p = i.trys, !(p = p.length > 0 && p[p.length - 1]) && (d[0] === 6 || d[0] === 2)) {
                i = 0;
                continue;
              }
              if (d[0] === 3 && (!p || d[1] > p[0] && d[1] < p[3])) {
                i.label = d[1];
                break;
              }
              if (d[0] === 6 && i.label < p[1]) {
                i.label = p[1], p = d;
                break;
              }
              if (p && i.label < p[2]) {
                i.label = p[2], i.ops.push(d);
                break;
              }
              p[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          d = s.call(o, i);
        } catch (h) {
          d = [6, h], f = 0;
        } finally {
          u = p = 0;
        }
        if (d[0] & 5) throw d[1];
        return { value: d[0] ? d[1] : void 0, done: !0 };
      }
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.defaultNextRequest = void 0;
    var a = fm();
    e.defaultNextRequest = function() {
      var o = -1;
      return function() {
        return ++o;
      };
    };
    var r = (
      /** @class */
      function() {
        function o(s, i) {
          i === void 0 && (i = e.defaultNextRequest()), this.batch = [], this.batchStarted = !1, this.lastId = -1, this.transports = s, this.requests = {}, this.connectPromise = this.connect(), this.requestChannel = new a.EventEmitter(), this.nextID = i;
        }
        return o.prototype.connect = function() {
          var s = this;
          return Promise.all(this.transports.map(function(i) {
            return t(s, void 0, void 0, function() {
              return n(this, function(u) {
                switch (u.label) {
                  case 0:
                    return i.subscribe("error", this.handleError.bind(this)), i.subscribe("notification", this.handleNotification.bind(this)), [4, i.connect()];
                  case 1:
                    return u.sent(), [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }));
        }, o.prototype.getPrimaryTransport = function() {
          return this.transports[0];
        }, o.prototype.request = function(s, i, u) {
          return i === void 0 && (i = !1), t(this, void 0, void 0, function() {
            var f, p, c, l, v = this;
            return n(this, function(d) {
              return f = this.nextID().toString(), p = i ? null : f, c = { request: this.makeRequest(s.method, s.params || [], p), internalID: f }, this.batchStarted ? (l = new Promise(function(h, g) {
                v.batch.push({ resolve: h, reject: g, request: c });
              }), [2, l]) : [2, this.getPrimaryTransport().sendData(c, u)];
            });
          });
        }, o.prototype.close = function() {
          this.requestChannel.removeAllListeners(), this.transports.forEach(function(s) {
            s.unsubscribe(), s.close();
          });
        }, o.prototype.startBatch = function() {
          this.batchStarted = !0;
        }, o.prototype.stopBatch = function() {
          if (this.batchStarted === !1)
            throw new Error("cannot end that which has never started");
          if (this.batch.length === 0) {
            this.batchStarted = !1;
            return;
          }
          this.getPrimaryTransport().sendData(this.batch), this.batch = [], this.batchStarted = !1;
        }, o.prototype.makeRequest = function(s, i, u) {
          return u ? { jsonrpc: "2.0", id: u, method: s, params: i } : { jsonrpc: "2.0", method: s, params: i };
        }, o.prototype.handleError = function(s) {
          this.requestChannel.emit("error", s);
        }, o.prototype.handleNotification = function(s) {
          this.requestChannel.emit("notification", s);
        }, o;
      }()
    );
    e.default = r;
  }(Gr)), Gr;
}
var wn = {}, ca = {}, fa = {}, da = {}, gd;
function Za() {
  return gd || (gd = 1, function(e) {
    var t = da && da.__extends || /* @__PURE__ */ function() {
      var a = function(r, o) {
        return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, i) {
          s.__proto__ = i;
        } || function(s, i) {
          for (var u in i) i.hasOwnProperty(u) && (s[u] = i[u]);
        }, a(r, o);
      };
      return function(r, o) {
        a(r, o);
        function s() {
          this.constructor = r;
        }
        r.prototype = o === null ? Object.create(o) : (s.prototype = o.prototype, new s());
      };
    }();
    Object.defineProperty(e, "__esModule", { value: !0 }), e.convertJSONToRPCError = e.JSONRPCError = e.ERR_UNKNOWN = e.ERR_MISSIING_ID = e.ERR_TIMEOUT = void 0, e.ERR_TIMEOUT = 7777, e.ERR_MISSIING_ID = 7878, e.ERR_UNKNOWN = 7979;
    var n = (
      /** @class */
      function(a) {
        t(r, a);
        function r(o, s, i) {
          var u = this.constructor, f = a.call(this, o) || this;
          return f.message = o, f.code = s, f.data = i, Object.setPrototypeOf(f, u.prototype), f;
        }
        return r;
      }(Error)
    );
    e.JSONRPCError = n, e.convertJSONToRPCError = function(a) {
      if (a.error) {
        var r = a.error, o = r.message, s = r.code, i = r.data;
        return new n(o, s, i);
      }
      return new n("Unknown error", e.ERR_UNKNOWN, a);
    };
  }(da)), da;
}
var yd;
function cS() {
  if (yd) return fa;
  yd = 1, Object.defineProperty(fa, "__esModule", { value: !0 }), fa.TransportRequestManager = void 0;
  var e = fm(), t = Za(), n = (
    /** @class */
    function() {
      function a() {
        this.pendingRequest = {}, this.pendingBatchRequest = {}, this.transportEventChannel = new e.EventEmitter();
      }
      return a.prototype.addRequest = function(r, o) {
        return this.transportEventChannel.emit("pending", r), r instanceof Array ? (this.addBatchReq(r, o), Promise.resolve()) : this.addReq(r.internalID, o);
      }, a.prototype.settlePendingRequest = function(r, o) {
        var s = this;
        r.forEach(function(i) {
          var u = s.pendingRequest[i.internalID];
          if (delete s.pendingBatchRequest[i.internalID], u !== void 0) {
            if (o) {
              u.reject(o);
              return;
            }
            u.resolve(), (i.request.id === null || i.request.id === void 0) && delete s.pendingRequest[i.internalID];
          }
        });
      }, a.prototype.isPendingRequest = function(r) {
        return this.pendingRequest.hasOwnProperty(r);
      }, a.prototype.resolveResponse = function(r, o) {
        o === void 0 && (o = !0);
        var s = r;
        try {
          return s = JSON.parse(r), this.checkJSONRPC(s) === !1 ? void 0 : s instanceof Array ? this.resolveBatch(s, o) : this.resolveRes(s, o);
        } catch {
          var i = new t.JSONRPCError("Bad response format", t.ERR_UNKNOWN, r);
          return o && this.transportEventChannel.emit("error", i), i;
        }
      }, a.prototype.addBatchReq = function(r, o) {
        var s = this;
        return r.forEach(function(i) {
          var u = i.resolve, f = i.reject, p = i.request.internalID;
          s.pendingBatchRequest[p] = !0, s.pendingRequest[p] = { resolve: u, reject: f };
        }), Promise.resolve();
      }, a.prototype.addReq = function(r, o) {
        var s = this;
        return new Promise(function(i, u) {
          o !== null && o && s.setRequestTimeout(r, o, u), s.pendingRequest[r] = { resolve: i, reject: u };
        });
      }, a.prototype.checkJSONRPC = function(r) {
        var o = [r];
        return r instanceof Array && (o = r), o.every(function(s) {
          return s.result !== void 0 || s.error !== void 0 || s.method !== void 0;
        });
      }, a.prototype.processResult = function(r, o) {
        if (r.error) {
          var s = t.convertJSONToRPCError(r);
          o.reject(s);
          return;
        }
        o.resolve(r.result);
      }, a.prototype.resolveBatch = function(r, o) {
        var s = this, i = r.map(function(f) {
          return s.resolveRes(f, o);
        }), u = i.filter(function(f) {
          return f;
        });
        if (u.length > 0)
          return u[0];
      }, a.prototype.resolveRes = function(r, o) {
        var s = r.id, i = r.error, u = this.pendingRequest[s];
        if (u) {
          delete this.pendingRequest[s], this.processResult(r, u), this.transportEventChannel.emit("response", r);
          return;
        }
        if (s === void 0 && i === void 0) {
          this.transportEventChannel.emit("notification", r);
          return;
        }
        var f;
        return i && (f = t.convertJSONToRPCError(r)), o && i && f && this.transportEventChannel.emit("error", f), f;
      }, a.prototype.setRequestTimeout = function(r, o, s) {
        var i = this;
        setTimeout(function() {
          delete i.pendingRequest[r], s(new t.JSONRPCError("Request timeout request took longer than " + o + " ms to resolve", t.ERR_TIMEOUT));
        }, o);
      }, a;
    }()
  );
  return fa.TransportRequestManager = n, fa;
}
var bd;
function Kn() {
  if (bd) return ca;
  bd = 1, Object.defineProperty(ca, "__esModule", { value: !0 }), ca.Transport = void 0;
  var e = cS(), t = (
    /** @class */
    function() {
      function n() {
        this.transportRequestManager = new e.TransportRequestManager(), this.transportRequestManager.transportEventChannel.on("error", function() {
        });
      }
      return n.prototype.subscribe = function(a, r) {
        this.transportRequestManager.transportEventChannel.addListener(a, r);
      }, n.prototype.unsubscribe = function(a, r) {
        if (!a)
          return this.transportRequestManager.transportEventChannel.removeAllListeners();
        a && r && this.transportRequestManager.transportEventChannel.removeListener(a, r);
      }, n.prototype.parseData = function(a) {
        return a instanceof Array ? a.map(function(r) {
          return r.request.request;
        }) : a.request;
      }, n;
    }()
  );
  return ca.Transport = t, ca;
}
var Ws = {}, wd;
function eo() {
  return wd || (wd = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getNotifications = e.getBatchRequests = e.isNotification = void 0, e.isNotification = function(t) {
      return t.request.id === void 0 || t.request.id === null;
    }, e.getBatchRequests = function(t) {
      return t instanceof Array ? t.filter(function(n) {
        var a = n.request.request.id;
        return a != null;
      }).map(function(n) {
        return n.request;
      }) : [];
    }, e.getNotifications = function(t) {
      return t instanceof Array ? t.filter(function(n) {
        return e.isNotification(n.request);
      }).map(function(n) {
        return n.request;
      }) : e.isNotification(t) ? [t] : [];
    };
  }(Ws)), Ws;
}
var Sd;
function fS() {
  if (Sd) return wn;
  Sd = 1;
  var e = wn && wn.__extends || /* @__PURE__ */ function() {
    var o = function(s, i) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, f) {
        u.__proto__ = f;
      } || function(u, f) {
        for (var p in f) f.hasOwnProperty(p) && (u[p] = f[p]);
      }, o(s, i);
    };
    return function(s, i) {
      o(s, i);
      function u() {
        this.constructor = s;
      }
      s.prototype = i === null ? Object.create(i) : (u.prototype = i.prototype, new u());
    };
  }();
  Object.defineProperty(wn, "__esModule", { value: !0 });
  var t = Kn(), n = eo(), a = Za(), r = (
    /** @class */
    function(o) {
      e(s, o);
      function s(i, u, f) {
        var p = o.call(this) || this;
        return p.connection = i, p.reqUri = u, p.resUri = f, p;
      }
      return s.prototype.connect = function() {
        var i = this;
        return this.connection.on(this.resUri, function(u) {
          i.transportRequestManager.resolveResponse(u);
        }), Promise.resolve();
      }, s.prototype.sendData = function(i, u) {
        u === void 0 && (u = null);
        var f = this.transportRequestManager.addRequest(i, u), p = n.getNotifications(i), c = this.parseData(i);
        try {
          return this.connection.emit(this.reqUri, c), this.transportRequestManager.settlePendingRequest(p), f;
        } catch (v) {
          var l = new a.JSONRPCError(v.message, a.ERR_UNKNOWN, v);
          return this.transportRequestManager.settlePendingRequest(p, l), Promise.reject(l);
        }
      }, s.prototype.close = function() {
        this.connection.removeAllListeners();
      }, s;
    }(t.Transport)
  );
  return wn.default = r, wn;
}
var mt = {}, Pd;
function dS() {
  if (Pd) return mt;
  Pd = 1;
  var e = mt && mt.__extends || /* @__PURE__ */ function() {
    var f = function(p, c) {
      return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, v) {
        l.__proto__ = v;
      } || function(l, v) {
        for (var d in v) v.hasOwnProperty(d) && (l[d] = v[d]);
      }, f(p, c);
    };
    return function(p, c) {
      f(p, c);
      function l() {
        this.constructor = p;
      }
      p.prototype = c === null ? Object.create(c) : (l.prototype = c.prototype, new l());
    };
  }(), t = mt && mt.__awaiter || function(f, p, c, l) {
    function v(d) {
      return d instanceof c ? d : new c(function(h) {
        h(d);
      });
    }
    return new (c || (c = Promise))(function(d, h) {
      function g(S) {
        try {
          E(l.next(S));
        } catch (w) {
          h(w);
        }
      }
      function b(S) {
        try {
          E(l.throw(S));
        } catch (w) {
          h(w);
        }
      }
      function E(S) {
        S.done ? d(S.value) : v(S.value).then(g, b);
      }
      E((l = l.apply(f, p || [])).next());
    });
  }, n = mt && mt.__generator || function(f, p) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, v, d, h;
    return h = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (h[Symbol.iterator] = function() {
      return this;
    }), h;
    function g(E) {
      return function(S) {
        return b([E, S]);
      };
    }
    function b(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, v && (d = E[0] & 2 ? v.return : E[0] ? v.throw || ((d = v.return) && d.call(v), 0) : v.next) && !(d = d.call(v, E[1])).done) return d;
        switch (v = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, v = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = p.call(f, c);
      } catch (S) {
        E = [6, S], v = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  }, a = mt && mt.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(mt, "__esModule", { value: !0 }), mt.HTTPTransport = void 0;
  var r = a(ou()), o = Kn(), s = eo(), i = Za(), u = (
    /** @class */
    function(f) {
      e(p, f);
      function p(c, l) {
        var v = f.call(this) || this;
        return v.onlyNotifications = function(d) {
          return d instanceof Array ? d.every(function(h) {
            return h.request.request.id === null || h.request.request.id === void 0;
          }) : d.request.id === null || d.request.id === void 0;
        }, v.uri = c, v.credentials = l && l.credentials, v.headers = p.setupHeaders(l && l.headers), v.injectedFetcher = l?.fetcher, v;
      }
      return p.prototype.connect = function() {
        return Promise.resolve();
      }, p.prototype.sendData = function(c, l) {
        return l === void 0 && (l = null), t(this, void 0, void 0, function() {
          var v, d, h, g, b, E, w, S, w;
          return n(this, function(y) {
            switch (y.label) {
              case 0:
                v = this.transportRequestManager.addRequest(c, l), d = s.getNotifications(c), h = s.getBatchRequests(c), g = this.injectedFetcher || r.default, y.label = 1;
              case 1:
                return y.trys.push([1, 4, , 5]), [4, g(this.uri, {
                  method: "POST",
                  headers: this.headers,
                  body: JSON.stringify(this.parseData(c)),
                  credentials: this.credentials
                })];
              case 2:
                return b = y.sent(), this.transportRequestManager.settlePendingRequest(d), this.onlyNotifications(c) ? [2, Promise.resolve()] : [4, b.text()];
              case 3:
                return E = y.sent(), w = this.transportRequestManager.resolveResponse(E), w ? (this.transportRequestManager.settlePendingRequest(h, w), [2, Promise.reject(w)]) : [3, 5];
              case 4:
                return S = y.sent(), w = new i.JSONRPCError(S.message, i.ERR_UNKNOWN, S), this.transportRequestManager.settlePendingRequest(d, w), this.transportRequestManager.settlePendingRequest(s.getBatchRequests(c), w), [2, Promise.reject(w)];
              case 5:
                return [2, v];
            }
          });
        });
      }, p.prototype.close = function() {
      }, p.setupHeaders = function(c) {
        var l = new Headers(c);
        return l.set("Content-Type", "application/json"), l;
      }, p;
    }(o.Transport)
  );
  return mt.HTTPTransport = u, mt.default = u, mt;
}
var At = {}, On = null;
typeof WebSocket < "u" ? On = WebSocket : typeof MozWebSocket < "u" ? On = MozWebSocket : typeof globalThis < "u" ? On = globalThis.WebSocket || globalThis.MozWebSocket : typeof window < "u" ? On = window.WebSocket || window.MozWebSocket : typeof self < "u" && (On = self.WebSocket || self.MozWebSocket);
const pS = On, hS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pS
}, Symbol.toStringTag, { value: "Module" })), mS = /* @__PURE__ */ Ev(hS);
var xd;
function vS() {
  if (xd) return At;
  xd = 1;
  var e = At && At.__extends || /* @__PURE__ */ function() {
    var f = function(p, c) {
      return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(l, v) {
        l.__proto__ = v;
      } || function(l, v) {
        for (var d in v) v.hasOwnProperty(d) && (l[d] = v[d]);
      }, f(p, c);
    };
    return function(p, c) {
      f(p, c);
      function l() {
        this.constructor = p;
      }
      p.prototype = c === null ? Object.create(c) : (l.prototype = c.prototype, new l());
    };
  }(), t = At && At.__awaiter || function(f, p, c, l) {
    function v(d) {
      return d instanceof c ? d : new c(function(h) {
        h(d);
      });
    }
    return new (c || (c = Promise))(function(d, h) {
      function g(S) {
        try {
          E(l.next(S));
        } catch (w) {
          h(w);
        }
      }
      function b(S) {
        try {
          E(l.throw(S));
        } catch (w) {
          h(w);
        }
      }
      function E(S) {
        S.done ? d(S.value) : v(S.value).then(g, b);
      }
      E((l = l.apply(f, p || [])).next());
    });
  }, n = At && At.__generator || function(f, p) {
    var c = { label: 0, sent: function() {
      if (d[0] & 1) throw d[1];
      return d[1];
    }, trys: [], ops: [] }, l, v, d, h;
    return h = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (h[Symbol.iterator] = function() {
      return this;
    }), h;
    function g(E) {
      return function(S) {
        return b([E, S]);
      };
    }
    function b(E) {
      if (l) throw new TypeError("Generator is already executing.");
      for (; c; ) try {
        if (l = 1, v && (d = E[0] & 2 ? v.return : E[0] ? v.throw || ((d = v.return) && d.call(v), 0) : v.next) && !(d = d.call(v, E[1])).done) return d;
        switch (v = 0, d && (E = [E[0] & 2, d.value]), E[0]) {
          case 0:
          case 1:
            d = E;
            break;
          case 4:
            return c.label++, { value: E[1], done: !1 };
          case 5:
            c.label++, v = E[1], E = [0];
            continue;
          case 7:
            E = c.ops.pop(), c.trys.pop();
            continue;
          default:
            if (d = c.trys, !(d = d.length > 0 && d[d.length - 1]) && (E[0] === 6 || E[0] === 2)) {
              c = 0;
              continue;
            }
            if (E[0] === 3 && (!d || E[1] > d[0] && E[1] < d[3])) {
              c.label = E[1];
              break;
            }
            if (E[0] === 6 && c.label < d[1]) {
              c.label = d[1], d = E;
              break;
            }
            if (d && c.label < d[2]) {
              c.label = d[2], c.ops.push(E);
              break;
            }
            d[2] && c.ops.pop(), c.trys.pop();
            continue;
        }
        E = p.call(f, c);
      } catch (S) {
        E = [6, S], v = 0;
      } finally {
        l = d = 0;
      }
      if (E[0] & 5) throw E[1];
      return { value: E[0] ? E[1] : void 0, done: !0 };
    }
  }, a = At && At.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(At, "__esModule", { value: !0 });
  var r = a(mS), o = Kn(), s = eo(), i = Za(), u = (
    /** @class */
    function(f) {
      e(p, f);
      function p(c) {
        var l = f.call(this) || this;
        return l.uri = c, l.connection = new r.default(c), l;
      }
      return p.prototype.connect = function() {
        var c = this;
        return new Promise(function(l, v) {
          var d = function() {
            c.connection.removeEventListener("open", d), l();
          };
          c.connection.addEventListener("open", d), c.connection.addEventListener("message", function(h) {
            var g = h.data;
            c.transportRequestManager.resolveResponse(g);
          });
        });
      }, p.prototype.sendData = function(c, l) {
        return l === void 0 && (l = 5e3), t(this, void 0, void 0, function() {
          var v, d, h;
          return n(this, function(g) {
            v = this.transportRequestManager.addRequest(c, l), d = s.getNotifications(c);
            try {
              this.connection.send(JSON.stringify(this.parseData(c))), this.transportRequestManager.settlePendingRequest(d);
            } catch (b) {
              h = new i.JSONRPCError(b.message, i.ERR_UNKNOWN, b), this.transportRequestManager.settlePendingRequest(d, h), this.transportRequestManager.settlePendingRequest(s.getBatchRequests(c), h), v = Promise.reject(h);
            }
            return [2, v];
          });
        });
      }, p.prototype.close = function() {
        this.connection.close();
      }, p;
    }(o.Transport)
  );
  return At.default = u, At;
}
var Zt = {}, Ed;
function gS() {
  if (Ed) return Zt;
  Ed = 1;
  var e = Zt && Zt.__extends || /* @__PURE__ */ function() {
    var i = function(u, f) {
      return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, c) {
        p.__proto__ = c;
      } || function(p, c) {
        for (var l in c) c.hasOwnProperty(l) && (p[l] = c[l]);
      }, i(u, f);
    };
    return function(u, f) {
      i(u, f);
      function p() {
        this.constructor = u;
      }
      u.prototype = f === null ? Object.create(f) : (p.prototype = f.prototype, new p());
    };
  }(), t = Zt && Zt.__awaiter || function(i, u, f, p) {
    function c(l) {
      return l instanceof f ? l : new f(function(v) {
        v(l);
      });
    }
    return new (f || (f = Promise))(function(l, v) {
      function d(b) {
        try {
          g(p.next(b));
        } catch (E) {
          v(E);
        }
      }
      function h(b) {
        try {
          g(p.throw(b));
        } catch (E) {
          v(E);
        }
      }
      function g(b) {
        b.done ? l(b.value) : c(b.value).then(d, h);
      }
      g((p = p.apply(i, u || [])).next());
    });
  }, n = Zt && Zt.__generator || function(i, u) {
    var f = { label: 0, sent: function() {
      if (l[0] & 1) throw l[1];
      return l[1];
    }, trys: [], ops: [] }, p, c, l, v;
    return v = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
      return this;
    }), v;
    function d(g) {
      return function(b) {
        return h([g, b]);
      };
    }
    function h(g) {
      if (p) throw new TypeError("Generator is already executing.");
      for (; f; ) try {
        if (p = 1, c && (l = g[0] & 2 ? c.return : g[0] ? c.throw || ((l = c.return) && l.call(c), 0) : c.next) && !(l = l.call(c, g[1])).done) return l;
        switch (c = 0, l && (g = [g[0] & 2, l.value]), g[0]) {
          case 0:
          case 1:
            l = g;
            break;
          case 4:
            return f.label++, { value: g[1], done: !1 };
          case 5:
            f.label++, c = g[1], g = [0];
            continue;
          case 7:
            g = f.ops.pop(), f.trys.pop();
            continue;
          default:
            if (l = f.trys, !(l = l.length > 0 && l[l.length - 1]) && (g[0] === 6 || g[0] === 2)) {
              f = 0;
              continue;
            }
            if (g[0] === 3 && (!l || g[1] > l[0] && g[1] < l[3])) {
              f.label = g[1];
              break;
            }
            if (g[0] === 6 && f.label < l[1]) {
              f.label = l[1], l = g;
              break;
            }
            if (l && f.label < l[2]) {
              f.label = l[2], f.ops.push(g);
              break;
            }
            l[2] && f.ops.pop(), f.trys.pop();
            continue;
        }
        g = u.call(i, f);
      } catch (b) {
        g = [6, b], c = 0;
      } finally {
        p = l = 0;
      }
      if (g[0] & 5) throw g[1];
      return { value: g[0] ? g[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Zt, "__esModule", { value: !0 });
  var a = Kn(), r = eo(), o = function(i) {
    var u = 400, f = window.screen.height, p = 0, c = 0;
    return window.open(i, "inspector:popup", "left=" + p + ",top=" + c + ",width=" + u + ",height=" + f + ",resizable,scrollbars=yes,status=1");
  }, s = (
    /** @class */
    function(i) {
      e(u, i);
      function u(f) {
        var p = i.call(this) || this;
        return p.messageHandler = function(c) {
          p.transportRequestManager.resolveResponse(JSON.stringify(c.data));
        }, p.uri = f, p.postMessageID = "post-message-transport-" + Math.random(), p;
      }
      return u.prototype.createWindow = function(f) {
        return new Promise(function(p, c) {
          var l;
          l = o(f), setTimeout(function() {
            p(l);
          }, 3e3);
        });
      }, u.prototype.connect = function() {
        var f = this, p = /^(http|https):\/\/.*$/;
        return new Promise(function(c, l) {
          return t(f, void 0, void 0, function() {
            var v;
            return n(this, function(d) {
              switch (d.label) {
                case 0:
                  return p.test(this.uri) || l(new Error("Bad URI")), v = this, [4, this.createWindow(this.uri)];
                case 1:
                  return v.frame = d.sent(), window.addEventListener("message", this.messageHandler), c(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        });
      }, u.prototype.sendData = function(f, p) {
        return t(this, void 0, void 0, function() {
          var c, l;
          return n(this, function(v) {
            return c = this.transportRequestManager.addRequest(f, null), l = r.getNotifications(f), this.frame && (this.frame.postMessage(f.request, this.uri), this.transportRequestManager.settlePendingRequest(l)), [2, c];
          });
        });
      }, u.prototype.close = function() {
        this.frame && (window.removeEventListener("message", this.messageHandler), this.frame.close());
      }, u;
    }(a.Transport)
  );
  return Zt.default = s, Zt;
}
var er = {}, _d;
function yS() {
  if (_d) return er;
  _d = 1;
  var e = er && er.__extends || /* @__PURE__ */ function() {
    var s = function(i, u) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, p) {
        f.__proto__ = p;
      } || function(f, p) {
        for (var c in p) p.hasOwnProperty(c) && (f[c] = p[c]);
      }, s(i, u);
    };
    return function(i, u) {
      s(i, u);
      function f() {
        this.constructor = i;
      }
      i.prototype = u === null ? Object.create(u) : (f.prototype = u.prototype, new f());
    };
  }(), t = er && er.__awaiter || function(s, i, u, f) {
    function p(c) {
      return c instanceof u ? c : new u(function(l) {
        l(c);
      });
    }
    return new (u || (u = Promise))(function(c, l) {
      function v(g) {
        try {
          h(f.next(g));
        } catch (b) {
          l(b);
        }
      }
      function d(g) {
        try {
          h(f.throw(g));
        } catch (b) {
          l(b);
        }
      }
      function h(g) {
        g.done ? c(g.value) : p(g.value).then(v, d);
      }
      h((f = f.apply(s, i || [])).next());
    });
  }, n = er && er.__generator || function(s, i) {
    var u = { label: 0, sent: function() {
      if (c[0] & 1) throw c[1];
      return c[1];
    }, trys: [], ops: [] }, f, p, c, l;
    return l = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
      return this;
    }), l;
    function v(h) {
      return function(g) {
        return d([h, g]);
      };
    }
    function d(h) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; u; ) try {
        if (f = 1, p && (c = h[0] & 2 ? p.return : h[0] ? p.throw || ((c = p.return) && c.call(p), 0) : p.next) && !(c = c.call(p, h[1])).done) return c;
        switch (p = 0, c && (h = [h[0] & 2, c.value]), h[0]) {
          case 0:
          case 1:
            c = h;
            break;
          case 4:
            return u.label++, { value: h[1], done: !1 };
          case 5:
            u.label++, p = h[1], h = [0];
            continue;
          case 7:
            h = u.ops.pop(), u.trys.pop();
            continue;
          default:
            if (c = u.trys, !(c = c.length > 0 && c[c.length - 1]) && (h[0] === 6 || h[0] === 2)) {
              u = 0;
              continue;
            }
            if (h[0] === 3 && (!c || h[1] > c[0] && h[1] < c[3])) {
              u.label = h[1];
              break;
            }
            if (h[0] === 6 && u.label < c[1]) {
              u.label = c[1], c = h;
              break;
            }
            if (c && u.label < c[2]) {
              u.label = c[2], u.ops.push(h);
              break;
            }
            c[2] && u.ops.pop(), u.trys.pop();
            continue;
        }
        h = i.call(s, u);
      } catch (g) {
        h = [6, g], p = 0;
      } finally {
        f = c = 0;
      }
      if (h[0] & 5) throw h[1];
      return { value: h[0] ? h[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(er, "__esModule", { value: !0 });
  var a = Kn(), r = eo(), o = (
    /** @class */
    function(s) {
      e(i, s);
      function i(u) {
        var f = s.call(this) || this;
        return f.messageHandler = function(p) {
          f.transportRequestManager.resolveResponse(JSON.stringify(p.data));
        }, f.uri = u, f.postMessageID = "post-message-transport-" + Math.random(), f;
      }
      return i.prototype.createWindow = function(u) {
        var f = this;
        return new Promise(function(p, c) {
          var l, v = document.createElement("iframe");
          v.setAttribute("id", f.postMessageID), v.setAttribute("width", "0px"), v.setAttribute("height", "0px"), v.setAttribute("style", "visiblity:hidden;border:none;outline:none;"), v.addEventListener("load", function() {
            p(l);
          }), v.setAttribute("src", u), window.document.body.appendChild(v), l = v.contentWindow;
        });
      }, i.prototype.connect = function() {
        var u = this, f = /^(http|https):\/\/.*$/;
        return new Promise(function(p, c) {
          return t(u, void 0, void 0, function() {
            var l;
            return n(this, function(v) {
              switch (v.label) {
                case 0:
                  return f.test(this.uri) || c(new Error("Bad URI")), l = this, [4, this.createWindow(this.uri)];
                case 1:
                  return l.frame = v.sent(), window.addEventListener("message", this.messageHandler), p(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        });
      }, i.prototype.sendData = function(u, f) {
        return t(this, void 0, void 0, function() {
          var p, c;
          return n(this, function(l) {
            return p = this.transportRequestManager.addRequest(u, null), c = r.getNotifications(u), this.frame && (this.frame.postMessage(u.request, "*"), this.transportRequestManager.settlePendingRequest(c)), [2, p];
          });
        });
      }, i.prototype.close = function() {
        var u = document.getElementById(this.postMessageID);
        u?.remove(), window.removeEventListener("message", this.messageHandler);
      }, i;
    }(a.Transport)
  );
  return er.default = o, er;
}
var $r = {}, Cd;
function bS() {
  if (Cd) return $r;
  Cd = 1;
  var e = $r && $r.__awaiter || function(a, r, o, s) {
    function i(u) {
      return u instanceof o ? u : new o(function(f) {
        f(u);
      });
    }
    return new (o || (o = Promise))(function(u, f) {
      function p(v) {
        try {
          l(s.next(v));
        } catch (d) {
          f(d);
        }
      }
      function c(v) {
        try {
          l(s.throw(v));
        } catch (d) {
          f(d);
        }
      }
      function l(v) {
        v.done ? u(v.value) : i(v.value).then(p, c);
      }
      l((s = s.apply(a, r || [])).next());
    });
  }, t = $r && $r.__generator || function(a, r) {
    var o = { label: 0, sent: function() {
      if (u[0] & 1) throw u[1];
      return u[1];
    }, trys: [], ops: [] }, s, i, u, f;
    return f = { next: p(0), throw: p(1), return: p(2) }, typeof Symbol == "function" && (f[Symbol.iterator] = function() {
      return this;
    }), f;
    function p(l) {
      return function(v) {
        return c([l, v]);
      };
    }
    function c(l) {
      if (s) throw new TypeError("Generator is already executing.");
      for (; o; ) try {
        if (s = 1, i && (u = l[0] & 2 ? i.return : l[0] ? i.throw || ((u = i.return) && u.call(i), 0) : i.next) && !(u = u.call(i, l[1])).done) return u;
        switch (i = 0, u && (l = [l[0] & 2, u.value]), l[0]) {
          case 0:
          case 1:
            u = l;
            break;
          case 4:
            return o.label++, { value: l[1], done: !1 };
          case 5:
            o.label++, i = l[1], l = [0];
            continue;
          case 7:
            l = o.ops.pop(), o.trys.pop();
            continue;
          default:
            if (u = o.trys, !(u = u.length > 0 && u[u.length - 1]) && (l[0] === 6 || l[0] === 2)) {
              o = 0;
              continue;
            }
            if (l[0] === 3 && (!u || l[1] > u[0] && l[1] < u[3])) {
              o.label = l[1];
              break;
            }
            if (l[0] === 6 && o.label < u[1]) {
              o.label = u[1], u = l;
              break;
            }
            if (u && o.label < u[2]) {
              o.label = u[2], o.ops.push(l);
              break;
            }
            u[2] && o.ops.pop(), o.trys.pop();
            continue;
        }
        l = r.call(a, o);
      } catch (v) {
        l = [6, v], i = 0;
      } finally {
        s = u = 0;
      }
      if (l[0] & 5) throw l[1];
      return { value: l[0] ? l[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty($r, "__esModule", { value: !0 });
  var n = (
    /** @class */
    function() {
      function a(r) {
        this.requestManager = r;
      }
      return a.prototype.startBatch = function() {
        return this.requestManager.startBatch();
      }, a.prototype.stopBatch = function() {
        return this.requestManager.stopBatch();
      }, a.prototype.request = function(r, o) {
        return e(this, void 0, void 0, function() {
          return t(this, function(s) {
            switch (s.label) {
              case 0:
                return this.requestManager.connectPromise ? [4, this.requestManager.connectPromise] : [3, 2];
              case 1:
                s.sent(), s.label = 2;
              case 2:
                return [2, this.requestManager.request(r, !1, o)];
            }
          });
        });
      }, a.prototype.notify = function(r) {
        return e(this, void 0, void 0, function() {
          return t(this, function(o) {
            switch (o.label) {
              case 0:
                return this.requestManager.connectPromise ? [4, this.requestManager.connectPromise] : [3, 2];
              case 1:
                o.sent(), o.label = 2;
              case 2:
                return [2, this.requestManager.request(r, !0, null)];
            }
          });
        });
      }, a.prototype.onNotification = function(r) {
        this.requestManager.requestChannel.addListener("notification", r);
      }, a.prototype.onError = function(r) {
        this.requestManager.requestChannel.addListener("error", r);
      }, a.prototype.close = function() {
        this.requestManager.close();
      }, a;
    }()
  );
  return $r.default = n, $r;
}
var Rd;
function wS() {
  return Rd || (Rd = 1, function(e) {
    var t = ua && ua.__importDefault || function(p) {
      return p && p.__esModule ? p : { default: p };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.PostMessageIframeTransport = e.PostMessageWindowTransport = e.JSONRPCError = e.WebSocketTransport = e.EventEmitterTransport = e.HTTPTransport = e.RequestManager = e.Client = void 0;
    var n = t(uS());
    e.RequestManager = n.default;
    var a = t(fS());
    e.EventEmitterTransport = a.default;
    var r = t(dS());
    e.HTTPTransport = r.default;
    var o = t(vS());
    e.WebSocketTransport = o.default;
    var s = t(gS());
    e.PostMessageWindowTransport = s.default;
    var i = t(yS());
    e.PostMessageIframeTransport = i.default;
    var u = Za();
    Object.defineProperty(e, "JSONRPCError", { enumerable: !0, get: function() {
      return u.JSONRPCError;
    } });
    var f = t(bS());
    e.Client = f.default, e.default = f.default;
  }(ua)), ua;
}
var bo = wS(), SS = Kn();
const dm = async (e, t, n, a) => {
  let r;
  const o = t.find((s) => s.type === n.type && s.name === n.name);
  if (o?.type === "websocket")
    r = new bo.WebSocketTransport(e);
  else if (o?.type === "http")
    r = new bo.HTTPTransport(e, a);
  else if (o?.type === "postmessageiframe")
    r = new bo.PostMessageIframeTransport(e);
  else if (o?.type === "postmessagewindow")
    r = new bo.PostMessageWindowTransport(e);
  else if (o?.type === "plugin") {
    const s = await dm(
      o.uri,
      t,
      o.transport
    );
    class i extends SS.Transport {
      async connect() {
        await s.connect();
        const f = await s.sendData({
          internalID: 0,
          request: {
            jsonrpc: "2.0",
            method: "connect",
            params: [e],
            id: 0
          }
        });
        return s.subscribe("notification", (p) => {
          this.transportRequestManager.transportEventChannel.emit("notification", p);
        }), s.subscribe("error", (p) => {
          this.transportRequestManager.transportEventChannel.emit("error", p);
        }), f;
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      sendData(f) {
        return s.sendData({
          internalID: 0,
          request: {
            jsonrpc: "2.0",
            method: "sendData",
            params: [f.request],
            id: 0
          }
        });
      }
      close() {
        s.unsubscribe(), s.sendData({
          internalID: 0,
          request: {
            jsonrpc: "2.0",
            method: "close",
            params: [],
            id: 0
          }
        }), s.close();
      }
    }
    r = new i();
  }
  return r;
}, PS = (e, t, n, a) => {
  const [r, o] = ke(), [s, i] = ke(!1), [u, f] = ke(n), [p, c] = ke();
  return Me(() => {
    if (!u)
      return;
    (async () => {
      r && (r.unsubscribe(), r.close());
      const d = await dm(
        t,
        e,
        u,
        a
      );
      return d.connect().then(() => {
        i(!0), o(d);
      }).catch((h) => {
        throw d.unsubscribe(), d.close(), h;
      });
    })().catch((d) => {
      i(!1), o(void 0), c(d);
    });
  }, [u, t, e, a]), [r, async (v) => {
    i(!1), f(v);
  }, p, s];
};
function pm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Od = { exports: {} }, pa = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $d;
function xS() {
  if ($d) return pa;
  $d = 1;
  var e = St, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(i, u, f) {
    var p, c = {}, l = null, v = null;
    f !== void 0 && (l = "" + f), u.key !== void 0 && (l = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (p in u) a.call(u, p) && !o.hasOwnProperty(p) && (c[p] = u[p]);
    if (i && i.defaultProps) for (p in u = i.defaultProps, u) c[p] === void 0 && (c[p] = u[p]);
    return { $$typeof: t, type: i, key: l, ref: v, props: c, _owner: r.current };
  }
  return pa.Fragment = n, pa.jsx = s, pa.jsxs = s, pa;
}
var Td;
function ES() {
  return Td || (Td = 1, Od.exports = xS()), Od.exports;
}
var ne = ES(), wo = {}, jd;
function _S() {
  if (jd) return wo;
  jd = 1;
  var e = Pv;
  return wo.createRoot = e.createRoot, wo.hydrateRoot = e.hydrateRoot, wo;
}
_S();
const hm = typeof window < "u" ? z.useLayoutEffect : z.useEffect;
function Wo(e, t) {
  const n = {
    ...t
  };
  for (const a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      const r = a;
      if (r === "components" || r === "slots")
        n[r] = {
          ...e[r],
          ...n[r]
        };
      else if (r === "componentsProps" || r === "slotProps") {
        const o = e[r], s = t[r];
        if (!s)
          n[r] = o || {};
        else if (!o)
          n[r] = s;
        else {
          n[r] = {
            ...s
          };
          for (const i in o)
            if (Object.prototype.hasOwnProperty.call(o, i)) {
              const u = i;
              n[r][u] = Wo(o[u], s[u]);
            }
        }
      } else n[r] === void 0 && (n[r] = e[r]);
    }
  return n;
}
function CS(e) {
  const {
    theme: t,
    name: n,
    props: a
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? a : Wo(t.components[n].defaultProps, a);
}
var Dd = { exports: {} }, Oe = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kd;
function RS() {
  if (kd) return Oe;
  kd = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), i = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), l = Symbol.for("react.offscreen"), v = Symbol.for("react.client.reference");
  function d(h) {
    if (typeof h == "object" && h !== null) {
      var g = h.$$typeof;
      switch (g) {
        case e:
          switch (h = h.type, h) {
            case n:
            case r:
            case a:
            case u:
            case f:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case s:
                case i:
                case c:
                case p:
                  return h;
                case o:
                  return h;
                default:
                  return g;
              }
          }
        case t:
          return g;
      }
    }
  }
  return Oe.ContextConsumer = o, Oe.ContextProvider = s, Oe.Element = e, Oe.ForwardRef = i, Oe.Fragment = n, Oe.Lazy = c, Oe.Memo = p, Oe.Portal = t, Oe.Profiler = r, Oe.StrictMode = a, Oe.Suspense = u, Oe.SuspenseList = f, Oe.isContextConsumer = function(h) {
    return d(h) === o;
  }, Oe.isContextProvider = function(h) {
    return d(h) === s;
  }, Oe.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, Oe.isForwardRef = function(h) {
    return d(h) === i;
  }, Oe.isFragment = function(h) {
    return d(h) === n;
  }, Oe.isLazy = function(h) {
    return d(h) === c;
  }, Oe.isMemo = function(h) {
    return d(h) === p;
  }, Oe.isPortal = function(h) {
    return d(h) === t;
  }, Oe.isProfiler = function(h) {
    return d(h) === r;
  }, Oe.isStrictMode = function(h) {
    return d(h) === a;
  }, Oe.isSuspense = function(h) {
    return d(h) === u;
  }, Oe.isSuspenseList = function(h) {
    return d(h) === f;
  }, Oe.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === n || h === r || h === a || h === u || h === f || h === l || typeof h == "object" && h !== null && (h.$$typeof === c || h.$$typeof === p || h.$$typeof === s || h.$$typeof === o || h.$$typeof === i || h.$$typeof === v || h.getModuleId !== void 0);
  }, Oe.typeOf = d, Oe;
}
var Ad;
function OS() {
  return Ad || (Ad = 1, Dd.exports = /* @__PURE__ */ RS()), Dd.exports;
}
var mm = /* @__PURE__ */ OS();
function Pr(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function vm(e) {
  if (/* @__PURE__ */ z.isValidElement(e) || mm.isValidElementType(e) || !Pr(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = vm(e[n]);
  }), t;
}
function $t(e, t, n = {
  clone: !0
}) {
  const a = n.clone ? {
    ...e
  } : e;
  return Pr(e) && Pr(t) && Object.keys(t).forEach((r) => {
    /* @__PURE__ */ z.isValidElement(t[r]) || mm.isValidElementType(t[r]) ? a[r] = t[r] : Pr(t[r]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, r) && Pr(e[r]) ? a[r] = $t(e[r], t[r], n) : n.clone ? a[r] = Pr(t[r]) ? vm(t[r]) : t[r] : a[r] = t[r];
  }), a;
}
const $S = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, a) => n.val - a.val), t.reduce((n, a) => ({
    ...n,
    [a.key]: a.val
  }), {});
};
function TS(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: a = 5,
    ...r
  } = e, o = $S(t), s = Object.keys(o);
  function i(l) {
    return `@media (min-width:${typeof t[l] == "number" ? t[l] : l}${n})`;
  }
  function u(l) {
    return `@media (max-width:${(typeof t[l] == "number" ? t[l] : l) - a / 100}${n})`;
  }
  function f(l, v) {
    const d = s.indexOf(v);
    return `@media (min-width:${typeof t[l] == "number" ? t[l] : l}${n}) and (max-width:${(d !== -1 && typeof t[s[d]] == "number" ? t[s[d]] : v) - a / 100}${n})`;
  }
  function p(l) {
    return s.indexOf(l) + 1 < s.length ? f(l, s[s.indexOf(l) + 1]) : i(l);
  }
  function c(l) {
    const v = s.indexOf(l);
    return v === 0 ? i(s[1]) : v === s.length - 1 ? u(s[v]) : f(l, s[s.indexOf(l) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: s,
    values: o,
    up: i,
    down: u,
    between: f,
    only: p,
    not: c,
    unit: n,
    ...r
  };
}
function an(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((a) => n.searchParams.append("args[]", a)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
function jS(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((a) => a.startsWith("@container")).sort((a, r) => {
    const o = /min-width:\s*([0-9.]+)/;
    return +(a.match(o)?.[1] || 0) - +(r.match(o)?.[1] || 0);
  });
  return n.length ? n.reduce((a, r) => {
    const o = t[r];
    return delete a[r], a[r] = o, a;
  }, {
    ...t
  }) : t;
}
function DS(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function kS(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n)
    return null;
  const [, a, r] = n, o = Number.isNaN(+a) ? a || 0 : +a;
  return e.containerQueries(r).up(o);
}
function AS(e) {
  const t = (o, s) => o.replace("@media", s ? `@container ${s}` : "@container");
  function n(o, s) {
    o.up = (...i) => t(e.breakpoints.up(...i), s), o.down = (...i) => t(e.breakpoints.down(...i), s), o.between = (...i) => t(e.breakpoints.between(...i), s), o.only = (...i) => t(e.breakpoints.only(...i), s), o.not = (...i) => {
      const u = t(e.breakpoints.not(...i), s);
      return u.includes("not all and") ? u.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : u;
    };
  }
  const a = {}, r = (o) => (n(a, o), a);
  return n(r), {
    ...e,
    containerQueries: r
  };
}
const MS = {
  borderRadius: 4
};
var Gs = { exports: {} }, Ks, Md;
function IS() {
  if (Md) return Ks;
  Md = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ks = e, Ks;
}
var Js, Id;
function NS() {
  if (Id) return Js;
  Id = 1;
  var e = /* @__PURE__ */ IS();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Js = function() {
    function a(s, i, u, f, p, c) {
      if (c !== e) {
        var l = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw l.name = "Invariant Violation", l;
      }
    }
    a.isRequired = a;
    function r() {
      return a;
    }
    var o = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: r,
      element: a,
      elementType: a,
      instanceOf: r,
      node: a,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Js;
}
var Nd;
function LS() {
  return Nd || (Nd = 1, Gs.exports = /* @__PURE__ */ NS()()), Gs.exports;
}
var qS = /* @__PURE__ */ LS();
const jo = /* @__PURE__ */ pm(qS);
function Ta(e, t) {
  return t ? $t(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Pi = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Ld = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Pi[e]}px)`
}, FS = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : Pi[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function Er(e, t, n) {
  const a = e.theme || {};
  if (Array.isArray(t)) {
    const r = a.breakpoints || Ld;
    return t.reduce((o, s, i) => (o[r.up(r.keys[i])] = n(t[i]), o), {});
  }
  if (typeof t == "object") {
    const r = a.breakpoints || Ld;
    return Object.keys(t).reduce((o, s) => {
      if (DS(r.keys, s)) {
        const i = kS(a.containerQueries ? a : FS, s);
        i && (o[i] = n(t[s], s));
      } else if (Object.keys(r.values || Pi).includes(s)) {
        const i = r.up(s);
        o[i] = n(t[s], s);
      } else {
        const i = s;
        o[i] = t[i];
      }
      return o;
    }, {});
  }
  return n(t);
}
function zS(e = {}) {
  return e.keys?.reduce((t, n) => {
    const a = e.up(n);
    return t[a] = {}, t;
  }, {}) || {};
}
function BS(e, t) {
  return e.reduce((n, a) => {
    const r = n[a];
    return (!r || Object.keys(r).length === 0) && delete n[a], n;
  }, t);
}
function ft(e) {
  if (typeof e != "string")
    throw new Error(an(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function xi(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const a = `vars.${t}`.split(".").reduce((r, o) => r && r[o] ? r[o] : null, e);
    if (a != null)
      return a;
  }
  return t.split(".").reduce((a, r) => a && a[r] != null ? a[r] : null, e);
}
function Go(e, t, n, a = n) {
  let r;
  return typeof e == "function" ? r = e(n) : Array.isArray(e) ? r = e[n] || a : r = xi(e, n) || a, t && (r = t(r, a, e)), r;
}
function Je(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: a,
    transform: r
  } = e, o = (s) => {
    if (s[t] == null)
      return null;
    const i = s[t], u = s.theme, f = xi(u, a) || {};
    return Er(s, i, (p) => {
      let c = Go(f, r, p);
      return p === c && typeof p == "string" && (c = Go(f, r, `${t}${p === "default" ? "" : ft(p)}`, p)), n === !1 ? c : {
        [n]: c
      };
    });
  };
  return o.propTypes = {}, o.filterProps = [t], o;
}
function US(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const HS = {
  m: "margin",
  p: "padding"
}, VS = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, qd = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, WS = US((e) => {
  if (e.length > 2)
    if (qd[e])
      e = qd[e];
    else
      return [e];
  const [t, n] = e.split(""), a = HS[t], r = VS[n] || "";
  return Array.isArray(r) ? r.map((o) => a + o) : [a + r];
}), fu = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], du = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...fu, ...du];
function to(e, t, n, a) {
  const r = xi(e, t, !0) ?? n;
  return typeof r == "number" || typeof r == "string" ? (o) => typeof o == "string" ? o : typeof r == "string" ? `calc(${o} * ${r})` : r * o : Array.isArray(r) ? (o) => {
    if (typeof o == "string")
      return o;
    const s = Math.abs(o), i = r[s];
    return o >= 0 ? i : typeof i == "number" ? -i : `-${i}`;
  } : typeof r == "function" ? r : () => {
  };
}
function pu(e) {
  return to(e, "spacing", 8);
}
function ro(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function GS(e, t) {
  return (n) => e.reduce((a, r) => (a[r] = ro(t, n), a), {});
}
function KS(e, t, n, a) {
  if (!t.includes(n))
    return null;
  const r = WS(n), o = GS(r, a), s = e[n];
  return Er(e, s, o);
}
function gm(e, t) {
  const n = pu(e.theme);
  return Object.keys(e).map((a) => KS(e, t, a, n)).reduce(Ta, {});
}
function He(e) {
  return gm(e, fu);
}
He.propTypes = {};
He.filterProps = fu;
function Ve(e) {
  return gm(e, du);
}
Ve.propTypes = {};
Ve.filterProps = du;
function ym(e = 8, t = pu({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...a) => (a.length === 0 ? [1] : a).map((r) => {
    const o = t(r);
    return typeof o == "number" ? `${o}px` : o;
  }).join(" ");
  return n.mui = !0, n;
}
function Ei(...e) {
  const t = e.reduce((a, r) => (r.filterProps.forEach((o) => {
    a[o] = r;
  }), a), {}), n = (a) => Object.keys(a).reduce((r, o) => t[o] ? Ta(r, t[o](a)) : r, {});
  return n.propTypes = {}, n.filterProps = e.reduce((a, r) => a.concat(r.filterProps), []), n;
}
function Lt(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Ft(e, t) {
  return Je({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const JS = Ft("border", Lt), QS = Ft("borderTop", Lt), YS = Ft("borderRight", Lt), XS = Ft("borderBottom", Lt), ZS = Ft("borderLeft", Lt), eP = Ft("borderColor"), tP = Ft("borderTopColor"), rP = Ft("borderRightColor"), nP = Ft("borderBottomColor"), aP = Ft("borderLeftColor"), oP = Ft("outline", Lt), iP = Ft("outlineColor"), _i = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = to(e.theme, "shape.borderRadius", 4), n = (a) => ({
      borderRadius: ro(t, a)
    });
    return Er(e, e.borderRadius, n);
  }
  return null;
};
_i.propTypes = {};
_i.filterProps = ["borderRadius"];
Ei(JS, QS, YS, XS, ZS, eP, tP, rP, nP, aP, _i, oP, iP);
const Ci = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = to(e.theme, "spacing", 8), n = (a) => ({
      gap: ro(t, a)
    });
    return Er(e, e.gap, n);
  }
  return null;
};
Ci.propTypes = {};
Ci.filterProps = ["gap"];
const Ri = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = to(e.theme, "spacing", 8), n = (a) => ({
      columnGap: ro(t, a)
    });
    return Er(e, e.columnGap, n);
  }
  return null;
};
Ri.propTypes = {};
Ri.filterProps = ["columnGap"];
const Oi = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = to(e.theme, "spacing", 8), n = (a) => ({
      rowGap: ro(t, a)
    });
    return Er(e, e.rowGap, n);
  }
  return null;
};
Oi.propTypes = {};
Oi.filterProps = ["rowGap"];
const sP = Je({
  prop: "gridColumn"
}), lP = Je({
  prop: "gridRow"
}), uP = Je({
  prop: "gridAutoFlow"
}), cP = Je({
  prop: "gridAutoColumns"
}), fP = Je({
  prop: "gridAutoRows"
}), dP = Je({
  prop: "gridTemplateColumns"
}), pP = Je({
  prop: "gridTemplateRows"
}), hP = Je({
  prop: "gridTemplateAreas"
}), mP = Je({
  prop: "gridArea"
});
Ei(Ci, Ri, Oi, sP, lP, uP, cP, fP, dP, pP, hP, mP);
function Mn(e, t) {
  return t === "grey" ? t : e;
}
const vP = Je({
  prop: "color",
  themeKey: "palette",
  transform: Mn
}), gP = Je({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Mn
}), yP = Je({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Mn
});
Ei(vP, gP, yP);
function Ct(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const bP = Je({
  prop: "width",
  transform: Ct
}), hu = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      const a = e.theme?.breakpoints?.values?.[n] || Pi[n];
      return a ? e.theme?.breakpoints?.unit !== "px" ? {
        maxWidth: `${a}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: a
      } : {
        maxWidth: Ct(n)
      };
    };
    return Er(e, e.maxWidth, t);
  }
  return null;
};
hu.filterProps = ["maxWidth"];
const wP = Je({
  prop: "minWidth",
  transform: Ct
}), SP = Je({
  prop: "height",
  transform: Ct
}), PP = Je({
  prop: "maxHeight",
  transform: Ct
}), xP = Je({
  prop: "minHeight",
  transform: Ct
});
Je({
  prop: "size",
  cssProperty: "width",
  transform: Ct
});
Je({
  prop: "size",
  cssProperty: "height",
  transform: Ct
});
const EP = Je({
  prop: "boxSizing"
});
Ei(bP, hu, wP, SP, PP, xP, EP);
const $i = {
  // borders
  border: {
    themeKey: "borders",
    transform: Lt
  },
  borderTop: {
    themeKey: "borders",
    transform: Lt
  },
  borderRight: {
    themeKey: "borders",
    transform: Lt
  },
  borderBottom: {
    themeKey: "borders",
    transform: Lt
  },
  borderLeft: {
    themeKey: "borders",
    transform: Lt
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Lt
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: _i
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Mn
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Mn
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Mn
  },
  // spacing
  p: {
    style: Ve
  },
  pt: {
    style: Ve
  },
  pr: {
    style: Ve
  },
  pb: {
    style: Ve
  },
  pl: {
    style: Ve
  },
  px: {
    style: Ve
  },
  py: {
    style: Ve
  },
  padding: {
    style: Ve
  },
  paddingTop: {
    style: Ve
  },
  paddingRight: {
    style: Ve
  },
  paddingBottom: {
    style: Ve
  },
  paddingLeft: {
    style: Ve
  },
  paddingX: {
    style: Ve
  },
  paddingY: {
    style: Ve
  },
  paddingInline: {
    style: Ve
  },
  paddingInlineStart: {
    style: Ve
  },
  paddingInlineEnd: {
    style: Ve
  },
  paddingBlock: {
    style: Ve
  },
  paddingBlockStart: {
    style: Ve
  },
  paddingBlockEnd: {
    style: Ve
  },
  m: {
    style: He
  },
  mt: {
    style: He
  },
  mr: {
    style: He
  },
  mb: {
    style: He
  },
  ml: {
    style: He
  },
  mx: {
    style: He
  },
  my: {
    style: He
  },
  margin: {
    style: He
  },
  marginTop: {
    style: He
  },
  marginRight: {
    style: He
  },
  marginBottom: {
    style: He
  },
  marginLeft: {
    style: He
  },
  marginX: {
    style: He
  },
  marginY: {
    style: He
  },
  marginInline: {
    style: He
  },
  marginInlineStart: {
    style: He
  },
  marginInlineEnd: {
    style: He
  },
  marginBlock: {
    style: He
  },
  marginBlockStart: {
    style: He
  },
  marginBlockEnd: {
    style: He
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Ci
  },
  rowGap: {
    style: Oi
  },
  columnGap: {
    style: Ri
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Ct
  },
  maxWidth: {
    style: hu
  },
  minWidth: {
    transform: Ct
  },
  height: {
    transform: Ct
  },
  maxHeight: {
    transform: Ct
  },
  minHeight: {
    transform: Ct
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function _P(...e) {
  const t = e.reduce((a, r) => a.concat(Object.keys(r)), []), n = new Set(t);
  return e.every((a) => n.size === Object.keys(a).length);
}
function CP(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function RP() {
  function e(n, a, r, o) {
    const s = {
      [n]: a,
      theme: r
    }, i = o[n];
    if (!i)
      return {
        [n]: a
      };
    const {
      cssProperty: u = n,
      themeKey: f,
      transform: p,
      style: c
    } = i;
    if (a == null)
      return null;
    if (f === "typography" && a === "inherit")
      return {
        [n]: a
      };
    const l = xi(r, f) || {};
    return c ? c(s) : Er(s, a, (v) => {
      let d = Go(l, p, v);
      return v === d && typeof v == "string" && (d = Go(l, p, `${n}${v === "default" ? "" : ft(v)}`, v)), u === !1 ? d : {
        [u]: d
      };
    });
  }
  function t(n) {
    const {
      sx: a,
      theme: r = {}
    } = n || {};
    if (!a)
      return null;
    const o = r.unstable_sxConfig ?? $i;
    function s(i) {
      let u = i;
      if (typeof i == "function")
        u = i(r);
      else if (typeof i != "object")
        return i;
      if (!u)
        return null;
      const f = zS(r.breakpoints), p = Object.keys(f);
      let c = f;
      return Object.keys(u).forEach((l) => {
        const v = CP(u[l], r);
        if (v != null)
          if (typeof v == "object")
            if (o[l])
              c = Ta(c, e(l, v, r, o));
            else {
              const d = Er({
                theme: r
              }, v, (h) => ({
                [l]: h
              }));
              _P(d, v) ? c[l] = t({
                sx: v,
                theme: r
              }) : c = Ta(c, d);
            }
          else
            c = Ta(c, e(l, v, r, o));
      }), jS(r, BS(p, c));
    }
    return Array.isArray(a) ? a.map(s) : s(a);
  }
  return t;
}
const zn = RP();
zn.filterProps = ["sx"];
function OP(e, t) {
  const n = this;
  if (n.vars) {
    if (!n.colorSchemes?.[e] || typeof n.getColorSchemeSelector != "function")
      return {};
    let a = n.getColorSchemeSelector(e);
    return a === "&" ? t : ((a.includes("data-") || a.includes(".")) && (a = `*:where(${a.replace(/\s*&$/, "")}) &`), {
      [a]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function mu(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: a = {},
    spacing: r,
    shape: o = {},
    ...s
  } = e, i = TS(n), u = ym(r);
  let f = $t({
    breakpoints: i,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...a
    },
    spacing: u,
    shape: {
      ...MS,
      ...o
    }
  }, s);
  return f = AS(f), f.applyStyles = OP, f = t.reduce((p, c) => $t(p, c), f), f.unstable_sxConfig = {
    ...$i,
    ...s?.unstable_sxConfig
  }, f.unstable_sx = function(p) {
    return zn({
      sx: p,
      theme: this
    });
  }, f;
}
function Ko() {
  return Ko = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) ({}).hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, Ko.apply(null, arguments);
}
function $P(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function TP(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var jP = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(r) {
      var o;
      a.tags.length === 0 ? a.insertionPoint ? o = a.insertionPoint.nextSibling : a.prepend ? o = a.container.firstChild : o = a.before : o = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(r, o), a.tags.push(r);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(TP(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var r = $P(a);
      try {
        r.insertRule(n, r.cssRules.length);
      } catch {
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      var a;
      return (a = n.parentNode) == null ? void 0 : a.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), lt = "-ms-", Jo = "-moz-", Se = "-webkit-", bm = "comm", vu = "rule", gu = "decl", DP = "@import", wm = "@keyframes", kP = "@layer", AP = Math.abs, Ti = String.fromCharCode, MP = Object.assign;
function IP(e, t) {
  return ot(e, 0) ^ 45 ? (((t << 2 ^ ot(e, 0)) << 2 ^ ot(e, 1)) << 2 ^ ot(e, 2)) << 2 ^ ot(e, 3) : 0;
}
function Sm(e) {
  return e.trim();
}
function NP(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function xe(e, t, n) {
  return e.replace(t, n);
}
function wl(e, t) {
  return e.indexOf(t);
}
function ot(e, t) {
  return e.charCodeAt(t) | 0;
}
function La(e, t, n) {
  return e.slice(t, n);
}
function ar(e) {
  return e.length;
}
function yu(e) {
  return e.length;
}
function So(e, t) {
  return t.push(e), e;
}
function LP(e, t) {
  return e.map(t).join("");
}
var ji = 1, Bn = 1, Pm = 0, xt = 0, Ze = 0, Jn = "";
function Di(e, t, n, a, r, o, s) {
  return { value: e, root: t, parent: n, type: a, props: r, children: o, line: ji, column: Bn, length: s, return: "" };
}
function ha(e, t) {
  return MP(Di("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function qP() {
  return Ze;
}
function FP() {
  return Ze = xt > 0 ? ot(Jn, --xt) : 0, Bn--, Ze === 10 && (Bn = 1, ji--), Ze;
}
function Tt() {
  return Ze = xt < Pm ? ot(Jn, xt++) : 0, Bn++, Ze === 10 && (Bn = 1, ji++), Ze;
}
function lr() {
  return ot(Jn, xt);
}
function Do() {
  return xt;
}
function no(e, t) {
  return La(Jn, e, t);
}
function qa(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function xm(e) {
  return ji = Bn = 1, Pm = ar(Jn = e), xt = 0, [];
}
function Em(e) {
  return Jn = "", e;
}
function ko(e) {
  return Sm(no(xt - 1, Sl(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function zP(e) {
  for (; (Ze = lr()) && Ze < 33; )
    Tt();
  return qa(e) > 2 || qa(Ze) > 3 ? "" : " ";
}
function BP(e, t) {
  for (; --t && Tt() && !(Ze < 48 || Ze > 102 || Ze > 57 && Ze < 65 || Ze > 70 && Ze < 97); )
    ;
  return no(e, Do() + (t < 6 && lr() == 32 && Tt() == 32));
}
function Sl(e) {
  for (; Tt(); )
    switch (Ze) {
      // ] ) " '
      case e:
        return xt;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && Sl(Ze);
        break;
      // (
      case 40:
        e === 41 && Sl(e);
        break;
      // \
      case 92:
        Tt();
        break;
    }
  return xt;
}
function UP(e, t) {
  for (; Tt() && e + Ze !== 57 && !(e + Ze === 84 && lr() === 47); )
    ;
  return "/*" + no(t, xt - 1) + "*" + Ti(e === 47 ? e : Tt());
}
function HP(e) {
  for (; !qa(lr()); )
    Tt();
  return no(e, xt);
}
function VP(e) {
  return Em(Ao("", null, null, null, [""], e = xm(e), 0, [0], e));
}
function Ao(e, t, n, a, r, o, s, i, u) {
  for (var f = 0, p = 0, c = s, l = 0, v = 0, d = 0, h = 1, g = 1, b = 1, E = 0, S = "", w = r, y = o, x = a, P = S; g; )
    switch (d = E, E = Tt()) {
      // (
      case 40:
        if (d != 108 && ot(P, c - 1) == 58) {
          wl(P += xe(ko(E), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        P += ko(E);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        P += zP(d);
        break;
      // \
      case 92:
        P += BP(Do() - 1, 7);
        continue;
      // /
      case 47:
        switch (lr()) {
          case 42:
          case 47:
            So(WP(UP(Tt(), Do()), t, n), u);
            break;
          default:
            P += "/";
        }
        break;
      // {
      case 123 * h:
        i[f++] = ar(P) * b;
      // } ; \0
      case 125 * h:
      case 59:
      case 0:
        switch (E) {
          // \0 }
          case 0:
          case 125:
            g = 0;
          // ;
          case 59 + p:
            b == -1 && (P = xe(P, /\f/g, "")), v > 0 && ar(P) - c && So(v > 32 ? zd(P + ";", a, n, c - 1) : zd(xe(P, " ", "") + ";", a, n, c - 2), u);
            break;
          // @ ;
          case 59:
            P += ";";
          // { rule/at-rule
          default:
            if (So(x = Fd(P, t, n, f, p, r, i, S, w = [], y = [], c), o), E === 123)
              if (p === 0)
                Ao(P, t, x, x, w, o, c, i, y);
              else
                switch (l === 99 && ot(P, 3) === 110 ? 100 : l) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ao(e, x, x, a && So(Fd(e, x, x, 0, 0, r, i, S, r, w = [], c), y), r, y, c, i, a ? w : y);
                    break;
                  default:
                    Ao(P, x, x, x, [""], y, 0, i, y);
                }
        }
        f = p = v = 0, h = b = 1, S = P = "", c = s;
        break;
      // :
      case 58:
        c = 1 + ar(P), v = d;
      default:
        if (h < 1) {
          if (E == 123)
            --h;
          else if (E == 125 && h++ == 0 && FP() == 125)
            continue;
        }
        switch (P += Ti(E), E * h) {
          // &
          case 38:
            b = p > 0 ? 1 : (P += "\f", -1);
            break;
          // ,
          case 44:
            i[f++] = (ar(P) - 1) * b, b = 1;
            break;
          // @
          case 64:
            lr() === 45 && (P += ko(Tt())), l = lr(), p = c = ar(S = P += HP(Do())), E++;
            break;
          // -
          case 45:
            d === 45 && ar(P) == 2 && (h = 0);
        }
    }
  return o;
}
function Fd(e, t, n, a, r, o, s, i, u, f, p) {
  for (var c = r - 1, l = r === 0 ? o : [""], v = yu(l), d = 0, h = 0, g = 0; d < a; ++d)
    for (var b = 0, E = La(e, c + 1, c = AP(h = s[d])), S = e; b < v; ++b)
      (S = Sm(h > 0 ? l[b] + " " + E : xe(E, /&\f/g, l[b]))) && (u[g++] = S);
  return Di(e, t, n, r === 0 ? vu : i, u, f, p);
}
function WP(e, t, n) {
  return Di(e, t, n, bm, Ti(qP()), La(e, 2, -2), 0);
}
function zd(e, t, n, a) {
  return Di(e, t, n, gu, La(e, 0, a), La(e, a + 1, -1), a);
}
function In(e, t) {
  for (var n = "", a = yu(e), r = 0; r < a; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function GP(e, t, n, a) {
  switch (e.type) {
    case kP:
      if (e.children.length) break;
    case DP:
    case gu:
      return e.return = e.return || e.value;
    case bm:
      return "";
    case wm:
      return e.return = e.value + "{" + In(e.children, a) + "}";
    case vu:
      e.value = e.props.join(",");
  }
  return ar(n = In(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function KP(e) {
  var t = yu(e);
  return function(n, a, r, o) {
    for (var s = "", i = 0; i < t; i++)
      s += e[i](n, a, r, o) || "";
    return s;
  };
}
function JP(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function _m(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var QP = function(e, t, n) {
  for (var a = 0, r = 0; a = r, r = lr(), a === 38 && r === 12 && (t[n] = 1), !qa(r); )
    Tt();
  return no(e, xt);
}, YP = function(e, t) {
  var n = -1, a = 44;
  do
    switch (qa(a)) {
      case 0:
        a === 38 && lr() === 12 && (t[n] = 1), e[n] += QP(xt - 1, t, n);
        break;
      case 2:
        e[n] += ko(a);
        break;
      case 4:
        if (a === 44) {
          e[++n] = lr() === 58 ? "&\f" : "", t[n] = e[n].length;
          break;
        }
      // fallthrough
      default:
        e[n] += Ti(a);
    }
  while (a = Tt());
  return e;
}, XP = function(e, t) {
  return Em(YP(xm(e), t));
}, Bd = /* @__PURE__ */ new WeakMap(), ZP = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var t = e.value, n = e.parent, a = e.column === n.column && e.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !Bd.get(n)) && !a) {
      Bd.set(e, !0);
      for (var r = [], o = XP(t, r), s = n.props, i = 0, u = 0; i < o.length; i++)
        for (var f = 0; f < s.length; f++, u++)
          e.props[u] = r[i] ? o[i].replace(/&\f/g, s[f]) : s[f] + " " + o[i];
    }
  }
}, ex = function(e) {
  if (e.type === "decl") {
    var t = e.value;
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
};
function Cm(e, t) {
  switch (IP(e, t)) {
    // color-adjust
    case 5103:
      return Se + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Se + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Se + e + Jo + e + lt + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return Se + e + lt + e + e;
    // order
    case 6165:
      return Se + e + lt + "flex-" + e + e;
    // align-items
    case 5187:
      return Se + e + xe(e, /(\w+).+(:[^]+)/, Se + "box-$1$2" + lt + "flex-$1$2") + e;
    // align-self
    case 5443:
      return Se + e + lt + "flex-item-" + xe(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return Se + e + lt + "flex-line-pack" + xe(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return Se + e + lt + xe(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return Se + e + lt + xe(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return Se + "box-" + xe(e, "-grow", "") + Se + e + lt + xe(e, "grow", "positive") + e;
    // transition
    case 4554:
      return Se + xe(e, /([^-])(transform)/g, "$1" + Se + "$2") + e;
    // cursor
    case 6187:
      return xe(xe(xe(e, /(zoom-|grab)/, Se + "$1"), /(image-set)/, Se + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return xe(e, /(image-set\([^]*)/, Se + "$1$`$1");
    // justify-content
    case 4968:
      return xe(xe(e, /(.+:)(flex-)?(.*)/, Se + "box-pack:$3" + lt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Se + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return xe(e, /(.+)-inline(.+)/, Se + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ar(e) - 1 - t > 6) switch (ot(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (ot(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return xe(e, /(.+:)(.+)-([^]+)/, "$1" + Se + "$2-$3$1" + Jo + (ot(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~wl(e, "stretch") ? Cm(xe(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (ot(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (ot(e, ar(e) - 3 - (~wl(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return xe(e, ":", ":" + Se) + e;
        // (inline-)?fl(e)x
        case 101:
          return xe(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Se + (ot(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Se + "$2$3$1" + lt + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (ot(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return Se + e + lt + xe(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return Se + e + lt + xe(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return Se + e + lt + xe(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Se + e + lt + e + e;
  }
  return e;
}
var tx = function(e, t, n, a) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case gu:
      e.return = Cm(e.value, e.length);
      break;
    case wm:
      return In([ha(e, {
        value: xe(e.value, "@", "@" + Se)
      })], a);
    case vu:
      if (e.length) return LP(e.props, function(r) {
        switch (NP(r, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return In([ha(e, {
              props: [xe(r, /:(read-\w+)/, ":" + Jo + "$1")]
            })], a);
          // :placeholder
          case "::placeholder":
            return In([ha(e, {
              props: [xe(r, /:(plac\w+)/, ":" + Se + "input-$1")]
            }), ha(e, {
              props: [xe(r, /:(plac\w+)/, ":" + Jo + "$1")]
            }), ha(e, {
              props: [xe(r, /:(plac\w+)/, lt + "input-$1")]
            })], a);
        }
        return "";
      });
  }
}, rx = [tx], nx = function(e) {
  var t = e.key;
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(d) {
      var h = d.getAttribute("data-emotion");
      h.indexOf(" ") !== -1 && (document.head.appendChild(d), d.setAttribute("data-s", ""));
    });
  }
  var a = e.stylisPlugins || rx, r = {}, o, s = [];
  o = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(d) {
      for (var h = d.getAttribute("data-emotion").split(" "), g = 1; g < h.length; g++)
        r[h[g]] = !0;
      s.push(d);
    }
  );
  var i, u = [ZP, ex];
  {
    var f, p = [GP, JP(function(d) {
      f.insert(d);
    })], c = KP(u.concat(a, p)), l = function(d) {
      return In(VP(d), c);
    };
    i = function(d, h, g, b) {
      f = g, l(d ? d + "{" + h.styles + "}" : h.styles), b && (v.inserted[h.name] = !0);
    };
  }
  var v = {
    key: t,
    sheet: new jP({
      key: t,
      container: o,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: r,
    registered: {},
    insert: i
  };
  return v.sheet.hydrate(s), v;
}, Ud = { exports: {} }, _e = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hd;
function ax() {
  if (Hd) return _e;
  Hd = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, l = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, d = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function S(y) {
    if (typeof y == "object" && y !== null) {
      var x = y.$$typeof;
      switch (x) {
        case t:
          switch (y = y.type, y) {
            case u:
            case f:
            case a:
            case o:
            case r:
            case c:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case i:
                case p:
                case d:
                case v:
                case s:
                  return y;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function w(y) {
    return S(y) === f;
  }
  return _e.AsyncMode = u, _e.ConcurrentMode = f, _e.ContextConsumer = i, _e.ContextProvider = s, _e.Element = t, _e.ForwardRef = p, _e.Fragment = a, _e.Lazy = d, _e.Memo = v, _e.Portal = n, _e.Profiler = o, _e.StrictMode = r, _e.Suspense = c, _e.isAsyncMode = function(y) {
    return w(y) || S(y) === u;
  }, _e.isConcurrentMode = w, _e.isContextConsumer = function(y) {
    return S(y) === i;
  }, _e.isContextProvider = function(y) {
    return S(y) === s;
  }, _e.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, _e.isForwardRef = function(y) {
    return S(y) === p;
  }, _e.isFragment = function(y) {
    return S(y) === a;
  }, _e.isLazy = function(y) {
    return S(y) === d;
  }, _e.isMemo = function(y) {
    return S(y) === v;
  }, _e.isPortal = function(y) {
    return S(y) === n;
  }, _e.isProfiler = function(y) {
    return S(y) === o;
  }, _e.isStrictMode = function(y) {
    return S(y) === r;
  }, _e.isSuspense = function(y) {
    return S(y) === c;
  }, _e.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === a || y === f || y === o || y === r || y === c || y === l || typeof y == "object" && y !== null && (y.$$typeof === d || y.$$typeof === v || y.$$typeof === s || y.$$typeof === i || y.$$typeof === p || y.$$typeof === g || y.$$typeof === b || y.$$typeof === E || y.$$typeof === h);
  }, _e.typeOf = S, _e;
}
var Vd;
function ox() {
  return Vd || (Vd = 1, Ud.exports = ax()), Ud.exports;
}
var Qs, Wd;
function ix() {
  if (Wd) return Qs;
  Wd = 1;
  var e = ox(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, a = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, r = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, o = {};
  o[e.ForwardRef] = a, o[e.Memo] = r;
  function s(d) {
    return e.isMemo(d) ? r : o[d.$$typeof] || t;
  }
  var i = Object.defineProperty, u = Object.getOwnPropertyNames, f = Object.getOwnPropertySymbols, p = Object.getOwnPropertyDescriptor, c = Object.getPrototypeOf, l = Object.prototype;
  function v(d, h, g) {
    if (typeof h != "string") {
      if (l) {
        var b = c(h);
        b && b !== l && v(d, b, g);
      }
      var E = u(h);
      f && (E = E.concat(f(h)));
      for (var S = s(d), w = s(h), y = 0; y < E.length; ++y) {
        var x = E[y];
        if (!n[x] && !(g && g[x]) && !(w && w[x]) && !(S && S[x])) {
          var P = p(h, x);
          try {
            i(d, x, P);
          } catch {
          }
        }
      }
    }
    return d;
  }
  return Qs = v, Qs;
}
ix();
var sx = !0;
function Rm(e, t, n) {
  var a = "";
  return n.split(" ").forEach(function(r) {
    e[r] !== void 0 ? t.push(e[r] + ";") : r && (a += r + " ");
  }), a;
}
var bu = function(e, t, n) {
  var a = e.key + "-" + t.name;
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  sx === !1) && e.registered[a] === void 0 && (e.registered[a] = t.styles);
}, Om = function(e, t, n) {
  bu(e, t, n);
  var a = e.key + "-" + t.name;
  if (e.inserted[t.name] === void 0) {
    var r = t;
    do
      e.insert(t === r ? "." + a : "", r, e.sheet, !0), r = r.next;
    while (r !== void 0);
  }
};
function lx(e) {
  for (var t = 0, n, a = 0, r = e.length; r >= 4; ++a, r -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (r) {
    case 3:
      t ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(a) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var ux = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, cx = /[A-Z]|^ms/g, fx = /_EMO_([^_]+?)_([^]*?)_EMO_/g, $m = function(e) {
  return e.charCodeAt(1) === 45;
}, Gd = function(e) {
  return e != null && typeof e != "boolean";
}, Ys = /* @__PURE__ */ _m(function(e) {
  return $m(e) ? e : e.replace(cx, "-$&").toLowerCase();
}), Kd = function(e, t) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(fx, function(n, a, r) {
          return or = {
            name: a,
            styles: r,
            next: or
          }, a;
        });
  }
  return ux[e] !== 1 && !$m(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function Fa(e, t, n) {
  if (n == null)
    return "";
  var a = n;
  if (a.__emotion_styles !== void 0)
    return a;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var r = n;
      if (r.anim === 1)
        return or = {
          name: r.name,
          styles: r.styles,
          next: or
        }, r.name;
      var o = n;
      if (o.styles !== void 0) {
        var s = o.next;
        if (s !== void 0)
          for (; s !== void 0; )
            or = {
              name: s.name,
              styles: s.styles,
              next: or
            }, s = s.next;
        var i = o.styles + ";";
        return i;
      }
      return dx(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var u = or, f = n(e);
        return or = u, Fa(e, t, f);
      }
      break;
    }
  }
  var p = n;
  if (t == null)
    return p;
  var c = t[p];
  return c !== void 0 ? c : p;
}
function dx(e, t, n) {
  var a = "";
  if (Array.isArray(n))
    for (var r = 0; r < n.length; r++)
      a += Fa(e, t, n[r]) + ";";
  else
    for (var o in n) {
      var s = n[o];
      if (typeof s != "object") {
        var i = s;
        t != null && t[i] !== void 0 ? a += o + "{" + t[i] + "}" : Gd(i) && (a += Ys(o) + ":" + Kd(o, i) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
        for (var u = 0; u < s.length; u++)
          Gd(s[u]) && (a += Ys(o) + ":" + Kd(o, s[u]) + ";");
      else {
        var f = Fa(e, t, s);
        switch (o) {
          case "animation":
          case "animationName": {
            a += Ys(o) + ":" + f + ";";
            break;
          }
          default:
            a += o + "{" + f + "}";
        }
      }
    }
  return a;
}
var Jd = /label:\s*([^\s;{]+)\s*(;|$)/g, or;
function ki(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var a = !0, r = "";
  or = void 0;
  var o = e[0];
  if (o == null || o.raw === void 0)
    a = !1, r += Fa(n, t, o);
  else {
    var s = o;
    r += s[0];
  }
  for (var i = 1; i < e.length; i++)
    if (r += Fa(n, t, e[i]), a) {
      var u = o;
      r += u[i];
    }
  Jd.lastIndex = 0;
  for (var f = "", p; (p = Jd.exec(r)) !== null; )
    f += "-" + p[1];
  var c = lx(r) + f;
  return {
    name: c,
    styles: r,
    next: or
  };
}
var px = function(e) {
  return e();
}, hx = z.useInsertionEffect ? z.useInsertionEffect : !1, Tm = hx || px, jm = /* @__PURE__ */ z.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ nx({
    key: "css"
  }) : null
);
jm.Provider;
var Dm = function(e) {
  return /* @__PURE__ */ Mp(function(t, n) {
    var a = Ip(jm);
    return e(t, a, n);
  });
}, wu = /* @__PURE__ */ z.createContext({}), Su = {}.hasOwnProperty, Pl = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", mx = function(e, t) {
  var n = {};
  for (var a in t)
    Su.call(t, a) && (n[a] = t[a]);
  return n[Pl] = e, n;
}, vx = function(e) {
  var t = e.cache, n = e.serialized, a = e.isStringTag;
  return bu(t, n, a), Tm(function() {
    return Om(t, n, a);
  }), null;
}, gx = /* @__PURE__ */ Dm(function(e, t, n) {
  var a = e.css;
  typeof a == "string" && t.registered[a] !== void 0 && (a = t.registered[a]);
  var r = e[Pl], o = [a], s = "";
  typeof e.className == "string" ? s = Rm(t.registered, o, e.className) : e.className != null && (s = e.className + " ");
  var i = ki(o, void 0, z.useContext(wu));
  s += t.key + "-" + i.name;
  var u = {};
  for (var f in e)
    Su.call(e, f) && f !== "css" && f !== Pl && (u[f] = e[f]);
  return u.className = s, n && (u.ref = n), /* @__PURE__ */ z.createElement(z.Fragment, null, /* @__PURE__ */ z.createElement(vx, {
    cache: t,
    serialized: i,
    isStringTag: typeof r == "string"
  }), /* @__PURE__ */ z.createElement(r, u));
}), yx = gx, Qd = function(e, t) {
  var n = arguments;
  if (t == null || !Su.call(t, "css"))
    return z.createElement.apply(void 0, n);
  var a = n.length, r = new Array(a);
  r[0] = yx, r[1] = mx(e, t);
  for (var o = 2; o < a; o++)
    r[o] = n[o];
  return z.createElement.apply(null, r);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(Qd || (Qd = {}));
function bx() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return ki(t);
}
function Pu() {
  var e = bx.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var wx = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Sx = /* @__PURE__ */ _m(
  function(e) {
    return wx.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Px = Sx, xx = function(e) {
  return e !== "theme";
}, Yd = function(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96 ? Px : xx;
}, Xd = function(e, t, n) {
  var a;
  if (t) {
    var r = t.shouldForwardProp;
    a = e.__emotion_forwardProp && r ? function(o) {
      return e.__emotion_forwardProp(o) && r(o);
    } : r;
  }
  return typeof a != "function" && n && (a = e.__emotion_forwardProp), a;
}, Ex = function(e) {
  var t = e.cache, n = e.serialized, a = e.isStringTag;
  return bu(t, n, a), Tm(function() {
    return Om(t, n, a);
  }), null;
}, _x = function e(t, n) {
  var a = t.__emotion_real === t, r = a && t.__emotion_base || t, o, s;
  n !== void 0 && (o = n.label, s = n.target);
  var i = Xd(t, n, a), u = i || Yd(r), f = !u("as");
  return function() {
    var p = arguments, c = a && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (o !== void 0 && c.push("label:" + o + ";"), p[0] == null || p[0].raw === void 0)
      c.push.apply(c, p);
    else {
      var l = p[0];
      c.push(l[0]);
      for (var v = p.length, d = 1; d < v; d++)
        c.push(p[d], l[d]);
    }
    var h = Dm(function(g, b, E) {
      var S = f && g.as || r, w = "", y = [], x = g;
      if (g.theme == null) {
        x = {};
        for (var P in g)
          x[P] = g[P];
        x.theme = z.useContext(wu);
      }
      typeof g.className == "string" ? w = Rm(b.registered, y, g.className) : g.className != null && (w = g.className + " ");
      var C = ki(c.concat(y), b.registered, x);
      w += b.key + "-" + C.name, s !== void 0 && (w += " " + s);
      var R = f && i === void 0 ? Yd(S) : u, m = {};
      for (var _ in g)
        f && _ === "as" || R(_) && (m[_] = g[_]);
      return m.className = w, E && (m.ref = E), /* @__PURE__ */ z.createElement(z.Fragment, null, /* @__PURE__ */ z.createElement(Ex, {
        cache: b,
        serialized: C,
        isStringTag: typeof S == "string"
      }), /* @__PURE__ */ z.createElement(S, m));
    });
    return h.displayName = o !== void 0 ? o : "Styled(" + (typeof r == "string" ? r : r.displayName || r.name || "Component") + ")", h.defaultProps = t.defaultProps, h.__emotion_real = h, h.__emotion_base = r, h.__emotion_styles = c, h.__emotion_forwardProp = i, Object.defineProperty(h, "toString", {
      value: function() {
        return "." + s;
      }
    }), h.withComponent = function(g, b) {
      var E = e(g, Ko({}, n, b, {
        shouldForwardProp: Xd(h, b, !0)
      }));
      return E.apply(void 0, c);
    }, h;
  };
}, Cx = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], xl = _x.bind(null);
Cx.forEach(function(e) {
  xl[e] = xl(e);
});
/**
 * @mui/styled-engine v6.4.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function Rx(e, t) {
  return xl(e, t);
}
function Ox(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const Zd = [];
function ep(e) {
  return Zd[0] = e, ki(Zd);
}
function $x(e) {
  return Object.keys(e).length === 0;
}
function km(e = null) {
  const t = z.useContext(wu);
  return !t || $x(t) ? e : t;
}
const Tx = mu();
function jx(e = Tx) {
  return km(e);
}
function Dx(e, t, n, a, r) {
  const [o, s] = z.useState(() => r && n ? n(e).matches : a ? a(e).matches : t);
  return hm(() => {
    if (!n)
      return;
    const i = n(e), u = () => {
      s(i.matches);
    };
    return u(), i.addEventListener("change", u), () => {
      i.removeEventListener("change", u);
    };
  }, [e, n]), o;
}
const kx = {
  ...z
}, Am = kx.useSyncExternalStore;
function Ax(e, t, n, a, r) {
  const o = z.useCallback(() => t, [t]), s = z.useMemo(() => {
    if (r && n)
      return () => n(e).matches;
    if (a !== null) {
      const {
        matches: f
      } = a(e);
      return () => f;
    }
    return o;
  }, [o, e, a, r, n]), [i, u] = z.useMemo(() => {
    if (n === null)
      return [o, () => () => {
      }];
    const f = n(e);
    return [() => f.matches, (p) => (f.addEventListener("change", p), () => {
      f.removeEventListener("change", p);
    })];
  }, [o, n, e]);
  return Am(u, i, s);
}
function Mm(e = {}) {
  const {
    themeId: t
  } = e;
  return function(n, a = {}) {
    let r = km();
    r && t && (r = r[t] || r);
    const o = typeof window < "u" && typeof window.matchMedia < "u", {
      defaultMatches: s = !1,
      matchMedia: i = o ? window.matchMedia : null,
      ssrMatchMedia: u = null,
      noSsr: f = !1
    } = CS({
      name: "MuiUseMediaQuery",
      props: a,
      theme: r
    });
    let p = typeof n == "function" ? n(r) : n;
    return p = p.replace(/^@media( ?)/m, ""), (Am !== void 0 ? Ax : Dx)(p, s, i, u, f);
  };
}
Mm();
const xu = "$$material";
Mm({
  themeId: xu
});
const tp = (e, t, n = !1) => {
  const a = t.palette.mode, r = {
    backgroundColor: t.palette.success[a]
  };
  return n ? (r.backgroundColor = t.palette.info[a], r.marginRight = t.spacing(1), r) : e.type === "request" ? (r.backgroundColor = t.palette.primary[a], r) : (e.payload.error && (r.backgroundColor = t.palette.common.white, r.color = t.palette.error.main), r);
}, Mx = (e) => {
  const t = zp();
  return /* @__PURE__ */ ne.jsxs(ne.Fragment, { children: [
    e.log.notification && /* @__PURE__ */ ne.jsx(Vu, { label: "notification", style: tp(e.log, t, !0) }),
    /* @__PURE__ */ ne.jsx(Vu, { label: e.log.type, style: tp(e.log, t) })
  ] });
}, Ix = z.memo(Mx);
function Qo(e) {
  "@babel/helpers - typeof";
  return Qo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qo(e);
}
function Fr(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function nt(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function jt(e) {
  nt(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Qo(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Nx(e, t) {
  nt(2, arguments);
  var n = jt(e).getTime(), a = Fr(t);
  return new Date(n + a);
}
var Lx = {};
function ao() {
  return Lx;
}
function za(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function rp(e) {
  nt(1, arguments);
  var t = jt(e);
  return t.setHours(0, 0, 0, 0), t;
}
var qx = 864e5;
function Fx(e, t) {
  nt(2, arguments);
  var n = rp(e), a = rp(t), r = n.getTime() - za(n), o = a.getTime() - za(a);
  return Math.round((r - o) / qx);
}
function zx(e) {
  return nt(1, arguments), e instanceof Date || Qo(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Bx(e) {
  if (nt(1, arguments), !zx(e) && typeof e != "number")
    return !1;
  var t = jt(e);
  return !isNaN(Number(t));
}
function El(e, t) {
  nt(2, arguments);
  var n = Fr(t);
  return Nx(e, -n);
}
var Ux = 864e5;
function Hx(e) {
  nt(1, arguments);
  var t = jt(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var a = t.getTime(), r = n - a;
  return Math.floor(r / Ux) + 1;
}
function Yo(e) {
  nt(1, arguments);
  var t = 1, n = jt(e), a = n.getUTCDay(), r = (a < t ? 7 : 0) + a - t;
  return n.setUTCDate(n.getUTCDate() - r), n.setUTCHours(0, 0, 0, 0), n;
}
function Im(e) {
  nt(1, arguments);
  var t = jt(e), n = t.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var r = Yo(a), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var s = Yo(o);
  return t.getTime() >= r.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function Vx(e) {
  nt(1, arguments);
  var t = Im(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = Yo(n);
  return a;
}
var Wx = 6048e5;
function Gx(e) {
  nt(1, arguments);
  var t = jt(e), n = Yo(t).getTime() - Vx(t).getTime();
  return Math.round(n / Wx) + 1;
}
function Xo(e, t) {
  var n, a, r, o, s, i, u, f;
  nt(1, arguments);
  var p = ao(), c = Fr((n = (a = (r = (o = t?.weekStartsOn) !== null && o !== void 0 ? o : t == null || (s = t.locale) === null || s === void 0 || (i = s.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && r !== void 0 ? r : p.weekStartsOn) !== null && a !== void 0 ? a : (u = p.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(c >= 0 && c <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var l = jt(e), v = l.getUTCDay(), d = (v < c ? 7 : 0) + v - c;
  return l.setUTCDate(l.getUTCDate() - d), l.setUTCHours(0, 0, 0, 0), l;
}
function Nm(e, t) {
  var n, a, r, o, s, i, u, f;
  nt(1, arguments);
  var p = jt(e), c = p.getUTCFullYear(), l = ao(), v = Fr((n = (a = (r = (o = t?.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (s = t.locale) === null || s === void 0 || (i = s.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && r !== void 0 ? r : l.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = l.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(v >= 1 && v <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var d = /* @__PURE__ */ new Date(0);
  d.setUTCFullYear(c + 1, 0, v), d.setUTCHours(0, 0, 0, 0);
  var h = Xo(d, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(c, 0, v), g.setUTCHours(0, 0, 0, 0);
  var b = Xo(g, t);
  return p.getTime() >= h.getTime() ? c + 1 : p.getTime() >= b.getTime() ? c : c - 1;
}
function Kx(e, t) {
  var n, a, r, o, s, i, u, f;
  nt(1, arguments);
  var p = ao(), c = Fr((n = (a = (r = (o = t?.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (s = t.locale) === null || s === void 0 || (i = s.options) === null || i === void 0 ? void 0 : i.firstWeekContainsDate) !== null && r !== void 0 ? r : p.firstWeekContainsDate) !== null && a !== void 0 ? a : (u = p.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), l = Nm(e, t), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(l, 0, c), v.setUTCHours(0, 0, 0, 0);
  var d = Xo(v, t);
  return d;
}
var Jx = 6048e5;
function Qx(e, t) {
  nt(1, arguments);
  var n = jt(e), a = Xo(n, t).getTime() - Kx(n, t).getTime();
  return Math.round(a / Jx) + 1;
}
function Ce(e, t) {
  for (var n = e < 0 ? "-" : "", a = Math.abs(e).toString(); a.length < t; )
    a = "0" + a;
  return n + a;
}
var Tr = {
  // Year
  y: function(e, t) {
    var n = e.getUTCFullYear(), a = n > 0 ? n : 1 - n;
    return Ce(t === "yy" ? a % 100 : a, t.length);
  },
  // Month
  M: function(e, t) {
    var n = e.getUTCMonth();
    return t === "M" ? String(n + 1) : Ce(n + 1, 2);
  },
  // Day of the month
  d: function(e, t) {
    return Ce(e.getUTCDate(), t.length);
  },
  // AM or PM
  a: function(e, t) {
    var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, t) {
    return Ce(e.getUTCHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H: function(e, t) {
    return Ce(e.getUTCHours(), t.length);
  },
  // Minute
  m: function(e, t) {
    return Ce(e.getUTCMinutes(), t.length);
  },
  // Second
  s: function(e, t) {
    return Ce(e.getUTCSeconds(), t.length);
  },
  // Fraction of second
  S: function(e, t) {
    var n = t.length, a = e.getUTCMilliseconds(), r = Math.floor(a * Math.pow(10, n - 3));
    return Ce(r, t.length);
  }
}, Sn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Yx = {
  // Era
  G: function(e, t, n) {
    var a = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return n.era(a, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      var a = e.getUTCFullYear(), r = a > 0 ? a : 1 - a;
      return n.ordinalNumber(r, {
        unit: "year"
      });
    }
    return Tr.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, a) {
    var r = Nm(e, a), o = r > 0 ? r : 1 - r;
    if (t === "YY") {
      var s = o % 100;
      return Ce(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : Ce(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    var n = Im(e);
    return Ce(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    var n = e.getUTCFullYear();
    return Ce(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    var a = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(a);
      // 01, 02, 03, 04
      case "QQ":
        return Ce(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    var a = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(a);
      // 01, 02, 03, 04
      case "qq":
        return Ce(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    var a = e.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return Tr.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    var a = e.getUTCMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(a + 1);
      // 01, 02, ..., 12
      case "LL":
        return Ce(a + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, t, n, a) {
    var r = Qx(e, a);
    return t === "wo" ? n.ordinalNumber(r, {
      unit: "week"
    }) : Ce(r, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    var a = Gx(e);
    return t === "Io" ? n.ordinalNumber(a, {
      unit: "week"
    }) : Ce(a, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Tr.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    var a = Hx(e);
    return t === "Do" ? n.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : Ce(a, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    var a = e.getUTCDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, a) {
    var r = e.getUTCDay(), o = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return Ce(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, a) {
    var r = e.getUTCDay(), o = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return Ce(o, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    var a = e.getUTCDay(), r = a === 0 ? 7 : a;
    switch (t) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return Ce(r, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, {
          unit: "day"
        });
      // Tue
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    var a = e.getUTCHours(), r = a / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    var a = e.getUTCHours(), r;
    switch (a === 12 ? r = Sn.noon : a === 0 ? r = Sn.midnight : r = a / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    var a = e.getUTCHours(), r;
    switch (a >= 17 ? r = Sn.evening : a >= 12 ? r = Sn.afternoon : a >= 4 ? r = Sn.morning : r = Sn.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      var a = e.getUTCHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return Tr.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Tr.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    var a = e.getUTCHours() % 12;
    return t === "Ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : Ce(a, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    var a = e.getUTCHours();
    return a === 0 && (a = 24), t === "ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : Ce(a, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Tr.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Tr.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Tr.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n, a) {
    var r = a._originalDate || e, o = r.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return ap(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Kr(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Kr(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n, a) {
    var r = a._originalDate || e, o = r.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return ap(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Kr(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Kr(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n, a) {
    var r = a._originalDate || e, o = r.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + np(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Kr(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n, a) {
    var r = a._originalDate || e, o = r.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + np(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Kr(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n, a) {
    var r = a._originalDate || e, o = Math.floor(r.getTime() / 1e3);
    return Ce(o, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n, a) {
    var r = a._originalDate || e, o = r.getTime();
    return Ce(o, t.length);
  }
};
function np(e, t) {
  var n = e > 0 ? "-" : "+", a = Math.abs(e), r = Math.floor(a / 60), o = a % 60;
  if (o === 0)
    return n + String(r);
  var s = t;
  return n + String(r) + s + Ce(o, 2);
}
function ap(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + Ce(Math.abs(e) / 60, 2);
  }
  return Kr(e, t);
}
function Kr(e, t) {
  var n = t || "", a = e > 0 ? "-" : "+", r = Math.abs(e), o = Ce(Math.floor(r / 60), 2), s = Ce(r % 60, 2);
  return a + o + n + s;
}
var op = function(e, t) {
  switch (e) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}, Lm = function(e, t) {
  switch (e) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}, Xx = function(e, t) {
  var n = e.match(/(P+)(p+)?/) || [], a = n[1], r = n[2];
  if (!r)
    return op(e, t);
  var o;
  switch (a) {
    case "P":
      o = t.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = t.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = t.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = t.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", op(a, t)).replace("{{time}}", Lm(r, t));
}, Zx = {
  p: Lm,
  P: Xx
}, eE = ["D", "DD"], tE = ["YY", "YYYY"];
function rE(e) {
  return eE.indexOf(e) !== -1;
}
function nE(e) {
  return tE.indexOf(e) !== -1;
}
function ip(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var aE = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, oE = function(e, t, n) {
  var a, r = aE[e];
  return typeof r == "string" ? a = r : t === 1 ? a = r.one : a = r.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function Xs(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, a = e.formats[n] || e.formats[e.defaultWidth];
    return a;
  };
}
var iE = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, sE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, lE = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, uE = {
  date: Xs({
    formats: iE,
    defaultWidth: "full"
  }),
  time: Xs({
    formats: sE,
    defaultWidth: "full"
  }),
  dateTime: Xs({
    formats: lE,
    defaultWidth: "full"
  })
}, cE = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, fE = function(e, t, n, a) {
  return cE[e];
};
function ma(e) {
  return function(t, n) {
    var a = n != null && n.context ? String(n.context) : "standalone", r;
    if (a === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : o;
      r = e.formattingValues[s] || e.formattingValues[o];
    } else {
      var i = e.defaultWidth, u = n != null && n.width ? String(n.width) : e.defaultWidth;
      r = e.values[u] || e.values[i];
    }
    var f = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[f];
  };
}
var dE = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, pE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, hE = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, mE = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, vE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, gE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, yE = function(e, t) {
  var n = Number(e), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, bE = {
  ordinalNumber: yE,
  era: ma({
    values: dE,
    defaultWidth: "wide"
  }),
  quarter: ma({
    values: pE,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: ma({
    values: hE,
    defaultWidth: "wide"
  }),
  day: ma({
    values: mE,
    defaultWidth: "wide"
  }),
  dayPeriod: ma({
    values: vE,
    defaultWidth: "wide",
    formattingValues: gE,
    defaultFormattingWidth: "wide"
  })
};
function va(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.width, r = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], o = t.match(r);
    if (!o)
      return null;
    var s = o[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(i) ? SE(i, function(c) {
      return c.test(s);
    }) : wE(i, function(c) {
      return c.test(s);
    }), f;
    f = e.valueCallback ? e.valueCallback(u) : u, f = n.valueCallback ? n.valueCallback(f) : f;
    var p = t.slice(s.length);
    return {
      value: f,
      rest: p
    };
  };
}
function wE(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function SE(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function PE(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = t.match(e.matchPattern);
    if (!a) return null;
    var r = a[0], o = t.match(e.parsePattern);
    if (!o) return null;
    var s = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    var i = t.slice(r.length);
    return {
      value: s,
      rest: i
    };
  };
}
var xE = /^(\d+)(th|st|nd|rd)?/i, EE = /\d+/i, _E = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, CE = {
  any: [/^b/i, /^(a|c)/i]
}, RE = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, OE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $E = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, TE = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, jE = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, DE = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, kE = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, AE = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ME = {
  ordinalNumber: PE({
    matchPattern: xE,
    parsePattern: EE,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: va({
    matchPatterns: _E,
    defaultMatchWidth: "wide",
    parsePatterns: CE,
    defaultParseWidth: "any"
  }),
  quarter: va({
    matchPatterns: RE,
    defaultMatchWidth: "wide",
    parsePatterns: OE,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: va({
    matchPatterns: $E,
    defaultMatchWidth: "wide",
    parsePatterns: TE,
    defaultParseWidth: "any"
  }),
  day: va({
    matchPatterns: jE,
    defaultMatchWidth: "wide",
    parsePatterns: DE,
    defaultParseWidth: "any"
  }),
  dayPeriod: va({
    matchPatterns: kE,
    defaultMatchWidth: "any",
    parsePatterns: AE,
    defaultParseWidth: "any"
  })
}, qm = {
  code: "en-US",
  formatDistance: oE,
  formatLong: uE,
  formatRelative: fE,
  localize: bE,
  match: ME,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, IE = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, NE = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, LE = /^'([^]*?)'?$/, qE = /''/g, FE = /[a-zA-Z]/;
function zE(e, t, n) {
  var a, r, o, s, i, u, f, p, c, l, v, d, h, g, b, E, S, w;
  nt(2, arguments);
  var y = String(t), x = ao(), P = (a = (r = n?.locale) !== null && r !== void 0 ? r : x.locale) !== null && a !== void 0 ? a : qm, C = Fr((o = (s = (i = (u = n?.firstWeekContainsDate) !== null && u !== void 0 ? u : n == null || (f = n.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && i !== void 0 ? i : x.firstWeekContainsDate) !== null && s !== void 0 ? s : (c = x.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(C >= 1 && C <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var R = Fr((v = (d = (h = (g = n?.weekStartsOn) !== null && g !== void 0 ? g : n == null || (b = n.locale) === null || b === void 0 || (E = b.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && h !== void 0 ? h : x.weekStartsOn) !== null && d !== void 0 ? d : (S = x.locale) === null || S === void 0 || (w = S.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && v !== void 0 ? v : 0);
  if (!(R >= 0 && R <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!P.localize)
    throw new RangeError("locale must contain localize property");
  if (!P.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var m = jt(e);
  if (!Bx(m))
    throw new RangeError("Invalid time value");
  var _ = za(m), O = El(m, _), T = {
    firstWeekContainsDate: C,
    weekStartsOn: R,
    locale: P,
    _originalDate: m
  }, A = y.match(NE).map(function(M) {
    var B = M[0];
    if (B === "p" || B === "P") {
      var J = Zx[B];
      return J(M, P.formatLong);
    }
    return M;
  }).join("").match(IE).map(function(M) {
    if (M === "''")
      return "'";
    var B = M[0];
    if (B === "'")
      return BE(M);
    var J = Yx[B];
    if (J)
      return !(n != null && n.useAdditionalWeekYearTokens) && nE(M) && ip(M, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && rE(M) && ip(M, t, String(e)), J(O, M, P.localize, T);
    if (B.match(FE))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + B + "`");
    return M;
  }).join("");
  return A;
}
function BE(e) {
  var t = e.match(LE);
  return t ? t[1].replace(qE, "'") : e;
}
function UE(e, t, n) {
  var a, r, o, s, i, u, f, p;
  nt(2, arguments);
  var c = jt(e), l = jt(t), v = ao(), d = (a = (r = void 0) !== null && r !== void 0 ? r : v.locale) !== null && a !== void 0 ? a : qm, h = Fr((o = (s = (i = (u = void 0) !== null && u !== void 0 ? u : void 0) !== null && i !== void 0 ? i : v.weekStartsOn) !== null && s !== void 0 ? s : (f = v.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && o !== void 0 ? o : 0);
  if (!d.localize)
    throw new RangeError("locale must contain localize property");
  if (!d.formatLong)
    throw new RangeError("locale must contain formatLong property");
  if (!d.formatRelative)
    throw new RangeError("locale must contain formatRelative property");
  var g = Fx(c, l);
  if (isNaN(g))
    throw new RangeError("Invalid time value");
  var b;
  g < -6 ? b = "other" : g < -1 ? b = "lastWeek" : g < 0 ? b = "yesterday" : g < 1 ? b = "today" : g < 2 ? b = "tomorrow" : g < 7 ? b = "nextWeek" : b = "other";
  var E = El(c, za(c)), S = El(l, za(l)), w = d.formatRelative(b, E, S, {
    locale: d,
    weekStartsOn: h
  });
  return zE(c, w, {
    locale: d,
    weekStartsOn: h
  });
}
function HE(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _l(e, t) {
  return _l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, _l(e, t);
}
function VE(e, t) {
  return () => null;
}
VE(jo.elementType);
jo.oneOfType([jo.func, jo.object]);
function WE(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function Mo(e) {
  const t = z.useRef(e);
  return hm(() => {
    t.current = e;
  }), z.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function Cl(...e) {
  return z.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      WE(n, t);
    });
  }, e);
}
const sp = {};
function Fm(e, t) {
  const n = z.useRef(sp);
  return n.current === sp && (n.current = e(t)), n;
}
const GE = [];
function KE(e) {
  z.useEffect(e, GE);
}
class Eu {
  static create() {
    return new Eu();
  }
  currentId = null;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
  clear = () => {
    this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
  };
  disposeEffect = () => this.clear;
}
function JE() {
  const e = Fm(Eu.create).current;
  return KE(e.disposeEffect), e;
}
function lp(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return !1;
}
function up() {
  return null;
}
up.isRequired = up;
function oo(e, t, n = void 0) {
  const a = {};
  for (const r in e) {
    const o = e[r];
    let s = "", i = !0;
    for (let u = 0; u < o.length; u += 1) {
      const f = o[u];
      f && (s += (i === !0 ? "" : " ") + t(f), i = !1, n && n[f] && (s += " " + n[f]));
    }
    a[r] = s;
  }
  return a;
}
const cp = (e) => e, QE = () => {
  let e = cp;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = cp;
    }
  };
}, YE = QE(), XE = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Qn(e, t, n = "Mui") {
  const a = XE[t];
  return a ? `${n}-${a}` : `${YE.generate(e)}-${t}`;
}
function Yn(e, t, n = "Mui") {
  const a = {};
  return t.forEach((r) => {
    a[r] = Qn(e, r, n);
  }), a;
}
function ZE(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function e_(e) {
  return typeof e == "string";
}
function t_(e, t, n) {
  return e === void 0 || e_(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function zm(e) {
  var t, n, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = zm(e[t])) && (a && (a += " "), a += n);
  } else for (n in e) e[n] && (a && (a += " "), a += n);
  return a;
}
function rt() {
  for (var e, t, n = 0, a = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = zm(e)) && (a && (a += " "), a += t);
  return a;
}
function r_(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((a) => a.match(/^on[A-Z]/) && typeof e[a] == "function" && !t.includes(a)).forEach((a) => {
    n[a] = e[a];
  }), n;
}
function fp(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function n_(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: a,
    externalForwardedProps: r,
    className: o
  } = e;
  if (!t) {
    const v = rt(n?.className, o, r?.className, a?.className), d = {
      ...n?.style,
      ...r?.style,
      ...a?.style
    }, h = {
      ...n,
      ...r,
      ...a
    };
    return v.length > 0 && (h.className = v), Object.keys(d).length > 0 && (h.style = d), {
      props: h,
      internalRef: void 0
    };
  }
  const s = r_({
    ...r,
    ...a
  }), i = fp(a), u = fp(r), f = t(s), p = rt(f?.className, n?.className, o, r?.className, a?.className), c = {
    ...f?.style,
    ...n?.style,
    ...r?.style,
    ...a?.style
  }, l = {
    ...f,
    ...n,
    ...u,
    ...i
  };
  return p.length > 0 && (l.className = p), Object.keys(c).length > 0 && (l.style = c), {
    props: l,
    internalRef: f.ref
  };
}
function a_(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function Bm(e) {
  const {
    variants: t,
    ...n
  } = e, a = {
    variants: t,
    style: ep(n),
    isProcessed: !0
  };
  return a.style === n || t && t.forEach((r) => {
    typeof r.style != "function" && (r.style = ep(r.style));
  }), a;
}
const o_ = mu();
function Zs(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function i_(e) {
  return e ? (t, n) => n[e] : null;
}
function s_(e, t, n) {
  e.theme = c_(e.theme) ? n : e.theme[t] || e.theme;
}
function Io(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((a) => Io(e, a));
  if (Array.isArray(n?.variants)) {
    let a;
    if (n.isProcessed)
      a = n.style;
    else {
      const {
        variants: r,
        ...o
      } = n;
      a = o;
    }
    return Um(e, n.variants, [a]);
  }
  return n?.isProcessed ? n.style : n;
}
function Um(e, t, n = []) {
  let a;
  e: for (let r = 0; r < t.length; r += 1) {
    const o = t[r];
    if (typeof o.props == "function") {
      if (a ??= {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }, !o.props(a))
        continue;
    } else
      for (const s in o.props)
        if (e[s] !== o.props[s] && e.ownerState?.[s] !== o.props[s])
          continue e;
    typeof o.style == "function" ? (a ??= {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }, n.push(o.style(a))) : n.push(o.style);
  }
  return n;
}
function l_(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = o_,
    rootShouldForwardProp: a = Zs,
    slotShouldForwardProp: r = Zs
  } = e;
  function o(s) {
    s_(s, t, n);
  }
  return (s, i = {}) => {
    Ox(s, (w) => w.filter((y) => y !== zn));
    const {
      name: u,
      slot: f,
      skipVariantsResolver: p,
      skipSx: c,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: l = i_(d_(f)),
      ...v
    } = i, d = p !== void 0 ? p : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      f && f !== "Root" && f !== "root" || !1
    ), h = c || !1;
    let g = Zs;
    f === "Root" || f === "root" ? g = a : f ? g = r : f_(s) && (g = void 0);
    const b = Rx(s, {
      shouldForwardProp: g,
      label: u_(),
      ...v
    }), E = (w) => {
      if (typeof w == "function" && w.__emotion_real !== w)
        return function(y) {
          return Io(y, w);
        };
      if (Pr(w)) {
        const y = Bm(w);
        return y.variants ? function(x) {
          return Io(x, y);
        } : y.style;
      }
      return w;
    }, S = (...w) => {
      const y = [], x = w.map(E), P = [];
      if (y.push(o), u && l && P.push(function(m) {
        const _ = m.theme.components?.[u]?.styleOverrides;
        if (!_)
          return null;
        const O = {};
        for (const T in _)
          O[T] = Io(m, _[T]);
        return l(m, O);
      }), u && !d && P.push(function(m) {
        const _ = m.theme?.components?.[u]?.variants;
        return _ ? Um(m, _) : null;
      }), h || P.push(zn), Array.isArray(x[0])) {
        const m = x.shift(), _ = new Array(y.length).fill(""), O = new Array(P.length).fill("");
        let T;
        T = [..._, ...m, ...O], T.raw = [..._, ...m.raw, ...O], y.unshift(T);
      }
      const C = [...y, ...x, ...P], R = b(...C);
      return s.muiName && (R.muiName = s.muiName), R;
    };
    return b.withConfig && (S.withConfig = b.withConfig), S;
  };
}
function u_(e, t) {
  return void 0;
}
function c_(e) {
  for (const t in e)
    return !1;
  return !0;
}
function f_(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function d_(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function _u(e, t = 0, n = 1) {
  return ZE(e, t, n);
}
function p_(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((a) => a + a)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((a, r) => r < 3 ? parseInt(a, 16) : Math.round(parseInt(a, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function zr(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return zr(p_(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(an(9, e));
  let a = e.substring(t + 1, e.length - 1), r;
  if (n === "color") {
    if (a = a.split(" "), r = a.shift(), a.length === 4 && a[3].charAt(0) === "/" && (a[3] = a[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(r))
      throw new Error(an(10, r));
  } else
    a = a.split(",");
  return a = a.map((o) => parseFloat(o)), {
    type: n,
    values: a,
    colorSpace: r
  };
}
const h_ = (e) => {
  const t = zr(e);
  return t.values.slice(0, 3).map((n, a) => t.type.includes("hsl") && a !== 0 ? `${n}%` : n).join(" ");
}, Ca = (e, t) => {
  try {
    return h_(e);
  } catch {
    return e;
  }
};
function Ai(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: a
  } = e;
  return t.includes("rgb") ? a = a.map((r, o) => o < 3 ? parseInt(r, 10) : r) : t.includes("hsl") && (a[1] = `${a[1]}%`, a[2] = `${a[2]}%`), t.includes("color") ? a = `${n} ${a.join(" ")}` : a = `${a.join(", ")}`, `${t}(${a})`;
}
function Hm(e) {
  e = zr(e);
  const {
    values: t
  } = e, n = t[0], a = t[1] / 100, r = t[2] / 100, o = a * Math.min(r, 1 - r), s = (f, p = (f + n / 30) % 12) => r - o * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  let i = "rgb";
  const u = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (i += "a", u.push(t[3])), Ai({
    type: i,
    values: u
  });
}
function Rl(e) {
  e = zr(e);
  let t = e.type === "hsl" || e.type === "hsla" ? zr(Hm(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function m_(e, t) {
  const n = Rl(e), a = Rl(t);
  return (Math.max(n, a) + 0.05) / (Math.min(n, a) + 0.05);
}
function Ba(e, t) {
  return e = zr(e), t = _u(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Ai(e);
}
function Po(e, t, n) {
  try {
    return Ba(e, t);
  } catch {
    return e;
  }
}
function Ua(e, t) {
  if (e = zr(e), t = _u(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return Ai(e);
}
function je(e, t, n) {
  try {
    return Ua(e, t);
  } catch {
    return e;
  }
}
function Ha(e, t) {
  if (e = zr(e), t = _u(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return Ai(e);
}
function De(e, t, n) {
  try {
    return Ha(e, t);
  } catch {
    return e;
  }
}
function v_(e, t = 0.15) {
  return Rl(e) > 0.5 ? Ua(e, t) : Ha(e, t);
}
function xo(e, t, n) {
  try {
    return v_(e, t);
  } catch {
    return e;
  }
}
const g_ = /* @__PURE__ */ z.createContext(void 0);
function y_(e) {
  const {
    theme: t,
    name: n,
    props: a
  } = e;
  if (!t || !t.components || !t.components[n])
    return a;
  const r = t.components[n];
  return r.defaultProps ? Wo(r.defaultProps, a) : !r.styleOverrides && !r.variants ? Wo(r, a) : a;
}
function b_({
  props: e,
  name: t
}) {
  const n = z.useContext(g_);
  return y_({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const dp = {
  theme: void 0
};
function w_(e) {
  let t, n;
  return function(a) {
    let r = t;
    return (r === void 0 || a.theme !== n) && (dp.theme = a.theme, r = Bm(e(dp)), t = r, n = a.theme), r;
  };
}
function S_(e = "") {
  function t(...n) {
    if (!n.length)
      return "";
    const a = n[0];
    return typeof a == "string" && !a.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${a}${t(...n.slice(1))})` : `, ${a}`;
  }
  return (n, ...a) => `var(--${e ? `${e}-` : ""}${n}${t(...a)})`;
}
const pp = (e, t, n, a = []) => {
  let r = e;
  t.forEach((o, s) => {
    s === t.length - 1 ? Array.isArray(r) ? r[Number(o)] = n : r && typeof r == "object" && (r[o] = n) : r && typeof r == "object" && (r[o] || (r[o] = a.includes(o) ? [] : {}), r = r[o]);
  });
}, P_ = (e, t, n) => {
  function a(r, o = [], s = []) {
    Object.entries(r).forEach(([i, u]) => {
      (!n || n && !n([...o, i])) && u != null && (typeof u == "object" && Object.keys(u).length > 0 ? a(u, [...o, i], Array.isArray(u) ? [...s, i] : s) : t([...o, i], u, s));
    });
  }
  a(e);
}, x_ = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((n) => e.includes(n)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function el(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: a
  } = t || {}, r = {}, o = {}, s = {};
  return P_(
    e,
    (i, u, f) => {
      if ((typeof u == "string" || typeof u == "number") && (!a || !a(i, u))) {
        const p = `--${n ? `${n}-` : ""}${i.join("-")}`, c = x_(i, u);
        Object.assign(r, {
          [p]: c
        }), pp(o, i, `var(${p})`, f), pp(s, i, `var(${p}, ${c})`, f);
      }
    },
    (i) => i[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: r,
    vars: o,
    varsWithDefaults: s
  };
}
function E_(e, t = {}) {
  const {
    getSelector: n = g,
    disableCssColorScheme: a,
    colorSchemeSelector: r
  } = t, {
    colorSchemes: o = {},
    components: s,
    defaultColorScheme: i = "light",
    ...u
  } = e, {
    vars: f,
    css: p,
    varsWithDefaults: c
  } = el(u, t);
  let l = c;
  const v = {}, {
    [i]: d,
    ...h
  } = o;
  if (Object.entries(h || {}).forEach(([b, E]) => {
    const {
      vars: S,
      css: w,
      varsWithDefaults: y
    } = el(E, t);
    l = $t(l, y), v[b] = {
      css: w,
      vars: S
    };
  }), d) {
    const {
      css: b,
      vars: E,
      varsWithDefaults: S
    } = el(d, t);
    l = $t(l, S), v[i] = {
      css: b,
      vars: E
    };
  }
  function g(b, E) {
    let S = r;
    if (r === "class" && (S = ".%s"), r === "data" && (S = "[data-%s]"), r?.startsWith("data-") && !r.includes("%s") && (S = `[${r}="%s"]`), b) {
      if (S === "media")
        return e.defaultColorScheme === b ? ":root" : {
          [`@media (prefers-color-scheme: ${o[b]?.palette?.mode || b})`]: {
            ":root": E
          }
        };
      if (S)
        return e.defaultColorScheme === b ? `:root, ${S.replace("%s", String(b))}` : S.replace("%s", String(b));
    }
    return ":root";
  }
  return {
    vars: l,
    generateThemeVars: () => {
      let b = {
        ...f
      };
      return Object.entries(v).forEach(([, {
        vars: E
      }]) => {
        b = $t(b, E);
      }), b;
    },
    generateStyleSheets: () => {
      const b = [], E = e.defaultColorScheme || "light";
      function S(x, P) {
        Object.keys(P).length && b.push(typeof x == "string" ? {
          [x]: {
            ...P
          }
        } : x);
      }
      S(n(void 0, {
        ...p
      }), p);
      const {
        [E]: w,
        ...y
      } = v;
      if (w) {
        const {
          css: x
        } = w, P = o[E]?.palette?.mode, C = !a && P ? {
          colorScheme: P,
          ...x
        } : {
          ...x
        };
        S(n(E, {
          ...C
        }), C);
      }
      return Object.entries(y).forEach(([x, {
        css: P
      }]) => {
        const C = o[x]?.palette?.mode, R = !a && C ? {
          colorScheme: C,
          ...P
        } : {
          ...P
        };
        S(n(x, {
          ...R
        }), R);
      }), b;
    }
  };
}
function __(e) {
  return function(t) {
    return e === "media" ? `@media (prefers-color-scheme: ${t})` : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${t}"] &` : e === "class" ? `.${t} &` : e === "data" ? `[data-${t}] &` : `${e.replace("%s", t)} &` : "&";
  };
}
const Va = {
  black: "#000",
  white: "#fff"
}, C_ = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Pn = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, xn = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, ga = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, En = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, _n = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, Cn = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function Vm() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Va.white,
      default: Va.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const R_ = Vm();
function Wm() {
  return {
    text: {
      primary: Va.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Va.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const hp = Wm();
function mp(e, t, n, a) {
  const r = a.light || a, o = a.dark || a * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Ha(e.main, r) : t === "dark" && (e.dark = Ua(e.main, o)));
}
function O_(e = "light") {
  return e === "dark" ? {
    main: En[200],
    light: En[50],
    dark: En[400]
  } : {
    main: En[700],
    light: En[400],
    dark: En[800]
  };
}
function $_(e = "light") {
  return e === "dark" ? {
    main: Pn[200],
    light: Pn[50],
    dark: Pn[400]
  } : {
    main: Pn[500],
    light: Pn[300],
    dark: Pn[700]
  };
}
function T_(e = "light") {
  return e === "dark" ? {
    main: xn[500],
    light: xn[300],
    dark: xn[700]
  } : {
    main: xn[700],
    light: xn[400],
    dark: xn[800]
  };
}
function j_(e = "light") {
  return e === "dark" ? {
    main: _n[400],
    light: _n[300],
    dark: _n[700]
  } : {
    main: _n[700],
    light: _n[500],
    dark: _n[900]
  };
}
function D_(e = "light") {
  return e === "dark" ? {
    main: Cn[400],
    light: Cn[300],
    dark: Cn[700]
  } : {
    main: Cn[800],
    light: Cn[500],
    dark: Cn[900]
  };
}
function k_(e = "light") {
  return e === "dark" ? {
    main: ga[400],
    light: ga[300],
    dark: ga[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: ga[500],
    dark: ga[900]
  };
}
function Cu(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: a = 0.2,
    ...r
  } = e, o = e.primary || O_(t), s = e.secondary || $_(t), i = e.error || T_(t), u = e.info || j_(t), f = e.success || D_(t), p = e.warning || k_(t);
  function c(d) {
    return m_(d, hp.text.primary) >= n ? hp.text.primary : R_.text.primary;
  }
  const l = ({
    color: d,
    name: h,
    mainShade: g = 500,
    lightShade: b = 300,
    darkShade: E = 700
  }) => {
    if (d = {
      ...d
    }, !d.main && d[g] && (d.main = d[g]), !d.hasOwnProperty("main"))
      throw new Error(an(11, h ? ` (${h})` : "", g));
    if (typeof d.main != "string")
      throw new Error(an(12, h ? ` (${h})` : "", JSON.stringify(d.main)));
    return mp(d, "light", b, a), mp(d, "dark", E, a), d.contrastText || (d.contrastText = c(d.main)), d;
  };
  let v;
  return t === "light" ? v = Vm() : t === "dark" && (v = Wm()), $t({
    // A collection of common colors.
    common: {
      ...Va
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: l({
      color: o,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: l({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: l({
      color: i,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: l({
      color: p,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: l({
      color: u,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: l({
      color: f,
      name: "success"
    }),
    // The grey colors.
    grey: C_,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: c,
    // Generate a rich color object.
    augmentColor: l,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: a,
    // The light and dark mode object.
    ...v
  }, r);
}
function A_(e) {
  const t = {};
  return Object.entries(e).forEach((n) => {
    const [a, r] = n;
    typeof r == "object" && (t[a] = `${r.fontStyle ? `${r.fontStyle} ` : ""}${r.fontVariant ? `${r.fontVariant} ` : ""}${r.fontWeight ? `${r.fontWeight} ` : ""}${r.fontStretch ? `${r.fontStretch} ` : ""}${r.fontSize || ""}${r.lineHeight ? `/${r.lineHeight} ` : ""}${r.fontFamily || ""}`);
  }), t;
}
function M_(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function I_(e) {
  return Math.round(e * 1e5) / 1e5;
}
const vp = {
  textTransform: "uppercase"
}, gp = '"Roboto", "Helvetica", "Arial", sans-serif';
function N_(e, t) {
  const {
    fontFamily: n = gp,
    // The default font size of the Material Specification.
    fontSize: a = 14,
    // px
    fontWeightLight: r = 300,
    fontWeightRegular: o = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: i = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: u = 16,
    // Apply the CSS properties to all the variants.
    allVariants: f,
    pxToRem: p,
    ...c
  } = typeof t == "function" ? t(e) : t, l = a / 14, v = p || ((g) => `${g / u * l}rem`), d = (g, b, E, S, w) => ({
    fontFamily: n,
    fontWeight: g,
    fontSize: v(b),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: E,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === gp ? {
      letterSpacing: `${I_(S / b)}em`
    } : {},
    ...w,
    ...f
  }), h = {
    h1: d(r, 96, 1.167, -1.5),
    h2: d(r, 60, 1.2, -0.5),
    h3: d(o, 48, 1.167, 0),
    h4: d(o, 34, 1.235, 0.25),
    h5: d(o, 24, 1.334, 0),
    h6: d(s, 20, 1.6, 0.15),
    subtitle1: d(o, 16, 1.75, 0.15),
    subtitle2: d(s, 14, 1.57, 0.1),
    body1: d(o, 16, 1.5, 0.15),
    body2: d(o, 14, 1.43, 0.15),
    button: d(s, 14, 1.75, 0.4, vp),
    caption: d(o, 12, 1.66, 0.4),
    overline: d(o, 12, 2.66, 1, vp),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return $t({
    htmlFontSize: u,
    pxToRem: v,
    fontFamily: n,
    fontSize: a,
    fontWeightLight: r,
    fontWeightRegular: o,
    fontWeightMedium: s,
    fontWeightBold: i,
    ...h
  }, c, {
    clone: !1
    // No need to clone deep
  });
}
const L_ = 0.2, q_ = 0.14, F_ = 0.12;
function Fe(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${L_})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${q_})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${F_})`].join(",");
}
const z_ = ["none", Fe(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Fe(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Fe(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Fe(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Fe(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Fe(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Fe(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Fe(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Fe(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Fe(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Fe(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Fe(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Fe(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Fe(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Fe(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Fe(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Fe(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Fe(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Fe(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Fe(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Fe(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Fe(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Fe(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Fe(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], B_ = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, U_ = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function yp(e) {
  return `${Math.round(e)}ms`;
}
function H_(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function V_(e) {
  const t = {
    ...B_,
    ...e.easing
  }, n = {
    ...U_,
    ...e.duration
  };
  return {
    getAutoHeightDuration: H_,
    create: (a = ["all"], r = {}) => {
      const {
        duration: o = n.standard,
        easing: s = t.easeInOut,
        delay: i = 0,
        ...u
      } = r;
      return (Array.isArray(a) ? a : [a]).map((f) => `${f} ${typeof o == "string" ? o : yp(o)} ${s} ${typeof i == "string" ? i : yp(i)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const W_ = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function G_(e) {
  return Pr(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function Gm(e = {}) {
  const t = {
    ...e
  };
  function n(a) {
    const r = Object.entries(a);
    for (let o = 0; o < r.length; o++) {
      const [s, i] = r[o];
      !G_(i) || s.startsWith("unstable_") ? delete a[s] : Pr(i) && (a[s] = {
        ...i
      }, n(a[s]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Ol(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: a = {},
    spacing: r,
    palette: o = {},
    transitions: s = {},
    typography: i = {},
    shape: u,
    ...f
  } = e;
  if (e.vars)
    throw new Error(an(20));
  const p = Cu(o), c = mu(e);
  let l = $t(c, {
    mixins: M_(c.breakpoints, a),
    palette: p,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: z_.slice(),
    typography: N_(p, i),
    transitions: V_(s),
    zIndex: {
      ...W_
    }
  });
  return l = $t(l, f), l = t.reduce((v, d) => $t(v, d), l), l.unstable_sxConfig = {
    ...$i,
    ...f?.unstable_sxConfig
  }, l.unstable_sx = function(v) {
    return zn({
      sx: v,
      theme: this
    });
  }, l.toRuntimeSource = Gm, l;
}
function $l(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const K_ = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = $l(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function Km(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Jm(e) {
  return e === "dark" ? K_ : [];
}
function J_(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: a,
    ...r
  } = e, o = Cu(t);
  return {
    palette: o,
    opacity: {
      ...Km(o.mode),
      ...n
    },
    overlays: a || Jm(o.mode),
    ...r
  };
}
function Q_(e) {
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!e[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}
const Y_ = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], X_ = (e) => (t, n) => {
  const a = e.rootSelector || ":root", r = e.colorSchemeSelector;
  let o = r;
  if (r === "class" && (o = ".%s"), r === "data" && (o = "[data-%s]"), r?.startsWith("data-") && !r.includes("%s") && (o = `[${r}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return Y_(e.cssVarPrefix).forEach((i) => {
        s[i] = n[i], delete n[i];
      }), o === "media" ? {
        [a]: n,
        "@media (prefers-color-scheme: dark)": {
          [a]: s
        }
      } : o ? {
        [o.replace("%s", t)]: s,
        [`${a}, ${o.replace("%s", t)}`]: n
      } : {
        [a]: {
          ...n,
          ...s
        }
      };
    }
    if (o && o !== "media")
      return `${a}, ${o.replace("%s", String(t))}`;
  } else if (t) {
    if (o === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [a]: n
        }
      };
    if (o)
      return o.replace("%s", String(t));
  }
  return a;
};
function Z_(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function H(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function Ra(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : Hm(e);
}
function gr(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = Ca(Ra(e[t])));
}
function eC(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const tr = (e) => {
  try {
    return e();
  } catch {
  }
}, tC = (e = "mui") => S_(e);
function tl(e, t, n, a) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const r = a === "dark" ? "dark" : "light";
  if (!n) {
    e[a] = J_({
      ...t,
      palette: {
        mode: r,
        ...t?.palette
      }
    });
    return;
  }
  const {
    palette: o,
    ...s
  } = Ol({
    ...n,
    palette: {
      mode: r,
      ...t?.palette
    }
  });
  return e[a] = {
    ...t,
    palette: o,
    opacity: {
      ...Km(r),
      ...t?.opacity
    },
    overlays: t?.overlays || Jm(r)
  }, s;
}
function rC(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: a,
    disableCssColorScheme: r = !1,
    cssVarPrefix: o = "mui",
    shouldSkipGeneratingVar: s = Q_,
    colorSchemeSelector: i = n.light && n.dark ? "media" : void 0,
    rootSelector: u = ":root",
    ...f
  } = e, p = Object.keys(n)[0], c = a || (n.light && p !== "light" ? "light" : p), l = tC(o), {
    [c]: v,
    light: d,
    dark: h,
    ...g
  } = n, b = {
    ...g
  };
  let E = v;
  if ((c === "dark" && !("dark" in n) || c === "light" && !("light" in n)) && (E = !0), !E)
    throw new Error(an(21, c));
  const S = tl(b, E, f, c);
  d && !b.light && tl(b, d, void 0, "light"), h && !b.dark && tl(b, h, void 0, "dark");
  let w = {
    defaultColorScheme: c,
    ...S,
    cssVarPrefix: o,
    colorSchemeSelector: i,
    rootSelector: u,
    getCssVar: l,
    colorSchemes: b,
    font: {
      ...A_(S.typography),
      ...S.font
    },
    spacing: eC(f.spacing)
  };
  Object.keys(w.colorSchemes).forEach((R) => {
    const m = w.colorSchemes[R].palette, _ = (O) => {
      const T = O.split("-"), A = T[1], M = T[2];
      return l(O, m[A][M]);
    };
    if (m.mode === "light" && (H(m.common, "background", "#fff"), H(m.common, "onBackground", "#000")), m.mode === "dark" && (H(m.common, "background", "#000"), H(m.common, "onBackground", "#fff")), Z_(m, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), m.mode === "light") {
      H(m.Alert, "errorColor", je(m.error.light, 0.6)), H(m.Alert, "infoColor", je(m.info.light, 0.6)), H(m.Alert, "successColor", je(m.success.light, 0.6)), H(m.Alert, "warningColor", je(m.warning.light, 0.6)), H(m.Alert, "errorFilledBg", _("palette-error-main")), H(m.Alert, "infoFilledBg", _("palette-info-main")), H(m.Alert, "successFilledBg", _("palette-success-main")), H(m.Alert, "warningFilledBg", _("palette-warning-main")), H(m.Alert, "errorFilledColor", tr(() => m.getContrastText(m.error.main))), H(m.Alert, "infoFilledColor", tr(() => m.getContrastText(m.info.main))), H(m.Alert, "successFilledColor", tr(() => m.getContrastText(m.success.main))), H(m.Alert, "warningFilledColor", tr(() => m.getContrastText(m.warning.main))), H(m.Alert, "errorStandardBg", De(m.error.light, 0.9)), H(m.Alert, "infoStandardBg", De(m.info.light, 0.9)), H(m.Alert, "successStandardBg", De(m.success.light, 0.9)), H(m.Alert, "warningStandardBg", De(m.warning.light, 0.9)), H(m.Alert, "errorIconColor", _("palette-error-main")), H(m.Alert, "infoIconColor", _("palette-info-main")), H(m.Alert, "successIconColor", _("palette-success-main")), H(m.Alert, "warningIconColor", _("palette-warning-main")), H(m.AppBar, "defaultBg", _("palette-grey-100")), H(m.Avatar, "defaultBg", _("palette-grey-400")), H(m.Button, "inheritContainedBg", _("palette-grey-300")), H(m.Button, "inheritContainedHoverBg", _("palette-grey-A100")), H(m.Chip, "defaultBorder", _("palette-grey-400")), H(m.Chip, "defaultAvatarColor", _("palette-grey-700")), H(m.Chip, "defaultIconColor", _("palette-grey-700")), H(m.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), H(m.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), H(m.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), H(m.LinearProgress, "primaryBg", De(m.primary.main, 0.62)), H(m.LinearProgress, "secondaryBg", De(m.secondary.main, 0.62)), H(m.LinearProgress, "errorBg", De(m.error.main, 0.62)), H(m.LinearProgress, "infoBg", De(m.info.main, 0.62)), H(m.LinearProgress, "successBg", De(m.success.main, 0.62)), H(m.LinearProgress, "warningBg", De(m.warning.main, 0.62)), H(m.Skeleton, "bg", `rgba(${_("palette-text-primaryChannel")} / 0.11)`), H(m.Slider, "primaryTrack", De(m.primary.main, 0.62)), H(m.Slider, "secondaryTrack", De(m.secondary.main, 0.62)), H(m.Slider, "errorTrack", De(m.error.main, 0.62)), H(m.Slider, "infoTrack", De(m.info.main, 0.62)), H(m.Slider, "successTrack", De(m.success.main, 0.62)), H(m.Slider, "warningTrack", De(m.warning.main, 0.62));
      const O = xo(m.background.default, 0.8);
      H(m.SnackbarContent, "bg", O), H(m.SnackbarContent, "color", tr(() => m.getContrastText(O))), H(m.SpeedDialAction, "fabHoverBg", xo(m.background.paper, 0.15)), H(m.StepConnector, "border", _("palette-grey-400")), H(m.StepContent, "border", _("palette-grey-400")), H(m.Switch, "defaultColor", _("palette-common-white")), H(m.Switch, "defaultDisabledColor", _("palette-grey-100")), H(m.Switch, "primaryDisabledColor", De(m.primary.main, 0.62)), H(m.Switch, "secondaryDisabledColor", De(m.secondary.main, 0.62)), H(m.Switch, "errorDisabledColor", De(m.error.main, 0.62)), H(m.Switch, "infoDisabledColor", De(m.info.main, 0.62)), H(m.Switch, "successDisabledColor", De(m.success.main, 0.62)), H(m.Switch, "warningDisabledColor", De(m.warning.main, 0.62)), H(m.TableCell, "border", De(Po(m.divider, 1), 0.88)), H(m.Tooltip, "bg", Po(m.grey[700], 0.92));
    }
    if (m.mode === "dark") {
      H(m.Alert, "errorColor", De(m.error.light, 0.6)), H(m.Alert, "infoColor", De(m.info.light, 0.6)), H(m.Alert, "successColor", De(m.success.light, 0.6)), H(m.Alert, "warningColor", De(m.warning.light, 0.6)), H(m.Alert, "errorFilledBg", _("palette-error-dark")), H(m.Alert, "infoFilledBg", _("palette-info-dark")), H(m.Alert, "successFilledBg", _("palette-success-dark")), H(m.Alert, "warningFilledBg", _("palette-warning-dark")), H(m.Alert, "errorFilledColor", tr(() => m.getContrastText(m.error.dark))), H(m.Alert, "infoFilledColor", tr(() => m.getContrastText(m.info.dark))), H(m.Alert, "successFilledColor", tr(() => m.getContrastText(m.success.dark))), H(m.Alert, "warningFilledColor", tr(() => m.getContrastText(m.warning.dark))), H(m.Alert, "errorStandardBg", je(m.error.light, 0.9)), H(m.Alert, "infoStandardBg", je(m.info.light, 0.9)), H(m.Alert, "successStandardBg", je(m.success.light, 0.9)), H(m.Alert, "warningStandardBg", je(m.warning.light, 0.9)), H(m.Alert, "errorIconColor", _("palette-error-main")), H(m.Alert, "infoIconColor", _("palette-info-main")), H(m.Alert, "successIconColor", _("palette-success-main")), H(m.Alert, "warningIconColor", _("palette-warning-main")), H(m.AppBar, "defaultBg", _("palette-grey-900")), H(m.AppBar, "darkBg", _("palette-background-paper")), H(m.AppBar, "darkColor", _("palette-text-primary")), H(m.Avatar, "defaultBg", _("palette-grey-600")), H(m.Button, "inheritContainedBg", _("palette-grey-800")), H(m.Button, "inheritContainedHoverBg", _("palette-grey-700")), H(m.Chip, "defaultBorder", _("palette-grey-700")), H(m.Chip, "defaultAvatarColor", _("palette-grey-300")), H(m.Chip, "defaultIconColor", _("palette-grey-300")), H(m.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), H(m.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), H(m.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), H(m.LinearProgress, "primaryBg", je(m.primary.main, 0.5)), H(m.LinearProgress, "secondaryBg", je(m.secondary.main, 0.5)), H(m.LinearProgress, "errorBg", je(m.error.main, 0.5)), H(m.LinearProgress, "infoBg", je(m.info.main, 0.5)), H(m.LinearProgress, "successBg", je(m.success.main, 0.5)), H(m.LinearProgress, "warningBg", je(m.warning.main, 0.5)), H(m.Skeleton, "bg", `rgba(${_("palette-text-primaryChannel")} / 0.13)`), H(m.Slider, "primaryTrack", je(m.primary.main, 0.5)), H(m.Slider, "secondaryTrack", je(m.secondary.main, 0.5)), H(m.Slider, "errorTrack", je(m.error.main, 0.5)), H(m.Slider, "infoTrack", je(m.info.main, 0.5)), H(m.Slider, "successTrack", je(m.success.main, 0.5)), H(m.Slider, "warningTrack", je(m.warning.main, 0.5));
      const O = xo(m.background.default, 0.98);
      H(m.SnackbarContent, "bg", O), H(m.SnackbarContent, "color", tr(() => m.getContrastText(O))), H(m.SpeedDialAction, "fabHoverBg", xo(m.background.paper, 0.15)), H(m.StepConnector, "border", _("palette-grey-600")), H(m.StepContent, "border", _("palette-grey-600")), H(m.Switch, "defaultColor", _("palette-grey-300")), H(m.Switch, "defaultDisabledColor", _("palette-grey-600")), H(m.Switch, "primaryDisabledColor", je(m.primary.main, 0.55)), H(m.Switch, "secondaryDisabledColor", je(m.secondary.main, 0.55)), H(m.Switch, "errorDisabledColor", je(m.error.main, 0.55)), H(m.Switch, "infoDisabledColor", je(m.info.main, 0.55)), H(m.Switch, "successDisabledColor", je(m.success.main, 0.55)), H(m.Switch, "warningDisabledColor", je(m.warning.main, 0.55)), H(m.TableCell, "border", je(Po(m.divider, 1), 0.68)), H(m.Tooltip, "bg", Po(m.grey[700], 0.92));
    }
    gr(m.background, "default"), gr(m.background, "paper"), gr(m.common, "background"), gr(m.common, "onBackground"), gr(m, "divider"), Object.keys(m).forEach((O) => {
      const T = m[O];
      O !== "tonalOffset" && T && typeof T == "object" && (T.main && H(m[O], "mainChannel", Ca(Ra(T.main))), T.light && H(m[O], "lightChannel", Ca(Ra(T.light))), T.dark && H(m[O], "darkChannel", Ca(Ra(T.dark))), T.contrastText && H(m[O], "contrastTextChannel", Ca(Ra(T.contrastText))), O === "text" && (gr(m[O], "primary"), gr(m[O], "secondary")), O === "action" && (T.active && gr(m[O], "active"), T.selected && gr(m[O], "selected")));
    });
  }), w = t.reduce((R, m) => $t(R, m), w);
  const y = {
    prefix: o,
    disableCssColorScheme: r,
    shouldSkipGeneratingVar: s,
    getSelector: X_(w)
  }, {
    vars: x,
    generateThemeVars: P,
    generateStyleSheets: C
  } = E_(w, y);
  return w.vars = x, Object.entries(w.colorSchemes[w.defaultColorScheme]).forEach(([R, m]) => {
    w[R] = m;
  }), w.generateThemeVars = P, w.generateStyleSheets = C, w.generateSpacing = function() {
    return ym(f.spacing, pu(this));
  }, w.getColorSchemeSelector = __(i), w.spacing = w.generateSpacing(), w.shouldSkipGeneratingVar = s, w.unstable_sxConfig = {
    ...$i,
    ...f?.unstable_sxConfig
  }, w.unstable_sx = function(R) {
    return zn({
      sx: R,
      theme: this
    });
  }, w.toRuntimeSource = Gm, w;
}
function bp(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: Cu({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function nC(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: a = !1,
    colorSchemes: r = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: o = n?.mode,
    ...s
  } = e, i = o || "light", u = r?.[i], f = {
    ...r,
    ...n ? {
      [i]: {
        ...typeof u != "boolean" && u,
        palette: n
      }
    } : void 0
  };
  if (a === !1) {
    if (!("colorSchemes" in e))
      return Ol(e, ...t);
    let p = n;
    "palette" in e || f[i] && (f[i] !== !0 ? p = f[i].palette : i === "dark" && (p = {
      mode: "dark"
    }));
    const c = Ol({
      ...e,
      palette: p
    }, ...t);
    return c.defaultColorScheme = i, c.colorSchemes = f, c.palette.mode === "light" && (c.colorSchemes.light = {
      ...f.light !== !0 && f.light,
      palette: c.palette
    }, bp(c, "dark", f.dark)), c.palette.mode === "dark" && (c.colorSchemes.dark = {
      ...f.dark !== !0 && f.dark,
      palette: c.palette
    }, bp(c, "light", f.light)), c;
  }
  return !n && !("light" in f) && i === "light" && (f.light = !0), rC({
    ...s,
    colorSchemes: f,
    defaultColorScheme: i,
    ...typeof a != "boolean" && a
  }, ...t);
}
const Qm = nC();
function aC() {
  const e = jx(Qm);
  return e[xu] || e;
}
function oC(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const iC = (e) => oC(e) && e !== "classes", fr = l_({
  themeId: xu,
  defaultTheme: Qm,
  rootShouldForwardProp: iC
}), Wa = w_;
function Xn(e) {
  return b_(e);
}
function sC(e) {
  return Qn("MuiSvgIcon", e);
}
Yn("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const lC = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: a
  } = e, r = {
    root: ["root", t !== "inherit" && `color${ft(t)}`, `fontSize${ft(n)}`]
  };
  return oo(r, sC, a);
}, uC = fr("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${ft(n.color)}`], t[`fontSize${ft(n.fontSize)}`]];
  }
})(Wa(({
  theme: e
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  display: "inline-block",
  flexShrink: 0,
  transition: e.transitions?.create?.("fill", {
    duration: (e.vars ?? e).transitions?.duration?.shorter
  }),
  variants: [
    {
      props: (t) => !t.hasSvgAsChild,
      style: {
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: "currentColor"
      }
    },
    {
      props: {
        fontSize: "inherit"
      },
      style: {
        fontSize: "inherit"
      }
    },
    {
      props: {
        fontSize: "small"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(20) || "1.25rem"
      }
    },
    {
      props: {
        fontSize: "medium"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(24) || "1.5rem"
      }
    },
    {
      props: {
        fontSize: "large"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(35) || "2.1875rem"
      }
    },
    // TODO v5 deprecate color prop, v6 remove for sx
    ...Object.entries((e.vars ?? e).palette).filter(([, t]) => t && t.main).map(([t]) => ({
      props: {
        color: t
      },
      style: {
        color: (e.vars ?? e).palette?.[t]?.main
      }
    })),
    {
      props: {
        color: "action"
      },
      style: {
        color: (e.vars ?? e).palette?.action?.active
      }
    },
    {
      props: {
        color: "disabled"
      },
      style: {
        color: (e.vars ?? e).palette?.action?.disabled
      }
    },
    {
      props: {
        color: "inherit"
      },
      style: {
        color: void 0
      }
    }
  ]
}))), Tl = /* @__PURE__ */ z.forwardRef(function(e, t) {
  const n = Xn({
    props: e,
    name: "MuiSvgIcon"
  }), {
    children: a,
    className: r,
    color: o = "inherit",
    component: s = "svg",
    fontSize: i = "medium",
    htmlColor: u,
    inheritViewBox: f = !1,
    titleAccess: p,
    viewBox: c = "0 0 24 24",
    ...l
  } = n, v = /* @__PURE__ */ z.isValidElement(a) && a.type === "svg", d = {
    ...n,
    color: o,
    component: s,
    fontSize: i,
    instanceFontSize: e.fontSize,
    inheritViewBox: f,
    viewBox: c,
    hasSvgAsChild: v
  }, h = {};
  f || (h.viewBox = c);
  const g = lC(d);
  return /* @__PURE__ */ ne.jsxs(uC, {
    as: s,
    className: rt(g.root, r),
    focusable: "false",
    color: u,
    "aria-hidden": p ? void 0 : !0,
    role: p ? "img" : void 0,
    ref: t,
    ...h,
    ...l,
    ...v && a.props,
    ownerState: d,
    children: [v ? a.props.children : a, p ? /* @__PURE__ */ ne.jsx("title", {
      children: p
    }) : null]
  });
});
Tl.muiName = "SvgIcon";
function on(e, t) {
  function n(a, r) {
    return /* @__PURE__ */ ne.jsx(Tl, {
      "data-testid": `${t}Icon`,
      ref: r,
      ...a,
      children: e
    });
  }
  return n.muiName = Tl.muiName, /* @__PURE__ */ z.memo(/* @__PURE__ */ z.forwardRef(n));
}
const cC = on(/* @__PURE__ */ ne.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), fC = on(/* @__PURE__ */ ne.jsx("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m2 14H7v-2h7zm3-4H7v-2h10zm0-4H7V7h10z"
}), "Assignment");
function wp(e, t) {
  const {
    className: n,
    elementType: a,
    ownerState: r,
    externalForwardedProps: o,
    internalForwardedProps: s,
    ...i
  } = t, {
    component: u,
    slots: f = {
      [e]: void 0
    },
    slotProps: p = {
      [e]: void 0
    },
    ...c
  } = o, l = f[e] || a, v = a_(p[e], r), {
    props: {
      component: d,
      ...h
    },
    internalRef: g
  } = n_({
    className: n,
    ...i,
    externalForwardedProps: e === "root" ? c : void 0,
    externalSlotProps: v
  }), b = Cl(g, v?.ref, t.ref), E = e === "root" ? d || u : d, S = t_(l, {
    ...e === "root" && !u && !f[e] && s,
    ...e !== "root" && !f[e] && s,
    ...h,
    ...E && {
      as: E
    },
    ref: b
  }, r);
  return [l, S];
}
function dC(e) {
  return typeof e.main == "string";
}
function pC(e, t = []) {
  if (!dC(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function ja(e = []) {
  return ([, t]) => t && pC(t, e);
}
function hC(e) {
  return Qn("MuiPaper", e);
}
Yn("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const mC = (e) => {
  const {
    square: t,
    elevation: n,
    variant: a,
    classes: r
  } = e, o = {
    root: ["root", a, !t && "rounded", a === "elevation" && `elevation${n}`]
  };
  return oo(o, hC, r);
}, vC = fr("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(Wa(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), gC = /* @__PURE__ */ z.forwardRef(function(e, t) {
  const n = Xn({
    props: e,
    name: "MuiPaper"
  }), a = aC(), {
    className: r,
    component: o = "div",
    elevation: s = 1,
    square: i = !1,
    variant: u = "elevation",
    ...f
  } = n, p = {
    ...n,
    component: o,
    elevation: s,
    square: i,
    variant: u
  }, c = mC(p);
  return /* @__PURE__ */ ne.jsx(vC, {
    as: o,
    ownerState: p,
    className: rt(c.root, r),
    ref: t,
    ...f,
    style: {
      ...u === "elevation" && {
        "--Paper-shadow": (a.vars || a).shadows[s],
        ...a.vars && {
          "--Paper-overlay": a.vars.overlays?.[s]
        },
        ...!a.vars && a.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${Ba("#fff", $l(s))}, ${Ba("#fff", $l(s))})`
        }
      },
      ...f.style
    }
  });
});
function yC(e) {
  return Qn("MuiAlert", e);
}
const Sp = Yn("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
class Zo {
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new Zo();
  }
  static use() {
    const t = Fm(Zo.create).current, [n, a] = z.useState(!1);
    return t.shouldMount = n, t.setShouldMount = a, z.useEffect(t.mountEffect, [n]), t;
  }
  constructor() {
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  mount() {
    return this.mounted || (this.mounted = wC(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  mountEffect = () => {
    this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
  };
  /* Ripple API */
  start(...t) {
    this.mount().then(() => this.ref.current?.start(...t));
  }
  stop(...t) {
    this.mount().then(() => this.ref.current?.stop(...t));
  }
  pulsate(...t) {
    this.mount().then(() => this.ref.current?.pulsate(...t));
  }
}
function bC() {
  return Zo.use();
}
function wC() {
  let e, t;
  const n = new Promise((a, r) => {
    e = a, t = r;
  });
  return n.resolve = e, n.reject = t, n;
}
function SC(e, t) {
  if (e == null) return {};
  var n = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (t.indexOf(a) !== -1) continue;
    n[a] = e[a];
  }
  return n;
}
function PC(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, _l(e, t);
}
const Pp = St.createContext(null);
function Ru(e, t) {
  var n = function(r) {
    return t && Ir(r) ? t(r) : r;
  }, a = /* @__PURE__ */ Object.create(null);
  return e && Np.map(e, function(r) {
    return r;
  }).forEach(function(r) {
    a[r.key] = n(r);
  }), a;
}
function xC(e, t) {
  e = e || {}, t = t || {};
  function n(p) {
    return p in t ? t[p] : e[p];
  }
  var a = /* @__PURE__ */ Object.create(null), r = [];
  for (var o in e)
    o in t ? r.length && (a[o] = r, r = []) : r.push(o);
  var s, i = {};
  for (var u in t) {
    if (a[u])
      for (s = 0; s < a[u].length; s++) {
        var f = a[u][s];
        i[a[u][s]] = n(f);
      }
    i[u] = n(u);
  }
  for (s = 0; s < r.length; s++)
    i[r[s]] = n(r[s]);
  return i;
}
function Yr(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function EC(e, t) {
  return Ru(e.children, function(n) {
    return Nr(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Yr(n, "appear", e),
      enter: Yr(n, "enter", e),
      exit: Yr(n, "exit", e)
    });
  });
}
function _C(e, t, n) {
  var a = Ru(e.children), r = xC(t, a);
  return Object.keys(r).forEach(function(o) {
    var s = r[o];
    if (Ir(s)) {
      var i = o in t, u = o in a, f = t[o], p = Ir(f) && !f.props.in;
      u && (!i || p) ? r[o] = Nr(s, {
        onExited: n.bind(null, s),
        in: !0,
        exit: Yr(s, "exit", e),
        enter: Yr(s, "enter", e)
      }) : !u && i && !p ? r[o] = Nr(s, {
        in: !1
      }) : u && i && Ir(f) && (r[o] = Nr(s, {
        onExited: n.bind(null, s),
        in: f.props.in,
        exit: Yr(s, "exit", e),
        enter: Yr(s, "enter", e)
      }));
    }
  }), r;
}
var CC = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, RC = {
  component: "div",
  childFactory: function(e) {
    return e;
  }
}, Ou = /* @__PURE__ */ function(e) {
  PC(t, e);
  function t(a, r) {
    var o;
    o = e.call(this, a, r) || this;
    var s = o.handleExited.bind(HE(o));
    return o.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, o;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(a, r) {
    var o = r.children, s = r.handleExited, i = r.firstRender;
    return {
      children: i ? EC(a, s) : _C(a, o, s),
      firstRender: !1
    };
  }, n.handleExited = function(a, r) {
    var o = Ru(this.props.children);
    a.key in o || (a.props.onExited && a.props.onExited(r), this.mounted && this.setState(function(s) {
      var i = Ko({}, s.children);
      return delete i[a.key], {
        children: i
      };
    }));
  }, n.render = function() {
    var a = this.props, r = a.component, o = a.childFactory, s = SC(a, ["component", "childFactory"]), i = this.state.contextValue, u = CC(this.state.children).map(o);
    return delete s.appear, delete s.enter, delete s.exit, r === null ? /* @__PURE__ */ St.createElement(Pp.Provider, {
      value: i
    }, u) : /* @__PURE__ */ St.createElement(Pp.Provider, {
      value: i
    }, /* @__PURE__ */ St.createElement(r, s, u));
  }, t;
}(St.Component);
Ou.propTypes = {};
Ou.defaultProps = RC;
function OC(e) {
  const {
    className: t,
    classes: n,
    pulsate: a = !1,
    rippleX: r,
    rippleY: o,
    rippleSize: s,
    in: i,
    onExited: u,
    timeout: f
  } = e, [p, c] = z.useState(!1), l = rt(t, n.ripple, n.rippleVisible, a && n.ripplePulsate), v = {
    width: s,
    height: s,
    top: -(s / 2) + o,
    left: -(s / 2) + r
  }, d = rt(n.child, p && n.childLeaving, a && n.childPulsate);
  return !i && !p && c(!0), z.useEffect(() => {
    if (!i && u != null) {
      const h = setTimeout(u, f);
      return () => {
        clearTimeout(h);
      };
    }
  }, [u, i, f]), /* @__PURE__ */ ne.jsx("span", {
    className: l,
    style: v,
    children: /* @__PURE__ */ ne.jsx("span", {
      className: d
    })
  });
}
const Mt = Yn("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), jl = 550, $C = 80, TC = Pu`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, jC = Pu`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, DC = Pu`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, kC = fr("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), AC = fr(OC, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${Mt.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${TC};
    animation-duration: ${jl}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${Mt.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${Mt.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${Mt.childLeaving} {
    opacity: 0;
    animation-name: ${jC};
    animation-duration: ${jl}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${Mt.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${DC};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, MC = /* @__PURE__ */ z.forwardRef(function(e, t) {
  const n = Xn({
    props: e,
    name: "MuiTouchRipple"
  }), {
    center: a = !1,
    classes: r = {},
    className: o,
    ...s
  } = n, [i, u] = z.useState([]), f = z.useRef(0), p = z.useRef(null);
  z.useEffect(() => {
    p.current && (p.current(), p.current = null);
  }, [i]);
  const c = z.useRef(!1), l = JE(), v = z.useRef(null), d = z.useRef(null), h = z.useCallback((S) => {
    const {
      pulsate: w,
      rippleX: y,
      rippleY: x,
      rippleSize: P,
      cb: C
    } = S;
    u((R) => [...R, /* @__PURE__ */ ne.jsx(AC, {
      classes: {
        ripple: rt(r.ripple, Mt.ripple),
        rippleVisible: rt(r.rippleVisible, Mt.rippleVisible),
        ripplePulsate: rt(r.ripplePulsate, Mt.ripplePulsate),
        child: rt(r.child, Mt.child),
        childLeaving: rt(r.childLeaving, Mt.childLeaving),
        childPulsate: rt(r.childPulsate, Mt.childPulsate)
      },
      timeout: jl,
      pulsate: w,
      rippleX: y,
      rippleY: x,
      rippleSize: P
    }, f.current)]), f.current += 1, p.current = C;
  }, [r]), g = z.useCallback((S = {}, w = {}, y = () => {
  }) => {
    const {
      pulsate: x = !1,
      center: P = a || w.pulsate,
      fakeElement: C = !1
      // For test purposes
    } = w;
    if (S?.type === "mousedown" && c.current) {
      c.current = !1;
      return;
    }
    S?.type === "touchstart" && (c.current = !0);
    const R = C ? null : d.current, m = R ? R.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let _, O, T;
    if (P || S === void 0 || S.clientX === 0 && S.clientY === 0 || !S.clientX && !S.touches)
      _ = Math.round(m.width / 2), O = Math.round(m.height / 2);
    else {
      const {
        clientX: A,
        clientY: M
      } = S.touches && S.touches.length > 0 ? S.touches[0] : S;
      _ = Math.round(A - m.left), O = Math.round(M - m.top);
    }
    if (P)
      T = Math.sqrt((2 * m.width ** 2 + m.height ** 2) / 3), T % 2 === 0 && (T += 1);
    else {
      const A = Math.max(Math.abs((R ? R.clientWidth : 0) - _), _) * 2 + 2, M = Math.max(Math.abs((R ? R.clientHeight : 0) - O), O) * 2 + 2;
      T = Math.sqrt(A ** 2 + M ** 2);
    }
    S?.touches ? v.current === null && (v.current = () => {
      h({
        pulsate: x,
        rippleX: _,
        rippleY: O,
        rippleSize: T,
        cb: y
      });
    }, l.start($C, () => {
      v.current && (v.current(), v.current = null);
    })) : h({
      pulsate: x,
      rippleX: _,
      rippleY: O,
      rippleSize: T,
      cb: y
    });
  }, [a, h, l]), b = z.useCallback(() => {
    g({}, {
      pulsate: !0
    });
  }, [g]), E = z.useCallback((S, w) => {
    if (l.clear(), S?.type === "touchend" && v.current) {
      v.current(), v.current = null, l.start(0, () => {
        E(S, w);
      });
      return;
    }
    v.current = null, u((y) => y.length > 0 ? y.slice(1) : y), p.current = w;
  }, [l]);
  return z.useImperativeHandle(t, () => ({
    pulsate: b,
    start: g,
    stop: E
  }), [b, g, E]), /* @__PURE__ */ ne.jsx(kC, {
    className: rt(Mt.root, r.root, o),
    ref: d,
    ...s,
    children: /* @__PURE__ */ ne.jsx(Ou, {
      component: null,
      exit: !0,
      children: i
    })
  });
});
function IC(e) {
  return Qn("MuiButtonBase", e);
}
const NC = Yn("MuiButtonBase", ["root", "disabled", "focusVisible"]), LC = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: a,
    classes: r
  } = e, o = oo({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, IC, r);
  return n && a && (o.root += ` ${a}`), o;
}, qC = fr("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${NC.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), FC = /* @__PURE__ */ z.forwardRef(function(e, t) {
  const n = Xn({
    props: e,
    name: "MuiButtonBase"
  }), {
    action: a,
    centerRipple: r = !1,
    children: o,
    className: s,
    component: i = "button",
    disabled: u = !1,
    disableRipple: f = !1,
    disableTouchRipple: p = !1,
    focusRipple: c = !1,
    focusVisibleClassName: l,
    LinkComponent: v = "a",
    onBlur: d,
    onClick: h,
    onContextMenu: g,
    onDragLeave: b,
    onFocus: E,
    onFocusVisible: S,
    onKeyDown: w,
    onKeyUp: y,
    onMouseDown: x,
    onMouseLeave: P,
    onMouseUp: C,
    onTouchEnd: R,
    onTouchMove: m,
    onTouchStart: _,
    tabIndex: O = 0,
    TouchRippleProps: T,
    touchRippleRef: A,
    type: M,
    ...B
  } = n, J = z.useRef(null), Q = bC(), Z = Cl(Q.ref, A), [te, le] = z.useState(!1);
  u && te && le(!1), z.useImperativeHandle(a, () => ({
    focusVisible: () => {
      le(!0), J.current.focus();
    }
  }), []);
  const me = Q.shouldMount && !f && !u;
  z.useEffect(() => {
    te && c && !f && Q.pulsate();
  }, [f, c, te, Q]);
  const G = yr(Q, "start", x, p), ee = yr(Q, "stop", g, p), ae = yr(Q, "stop", b, p), j = yr(Q, "stop", C, p), N = yr(Q, "stop", (se) => {
    te && se.preventDefault(), P && P(se);
  }, p), W = yr(Q, "start", _, p), K = yr(Q, "stop", R, p), I = yr(Q, "stop", m, p), L = yr(Q, "stop", (se) => {
    lp(se.target) || le(!1), d && d(se);
  }, !1), X = Mo((se) => {
    J.current || (J.current = se.currentTarget), lp(se.target) && (le(!0), S && S(se)), E && E(se);
  }), Y = () => {
    const se = J.current;
    return i && i !== "button" && !(se.tagName === "A" && se.href);
  }, re = Mo((se) => {
    c && !se.repeat && te && se.key === " " && Q.stop(se, () => {
      Q.start(se);
    }), se.target === se.currentTarget && Y() && se.key === " " && se.preventDefault(), w && w(se), se.target === se.currentTarget && Y() && se.key === "Enter" && !u && (se.preventDefault(), h && h(se));
  }), pe = Mo((se) => {
    c && se.key === " " && te && !se.defaultPrevented && Q.stop(se, () => {
      Q.pulsate(se);
    }), y && y(se), h && se.target === se.currentTarget && Y() && se.key === " " && !se.defaultPrevented && h(se);
  });
  let ie = i;
  ie === "button" && (B.href || B.to) && (ie = v);
  const ce = {};
  ie === "button" ? (ce.type = M === void 0 ? "button" : M, ce.disabled = u) : (!B.href && !B.to && (ce.role = "button"), u && (ce["aria-disabled"] = u));
  const de = Cl(t, J), ye = {
    ...n,
    centerRipple: r,
    component: i,
    disabled: u,
    disableRipple: f,
    disableTouchRipple: p,
    focusRipple: c,
    tabIndex: O,
    focusVisible: te
  }, tt = LC(ye);
  return /* @__PURE__ */ ne.jsxs(qC, {
    as: ie,
    className: rt(tt.root, s),
    ownerState: ye,
    onBlur: L,
    onClick: h,
    onContextMenu: ee,
    onFocus: X,
    onKeyDown: re,
    onKeyUp: pe,
    onMouseDown: G,
    onMouseLeave: N,
    onMouseUp: j,
    onDragLeave: ae,
    onTouchEnd: K,
    onTouchMove: I,
    onTouchStart: W,
    ref: de,
    tabIndex: u ? -1 : O,
    type: M,
    ...ce,
    ...B,
    children: [o, me ? /* @__PURE__ */ ne.jsx(MC, {
      ref: Z,
      center: r,
      ...T
    }) : null]
  });
});
function yr(e, t, n, a = !1) {
  return Mo((r) => (n && n(r), a || e[t](r), !0));
}
function zC(e) {
  return Qn("MuiIconButton", e);
}
const BC = Yn("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), UC = (e) => {
  const {
    classes: t,
    disabled: n,
    color: a,
    edge: r,
    size: o
  } = e, s = {
    root: ["root", n && "disabled", a !== "default" && `color${ft(a)}`, r && `edge${ft(r)}`, `size${ft(o)}`]
  };
  return oo(s, zC, t);
}, HC = fr(FC, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${ft(n.color)}`], n.edge && t[`edge${ft(n.edge)}`], t[`size${ft(n.size)}`]];
  }
})(Wa(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Ba(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), Wa(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(ja()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(ja()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Ba((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${BC.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  }
}))), VC = /* @__PURE__ */ z.forwardRef(function(e, t) {
  const n = Xn({
    props: e,
    name: "MuiIconButton"
  }), {
    edge: a = !1,
    children: r,
    className: o,
    color: s = "default",
    disabled: i = !1,
    disableFocusRipple: u = !1,
    size: f = "medium",
    ...p
  } = n, c = {
    ...n,
    edge: a,
    color: s,
    disabled: i,
    disableFocusRipple: u,
    size: f
  }, l = UC(c);
  return /* @__PURE__ */ ne.jsx(HC, {
    className: rt(l.root, o),
    centerRipple: !0,
    focusRipple: !u,
    disabled: i,
    ref: t,
    ...p,
    ownerState: c,
    children: r
  });
}), WC = on(/* @__PURE__ */ ne.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), GC = on(/* @__PURE__ */ ne.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), KC = on(/* @__PURE__ */ ne.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), JC = on(/* @__PURE__ */ ne.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), QC = on(/* @__PURE__ */ ne.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), YC = (e) => {
  const {
    variant: t,
    color: n,
    severity: a,
    classes: r
  } = e, o = {
    root: ["root", `color${ft(n || a)}`, `${t}${ft(n || a)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return oo(o, yC, r);
}, XC = fr(gC, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${ft(n.color || n.severity)}`]];
  }
})(Wa(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? Ua : Ha, n = e.palette.mode === "light" ? Ha : Ua;
  return {
    ...e.typography.body2,
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter(ja(["light"])).map(([a]) => ({
      props: {
        colorSeverity: a,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${a}Color`] : t(e.palette[a].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${a}StandardBg`] : n(e.palette[a].light, 0.9),
        [`& .${Sp.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${a}IconColor`]
        } : {
          color: e.palette[a].main
        }
      }
    })), ...Object.entries(e.palette).filter(ja(["light"])).map(([a]) => ({
      props: {
        colorSeverity: a,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${a}Color`] : t(e.palette[a].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[a].light}`,
        [`& .${Sp.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${a}IconColor`]
        } : {
          color: e.palette[a].main
        }
      }
    })), ...Object.entries(e.palette).filter(ja(["dark"])).map(([a]) => ({
      props: {
        colorSeverity: a,
        variant: "filled"
      },
      style: {
        fontWeight: e.typography.fontWeightMedium,
        ...e.vars ? {
          color: e.vars.palette.Alert[`${a}FilledColor`],
          backgroundColor: e.vars.palette.Alert[`${a}FilledBg`]
        } : {
          backgroundColor: e.palette.mode === "dark" ? e.palette[a].dark : e.palette[a].main,
          color: e.palette.getContrastText(e.palette[a].main)
        }
      }
    }))]
  };
})), ZC = fr("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), eR = fr("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), xp = fr("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), Ep = {
  success: /* @__PURE__ */ ne.jsx(WC, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ ne.jsx(GC, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ ne.jsx(KC, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ ne.jsx(JC, {
    fontSize: "inherit"
  })
}, tR = /* @__PURE__ */ z.forwardRef(function(e, t) {
  const n = Xn({
    props: e,
    name: "MuiAlert"
  }), {
    action: a,
    children: r,
    className: o,
    closeText: s = "Close",
    color: i,
    components: u = {},
    componentsProps: f = {},
    icon: p,
    iconMapping: c = Ep,
    onClose: l,
    role: v = "alert",
    severity: d = "success",
    slotProps: h = {},
    slots: g = {},
    variant: b = "standard",
    ...E
  } = n, S = {
    ...n,
    color: i,
    severity: d,
    variant: b,
    colorSeverity: i || d
  }, w = YC(S), y = {
    slots: {
      closeButton: u.CloseButton,
      closeIcon: u.CloseIcon,
      ...g
    },
    slotProps: {
      ...f,
      ...h
    }
  }, [x, P] = wp("closeButton", {
    elementType: VC,
    externalForwardedProps: y,
    ownerState: S
  }), [C, R] = wp("closeIcon", {
    elementType: QC,
    externalForwardedProps: y,
    ownerState: S
  });
  return /* @__PURE__ */ ne.jsxs(XC, {
    role: v,
    elevation: 0,
    ownerState: S,
    className: rt(w.root, o),
    ref: t,
    ...E,
    children: [p !== !1 ? /* @__PURE__ */ ne.jsx(ZC, {
      ownerState: S,
      className: w.icon,
      children: p || c[d] || Ep[d]
    }) : null, /* @__PURE__ */ ne.jsx(eR, {
      ownerState: S,
      className: w.message,
      children: r
    }), a != null ? /* @__PURE__ */ ne.jsx(xp, {
      ownerState: S,
      className: w.action,
      children: a
    }) : null, a == null && l ? /* @__PURE__ */ ne.jsx(xp, {
      ownerState: S,
      className: w.action,
      children: /* @__PURE__ */ ne.jsx(x, {
        size: "small",
        "aria-label": s,
        title: s,
        color: "inherit",
        onClick: l,
        ...P,
        children: /* @__PURE__ */ ne.jsx(C, {
          fontSize: "small",
          ...R
        })
      })
    }) : null]
  });
}), rR = (e) => /* @__PURE__ */ ne.jsx(tR, { elevation: 6, variant: "filled", ...e });
var _p, Cp;
function nR() {
  return Cp || (Cp = 1, _p = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var t = document.activeElement, n = [], a = 0; a < e.rangeCount; a++)
      n.push(e.getRangeAt(a));
    switch (t.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        t.blur();
        break;
      default:
        t = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(r) {
        e.addRange(r);
      }), t && t.focus();
    };
  }), _p;
}
var rl, Rp;
function aR() {
  if (Rp) return rl;
  Rp = 1;
  var e = nR(), t = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, n = "Copy to clipboard: #{key}, Enter";
  function a(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function r(o, s) {
    var i, u, f, p, c, l, v = !1;
    s || (s = {}), i = s.debug || !1;
    try {
      f = e(), p = document.createRange(), c = document.getSelection(), l = document.createElement("span"), l.textContent = o, l.ariaHidden = "true", l.style.all = "unset", l.style.position = "fixed", l.style.top = 0, l.style.clip = "rect(0, 0, 0, 0)", l.style.whiteSpace = "pre", l.style.webkitUserSelect = "text", l.style.MozUserSelect = "text", l.style.msUserSelect = "text", l.style.userSelect = "text", l.addEventListener("copy", function(h) {
        if (h.stopPropagation(), s.format)
          if (h.preventDefault(), typeof h.clipboardData > "u") {
            i && console.warn("unable to use e.clipboardData"), i && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var g = t[s.format] || t.default;
            window.clipboardData.setData(g, o);
          } else
            h.clipboardData.clearData(), h.clipboardData.setData(s.format, o);
        s.onCopy && (h.preventDefault(), s.onCopy(h.clipboardData));
      }), document.body.appendChild(l), p.selectNodeContents(l), c.addRange(p);
      var d = document.execCommand("copy");
      if (!d)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (h) {
      i && console.error("unable to copy using execCommand: ", h), i && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (g) {
        i && console.error("unable to copy using clipboardData: ", g), i && console.error("falling back to prompt"), u = a("message" in s ? s.message : n), window.prompt(u, o);
      }
    } finally {
      c && (typeof c.removeRange == "function" ? c.removeRange(p) : c.removeAllRanges()), l && document.body.removeChild(l), f();
    }
    return v;
  }
  return rl = r, rl;
}
var oR = aR();
const iR = /* @__PURE__ */ pm(oR), Op = (e) => "name" in e && "params" in e, nl = {
  type: "object",
  properties: {
    jsonrpc: {
      type: "string",
      enum: ["2.0"],
      description: "JSON-RPC version string"
    },
    id: {
      description: "unique identifier for the JSON-RPC request",
      oneOf: [
        {
          type: "string"
        },
        {
          type: "number"
        }
      ]
    },
    method: {
      type: "string"
    }
  }
}, sR = (e) => e ? {
  type: "object",
  properties: {
    id: {
      ...nl.properties.id
    },
    jsonrpc: {
      ...nl.properties.jsonrpc
    },
    method: {
      type: "string",
      oneOf: e?.methods?.filter(Op).map((t) => ({
        const: t.name,
        description: t.description || t.summary,
        markdownDescription: t.description || t.summary
      }))
    }
  },
  allOf: e?.methods?.filter(Op).map((t) => ({
    if: {
      properties: {
        method: {
          const: t.name
        }
      }
    },
    then: {
      properties: {
        params: {
          oneOf: [
            {
              type: "array",
              minItems: (
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                t.params && t.params.filter((n) => n.required).length
              ),
              maxItems: t.params && t.params.length,
              defaultSnippets: t.examples ? (
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                t.examples.map((n) => ({
                  label: n.name,
                  description: n.description || n.summary,
                  body: n.params && n.params.map((a) => a.value)
                }))
              ) : [],
              items: t.params && // eslint-disable-next-line @typescript-eslint/no-explicit-any
              t.params.map((n) => ({
                ...n.schema,
                markdownDescription: n.description || n.summary,
                description: n.description || n.summary,
                additionalProperties: !1
              }))
            },
            {
              type: "object",
              properties: t.params && t.params.reduce(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (n, a) => (n[a.name] = {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ...a.schema,
                  markdownDescription: a.description || a.summary,
                  description: a.description || a.summary,
                  additionalProperties: !1
                }, n),
                {}
              )
            }
          ]
        }
      }
    }
  }))
} : nl, lR = (e) => "name" in e && "params" in e, al = {
  type: "object",
  properties: {
    jsonrpc: {
      type: "string",
      description: "JSON-RPC Version String",
      const: "2.0"
    },
    id: {
      oneOf: [
        {
          type: "string"
        },
        {
          type: "number"
        }
      ]
    }
  }
}, uR = (e, t) => {
  if (!t)
    return al;
  const n = t.methods.filter(lR).find((r) => r.name === e);
  let a;
  return n !== void 0 && n.result !== void 0 && (a = n.result.schema), {
    type: "object",
    properties: {
      id: {
        ...al.properties.id
      },
      jsonrpc: {
        ...al.properties.jsonrpc
      },
      result: {
        ...a,
        markdownDescription: n?.description || n?.summary,
        description: n?.description || n?.summary
      }
    }
  };
}, $p = "cardListItem", Dl = {
  cardHeader: `${$p}-cardHeader`,
  cardContent: `${$p}-cardContent`
}, cR = Fp(uv)(({ theme: e }) => ({
  [`& .${Dl.cardHeader}`]: {
    padding: "8px",
    paddingBottom: "0px",
    paddingTop: "0px"
  },
  [`& .${Dl.cardContent}`]: {
    padding: "8px !important"
  }
})), fR = (e, t) => {
  const n = t.palette.mode;
  return e.payload.error ? { backgroundColor: t.palette.error[n] } : {};
}, dR = (e) => e.method.includes("rpc.") ? "call rpc-call" : e.type === "response" ? e.payload.error ? "call response-error" : "call response-success" : "call request", pR = (e) => {
  const t = zp(), n = dR(e.log), [a, r] = z.useState(!1), o = 300, s = 20, [i, u] = z.useState(170), f = z.useRef(null), p = (d) => {
    f.current = d;
  }, c = (d) => {
    if (d) {
      const h = d.split(`
`).length, g = Math.min(h * s, o);
      u(g);
    }
  }, l = (d, h) => {
    d.stopPropagation(), r(!0), iR(JSON.stringify(h, null, 4));
  }, v = () => {
    r(!1);
  };
  return Me(() => {
    if (!f.current || !e.openrpcDocument || !e.log.method) return;
    let d;
    if (e.log.type === "request" ? d = sR(e.openrpcDocument) : d = uR(e.log.method, e.openrpcDocument), !f.current?.getModel())
      return;
    const h = Lr.editor.createModel(JSON.stringify(e.log.payload, null, 2), "json");
    f.current?.setModel(h), Fo(h.uri.toString(), d, Lr), c(h.getValue());
  }, [e.openrpcDocument, e.log]), /* @__PURE__ */ ne.jsxs(
    cR,
    {
      m: 2,
      className: [
        "call-box",
        `${e.log.type === "response" ? "response" : ""}`,
        `${e.filter.includes(e.log.method) || e.filter.includes("all") ? "" : "hidden"}`
      ].join(" "),
      children: [
        /* @__PURE__ */ ne.jsx(cv, { open: a, autoHideDuration: 4e3, onClose: v, children: /* @__PURE__ */ ne.jsx(rR, { severity: "success", children: "Payload Copied to Clipboard" }) }),
        /* @__PURE__ */ ne.jsxs(
          fv,
          {
            raised: !0,
            elevation: 8,
            className: n,
            style: fR(e.log, t),
            children: [
              /* @__PURE__ */ ne.jsx(
                dv,
                {
                  title: e.log.method,
                  action: /* @__PURE__ */ ne.jsx(Ix, { log: e.log }),
                  subheader: /* @__PURE__ */ ne.jsx(gt, { variant: "caption", color: "textSecondary", children: UE(/* @__PURE__ */ new Date(), e.log.timestamp) })
                }
              ),
              /* @__PURE__ */ ne.jsxs(pv, { className: Dl.cardContent, children: [
                e.log.batchId && /* @__PURE__ */ ne.jsxs(gt, { children: [
                  "Batch: ",
                  e.log.batchId
                ] }),
                /* @__PURE__ */ ne.jsxs(hv, { defaultExpanded: !0, children: [
                  /* @__PURE__ */ ne.jsx(mv, { expandIcon: /* @__PURE__ */ ne.jsx(cC, {}), component: "div", disableRipple: !0, children: /* @__PURE__ */ ne.jsx(wr, { title: "Copy to clipboard", children: /* @__PURE__ */ ne.jsxs(
                    "span",
                    {
                      onClick: (d) => {
                        d.stopPropagation(), l(d, e.log.payload);
                      },
                      style: { display: "flex", alignItems: "center", cursor: "pointer" },
                      children: [
                        /* @__PURE__ */ ne.jsx(gt, { children: "Payload" }),
                        /* @__PURE__ */ ne.jsx(fC, { style: { fontSize: 14, marginLeft: 8 } })
                      ]
                    }
                  ) }) }),
                  /* @__PURE__ */ ne.jsx(vv, { style: { margin: 0, padding: 0 }, children: /* @__PURE__ */ ne.jsx(
                    oi,
                    {
                      width: "100%",
                      height: i,
                      language: "json",
                      value: JSON.stringify(e.log.payload, null, 4),
                      options: {
                        automaticLayout: !0,
                        theme: t.palette.mode === "dark" ? "vs-dark" : "vs",
                        minimap: { enabled: !1 },
                        glyphMargin: !1,
                        overviewRulerBorder: !1,
                        showFoldingControls: "always",
                        hideCursorInOverviewRuler: !0,
                        scrollbar: {
                          useShadows: !1
                        },
                        scrollBeyondLastLine: !1,
                        lineNumbers: "off",
                        fixedOverflowWidgets: !0,
                        readOnly: !0
                      },
                      onChange: c,
                      onMount: p
                    },
                    JSON.stringify(e.log)
                  ) })
                ] })
              ] })
            ]
          }
        )
      ]
    },
    JSON.stringify(e.log)
  );
}, Tp = z.memo(pR), jp = (e) => /* @__PURE__ */ ne.jsx(ne.Fragment, { children: e.logs.map((t, n) => e.logs.length - 1 === n ? /* @__PURE__ */ ne.jsx(
  Tp,
  {
    openrpcDocument: e.openrpcDocument,
    log: t,
    filter: e.filter,
    open: !0,
    darkMode: e.darkMode
  },
  `log-${n}`
) : /* @__PURE__ */ ne.jsx(
  Tp,
  {
    openrpcDocument: e.openrpcDocument,
    log: t,
    filter: e.filter,
    open: !1,
    darkMode: e.darkMode
  },
  `log-${n}`
)) }), jr = "JSONRPCLogger", yt = {
  logsReact: `${jr}-logsReact`,
  extendDiv: `${jr}-extendDiv`,
  hide: `${jr}-hide`,
  menuButton: `${jr}-menuButton`,
  content: `${jr}-content`,
  left: `${jr}-left`,
  right: `${jr}-right`,
  contentShift: `${jr}-contentShift`
}, hR = Fp("div")(({ theme: e }) => ({
  [`& .${yt.logsReact}`]: {
    display: "flex",
    width: "100%",
    height: "100%"
  },
  [`& .${yt.extendDiv}`]: {
    width: "25px"
  },
  [`& .${yt.hide}`]: {
    display: "none"
  },
  [`& .${yt.menuButton}`]: {
    paddingLeft: 0,
    paddingRight: 0,
    marginLeft: 0,
    marginRight: 0
  },
  [`& .${yt.content}`]: {
    width: "100%",
    height: "auto",
    overflow: "auto",
    transition: e.transitions.create("margin", {
      easing: e.transitions.easing.sharp,
      duration: e.transitions.duration.leavingScreen
    })
  },
  [`& .${yt.left}`]: {
    marginLeft: -200
  },
  [`& .${yt.right}`]: {
    marginRight: -200
  },
  [`& .${yt.contentShift}`]: {
    width: "100%",
    transition: e.transitions.create("margin", {
      easing: e.transitions.easing.easeOut,
      duration: e.transitions.duration.enteringScreen
    }),
    marginLeft: 0,
    marginRight: 0
  }
})), mR = !1, vR = "left", gR = (e) => {
  const t = ct(null), [n] = ke(["all"]), a = e.sidebarAlign !== void 0 ? e.sidebarAlign : vR, r = e.openRecentPayload !== void 0 ? e.openRecentPayload : mR, o = () => {
    t && t.current !== null && t.current.scrollIntoView({ behavior: "smooth" });
  };
  return il(o, [e.logs]), il(o, []), /* @__PURE__ */ ne.jsx(hR, { children: a === "left" ? /* @__PURE__ */ ne.jsx("div", { className: yt.logsReact, children: /* @__PURE__ */ ne.jsxs("div", { className: rt(yt.content, yt.left), children: [
    /* @__PURE__ */ ne.jsx(
      jp,
      {
        logs: e.logs,
        filter: n,
        openRecentPayload: r,
        openrpcDocument: e.openrpcDocument,
        darkMode: e.darkMode
      }
    ),
    /* @__PURE__ */ ne.jsx("div", { ref: t })
  ] }) }) : /* @__PURE__ */ ne.jsx("div", { className: yt.logsReact, children: /* @__PURE__ */ ne.jsxs("div", { className: rt(yt.content, yt.right), children: [
    /* @__PURE__ */ ne.jsx(
      jp,
      {
        logs: e.logs,
        filter: n,
        openRecentPayload: r,
        openrpcDocument: e.openrpcDocument,
        darkMode: e.darkMode
      }
    ),
    /* @__PURE__ */ ne.jsx("div", { ref: t })
  ] }) }) });
};
class yR extends z.Component {
  constructor(t) {
    super(t), this.state = { hasError: !1, error: null };
  }
  static getDerivedStateFromError(t) {
    return { hasError: !0, error: t };
  }
  componentDidCatch(t, n) {
    console.error("Error caught by boundary:", t, n);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ ne.jsxs("div", { style: { padding: 20, color: "red" }, children: [
      /* @__PURE__ */ ne.jsx("h2", { children: "Something went wrong." }),
      /* @__PURE__ */ ne.jsx("pre", { children: this.state.error?.toString() })
    ] }) : this.props.children;
  }
}
const bR = (e) => /* @__PURE__ */ ne.jsx(yR, { children: /* @__PURE__ */ ne.jsx(gR, { ...e }) }), wR = (e) => {
  const [t, n] = ke(), a = fh();
  Me(() => {
    t && t.layout();
  }, [a, t]), Me(() => {
    t && (t.getModel()?.setValue(e.value), t.getModel()?.setLanguage("json"), Fo(t.getModel()?.uri.toString() || "", e.schema, Lr));
  }, [e.schema, t]);
  function r(i) {
    n(i);
  }
  const o = (i) => {
    e.onChange && e.onChange(i);
  }, s = Ml();
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    /* @__PURE__ */ V.jsx("div", { style: { marginTop: "5px", background: "black" } }),
    /* @__PURE__ */ V.jsx(
      oi,
      {
        height: "95%",
        width: "100%",
        value: e.value,
        onMount: r,
        options: {
          theme: s.value ? "vs-dark" : "vs",
          minimap: {
            enabled: !1
          },
          lineNumbers: "off",
          glyphMargin: !1,
          folding: !1,
          automaticLayout: !0,
          fixedOverflowWidgets: !0
        },
        language: "json",
        onChange: o
      }
    )
  ] });
};
class ei {
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new ei();
  }
  static use() {
    const t = mh(ei.create).current, [n, a] = z.useState(!1);
    return t.shouldMount = n, t.setShouldMount = a, z.useEffect(t.mountEffect, [n]), t;
  }
  constructor() {
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  mount() {
    return this.mounted || (this.mounted = PR(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  mountEffect = () => {
    this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
  };
  /* Ripple API */
  start(...t) {
    this.mount().then(() => this.ref.current?.start(...t));
  }
  stop(...t) {
    this.mount().then(() => this.ref.current?.stop(...t));
  }
  pulsate(...t) {
    this.mount().then(() => this.ref.current?.pulsate(...t));
  }
}
function SR() {
  return ei.use();
}
function PR() {
  let e, t;
  const n = new Promise((a, r) => {
    e = a, t = r;
  });
  return n.resolve = e, n.reject = t, n;
}
function xR(e, t) {
  if (e == null) return {};
  var n = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (t.indexOf(a) !== -1) continue;
    n[a] = e[a];
  }
  return n;
}
function kl(e, t) {
  return kl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, kl(e, t);
}
function ER(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, kl(e, t);
}
const Dp = St.createContext(null);
function _R(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $u(e, t) {
  var n = function(o) {
    return t && Ir(o) ? t(o) : o;
  }, a = /* @__PURE__ */ Object.create(null);
  return e && Np.map(e, function(r) {
    return r;
  }).forEach(function(r) {
    a[r.key] = n(r);
  }), a;
}
function CR(e, t) {
  e = e || {}, t = t || {};
  function n(p) {
    return p in t ? t[p] : e[p];
  }
  var a = /* @__PURE__ */ Object.create(null), r = [];
  for (var o in e)
    o in t ? r.length && (a[o] = r, r = []) : r.push(o);
  var s, i = {};
  for (var u in t) {
    if (a[u])
      for (s = 0; s < a[u].length; s++) {
        var f = a[u][s];
        i[a[u][s]] = n(f);
      }
    i[u] = n(u);
  }
  for (s = 0; s < r.length; s++)
    i[r[s]] = n(r[s]);
  return i;
}
function Xr(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function RR(e, t) {
  return $u(e.children, function(n) {
    return Nr(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Xr(n, "appear", e),
      enter: Xr(n, "enter", e),
      exit: Xr(n, "exit", e)
    });
  });
}
function OR(e, t, n) {
  var a = $u(e.children), r = CR(t, a);
  return Object.keys(r).forEach(function(o) {
    var s = r[o];
    if (Ir(s)) {
      var i = o in t, u = o in a, f = t[o], p = Ir(f) && !f.props.in;
      u && (!i || p) ? r[o] = Nr(s, {
        onExited: n.bind(null, s),
        in: !0,
        exit: Xr(s, "exit", e),
        enter: Xr(s, "enter", e)
      }) : !u && i && !p ? r[o] = Nr(s, {
        in: !1
      }) : u && i && Ir(f) && (r[o] = Nr(s, {
        onExited: n.bind(null, s),
        in: f.props.in,
        exit: Xr(s, "exit", e),
        enter: Xr(s, "enter", e)
      }));
    }
  }), r;
}
var $R = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, TR = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Tu = /* @__PURE__ */ function(e) {
  ER(t, e);
  function t(a, r) {
    var o;
    o = e.call(this, a, r) || this;
    var s = o.handleExited.bind(_R(o));
    return o.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, o;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(r, o) {
    var s = o.children, i = o.handleExited, u = o.firstRender;
    return {
      children: u ? RR(r, i) : OR(r, s, i),
      firstRender: !1
    };
  }, n.handleExited = function(r, o) {
    var s = $u(this.props.children);
    r.key in s || (r.props.onExited && r.props.onExited(o), this.mounted && this.setState(function(i) {
      var u = Uo({}, i.children);
      return delete u[r.key], {
        children: u
      };
    }));
  }, n.render = function() {
    var r = this.props, o = r.component, s = r.childFactory, i = xR(r, ["component", "childFactory"]), u = this.state.contextValue, f = $R(this.state.children).map(s);
    return delete i.appear, delete i.enter, delete i.exit, o === null ? /* @__PURE__ */ St.createElement(Dp.Provider, {
      value: u
    }, f) : /* @__PURE__ */ St.createElement(Dp.Provider, {
      value: u
    }, /* @__PURE__ */ St.createElement(o, i, f));
  }, t;
}(St.Component);
Tu.propTypes = {};
Tu.defaultProps = TR;
function jR(e) {
  const {
    className: t,
    classes: n,
    pulsate: a = !1,
    rippleX: r,
    rippleY: o,
    rippleSize: s,
    in: i,
    onExited: u,
    timeout: f
  } = e, [p, c] = z.useState(!1), l = wt(t, n.ripple, n.rippleVisible, a && n.ripplePulsate), v = {
    width: s,
    height: s,
    top: -(s / 2) + o,
    left: -(s / 2) + r
  }, d = wt(n.child, p && n.childLeaving, a && n.childPulsate);
  return !i && !p && c(!0), z.useEffect(() => {
    if (!i && u != null) {
      const h = setTimeout(u, f);
      return () => {
        clearTimeout(h);
      };
    }
  }, [u, i, f]), /* @__PURE__ */ V.jsx("span", {
    className: l,
    style: v,
    children: /* @__PURE__ */ V.jsx("span", {
      className: d
    })
  });
}
const It = si("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Al = 550, DR = 80, kR = Yl`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, AR = Yl`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, MR = Yl`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, IR = Vn("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), NR = Vn(jR, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${It.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${kR};
    animation-duration: ${Al}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${It.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${It.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${It.childLeaving} {
    opacity: 0;
    animation-name: ${AR};
    animation-duration: ${Al}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${It.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${MR};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, LR = /* @__PURE__ */ z.forwardRef(function(t, n) {
  const a = Xa({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: r = !1,
    classes: o = {},
    className: s,
    ...i
  } = a, [u, f] = z.useState([]), p = z.useRef(0), c = z.useRef(null);
  z.useEffect(() => {
    c.current && (c.current(), c.current = null);
  }, [u]);
  const l = z.useRef(!1), v = bg(), d = z.useRef(null), h = z.useRef(null), g = z.useCallback((w) => {
    const {
      pulsate: y,
      rippleX: x,
      rippleY: P,
      rippleSize: C,
      cb: R
    } = w;
    f((m) => [...m, /* @__PURE__ */ V.jsx(NR, {
      classes: {
        ripple: wt(o.ripple, It.ripple),
        rippleVisible: wt(o.rippleVisible, It.rippleVisible),
        ripplePulsate: wt(o.ripplePulsate, It.ripplePulsate),
        child: wt(o.child, It.child),
        childLeaving: wt(o.childLeaving, It.childLeaving),
        childPulsate: wt(o.childPulsate, It.childPulsate)
      },
      timeout: Al,
      pulsate: y,
      rippleX: x,
      rippleY: P,
      rippleSize: C
    }, p.current)]), p.current += 1, c.current = R;
  }, [o]), b = z.useCallback((w = {}, y = {}, x = () => {
  }) => {
    const {
      pulsate: P = !1,
      center: C = r || y.pulsate,
      fakeElement: R = !1
      // For test purposes
    } = y;
    if (w?.type === "mousedown" && l.current) {
      l.current = !1;
      return;
    }
    w?.type === "touchstart" && (l.current = !0);
    const m = R ? null : h.current, _ = m ? m.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let O, T, A;
    if (C || w === void 0 || w.clientX === 0 && w.clientY === 0 || !w.clientX && !w.touches)
      O = Math.round(_.width / 2), T = Math.round(_.height / 2);
    else {
      const {
        clientX: M,
        clientY: B
      } = w.touches && w.touches.length > 0 ? w.touches[0] : w;
      O = Math.round(M - _.left), T = Math.round(B - _.top);
    }
    if (C)
      A = Math.sqrt((2 * _.width ** 2 + _.height ** 2) / 3), A % 2 === 0 && (A += 1);
    else {
      const M = Math.max(Math.abs((m ? m.clientWidth : 0) - O), O) * 2 + 2, B = Math.max(Math.abs((m ? m.clientHeight : 0) - T), T) * 2 + 2;
      A = Math.sqrt(M ** 2 + B ** 2);
    }
    w?.touches ? d.current === null && (d.current = () => {
      g({
        pulsate: P,
        rippleX: O,
        rippleY: T,
        rippleSize: A,
        cb: x
      });
    }, v.start(DR, () => {
      d.current && (d.current(), d.current = null);
    })) : g({
      pulsate: P,
      rippleX: O,
      rippleY: T,
      rippleSize: A,
      cb: x
    });
  }, [r, g, v]), E = z.useCallback(() => {
    b({}, {
      pulsate: !0
    });
  }, [b]), S = z.useCallback((w, y) => {
    if (v.clear(), w?.type === "touchend" && d.current) {
      d.current(), d.current = null, v.start(0, () => {
        S(w, y);
      });
      return;
    }
    d.current = null, f((x) => x.length > 0 ? x.slice(1) : x), c.current = y;
  }, [v]);
  return z.useImperativeHandle(n, () => ({
    pulsate: E,
    start: b,
    stop: S
  }), [E, b, S]), /* @__PURE__ */ V.jsx(IR, {
    className: wt(It.root, o.root, s),
    ref: h,
    ...i,
    children: /* @__PURE__ */ V.jsx(Tu, {
      component: null,
      exit: !0,
      children: u
    })
  });
});
function qR(e) {
  return Ga("MuiButtonBase", e);
}
const FR = si("MuiButtonBase", ["root", "disabled", "focusVisible"]), zR = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: a,
    classes: r
  } = e, s = ii({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, qR, r);
  return n && a && (s.root += ` ${a}`), s;
}, BR = Vn("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${FR.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), UR = /* @__PURE__ */ z.forwardRef(function(t, n) {
  const a = Xa({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: r,
    centerRipple: o = !1,
    children: s,
    className: i,
    component: u = "button",
    disabled: f = !1,
    disableRipple: p = !1,
    disableTouchRipple: c = !1,
    focusRipple: l = !1,
    focusVisibleClassName: v,
    LinkComponent: d = "a",
    onBlur: h,
    onClick: g,
    onContextMenu: b,
    onDragLeave: E,
    onFocus: S,
    onFocusVisible: w,
    onKeyDown: y,
    onKeyUp: x,
    onMouseDown: P,
    onMouseLeave: C,
    onMouseUp: R,
    onTouchEnd: m,
    onTouchMove: _,
    onTouchStart: O,
    tabIndex: T = 0,
    TouchRippleProps: A,
    touchRippleRef: M,
    type: B,
    ...J
  } = a, Q = z.useRef(null), Z = SR(), te = dl(Z.ref, M), [le, me] = z.useState(!1);
  f && le && me(!1), z.useImperativeHandle(r, () => ({
    focusVisible: () => {
      me(!0), Q.current.focus();
    }
  }), []);
  const G = Z.shouldMount && !p && !f;
  z.useEffect(() => {
    le && l && !p && Z.pulsate();
  }, [p, l, le, Z]);
  const ee = br(Z, "start", P, c), ae = br(Z, "stop", b, c), j = br(Z, "stop", E, c), N = br(Z, "stop", R, c), W = br(Z, "stop", (oe) => {
    le && oe.preventDefault(), C && C(oe);
  }, c), K = br(Z, "start", O, c), I = br(Z, "stop", m, c), L = br(Z, "stop", _, c), X = br(Z, "stop", (oe) => {
    pc(oe.target) || me(!1), h && h(oe);
  }, !1), Y = Co((oe) => {
    Q.current || (Q.current = oe.currentTarget), pc(oe.target) && (me(!0), w && w(oe)), S && S(oe);
  }), re = () => {
    const oe = Q.current;
    return u && u !== "button" && !(oe.tagName === "A" && oe.href);
  }, pe = Co((oe) => {
    l && !oe.repeat && le && oe.key === " " && Z.stop(oe, () => {
      Z.start(oe);
    }), oe.target === oe.currentTarget && re() && oe.key === " " && oe.preventDefault(), y && y(oe), oe.target === oe.currentTarget && re() && oe.key === "Enter" && !f && (oe.preventDefault(), g && g(oe));
  }), ie = Co((oe) => {
    l && oe.key === " " && le && !oe.defaultPrevented && Z.stop(oe, () => {
      Z.pulsate(oe);
    }), x && x(oe), g && oe.target === oe.currentTarget && re() && oe.key === " " && !oe.defaultPrevented && g(oe);
  });
  let ce = u;
  ce === "button" && (J.href || J.to) && (ce = d);
  const de = {};
  ce === "button" ? (de.type = B === void 0 ? "button" : B, de.disabled = f) : (!J.href && !J.to && (de.role = "button"), f && (de["aria-disabled"] = f));
  const ye = dl(n, Q), tt = {
    ...a,
    centerRipple: o,
    component: u,
    disabled: f,
    disableRipple: p,
    disableTouchRipple: c,
    focusRipple: l,
    tabIndex: T,
    focusVisible: le
  }, se = zR(tt);
  return /* @__PURE__ */ V.jsxs(BR, {
    as: ce,
    className: wt(se.root, i),
    ownerState: tt,
    onBlur: X,
    onClick: g,
    onContextMenu: ae,
    onFocus: Y,
    onKeyDown: pe,
    onKeyUp: ie,
    onMouseDown: ee,
    onMouseLeave: W,
    onMouseUp: N,
    onDragLeave: j,
    onTouchEnd: I,
    onTouchMove: L,
    onTouchStart: K,
    ref: ye,
    tabIndex: f ? -1 : T,
    type: B,
    ...de,
    ...J,
    children: [s, G ? /* @__PURE__ */ V.jsx(LR, {
      ref: te,
      center: o,
      ...A
    }) : null]
  });
});
function br(e, t, n, a = !1) {
  return Co((r) => (n && n(r), a || e[t](r), !0));
}
const kp = /* @__PURE__ */ z.createContext({});
function HR(e) {
  return Ga("MuiListItemButton", e);
}
const ya = si("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), VR = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters];
}, WR = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: a,
    disabled: r,
    disableGutters: o,
    divider: s,
    selected: i
  } = e, f = ii({
    root: ["root", a && "dense", !o && "gutters", s && "divider", r && "disabled", t === "flex-start" && "alignItemsFlexStart", i && "selected"]
  }, HR, n);
  return {
    ...n,
    ...f
  };
}, GR = Vn(UR, {
  shouldForwardProp: (e) => Hh(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: VR
})(Vh(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${ya.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : xa(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${ya.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : xa(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${ya.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : xa(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : xa(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${ya.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${ya.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }]
}))), KR = /* @__PURE__ */ z.forwardRef(function(t, n) {
  const a = Xa({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: r = "center",
    autoFocus: o = !1,
    component: s = "div",
    children: i,
    dense: u = !1,
    disableGutters: f = !1,
    divider: p = !1,
    focusVisibleClassName: c,
    selected: l = !1,
    className: v,
    ...d
  } = a, h = z.useContext(kp), g = z.useMemo(() => ({
    dense: u || h.dense || !1,
    alignItems: r,
    disableGutters: f
  }), [r, h.dense, u, f]), b = z.useRef(null);
  hh(() => {
    o && b.current && b.current.focus();
  }, [o]);
  const E = {
    ...a,
    alignItems: r,
    dense: g.dense,
    disableGutters: f,
    divider: p,
    selected: l
  }, S = WR(E), w = dl(b, n);
  return /* @__PURE__ */ V.jsx(kp.Provider, {
    value: g,
    children: /* @__PURE__ */ V.jsx(GR, {
      ref: w,
      href: d.href || d.to,
      component: (d.href || d.to) && s === "div" ? "button" : s,
      focusVisibleClassName: wt(S.focusVisible, c),
      ownerState: E,
      className: wt(S.root, v),
      ...d,
      classes: S,
      children: i
    })
  });
}), JR = Up("inspector-custom-transports"), Eo = [
  {
    type: "http",
    name: "HTTP",
    schema: {
      type: "object",
      properties: {
        headers: {
          patternProperties: {
            "": {
              type: "string"
            }
          }
        },
        credentials: {
          type: "string",
          enum: ["omit", "same-origin", "include"]
        }
      },
      examples: [
        {
          headers: {}
        }
      ]
    }
  },
  {
    type: "websocket",
    name: "WebSocket"
  },
  {
    type: "postmessagewindow",
    name: "PostMessageWindow"
  },
  {
    type: "postmessageiframe",
    name: "PostMessageIframe"
  }
], Ap = (e, t) => {
  if (!(e instanceof Error) || !e)
    return;
  const a = {
    jsonrpc: "2.0",
    id: t
  };
  return e.data instanceof Error ? {
    ...a,
    error: {
      code: e.data.code,
      message: e.data.message,
      data: e.data.data
    }
  } : {
    ...a,
    error: {
      code: e.code,
      message: e.message,
      data: e.data
    }
  };
}, ol = {
  jsonrpc: "2.0",
  method: "",
  params: [],
  id: 0
}, tO = (e) => {
  const {
    setTabContent: t,
    setTabEditing: n,
    setTabIndex: a,
    tabs: r,
    setTabs: o,
    handleClose: s,
    tabIndex: i,
    setTabUrl: u,
    handleLabelChange: f
  } = t1([
    {
      name: e.request ? e.request.method : "New Tab",
      content: e.request || { ...ol },
      logs: [],
      url: e.url || "",
      openrpcDocument: e.openrpcDocument
    }
  ]), [p, c] = ke(e.openrpcDocument), [l, v] = ke(
    e.request || {
      jsonrpc: "2.0",
      method: "",
      params: [],
      id: 0
    }
  ), [d, h] = JR(() => e.customTransport ? [...Eo, e.customTransport] : Eo), [g, b] = ke(e.url || ""), [E] = zc(g, 1e3), [S, w] = ke(
    e.customTransport || Eo[0]
  ), [y, x] = ke(), [P] = zc(y, 1e3), [C, R, , m] = PS(
    d,
    E,
    e.customTransport || Eo[0],
    P
  ), [_, O] = ke(!1), [T, A] = ke([]), [M, B] = ke(0), [J, Q] = ke([]), Z = z.useRef(null), te = z.useRef(null);
  Me(() => {
    o([
      ...r,
      {
        name: e.request && e.request.method || "New Tab",
        content: e.request || JSON.stringify({ ...ol }, null, 2),
        url: e.url,
        openrpcDocument: p
      }
    ]), a(r.length);
  }, [e.request]), Me(() => {
    if (S !== void 0) {
      R(S);
      const I = S;
      I.schema !== void 0 && I.schema !== !0 && I.schema !== !1 && x(I.schema.examples[0]);
    }
  }, [S]), Me(() => {
    l && t(i, l);
  }, [l]), Me(() => {
    if (e.transport) {
      const I = d, L = I.findIndex(
        (X) => X.name?.toLowerCase() === e.transport?.toLowerCase()
      );
      L !== -1 && w(I[L]);
    }
  }, [e.transport]), Me(() => {
    e.url && (b(e.url), u(i, e.url));
  }, [e.url]), il(() => {
    Z.current?.setLayout([50, 50]), S.schema ? te.current?.setLayout([85, 15]) : te.current?.setLayout([100]);
  }, [S]);
  const le = async () => {
    let I = /* @__PURE__ */ new Date();
    if (C)
      try {
        I = /* @__PURE__ */ new Date();
        const L = await C.sendData({
          internalID: l.id,
          request: l
        }), X = /* @__PURE__ */ new Date(), Y = { jsonrpc: "2.0", result: L, id: l.id }, re = {
          type: "request",
          method: l.method,
          timestamp: I,
          payload: l
        }, pe = {
          type: "response",
          method: l.method,
          timestamp: X,
          payload: Y
        }, ie = [...T, { ...r[i] }];
        A(ie), Q((ce) => [...ce, re, pe]), o(
          (ce) => ce.map(
            (de, ye) => ye === i ? { ...de, logs: [...de.logs || [], re, pe] } : de
          )
        );
      } catch (L) {
        const X = /* @__PURE__ */ new Date(), Y = Ap(L, l.id), re = {
          type: "request",
          method: l.method,
          timestamp: I,
          payload: l
        }, pe = {
          type: "response",
          method: l.method,
          timestamp: X,
          payload: Y
        }, ie = [...T, { ...r[i] }];
        A(ie), Q((ce) => [...ce, re, pe]), o(
          (ce) => ce.map(
            (de, ye) => ye === i ? { ...de, logs: [...de.logs || [], re, pe] } : de
          )
        );
      }
  }, me = () => {
    Q([]), o(
      (I) => I.map((L, X) => X === i ? { ...L, logs: [] } : L)
    );
  }, G = () => {
    me();
  }, ee = () => {
    e.onToggleDarkMode && e.onToggleDarkMode();
  }, ae = async () => {
    if (r[i]) {
      try {
        const I = await C?.sendData({
          internalID: 999999,
          request: {
            jsonrpc: "2.0",
            params: [],
            id: 999999,
            method: "rpc.discover"
          }
        }), L = await sS.parseOpenRPCDocument(I);
        c(L), o(
          (X) => X.map(
            (Y, re) => re === i ? { ...Y, openrpcDocument: L } : Y
          )
        );
      } catch {
        e.openrpcDocument || (c(void 0), o(
          (L) => L.map(
            (X, Y) => Y === i ? { ...X, openrpcDocument: void 0 } : X
          )
        ));
      }
      C && (C.subscribe("notification", (I) => {
        const L = /* @__PURE__ */ new Date(), X = {
          type: "response",
          notification: !0,
          method: I.method,
          timestamp: L,
          payload: I
        };
        Q((Y) => [...Y, X]), o((Y) => Y[i] ? Y.map(
          (re, pe) => pe === i ? { ...re, logs: [...re.logs || [], X] } : re
        ) : Y);
      }), C.subscribe("error", (I) => {
        const X = {
          type: "response",
          method: "",
          timestamp: /* @__PURE__ */ new Date(),
          payload: Ap(I, null)
        };
        Q((Y) => [...Y, X]), o((Y) => Y[i] ? Y.map(
          (re, pe) => pe === i ? { ...re, logs: [...re.logs || [], X] } : re
        ) : Y);
      }));
    }
  };
  Me(() => {
    if (e.openrpcDocument || c(void 0), r[i])
      try {
        ae();
      } catch (I) {
        console.warn("Failed to refresh openrpc document", I);
      }
  }, [C, i]), Me(() => {
    r[i] && (v(r[i].content), b(r[i].url || ""), Q(r[i].logs || []));
  }, [i]), Me(() => {
    c(e.openrpcDocument), o(
      (I) => I.map(
        (L, X) => X === i ? { ...L, openrpcDocument: e.openrpcDocument } : L
      )
    );
  }, [e.openrpcDocument]), Me(() => {
    _ || le();
  }, [_]);
  const j = (I, L) => {
    a(L);
  }, N = () => {
    T[M] && (v(T[M].content), b(T[M].url), c(T[M].openrpcDocument), O(!1));
  }, W = (I) => {
    try {
      x(JSON.parse(I));
    } catch {
    }
  }, K = Ml();
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    /* @__PURE__ */ V.jsx(
      Lp,
      {
        onClose: () => O(!1),
        "aria-labelledby": "simple-dialog-title",
        open: _,
        children: /* @__PURE__ */ V.jsxs(sl, { maxWidth: "sm", children: [
          /* @__PURE__ */ V.jsxs(
            Ar,
            {
              container: !0,
              justifyContent: "space-between",
              alignItems: "center",
              style: { padding: "30px", paddingTop: "10px", paddingBottom: "10px" },
              children: [
                /* @__PURE__ */ V.jsx(gt, { color: "textPrimary", children: "History" }),
                T.length === 0 ? null : /* @__PURE__ */ V.jsx(wr, { title: "Use", children: /* @__PURE__ */ V.jsx(un, { onClick: N, children: /* @__PURE__ */ V.jsx(Fc, {}) }) })
              ]
            }
          ),
          T.length === 0 ? /* @__PURE__ */ V.jsx(gt, { style: { padding: "30px" }, children: "No History Yet." }) : /* @__PURE__ */ V.jsxs(Ar, { container: !0, style: { paddingBottom: "30px" }, children: [
            /* @__PURE__ */ V.jsx(
              gv,
              {
                style: { padding: "10px", overflowY: "scroll", height: "250px", width: "200px" },
                children: T.map((I, L) => /* @__PURE__ */ V.jsx(
                  KR,
                  {
                    selected: L === M,
                    onClick: () => B(L),
                    children: /* @__PURE__ */ V.jsx(
                      yv,
                      {
                        primary: I.content.method || "Empty Method",
                        secondary: I.url || "Empty Url"
                      }
                    )
                  },
                  `history-${L}`
                ))
              }
            ),
            /* @__PURE__ */ V.jsx(
              oi,
              {
                width: "300px",
                height: "250px",
                options: {
                  theme: K.value ? "vs-dark" : "vs"
                },
                value: T[M] ? JSON.stringify(T[M].content, null, 4) : "",
                language: "json",
                onMount: () => {
                }
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ V.jsx("div", { style: { position: "relative" }, children: /* @__PURE__ */ V.jsxs(
      bv,
      {
        style: { background: "transparent" },
        value: i,
        variant: "scrollable",
        indicatorColor: "primary",
        onChange: j,
        children: [
          r.map((I, L) => /* @__PURE__ */ V.jsx(
            Wu,
            {
              disableRipple: !0,
              style: {
                border: "none",
                outline: "none",
                userSelect: "none"
              },
              component: "div",
              onDoubleClick: () => n(I, !0),
              label: /* @__PURE__ */ V.jsxs("div", { style: { userSelect: "none" }, children: [
                I.editing ? /* @__PURE__ */ V.jsx(
                  No,
                  {
                    value: I.name,
                    onChange: (X) => f(X, I),
                    onBlur: () => n(I, !1),
                    autoFocus: !0,
                    style: { maxWidth: "80px", marginRight: "25px" }
                  },
                  `tab-label-input-${L}`
                ) : /* @__PURE__ */ V.jsx(
                  gt,
                  {
                    style: { display: "inline", textTransform: "none", marginRight: "25px" },
                    variant: "body1",
                    children: I.name
                  },
                  `tab-label-text-${L}`
                ),
                i === L ? /* @__PURE__ */ V.jsx(wr, { title: "Close Tab", children: /* @__PURE__ */ V.jsx(
                  un,
                  {
                    component: "div",
                    onClick: (X) => s(X, L),
                    style: { position: "absolute", right: "0px", top: "25%" },
                    size: "small",
                    children: /* @__PURE__ */ V.jsx(Wb, {})
                  },
                  `tab-close-btn-${L}`
                ) }, `tab-close-${L}`) : null
              ] })
            },
            `tab-${L}`
          )),
          /* @__PURE__ */ V.jsx(
            Wu,
            {
              disableRipple: !0,
              style: { minWidth: "50px" },
              component: "div",
              label: /* @__PURE__ */ V.jsx(wr, { title: "Create New Tab", children: /* @__PURE__ */ V.jsx(
                un,
                {
                  onClick: () => {
                    const I = {
                      name: "New Tab",
                      content: { ...ol, id: 0 },
                      logs: [],
                      openrpcDocument: p,
                      url: g
                    };
                    o((L) => {
                      const X = [...L, I];
                      return setTimeout(() => a(X.length - 1), 0), X;
                    });
                  },
                  children: /* @__PURE__ */ V.jsx(Wh, { style: { transform: "scale(1)" } })
                }
              ) })
            },
            "tab-new"
          )
        ]
      }
    ) }),
    /* @__PURE__ */ V.jsx(wv, { elevation: 0, position: "static", style: { zIndex: 1 }, children: /* @__PURE__ */ V.jsxs(Sv, { children: [
      /* @__PURE__ */ V.jsx(
        "img",
        {
          height: "30",
          alt: "openrpc-logo",
          style: { marginRight: "10px" },
          src: "https://github.com/open-rpc/design/raw/master/icons/open-rpc-logo-noText/open-rpc-logo-noText%20(PNG)/128x128.png"
        }
      ),
      /* @__PURE__ */ V.jsx(gt, { variant: "h6", color: "textSecondary", children: "Inspector" }),
      /* @__PURE__ */ V.jsx(
        lS,
        {
          transports: d,
          onAddTransport: (I) => {
            h((L) => [...L, I]);
          },
          selectedTransport: S,
          onChange: (I) => w(I),
          style: {
            marginLeft: "10px"
          }
        }
      ),
      /* @__PURE__ */ V.jsx(wr, { title: "Play", children: /* @__PURE__ */ V.jsx(un, { component: "div", onClick: le, children: /* @__PURE__ */ V.jsx(Fc, { fontSize: "large" }) }) }),
      /* @__PURE__ */ V.jsx(
        No,
        {
          startAdornment: /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
            /* @__PURE__ */ V.jsx(wr, { title: m ? "Connected" : "Not Connected", children: m ? /* @__PURE__ */ V.jsx(Gb, { style: { color: Dr[500] } }) : /* @__PURE__ */ V.jsx(Kb, { color: "error" }) }),
            p ? /* @__PURE__ */ V.jsx(
              wr,
              {
                title: /* @__PURE__ */ V.jsxs("div", { style: { textAlign: "center" }, children: [
                  /* @__PURE__ */ V.jsx(gt, { children: "OpenRPC Document Detected" }),
                  /* @__PURE__ */ V.jsx(gt, { variant: "caption", children: "A JSON-RPC endpoint may respond to the rpc.discover method or a provide a static document. This adds features like auto completion to the inspector." })
                ] }),
                onClick: () => window.open("https://spec.open-rpc.org/#service-discovery-method"),
                children: /* @__PURE__ */ V.jsx(
                  Yb,
                  {
                    style: {
                      color: Dr[500],
                      marginRight: "5px",
                      cursor: "pointer",
                      transform: "scale(1)"
                    }
                  }
                )
              }
            ) : null
          ] }),
          value: g,
          placeholder: "Enter a JSON-RPC server URL",
          onChange: (I) => {
            b(I.target.value), u(i, I.target.value);
          },
          fullWidth: !0,
          style: {
            background: "rgba(0,0,0,0.1)",
            borderRadius: "4px",
            padding: "0px 10px",
            marginRight: "5px"
          }
        }
      ),
      /* @__PURE__ */ V.jsx(wr, { title: "History", children: /* @__PURE__ */ V.jsx(un, { onClick: () => O(!0), children: /* @__PURE__ */ V.jsx(Jb, {}) }) }),
      e.hideToggleTheme ? null : /* @__PURE__ */ V.jsx(wr, { title: "Toggle Theme", children: /* @__PURE__ */ V.jsx(un, { onClick: ee, children: e.darkMode ? /* @__PURE__ */ V.jsx(Xb, {}) : /* @__PURE__ */ V.jsx(Zb, {}) }) })
    ] }) }),
    /* @__PURE__ */ V.jsxs(
      ul,
      {
        ref: Z,
        direction: "horizontal",
        style: {
          display: "flex",
          height: "calc(100vh - 128px)"
        },
        children: [
          /* @__PURE__ */ V.jsx(
            ba,
            {
              style: {
                display: "flex",
                flexDirection: "column",
                minHeight: 0
              },
              children: /* @__PURE__ */ V.jsxs(
                ul,
                {
                  ref: te,
                  direction: "vertical",
                  style: {
                    display: "flex",
                    height: "100%"
                  },
                  children: [
                    /* @__PURE__ */ V.jsx(ba, { style: { overflow: "auto", minHeight: 0 }, children: /* @__PURE__ */ V.jsx(
                      dg,
                      {
                        onChange: (I) => {
                          let L;
                          try {
                            L = JSON.parse(I);
                          } catch (X) {
                            console.warn(X);
                          }
                          L && (v(L), t(i, L));
                        },
                        openrpcDocument: p,
                        value: JSON.stringify(l, null, 4)
                      }
                    ) }),
                    S.schema && /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
                      /* @__PURE__ */ V.jsx(cl, { className: "resize-handle" }),
                      /* @__PURE__ */ V.jsx(ba, { style: { overflow: "auto", minHeight: 0 }, children: /* @__PURE__ */ V.jsx(
                        wR,
                        {
                          schema: S.schema,
                          value: JSON.stringify(y, null, 4),
                          onChange: W
                        }
                      ) })
                    ] })
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ V.jsx(cl, { className: "resize-handle" }),
          /* @__PURE__ */ V.jsxs(
            ba,
            {
              style: {
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                minHeight: 0,
                position: "relative"
              },
              children: [
                J.length > 0 && /* @__PURE__ */ V.jsx(
                  Oa,
                  {
                    variant: "contained",
                    style: {
                      cursor: "pointer",
                      position: "absolute",
                      top: "5px",
                      right: "50px",
                      zIndex: 2,
                      background: "rgba(255,255,255,0.2)"
                    },
                    onClick: G,
                    children: "Clear"
                  }
                ),
                J.length === 0 ? /* @__PURE__ */ V.jsx(sl, { maxWidth: "sm", children: /* @__PURE__ */ V.jsxs(Ar, { container: !0, justifyContent: "center", style: { paddingTop: "40px" }, children: [
                  /* @__PURE__ */ V.jsx(gt, { gutterBottom: !0, children: "Press the Play button to see the results here." }),
                  /* @__PURE__ */ V.jsxs(gt, { children: [
                    "Use ",
                    /* @__PURE__ */ V.jsx(
                      Oa,
                      {
                        startIcon: /* @__PURE__ */ V.jsx(Qb, {}),
                        variant: "contained",
                        disabled: !0,
                        size: "small",
                        style: { marginRight: "3px" },
                        children: "CTRL + SPACE"
                      }
                    ),
                    "to auto-complete in the editor."
                  ] })
                ] }) }) : /* @__PURE__ */ V.jsx("div", { style: { height: "100%" }, children: /* @__PURE__ */ V.jsx(
                  bR,
                  {
                    sidebarOpen: !1,
                    openrpcDocument: p,
                    logs: J,
                    sidebarAlign: "right",
                    openRecentPayload: !0
                  }
                ) })
              ]
            }
          )
        ]
      }
    )
  ] });
};
export {
  tO as Inspector,
  tO as default
};
